import React, { Component } from 'react';
import axios from 'axios';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import moment from 'moment';
import { Toolbar, Data } from 'react-data-grid-addons';
import _, { debounce, isString } from 'lodash';
import ReactPaginate from 'react-paginate';
import { Field } from 'redux-form';
import {
  Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb, Input,
  Dropdown, MenuItem, DropdownButton, Spinner,
} from 'react-bootstrap';
import { Translate, I18n } from 'react-redux-i18n';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';

import GenericDatePicker from '../Common/GenericDatePicker';
import EmailContentModal from './components/EmailContentModal';
import {SALES_ORDERS_URL, PICKER_UR, MOBILE_ACCOUNT_URL, MOBILE_ACCOUNT_TREE_URL, CHANGE_TRACKING_URL} from '../../actions/url';
import SpinnerButton from '../Common/SpinnerButton';
import { UI_HEIGHT } from '../Common/constants';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import WidgetsSpinner from '../../components/Widgets/spinner';
import CashFormatter from '../Common/cashFormatter';
import { DateFormatter2 } from '../Common/dateFormat';
import { DatePicker } from '../Common/datePicker';
import { Selection, SelectionWithProps } from '../Common/selection';
import TypeRadios from '../../containers/Common/TypeRadios';
import GenericProductSuggest from '../../containers/Common/GenericProductSuggest';
import { toFromDates, isGGiOver, toFromDispatchDates, converTimeUTCToLocal } from '../Common/cleanDates';
import ConfirmActionModal from '../Common/confirmActionModal';
import genericRadioFilter from '../Common/genericRadioFilter';
import { numberWithCommas } from '../Common/numberWithCommas';
import dateFilterRadios from '../Common/dateFilterRadios';
import dispatchFilterRadios from '../Common/dispatchFilterRadios';
import PercentFormatter from '../Common/percentFormatter';
import checkPermission from '../Common/permissions';
import checkPermissionLocal from '../Common/permissions';
import { WeightChangeModalMulti } from '../Common/weightChangeModalMulti';
import { MultiplePackageModal } from '../Common/MultiplePackageModal';
import { BOLListModal } from '../Common/bolListModal';
import { DSQPrintModal } from '../Common/dsqPrintModal';
import { WIZPODModal } from '../Common/wizPODModal';
import { GenerateBOLModal } from '../Common/generateBOLModal';
import { SplitTrackingNumberModal } from '../Common/SplitTrackingNumberModal';
import { SplitSOModal } from '../Common/splitSOModal';
import PaymentMethodModal from './PaymentMethodModal';
import ShipMethodModal from './components/ShipMethodModal';
import ShipQtyModal from './components/ShipQtyModal';
import EditTrackingModal from './components/EditTrackingModal';
import BolImagesTable from './components/BolImagesTable';
import {
  ROOT_URL, ROOT_API_URL, companyCodeTitle, isDAICHEONG, isESC, isSKH, isHMM,
  isSUN, isCPG, isABBLE, isGGI, isSH, isAP, isOCM, isHO, isJRC, isOLG, isLAP, isUSPrideMulti, isAPD, isPRS,
  isSW, isABCFF, isVAK, isKM, isLMH, isLMHST, isBRO, isSDR, isCRW, isSV, isEKC, isTQ, isAGD,
  isVIP, isCCW, isGFD, isSC, isCT
} from '../../actions/root_url';
import salesOrderModals from "../Common/modals/salesOrder";
import { isArray } from 'lodash';
import SalesShippingModal from '../../containers/Sales/salesShippingModal';
import AutoPrintModal from '../Common/autoPrintModal';
import {
  submitBolImage, podUpload, generateSOWithExcelUSPride, expressMultipleSOInvoices,
  fetchSalesOrderPDFSuccess, fetchSalesOrderPDFFetch, mobileSoDealQuote
} from '../../actions/sales_actions';
import DropshipModal from './DropshipModal'

const {
  DriverListModal, ISAEditModal, CTNEditModal, LocationChange, InboundDateChange,
  TeapplixResyncModal, StuffResyncModal, MissingSKUsModal, MonitorNoteModal, MonitorRemoveModal,
  MonitorListModal, ImageModal, ShippingRateModal, CreateExcelModal
} = salesOrderModals;
const isMyuMyu =
  ROOT_API_URL === "https://mmstage-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://myumyu-scm.truckxi.com/api/";
const isCalco =
  ROOT_API_URL === "https://calco-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://calco-stage.truckxi.com/api/";
const isAFG =
  ROOT_API_URL === "https://afg-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afgstage-scm.truckxi.com/api/";
const isMAG = ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || ROOT_URL === 'https://magna-scm.truckxi.com/api/';
const isRivera =
  ROOT_API_URL === "https://rivera-scm.truckxi.com/api/" ||
  ROOT_URL === "https://rvrstage-scm.truckxi.com/api/";
const isWecom = ROOT_API_URL === "https://wecom-scm.truckxi.com/api/";
const isCO = ROOT_API_URL === "https://co-scm.truckxi.com/api/";
const isJML = ROOT_API_URL === "https://jml-scm.truckxi.com/api/";
const isSY = ROOT_API_URL === "https://sunny-scm.truckxi.com/api/";
const isAFM =
  ROOT_API_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
const isTN =
  ROOT_API_URL === "https://tn-scm.truckxi.com/api/" ||
  ROOT_URL === "https://tn-scm.truckxi.com/api/";
const isABC =
  ROOT_API_URL === "https://abc-scm.truckxi.com/api/" ||
  ROOT_URL === "https://abc-scm.truckxi.com/api/";
const isChinaTown = ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';
const isDSQ = ROOT_API_URL === 'https://dsq-scm.truckxi.com/api/' || ROOT_URL === 'https://dsq-scm.truckxi.com/api/';
const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
const isGV = ROOT_API_URL === 'https://scm.gvyummy.com/api/' || ROOT_URL === 'https://scm.gvyummy.com/api/';
const isFJ = ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || ROOT_URL === 'https://fj-scm.truckxi.com/api/';
const isJTB = ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
const isFIT = ROOT_API_URL === 'https://fit-scm.truckxi.com/api/' || ROOT_URL === 'https://fit-scm.truckxi.com/api/';
const isNBT = ROOT_API_URL === 'https://nbt-scm.truckxi.com/api/' || ROOT_URL === 'https://nbt-scm.truckxi.com/api/';
import { getLocalStorageData } from '../../reducers/headerRedux';
import { getSortVal, getKeysMap, moveColumnToPosition, fileDownload, fileUpload } from '../../utils';
import { SALES_ORDER_SORT_KEY_OBJ } from '../../utils/map';
import ReactDOM from 'react-dom';
import { vakLogisticCarrierOptions } from '../../utils/constant';

const createDialogShippingStyle = {
  height: '740px',
  width: window.innerWidth * 4 / 5,
  marginLeft: '-35%',
  marginTop: '-22%',
  top: '60%'
};

const {
  Draggable: {
    Container: DraggableContainer,
    RowActionsCell,
    DropTargetRowContainer,
  },
  Data: { Selectors },
} = require("react-data-grid-addons");
class ToolBarCustom extends Component {
  render() {
    return <Toolbar enableFilter {...this.props} />
  }
}
class RowRenderer extends Component {
  render() {
    const row = this.props.row;
    const IsMonitor = row.IsMonitor;
    const style = {};
    if (IsMonitor) {
      style.borderBottom = "3px solid orange";
    }
    // if(isSH) {
    //   otherParams.cellRenderer= (cellProps) => {
    //     return <ReactDataGrid.Cell
    //     {...cellProps}
    //     className={this.props.row.PickedQuantity < this.props.row.OrderQuantity ? 'warning-Cell' : null}
    //   />
    //   }
    // }

    return (
      <div
        onDoubleClick={() => {
        }}
        style={style}
      >
        <ReactDataGrid.Row ref="row" {...this.props}/>
      </div>
    );
  }
}

class SalesOrder extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.fiveLineButton,
      clear: true,

      salesOrders: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      topIds: [],

      salesOrderDetail: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },

      magSalesOrderDetail: {
      },

      shippingPdfFrameLoaded: true,
      pickingListPdfFrameLoaded: true,
      packingListPdfFrameLoaded: true,
      salesOrderPdfFrameLoaded: true,
      bolIdPdfFrameLoaded: true,
      bolWithoutLogPdfFrameLoaded: true,
      bolFbaPdfFrameLoaded: true,
      bolLabelFrameLoaded: true,

      suggestValue: "",
      productSearchType: "invoiceNo",
      days: "1",
      FromDate: undefined,
      ToDate: undefined,
      filteredByItem: false,
      Status: "all",
      rowsCount: 0,
      total: 0,
      totalOrders: 0,
      canceledOrders: 0,
      canceledTotal: 0,
      totalQty: 0,
      totalCancelledQty:0,
      dispatchDays: (isLAP || isGGI) ? "1" : null,
      dispatchDateGT: undefined,
      dispatchDateLT: undefined,

      checkAuthorizeOpen: false,
      action: null,
      title: "Quote",
      breadcrumbTitle: "mobile_sales_order",
      changeWeightOpen: false,
      showMin: false,
      displayTrackingOpen: false,
      changePullSheetOpen: false,
      confirmReshipOpen: false,
      confirmQuoteOpen: false,
      confirmQuotePending: false,
      confirmOpenToQuote: false,
      showDriverImageOpen: false,
      showSignatureImageOpen: false,
      submitImageOpen: false,
      printBolOpen: false,
      finalShippingWeight: 0,
      pullSheetAmount: 0,
      pullSheetSort: "",
      scrollTopPositionIndex: null,
      trackingNumberSelected: null,
      invoiceNoSearchTerm: "",
      trackingNoSearchTerm: "",
      onlyRefreshCurrentItem: false,

      isInvoice: false,

      trackingFormOpen: false,
      trackingformNum: null,
      trackingformCarrier: null,
      trackingformMethod: null,

      bolListModalVisibility: false,
      generateBOLModalVisibility: false,
      dsqPrintVisibility: false,
      wizPODVisibility: false,

      paymentMethodModalVisibility: false,
      shipMethodModalVisibility: false,
      shipQtyModalVisibility: false,
      changeShipQtyId: null,
      editTrackingModalVisibility: false,
      changeTrackingId: null,
      voidNoteModalVisibility: false,
      voidReason: "",
      voidNote: "",

      chowbusModalVisibility: false,
      chowbusImportFile: null,

      splitSoVisible: false,

      mag1: {
        DRYRUN: false,
        OFFHIRE: false,
        EXTRA_STOP: false,
        EXAM: false,
        EXTRA_DELIVERY: false,
        STORAGE: false,
        BOBTAIL_FEE: false,
      },

      mag2: {
        FREIGHT_HOLD: false,
        CUSTOM_HOLD: false,
        PIERPASS_HOLD: false,
        EXAM: false,
        CLOSED_AREA: false,
      },

      rows: [],
      file: [],
      bolAddressFBA: "",


      multiplePackageVisibility: false,

      warehouseOptions: [],
      changeTrackingOpen: false,
      newTrackingNum: null,
      newTrackingNumID: null,

      quoteSelectedCustomerId: null,
      quoteSelectedCustomerName: "",
      quoteSelectedWarehouseId: null,
      quoteSelectedCustomerPlaceholder: "",
      quoteSelectedWarehousePlaceholder: "",
      quoteCustomerOptions: [],
      quoteCustomerNoOptions: [],
      quoteCustomerZipOptions: [],
      quoteCustomerPhoneOptions: [],
      quoteWarehouseOptions: [],
      quoteShippingOptions: [],

      davisPOVisibility: false,
      driverListModalVisibility: false,
      isaEditModalVisibility: false,
      ctnEditModalVisibility: false,

      limit: isABC ? 25 : isOLG ? 50 : (isKM || isABBLE || isAGD || isSV) ? 100 : (isAP) ? 10 : isSH ? 100 : 30,
      limitDisplay: isABC ? '25' : (isOCM || isVAK || isSW) ? '30' : isOLG ? '50' : (isKM || isABBLE || isAGD || isSV) ? 100 : (isAP) ? 10 : isSH ? 100 : 'all',
      currentPage: 0,
      searchFilter: {
        SONum: '',
        CompanyName: '',
        FBACode: '',
        CustomerBOLNo: '',
        IsaNo: '',
        ContainerNo: '',
        ShippingStatus: '',
      },
      sort: '',
      pridePrintVisibility: false,
      assigningInboundDriver: false,
      assigningOutboundDriver: false,
      PODIframeLoaded: false,
      selectedPODFile: '',
      abcDatePickerShow: true,
      isLocationChangeModalVisible: false,
      USPrideCreateOpen: false,
      USPridePlatform: "",
      USPrideCustomer: "",
      USPrideCreateLoading: false,
      PickerOpen: false,
      SelectedPicker: null,
      isInboundDateChangeModalVisibile: false,
      Type: null,
      emailContentModalVisibility: false,
      emailSubjectTemplate: '',
      emailContentTemplate: '',
      isTeapplixResyncModalVisibile: false,
      isStuffResyncModalVisibile: false,
      resyncType: null,
      isMissingSKUsModalVisible: false,
      isMonitorNoteModalVisible: false,
      monitorRow: null,
      isCancelMonitorModalVisible: false,
      isMonitorListModalVisible: false,
      isOrderImageModalVisible: false,
      showShippingOpen: false,
      duplicateSOLoading: false,
      isShipingRateVisible: false,
      setOrderLoading: false,
      createExcelLoading: false,
      importUploadLoading: false,
      isMergeSo: true,
      currentSalesOrder: null,
      managePodOpen: false,
      podImageRows: {
        rows: [],
        selectedRows: [],
      },
      autoPrintModalVisibility: false,
      isTrackingNumSyncing: false,
      isPickingLoading: false,
      storeModalVisibility: false,
      mesModalVisibility: false,
      mobileAccounts:[],
      mobileAccountsTree: [],
      checkedKeys: [],
      checkedChildKeys: [],
      expandedNodes: [],
      isDropshipOpen: false,
      salesOrderIds:'',
    };

    this.handleResize = this.handleResize.bind(this);
    this.printForm = this.printForm.bind(this);
    this.loadsPost = this.loadsPost.bind(this);
    this.fetchSalesOrdersByDetails = this.fetchSalesOrdersByDetails.bind(this);
    this.fetchSalesOrdersByDispatch = this.fetchSalesOrdersByDispatch.bind(
      this
    );
    this.checkAuthorize = this.checkAuthorize.bind(this);
    this.openCheckAuthorize = this.openCheckAuthorize.bind(this);
    this.closeCheckAuthorize = this.closeCheckAuthorize.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.renderDriverImage = this.renderDriverImage.bind(this);
    this.closeConfirmQuote = this.closeConfirmQuote.bind(this);
    this.openConfirmQuote = this.openConfirmQuote.bind(this);

    this.openGenerateBOLModal = this.openGenerateBOLModal.bind(this);
    this.closeGenerateBOLModal = this.closeGenerateBOLModal.bind(this);

    this.openDSQPrint = this.openDSQPrint.bind(this);
    this.closeDSQPrint = this.closeDSQPrint.bind(this);

    this.openWIZPOD = this.openWIZPOD.bind(this);
    this.closeWIZPOD = this.closeWIZPOD.bind(this);
    this.onMinOrMax = this.onMinOrMax.bind(this);
  }

  componentDidMount() {
    let {warehouseOptions} = this.state;
    if (isUSPrideMulti) {
      // warehouseOptions.push({label: "All", value: 999});
      axios
      .get(
        `${ROOT_URL}v1/warehouse/`,
        {headers: {Authorization: `Bearer ${localStorage.getItem("token")}`,},},
      )
      .then(
        (res) => {
          res.data.map(r=>{
            warehouseOptions.push({label: r.Name, value: r.Warehouse_id});
          });
          this.setState({warehouseOptions});
        },
        (err) => {
          if (err.data) {
            alert(err.data);
          } else {
            alert("Server issue detected, please contact admin.");
          }
        }
      );
      // this.props.setValue("salesOrders", "Warehouse_id", 999);
    }

    window.addEventListener("resize", this.handleResize);
    document.title = companyCodeTitle;
    if (isABC) {
      // this.grid.onToggleFilter()
    }
    if (isOCM || isKM || isABBLE || isAGD || isSV) {
      this.state.currentPage = this.props.currentPage;
    }
    const salesOrdersFilter = this.props.salesOrdersFilter;
    const route = this.context.router.routes[1].path;

    if (salesOrdersFilter && route === salesOrdersFilter.currentPage) {
      const selectedRows = salesOrdersFilter.currentRows.filter((r, idx) => {
        if (r.isSelected === true) {
          this.setState({
            scrollTopPositionIndex: idx,
          });
        }
        return r.isSelected === true;
      });
      const salesOrders = {
        ...this.state.salesOrders,
        rows: salesOrdersFilter.currentRows,
        selectedRows,
        // filters: {},
      };
      this.setState({
        salesOrders,
        Status: salesOrdersFilter.Status,
        FromDate: salesOrdersFilter.FromDate,
        ToDate: salesOrdersFilter.ToDate,
        days: salesOrdersFilter.Days,
      });
      this.props.setValue("salesOrders", "Seller", salesOrdersFilter.Seller);
      this.props.setValue("salesOrders", "ProductNum", salesOrdersFilter.ProductNum);
      const todayDate = new Date();
      let fromDate = moment(todayDate).format("YYYY-MM-DD");
      if (salesOrdersFilter.FromDate) {
        fromDate = this.formatDate(salesOrdersFilter.FromDate);
      }
      let toDate = moment(todayDate).format("YYYY-MM-DD");
      if (salesOrdersFilter.ToDate) {
        toDate = this.formatDate(salesOrdersFilter.ToDate);
      }
      let seller = salesOrdersFilter.Seller;
      if (salesOrdersFilter.Seller) {
        seller = salesOrdersFilter.Seller.value;
      }

      let filterParams = "";
      if (isOCM || isKM || isABBLE || isAGD || isSV) {
        const filterPaires = [];
        _.forOwn(this.state.salesOrders.filters, (value, key) => {
          filterPaires.push([key, value.filterTerm].join('='))
        });
        filterParams = filterPaires.join('&');

        // this when back from edit, keep the props sorting
        if (['ASC', 'DESC'].includes(this.props.salesOrdersFilter.sortDirection)) {
          const key = getKeysMap(this.props.salesOrdersFilter.sortColumn, SALES_ORDER_SORT_KEY_OBJ);
          const sort = getSortVal(key,this.props.salesOrdersFilter.sortDirection === "DESC");
          // this.setState({currentPage: 0, sort});
          this.setState({ sort });
          filterParams += `&sort=${sort}`;
        } else {
          this.setState({sort: ''});
        }
      }

      this.props.fetchSalesOrdersByFilter(
        fromDate,
        toDate,
        salesOrdersFilter.Days,
        salesOrdersFilter.Status,
        seller,
        salesOrdersFilter.ProductNum,
        route,
        null,
        null,
        this.state.dispatchDays,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        filterParams,
      );
      this.props.fetchBaseUsers(false,true);
      this.props.fetchBolAddress();
    } else {
      const fromDate = moment().format('YYYY-MM-DD');
      const toDate = moment().format('YYYY-MM-DD');
      let days = "1";
      let status = "all";
      if (isRivera) {
        status = "open";
      }
      if (isUSPrideMulti) {
        status = "open";
        days = "2";
      }

      if (isCPG || isVIP) {
        status = "open";
        days = "1";
      }
      if (isCPG) {
        days = "7";
      }
      if (isSH) {
        status = 'open';
        days = "7";
      }
      if (isSDR) {
        days = "30";
      }
      
      if (route === "mobileSalesOrders") {
        if (isMyuMyu || isAFG || isWecom || isJML || isSKH ) {
          days = "1";
        } else if (isABC) {
          status = 'all';
        } else {
          status = "open";
        }
      }

      // for lap and ggi
      if ((isLAP || isUSPrideMulti || isAPD) || isGGI) {
        let days = "1";
      }

      this.props.setDefaultDays("salesOrders");
      this.setState({ Status: status, days }, () =>
        this.props.fetchSalesOrdersByFilter(
          fromDate,
          toDate,
          days,
          status,
          null,
          null,
          route,
          null,
          null,
          this.state.dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
        ),
      );
      this.props.fetchBaseUsers(false,true);
      this.props.fetchBolAddress();
    }
    if (salesOrdersFilter && route !== salesOrdersFilter.currentPage) {
      // what situation will go here?
      this.props.setSalesOrdersFilter(null);
    }
    this.handleBreadCrumbTitle();
    if (isLMH) {
      this.props.fetchCustomers(() => {}, this.props.selectedCompany && this.props.selectedCompany.value);
    } else {
      this.props.fetchCustomers();
    }
    this.props.fetchWarehouses();
    if(isVAK) {
      this.handleFetchMobileAccount();
      if ((this.props.selectedCompany || {value: ''}).value == 6) {
        this.handleFetchMobileAccountTreeData();
      }
    }
  }

  componentWillUnmount() {
    if (this.state.clear) {
      this.props.setSalesOrdersFilter(null);
    }
    window.removeEventListener("resize", this.handleResize);
  }

  // Once products are ready, reset state.
  componentWillReceiveProps(nextProps) {
    if (this.props.salesShippingCustomerDetails !== nextProps.salesShippingCustomerDetails && nextProps.salesShippingCustomerDetails) {
      const quoteShippingOptions = [];
      nextProps.salesShippingCustomerDetails.Shipping.forEach(shipping => {
        quoteShippingOptions.push({
          label: [shipping.Street, shipping.City, shipping.State].join(', '),
          value: shipping.CustomerDetail_id,
        })
      })
      this.setState({ quoteShippingOptions });
    }
    if (this.props.selectedWarehouse !== nextProps.selectedWarehouse && nextProps.selectedWarehouse.value) {
      this.props.fetchBaseUsers(false,true);
      if (isLMH) {
        this.props.fetchCustomers(() => {}, this.props.selectedCompany && this.props.selectedCompany.value);
      } else {
        this.props.fetchCustomers();
      }
      this.refreshSOList();
    }
    const route = this.context.router.routes[1].path;
    if (
      nextProps.checkPasswordSuccess &&
      nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess
    ) {
      this.closeCheckAuthorize();
      if (this.state.action === "void") {
        if (isAFG) {
          this.openVoidNote();
        } else {
          this.voidOrder();
        }
      }

      if (this.state.action === "cancelLabel") {
        if (isABBLE || isUSPrideMulti) {
          const { salesOrders } = this.state;
          const salesOrderIds = [];
          if (salesOrders && salesOrders.selectedRows.length > 0) {
            salesOrders.selectedRows.map((row) => {
              salesOrderIds.push(row.SalesOrder_id);
            });
          }
          const salesOrderIdsString = salesOrderIds.join(',');
          const successDelete = () => {
            alert('Success on delete teapplix label');
            if (isABBLE) return;
            this.refreshSOList();
          }
          this.props.deleteTeapplixShipping(salesOrderIdsString, successDelete);
        }
      }
    }
    if (
      nextProps.salesOrders &&
      nextProps.salesOrders !== this.props.salesOrders
    ) {
      // Split Weight
      if (
        this.state.salesOrders &&
        this.state.salesOrders.selectedRows &&
        this.state.salesOrders.selectedRows.length === 1
        && nextProps.salesOrders && nextProps.salesOrders.Orders
      ) {
        nextProps.salesOrders.Orders.map((orders) => {
          if (orders.SONum === this.state.salesOrders.selectedRows[0].SONum) {
            if((isVAK || isGFD) && this.state.onlyRefreshCurrentItem) {
              this.state.salesOrders.selectedRows[0] = {...orders};
              orders.isSelected = true;
            } else if(isAP) {
              this.state.salesOrders.selectedRows[0] = {...orders};
              orders.isSelected = true;
            } else {
              this.state.salesOrders.selectedRows[0].FinalShippingWeight =
              orders.FinalShippingWeight;
            }
          }
        });
      }
      this.setState({
        total: nextProps.salesOrders.Total,
        totalOrders: nextProps.salesOrders.Rows
      });
      if (isVAK) {
        this.setState({
          totalNetWeight: nextProps.salesOrders.TotalWT,
        });
      }
      if (
        this.props.salesOrdersFilter &&
        this.props.salesOrdersFilter.currentRows &&
        this.context.router.routes[1].path ===
          this.props.salesOrdersFilter.currentPage
      ) {
        const salesOrders = nextProps.salesOrders.Orders;
        // let rows = [...this.state.salesOrders.rows];
        // rows = rows.map((r) => {
        //   const index = _.findIndex(salesOrders, { SalesOrder_id: r.SalesOrder_id });
        //   if (index > -1) {
        //     r.OrderDate = salesOrders[index].OrderDate;
        //     r.DispatchDate = salesOrders[index].DispatchDate;
        //     r.SaleStatus = salesOrders[index].SaleStatus;
        //   } else {
        //     r = null;
        //   }
        //   return r;
        // });
        // rows = rows.filter(r => r !== null);
        let rows = salesOrders.map((order) => {
          if (
            order.InvoiceNum ===
              this.state.salesOrders.selectedRows[0].InvoiceNum &&
            order.SONum === this.state.salesOrders.selectedRows[0].SONum
          ) {
            return {
              ...order,
              isSelected: true,
            };
          } else {
            return {
              ...order,
              isSelected: false,
            };
          }
        });
        const newSalesOrders = {
          ...this.state.salesOrders,
          rows,
          selectedRows: this.state.salesOrders.selectedRows || [],
          sortColumn: this.props.salesOrdersFilter.sortColumn || null,
          sortDirection: this.props.salesOrdersFilter.sortDirection|| null,
        };
        if (this.props.salesOrderDetail) {
          var salesOrderDetail = {
            ...this.state.salesOrderDetail,
            rows: this.props.salesOrderDetail.Sales_Order_Lines,
          };
          this.setState({ salesOrderDetail });
        }
        this.setState({ salesOrders: newSalesOrders });
        if (!isKM) {
          this.props.setSalesOrdersFilter(null);
        }
      } else {
        let selectedRow = this.state.onlyRefreshCurrentItem
        && (isVAK || isGFD) ? [...this.state.salesOrders.selectedRows] : []

        const salesOrders = {
          ...this.state.salesOrders,
          rows: nextProps.salesOrders.Orders,
          // filters: {},
          selectedRows: selectedRow,
        };
        _.forEach(salesOrders.selectedRows, selectedRow => {
          salesOrders.rows = _.map(salesOrders.rows, row => {
            if(row.SalesOrder_id === selectedRow.SalesOrder_id) {
              return {
                ...row,
                isSelected: true
              }
            }
            return row;
          })
        })
        let topIds = [];
        if(isVAK && this.state.topIds.length > 0) {
          topIds = [...this.state.topIds];
          let topRows = [];
          let bottomRows = [];
          salesOrders.rows.map(row => {
            if(this.state.topIds.findIndex(id => id == row.SalesOrder_id) != -1) {
              topRows.push({...row, isSelected: true});
            } else {
              bottomRows.push({...row})
            }
          });
          if(topRows.length > 0) {
            topIds =[];
            salesOrders.rows = [...topRows, ...bottomRows];
            salesOrders.selectedRows = [...topRows];
          }
        }
        // for (var i = 0; i < salesOrders.rows.length; i++) {
        //   if (
        //     salesOrders.selectedRows[0] &&
        //     salesOrders.rows[i].InvoiceNum ===
        //       salesOrders.selectedRows[0].InvoiceNum &&
        //     salesOrders.rows[i].SONum === salesOrders.selectedRows[0].SONum
        //   ) {
        //     salesOrders.rows[i].isSelected = true;
        //   }
        // }
        var salesOrderDetail = { ...this.state.salesOrderDetail, rows: [] };
        this.setState({ salesOrders, salesOrderDetail, topIds });
        this.props.setSalesOrdersFilter(null);
      }
      this.state.onlyRefreshCurrentItem = false;
      if (this.state.scrollTopPositionIndex !== null) {
        var top = 25 * this.state.scrollTopPositionIndex;
        if (this.grid) {
          var gridCanvas = this.grid
            .getDataGridDOMNode()
            .querySelector(".react-grid-Canvas");
          gridCanvas.scrollTop = top;
        }
      }
    }

    if (
      nextProps.salesOrderDetail &&
      nextProps.salesOrderDetail !== this.props.salesOrderDetail
    ) {
      var salesOrderDetail = {
        ...this.state.salesOrderDetail,
        rows: nextProps.salesOrderDetail.Sales_Order_Lines,
      };

      this.state.mag1 = {};
      let mag1TempSplit = [];
      if (isMAG && nextProps.salesOrderDetail.mag_note) {

        mag1TempSplit = nextProps.salesOrderDetail.mag_note.split(',');
        mag1TempSplit.map(r=>{
          if (r === 'DRYRUN') {this.state.mag1.DRYRUN = true;}
          if (r === 'OFFHIRE') {this.state.mag1.OFFHIRE = true;}
          if (r === 'EXTRA_STOP') {this.state.mag1.EXTRA_STOP = true;}
          if (r === 'EXAM') {this.state.mag1.EXAM = true;}
          if (r === 'EXTRA_DELIVERY') {this.state.mag1.EXTRA_DELIVERY = true;}
          if (r === 'STORAGE') {this.state.mag1.STORAGE = true;}
          if (r === 'BOBTAIL_FEE') {this.state.mag1.BOBTAIL_FEE = true;}
         });
      }

      this.state.mag2 = {};
      let mag2TempSplit = [];
      if (isMAG && nextProps.salesOrderDetail.DeliveryStatus) {
        mag2TempSplit = nextProps.salesOrderDetail.DeliveryStatus.split(',');
        mag2TempSplit.map(r=>{
          if (r === 'FREIGHT_HOLD') {this.state.mag2.FREIGHT_HOLD = true;}
          if (r === 'CUSTOM_HOLD') {this.state.mag2.CUSTOM_HOLD = true;}
          if (r === 'PIERPASS_HOLD') {this.state.mag2.PIERPASS_HOLD = true;}
          if (r === 'EXAM') {this.state.mag2.EXAM = true;}
          if (r === 'CLOSED_AREA') {this.state.mag2.CLOSED_AREA = true;}
         });
      }

      this.setState({ magSalesOrderDetail: {} });
      this.setState({ salesOrderDetail, magSalesOrderDetail: nextProps.salesOrderDetail });
    }

    if (nextProps.Seller && nextProps.Seller !== this.props.Seller) {
      const salesOrdersFilter = this.props.salesOrdersFilter;
      if (!salesOrdersFilter) {
        let seller = nextProps.Seller;
        if (nextProps.Seller) {
          seller = nextProps.Seller.value;
        }
        const fromDate = this.state.FromDate
          ? this.formatDate(this.state.FromDate)
          : moment().format('YYYY-MM-DD');
        const toDate = this.state.ToDate
          ? this.formatDate(this.state.ToDate)
          : moment().format('YYYY-MM-DD');
        const days = this.state.days;

        // if (fromDate == null) {
        //   fromDate = '1900-01-01';
        // }
        // if (toDate == null) {
        //   toDate = '3000-01-01';
        // }

        let filterParams = "";
        if (isOCM || isKM || isABBLE || isAGD || isSV || isVAK) {
          const filterPaires = [];
          _.forOwn(this.state.salesOrders.filters, (value, key) => {
            filterPaires.push([key, value.filterTerm].join('='))
          });
          filterParams = filterPaires.join('&');
        }
        const productNum = this.state.filterProductID;
        this.props.fetchSalesOrdersByFilter(
          fromDate,
          toDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          null,
          null,
          this.state.dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterParams,
        );
      }
    }
    const isEzgo = (this.props.selectedCompany || {value: ''}).value == 6;
    if (isVAK && nextProps.store_name !== this.props.store_name) {
      const salesOrdersFilter = this.props.salesOrdersFilter;
      if (!salesOrdersFilter) {
        let storeName = '';
        if(nextProps.store_name) {
          storeName = nextProps.store_name.label;
          if (isEzgo) {
            this.setState({
              checkedKeys: [],
              checkedChildKeys: [],
              expandedNodes: []
            })
          }
        }
        const fromDate = this.state.FromDate
          ? this.formatDate(this.state.FromDate)
          : moment().format('YYYY-MM-DD');
        const toDate = this.state.ToDate
          ? this.formatDate(this.state.ToDate)
          : moment().format('YYYY-MM-DD');
        const days = this.state.days;
        let filterParams = "";
          const filterPaires = [];
          if(this.state.pullSheetSort) {
            filterPaires.push(['order_by', this.state.pullSheetSort].join('='))
          }
          _.forOwn(this.state.salesOrders.filters, (value, key) => {
            filterPaires.push([key, value.filterTerm].join('='))
          });
          if(storeName && storeName != 'All') {
            filterPaires.push(['store_name', storeName].join('='))
          }
          if(isEzgo && !nextProps.store_name && this.state.checkedKeys && this.state.checkedKeys.length) {
            filterPaires.push(['group_ids', this.state.checkedKeys.join(',')].join('='))
          }
          if(isEzgo && !nextProps.store_name && this.state.checkedChildKeys && this.state.checkedChildKeys.length) {
            filterPaires.push(['store_ids', this.state.checkedChildKeys.join(',')].join('='))
          }
          filterParams = filterPaires.join('&');
        this.props.fetchSalesOrdersByFilter(
          fromDate,
          toDate,
          days,
          this.state.Status,
          '',
          null,
          route,
          null,
          null,
          this.state.dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterParams,
        );
      }
    }

    if (nextProps.Picker) {
      this.setState({SelectedPicker: nextProps.Picker});
    }

    if (this.props.Seller && nextProps.Seller == null) {
      const seller = nextProps.Seller;
      const fromDate = this.state.FromDate
        ? this.formatDate(this.state.FromDate)
        : moment().format('YYYY-MM-DD');
      const toDate = this.state.ToDate
        ? this.formatDate(this.state.ToDate)
        : moment().format('YYYY-MM-DD');
      const days = this.state.days;

      // if (fromDate == null) {
      //   fromDate = '1900-01-01';
      // }
      // if (toDate == null) {
      //   toDate = '3000-01-01';
      // }

      let filterParams = "";
      if (isOCM || isKM || isABBLE || isAGD || isSV) {
        const filterPaires = [];
        _.forOwn(this.state.salesOrders.filters, (value, key) => {
          filterPaires.push([key, value.filterTerm].join('='))
        });
        filterParams = filterPaires.join('&');
      }
      const productNum = this.state.filterProductID;
      this.props.fetchSalesOrdersByFilter(
        fromDate,
        toDate,
        this.state.days,
        this.state.Status,
        seller,
        productNum,
        route,
        null,
        null,
        this.state.dispatchDays,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        filterParams
      );
    }

    if (
      nextProps.shippingListPDF &&
      nextProps.shippingListPDF !== this.props.shippingListPDF
    ) {
      this.setState({ shippingPdfFrameLoaded: false });
    }

    if (
      nextProps.pickingListPDF &&
      nextProps.pickingListPDF !== this.props.pickingListPDF
    ) {
      this.setState({ pickingListPdfFrameLoaded: false });
    }

    if (
      nextProps.packingListPDF &&
      nextProps.packingListPDF !== this.props.packingListPDF
    ) {
      this.setState({ packingListPdfFrameLoaded: false });
    }

    if (
      nextProps.salesOrderPDF &&
      nextProps.salesOrderPDF !== this.props.salesOrderPDF
    ) {
      if ((isLAP || isUSPrideMulti || isAPD) && this.state.salesOrders && this.state.salesOrders.selectedRows && this.state.salesOrders.selectedRows.length > 0) {
        let a = document.createElement("a");
        a.style = "display: none";
        document.body.appendChild(a);
        let url = window.URL.createObjectURL(nextProps.salesOrderPDF);
        a.href = url;
        a.download = this.state.salesOrders.selectedRows[0].SONum;
        a.click();
        window.URL.revokeObjectURL(url);
      } else {
        this.setState({ salesOrderPdfFrameLoaded: false });
      }
    }

    if (nextProps.salesOrderPDF && nextProps.salesOrderPDF !== this.props.salesOrderPDF) {
      if (isUSPrideMulti) {
        this.refreshSOList();
      }
    }

    if (nextProps.bolIdPDF && nextProps.bolIdPDF !== this.props.bolIdPDF) {
      this.setState({ bolIdPdfFrameLoaded: false });
    }
    if (nextProps.bolWithoutLogPDF && nextProps.bolWithoutLogPDF !== this.props.bolWithoutLogPDF) {
      this.setState({ bolWithoutLogPdfFrameLoaded: false });
    }
    if (nextProps.bolLabel && nextProps.bolLabel !== this.props.bolLabel) {
      this.setState({ bolLabelFrameLoaded: false });
    }
    if (nextProps.bolFbaPDF && nextProps.bolFbaPDF !== this.props.bolFbaPDF) {
      this.setState({ bolFbaPdfFrameLoaded: false });
    }
    if (nextProps.currentPage && nextProps.currentPage !== this.props.currentPage) {
      this.setState({ currentPage: nextProps.currentPage });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextState.shippingPdfFrameLoaded !== this.state.shippingPdfFrameLoaded &&
      this.state.shippingPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.pickingListPdfFrameLoaded !==
        this.state.pickingListPdfFrameLoaded &&
      this.state.pickingListPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.packingListPdfFrameLoaded !==
        this.state.packingListPdfFrameLoaded &&
      this.state.packingListPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.salesOrderPdfFrameLoaded !==
        this.state.salesOrderPdfFrameLoaded &&
      this.state.salesOrderPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.bolIdPdfFrameLoaded !== this.state.bolIdPdfFrameLoaded &&
      this.state.bolIdPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.bolWithoutLogPdfFrameLoaded !== this.state.bolWithoutLogPdfFrameLoaded &&
      this.state.bolWithoutLogPdfFrameLoaded === false
    ) {
      return false;
    }
    if (
      nextState.bolLabelFrameLoaded !== this.state.bolLabelFrameLoaded &&
      this.state.bolLabelFrameLoaded === false
    ) {
      return false;
    }

    if (
      nextState.bolFbaPdfFrameLoaded !== this.state.bolFbaPdfFrameLoaded &&
      this.state.bolFbaPdfFrameLoaded === false
    ) {
      return false;
    }

    return true;
  }

  handleSumTotal = (rows) => {
    if(!rows) {
      return
    }
    let canceledTotal = 0;
    let totalNetWeight = 0;
    let totalCancelledNetWeight = 0;
    let totalQty = 0;
    let totalCancelledQty = 0;
    let total = 0;
    let canceledOrders = [];
    if (rows && rows.length !== 0) {
      rows.map((row) => {
        totalNetWeight += row.FinalNetWeight;
        total += row.FinalPrice;
        totalQty += row.Total_Net_Qty;
        if(row.SaleStatus == 'Canceled') {
          totalCancelledNetWeight += row.FinalNetWeight
          canceledTotal += row.FinalPrice;
          totalCancelledQty += row.Total_Net_Qty;
          canceledOrders.push(row);
        }
      });
    }
    this.setState({
      rowsCount: rows.length || 0,
      canceledOrders: canceledOrders.length,
      total,
      canceledTotal,
      totalNetWeight,
      totalQty,
      totalCancelledQty,
      totalCancelledNetWeight, });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.salesOrders !== this.state.salesOrders) {
      if(isGGI) {
        this.handleSumTotal(Data.Selectors.getRows(this.state.salesOrders));
      } else {
        let canceledTotal = 0;
        let totalNetWeight = 0;
        let totalCancelledNetWeight = 0;
        let totalQty = 0;
        let totalCancelledQty = 0;
        const canceledOrders = (this.state.salesOrders.rows || []).filter((row) => {
          const match = row.SaleStatus === "Canceled";
          totalNetWeight += row.FinalNetWeight;
          totalQty += row.Total_Net_Qty;
          if (match) {
            canceledTotal += row.FinalPrice;
            totalCancelledNetWeight += row.FinalNetWeight;
            totalCancelledQty += row.Total_Net_Qty;
          }
          return match;
        });
        if (isVAK && this.state.salesOrders.selectedRows.length === 0) {
          totalNetWeight = this.props.salesOrders.TotalWT
        }

        this.setState({
          rowsCount: (this.props.totalRows && (isOCM || isKM || isABBLE || isAGD || isSV)) ? this.props.totalRows : Data.Selectors.getRows(this.state.salesOrders).length,
          canceledOrders: canceledOrders.length,
          canceledTotal,
          totalNetWeight,
          totalQty,
          totalCancelledQty,
          totalCancelledNetWeight,
        });
      }
    }
    if (this.state.salesOrders.selectedRows.length && (this.state.salesOrders.selectedRows !== prevState.salesOrders.selectedRows)) {
      let canceledTotal = 0;
      let total = 0;
      let totalNetWeight = 0;
      let totalCancelledNetWeight = 0;
      let totalQty = 0;
      let totalCancelledQty = 0;
      const canceledOrders = this.state.salesOrders.selectedRows.filter((row) => {
        const match = row.SaleStatus === "Canceled";
        if (match) {
          canceledTotal += row.FinalPrice;
          totalCancelledNetWeight += row.FinalNetWeight;
          totalCancelledQty += row.Total_Net_Qty;
        }
        return match;
      });
      const rows = this.state.salesOrders.selectedRows;
      if (rows.length === 1) {
        this.props.fetchSalesOrderDetail(rows[0].SalesOrder_id, this.context.router.routes[1].path, this.state.Status);
      }
      _.forEach(this.state.salesOrders.selectedRows, row => {
        total += row.FinalPrice;
        totalQty += row.Total_Net_Qty;
        totalNetWeight += row.FinalNetWeight;
      })
      if (isVAK && this.state.salesOrders.selectedRows.length === 0) {
        totalNetWeight = this.props.salesOrders.TotalWT
      }
      this.setState({
        // rowsCount: Data.Selectors.getRows(this.state.salesOrders).length,
        canceledOrders: canceledOrders.length,
        canceledTotal,
        total,
        totalNetWeight,
        totalCancelledNetWeight,
        totalQty,
        totalCancelledQty
      });
    }
    if ((this.state.salesOrders.selectedRows.length === 0) && (prevState.salesOrders.selectedRows.length !== 0)) {
      let canceledTotal = 0;
      let total = 0;
      let totalNetWeight = 0;
      let totalCancelledNetWeight = 0;
      let totalQty = 0;
      let totalCancelledQty = 0;
      const canceledOrders = this.state.salesOrders.rows.filter((row) => {
        const match = row.SaleStatus === "Canceled";
        if (match) {
          totalCancelledNetWeight += row.FinalNetWeight
          canceledTotal += row.FinalPrice;
          totalCancelledQty += row.Total_Net_Qty;
        }
        return match;
      });
      _.forEach(this.state.salesOrders.rows, row => {
        total += row.FinalPrice;
        totalQty += row.Total_Net_Qty;
        totalNetWeight += row.FinalNetWeight
      })
      if(isVAK && this.state.salesOrders.selectedRows.length === 0){
        totalNetWeight = this.props.salesOrders.TotalWT
      }
      this.setState({
        // rowsCount: Data.Selectors.getRows(this.state.salesOrders).length,
        canceledOrders: canceledOrders.length,
        canceledTotal,
        total,
        totalNetWeight,
        totalCancelledNetWeight,
        totalQty,
        totalCancelledQty
      });
    }
    if (prevState.currentPage !== prevProps.currentPage) {
      this.props.setSalesOrdersPaginationFilter({currentPage: prevState.currentPage})
    }
  }


  setMultiplePackagelVisibility = (multiplePackageVisibility = false) =>
    this.setState({ multiplePackageVisibility });

  setDriverListModalVisibility = (driverListModalVisibility = false) =>
    this.setState({ driverListModalVisibility });
  handleAssignSOToDriverSuccess = () => {
    this.setDriverListModalVisibility();
    this.fetchSalesOrdersByDetails(this.state.days);
  };
  setISAEditModalVisibility = (isaEditModalVisibility = false) => this.setState({ isaEditModalVisibility });
  setCTNEditModalVisibility = (ctnEditModalVisibility = false) => this.setState({ ctnEditModalVisibility });

  handleISANoUpdateSuccess = () => {
    this.setISAEditModalVisibility();
    this.fetchSalesOrdersByDetails(this.state.days);
  }

  handleFetchMobileAccount = () => {
    axios.get(
      MOBILE_ACCOUNT_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then(res => {
      if(res.data) {
        let mobileAccounts = [{value: 1, label: 'All'}];
        res.data.map((item, index) => { mobileAccounts.push({value: index + 2, label:item.system_name})});
        this.setState({mobileAccounts})
      }
    })
  }
  handleFetchMobileAccountTreeData = () => {
    axios.get(
      MOBILE_ACCOUNT_TREE_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then(res => {
      if(res.status === 200 && res.data) {
        this.setState({
          mobileAccountsTree: res.data
        })
      }
    })
  }

  openPridePrint = () => {
    this.setState({ pridePrintVisibility: true });
  }
  closePridePrint = () => {
    this.setState({ pridePrintVisibility: false });
  }
  onConfirmPridePrint = () => {
    const {
      selectedRows,
    } = this.state.salesOrders;

    const salesOrder_id = [];
    selectedRows.forEach(({ SalesOrder_id }) => {
      salesOrder_id.push(SalesOrder_id);
    });
    this.props.printSalesOrderLabelUSPride({ salesOrder_id });
    this.closePridePrint();
  }

  handleCTNNoUpdateSuccess = () => {
    this.setCTNEditModalVisibility();
    this.fetchSalesOrdersByDetails(this.state.days);
  }
  openDavisPO = () => {
    this.setState({ davisPOVisibility: true });
  };
  closeDavisPO = () => {
    this.setState({ davisPOVisibility: false });
  };
  onConfirmDavisPO() {
    const { salesOrders } = this.state;
    if (
      salesOrders &&
      salesOrders.selectedRows &&
      salesOrders.selectedRows[0]
    ) {
      this.props.setDavisPO(salesOrders.selectedRows[0].SalesOrder_id);
    }
    this.setState({ davisPOVisibility: false });

    // const route = this.context.router.routes[1].path;
    // const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    // const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    // const days = this.state.days;
    // const productNum = this.state.filterProductID;
    // const seller = this.props.Seller;
    // setTimeout(() => {
    //   this.props.fetchSalesOrdersByFilter(fromDate, toDate, days, this.state.Status, seller, productNum, route);
    // }, 1000);
  }

  openChowbusModal = () => {
    this.setState({ chowbusModalVisibility: true });
  };
  closeChowbusModal = () => {
    this.setState({ chowbusModalVisibility: false, chowbusImportFile: null });
  };
  onChangeChowbusImport = (event) => {
    this.setState({ chowbusImportFile: event.target.files[0] });
  };
  onConfirmChowbusImport() {
    if (!this.state.chowbusImportFile) {
      alert("Please select a file to import");
      return;
    }
    const data = new FormData();
    data.append("file", this.state.chowbusImportFile);
    this.props.chowbusImport(data).then(
      (response) => {
        alert("Chowbus Orders Imported");
        this.closeChowbusModal();
      },
      (err) => {
        alert("Import Error:" + err.data);
      },
    );
  }

  openVoidNote = () => {
    this.setState({ voidNoteModalVisibility: true });
  };
  closeVoidNote = () => {
    this.setState({
      voidNoteModalVisibility: false,
      voidReason: "",
      voidNote: "",
    });
  };
  onVoidReasonChange = (e) => {
    this.setState({ voidReason: e.value });
  };
  onVoidNoteChange = (e) => {
    this.state.voidNote = e.target.value;
  };
  onConfirmVoidNote() {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    let voidString = "";
    if (this.state.voidReason) {
      voidString = this.state.voidReason + ": ";
    }
    voidString += this.state.voidNote;
    this.props.updateVoidNote(salesOrder_id, voidString);
    setTimeout(() => {
      this.voidOrder();
    }, 1000);
    this.closeVoidNote();
  }

  closePrintTrackingConfirm = () => {
    this.setState({ printTrackingConfirmOpen: false });
  };
  openPrintTrackingConfirm = () => {
    this.setState({ printTrackingConfirmOpen: true });
  };
  printTrackingConfirm = () => {
    const { trackingNumberSelected } = this.state;
    this.props.printSalesOrderLabelBatch(trackingNumberSelected);
    this.setState({ printTrackingConfirmOpen: false });
  };

  // abcff tracking for outbound, kimi for MSO
  openTrackingForm() {
    this.setState({
      trackingFormOpen: true,
      trackingformNum: null,
      trackingformCarrier: null,
      trackingformMethod: null,
    });
  }
  closeTrackingForm() {
    this.setState({ trackingFormOpen: false });
  }
  onChangeFormNum = (e) => {
    this.setState({ trackingformNum: e.target.value });
  };
  onChangeFormCarrier = (e) => {
    if (isKM) {
      this.setState({ trackingformCarrier: e.value });
    } else {
      this.setState({ trackingformCarrier: e.target.value });
    }
  };
  onChangeFormMethod = (e) => {
    if (isKM) {
      this.setState({ trackingformMethod: e.value });
    } else {
      this.setState({ trackingformMethod: e.target.value });
    }
  };
  confirmTrackingForm = () => {
    const singleSalesOrderId =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;

    const data = {
      tracking: this.state.trackingformNum,
      carrier: this.state.trackingformCarrier,
      ship_method: this.state.trackingformMethod,
    };

    let url = `${ROOT_URL}v2/shipping/add_tracking_num/${singleSalesOrderId}`;
    if (isKM) {
      url = `${ROOT_URL}v2/shipping/upload_tracking_teapplix/${singleSalesOrderId}`;
    }

    axios.post(
      url,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Tracking Info Added");
      this.fetchSalesOrdersByDetails(this.state.days);
      this.closeTrackingForm();
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });
  };


  openDisplayTracking() {
    this.setState({ displayTrackingOpen: true });
  }
  closeDisplayTracking() {
    this.setState({ displayTrackingOpen: false });
  }
  openSplitSo() {
    this.setState({ splitSoVisible: true });
  }
  closeSplitSo(isRefresh = false) {
    this.setState({ splitSoVisible: false }, () => {
      if(isRefresh) {
        this.refreshSOList();
        this.setState({
          salesOrders: {...this.state.salesOrders, selectedRows:[]}
        })
      }
    });
  }

  openChangeWeight() {
    this.setState({
      changeWeightOpen: true,
      finalShippingWeight: this.state.salesOrders.selectedRows[0]
        .FinalShippingWeight,
    });
  }

  openbolListModal() {
    this.setState({ bolListModalVisibility: true });
  }
  closebolListModal() {
    this.setState({ bolListModalVisibility: false });
  }

  openDSQPrint() {
    this.setState({ dsqPrintVisibility: true });
  }
  closeDSQPrint() {
    this.setState({ dsqPrintVisibility: false });
  }

  openWIZPOD() {
    this.setState({ wizPODVisibility: true });
  }
  closeWIZPOD() {
    this.setState({ wizPODVisibility: false });
  }

  openGenerateBOLModal() {
    this.setState({ generateBOLModalVisibility: true });
  }
  closeGenerateBOLModal() {
    this.setState({ generateBOLModalVisibility: false });
  }

  openChangePaymentMethodModal() {
    this.setState({
      paymentMethodModalVisibility: true,
    });
  }
  closePaymentMethodModal() {
    this.setState({
      paymentMethodModalVisibility: false,
    });
  }

  openChangeShipMethodModal() {
    this.setState({ shipMethodModalVisibility: true });
  }
  closeChangeShipMethodModal() {
    this.setState({ shipMethodModalVisibility: false });
  }
  handleSOShipMethodSaved = () => {
    this.closeChangeShipMethodModal();
    this.refreshSOList();
  };

  // change ship qty
  openChangeShipQtyModal(id) {
    this.setState({ changeShipQtyId: id, shipQtyModalVisibility: true });
  }
  closeChangeShipQtyModal() {
    this.setState({ changeShipQtyId: null, shipQtyModalVisibility: false });
  }
  handleSOShipQtySaved = () => {
    this.closeChangeShipQtyModal();
    this.refreshSOList();
  };

  // change tracking
  openChangeTrackingModal(id) {
    this.setState({ changeTrackingId: id, editTrackingModalVisibility: true });
  }
  closeChangeTrackingModal() {
    this.setState({ changeTrackingId: null, editTrackingModalVisibility: false });
  }
  handleSOTrackingcSaved = () => {
    this.closeChangeTrackingModal();
    this.refreshSOList();
  };


  openChangeTracking(val, dep) {
    this.setState({ changeTrackingOpen: true, newTrackingNum: val, newTrackingNumID: dep.SalesOrder_id });
  }
  closeChangeTracking() {
    this.setState({ changeTrackingOpen: false });
  }
  onChangeTrackingNum = (e) => {
    this.setState({ newTrackingNum: e.target.value });
  };
  changeTrackingConfirm = () => {
    const { salesOrders } = this.state;
    let data = {delivery_tracking_num: this.state.newTrackingNum};
    if (isUSPrideMulti) {
      data = {Tracking: this.state.newTrackingNum};
    }

    // axios here
    axios.put(
      (CHANGE_TRACKING_URL + this.state.newTrackingNumID),
      // (SALES_ORDERS_URL + this.state.newTrackingNumID),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Tracking Number Changed");
      this.fetchSalesOrdersByDetails(
        this.state.days
      );
      this.setState({ changeTrackingOpen: false });
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });

  };

  handleSOPaymentMethodSaved = (so_id, method) => {
    this.closePaymentMethodModal();
    const salesOrderRows = [...this.state.salesOrders.rows];
    const newRows = salesOrderRows.map((row) => {
      if (row.SalesOrder_id === so_id) {
        return {
          ...row,
          PaymentType: method,
        };
      }
      return row;
    });
    this.setState({
      salesOrders: {
        ...this.state.salesOrders,
        rows: newRows,
      },
    });
    // const route = this.context.router.routes[1].path;
    // const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    // const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    // const days = this.state.days;
    // const productNum = this.state.filterProductID;
    // const seller = this.props.Seller;
    // setTimeout(() => {
    //   this.props.fetchSalesOrdersByFilter(fromDate, toDate, days, this.state.Status, seller, productNum, route);
    // }, 1000);
  };

  closeChangeWeight() {
    this.setState({ changeWeightOpen: false });
  }
  onMinOrMax(showMin) {
    this.setState({showMin})
  }
  onChangeWeightSubmit = (splitArray, isUnfreeze = false) => {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    this.props.updateShippingWeightSplit(salesOrder_id, splitArray, isUnfreeze);
    this.setState({ changeWeightOpen: false, onlyRefreshCurrentItem: isVAK && this.state.salesOrders.rows.length > 1, topIds: [salesOrder_id] });
    this.refreshSOList(() => {}, true);
  };
  onChangeWeightSubmitPrint = (splitArray, onlyPrint = false, isUnfreeze = false) => {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    if (!isVAK && (
      this.state.salesOrders.selectedRows[0].InvoiceNum === "" ||
      !this.state.salesOrders.selectedRows[0].InvoiceNum)
    ) {
      alert("Cannot print without Invoice Number");
      return;
    }
    if(!onlyPrint) {
      this.props.updateShippingWeightSplit(salesOrder_id, splitArray);
    } else {
      this.props.printSalesOrderLabelBatch([salesOrder_id], splitArray, isUnfreeze);
      this.setState({ changeWeightOpen: false });
      return
    }
    this.setState({ changeWeightOpen: false });
    this.refreshSOList(() => {
      const SalesOrder_id = [];
      SalesOrder_id.push(salesOrder_id);
      this.props.printSalesOrderLabelBatch(SalesOrder_id);
    }, true);
  };

  onPackingPrint = (ids) => {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    this.setState({ changeWeightOpen: false });
    const SalesOrder_id = [];
    SalesOrder_id.push(salesOrder_id);
    this.props.printPackingSalesOrder(SalesOrder_id, ids);
  };

  onShippingWeightChange = (e) => {
    this.setState({
      finalShippingWeight: e.target.value,
    });
  };

  openConfirmReship() {
    this.setState({ confirmReshipOpen: true });
  }
  closeConfirmReship() {
    this.setState({ confirmReshipOpen: false });
  }
  onConfirmReship() {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    this.props.reshipOrder(salesOrder_id);
    this.setState({ confirmReshipOpen: false });
  }

  // USPride create with excel modal
  openUSPrideCreate() {
    let { customers } = this.props;
    let {excelCustomerOptions } = this.state;
    if (isABCFF) {
      if (customers) {
        customers.map((r) => {
          excelCustomerOptions.push({ label: r.Name, value: r.Customer_id });
        });
      }
      this.setState({excelCustomerOptions});
    }
    this.setState({USPrideCreateOpen: true });
  }
  closeUSPrideCreate() {
    this.setState({ USPrideCreateOpen: false });
  }
  onUSPridePlatformChange = (e) => {
    this.setState({ USPridePlatform: e.value });
  };
  onUSPrideCustomerChange = (e) => {
    if (e && e.value) {
      this.setState({ USPrideCustomer: e.value });
    } else {
      this.setState({ USPrideCustomer: "" });
    }
  };

  openPicker() {
    this.setState({PickerOpen: true });
  }
  closePicker() {
    this.setState({ PickerOpen: false });
  }
  onPickerChange = (e) => {
    this.setState({ SelectedPicker: e.value });
  };

  openConfirmQuote(invoiceParam) {
    const { salesOrders } = this.state;
    const { customers, warehouses} = this.props;
    let quoteSelectedCustomerId = null;
    let quoteSelectedCustomerName = "";
    let quoteSelectedWarehouseId = null;
    let quoteSelectedCustomerPlaceholder = "";
    let quoteSelectedWarehousePlaceholder = "";
    let quoteSelectedShipping = null;
    let quoteSelectedShippingPH = '';
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        quoteSelectedCustomerId = salesOrder.Deliver_Customer_id;
        if ((isABBLE || isSH || isUSPrideMulti) && !quoteSelectedCustomerId) {
          quoteSelectedCustomerId = salesOrder.Deliver_Customer_id_id;
        }
        quoteSelectedCustomerName = salesOrder.Deliver_CustomerName;
        quoteSelectedCustomerPlaceholder = salesOrder.Deliver_CustomerName;

        // abble Pickup_Warehouse_id_id
        let warehouseFilter = warehouses.filter(w => w.id === salesOrder.Pickup_Warehouse_id_id);
        // kimi Pickup_Warehouse_id
        if (isKM) {
          warehouseFilter = warehouses.filter(w => w.id === salesOrder.Pickup_Warehouse_id);
        }

        if (warehouseFilter.length > 0 ) {
          quoteSelectedWarehouseId = warehouseFilter[0].Pickup_Warehouse_id_id;
          quoteSelectedWarehousePlaceholder = warehouseFilter[0].name;
        }

        quoteSelectedShipping = salesOrder.Deliver_CustomerDetail_id;
        // Deliver_CustomerDetail_id //Deliver_Customer_id //Deliver_CustomerName
      });
    }
    let quoteCustomerOptions = [];
    let quoteWarehouseOptions = [];
    const quoteCustomerNoOptions = [];
    const quoteCustomerZipOptions = [];
    const quoteCustomerPhoneOptions = [];
    if (customers) {
      customers.map((r) => {
        quoteCustomerOptions.push({ label: r.Name, value: r.Customer_id });
        quoteCustomerNoOptions.push({ label: r.CustomerNum, value: r.Customer_id });
        quoteCustomerZipOptions.push({ label: r.Zip, value: r.Customer_id });
        quoteCustomerPhoneOptions.push({ label: r.Telephone, value: r.Customer_id });
      });
    }

    if (warehouses) {
      warehouses.map((r) => {
        quoteWarehouseOptions.push({ label: r.Name, value: r.Warehouse_id });
      });
    }
    this.props.fetchSalesCustomerDetail(quoteSelectedCustomerId, null, true, (response) => {
      _.forEach(response.data.Shipping, shipping => {
        if (shipping.CustomerDetail_id === quoteSelectedShipping) {
          quoteSelectedShippingPH = [shipping.Street, shipping.City, shipping.State, shipping.Zip].join(', ');
        }
      })
      this.setState({
        confirmQuoteOpen: true,
        isInvoice: invoiceParam ? invoiceParam : false,
        quoteSelectedCustomerId,
        quoteSelectedCustomerName,
        quoteCustomerOptions,
        quoteCustomerNoOptions,
        quoteCustomerZipOptions,
        quoteCustomerPhoneOptions,
        quoteWarehouseOptions,
        quoteSelectedCustomerPlaceholder,
        quoteSelectedWarehousePlaceholder,
        quoteSelectedShipping,
        quoteSelectedShippingPH,
      });
      this.props.setValue("salesOrders", "hmmCustomer", "");
      this.props.setValue("salesOrders", "hmmWarehouse", "");
    });
  }
  closeConfirmQuote() {
    this.setState({ confirmQuoteOpen: false });
  }
  onQuoteCustomerChange = (e) => {
    this.props.fetchSalesCustomerDetail(e.value, false, true);
    this.props.setValue('salesOrders', 'customerShipping', '');
    if (e) {
      this.setState({
        quoteSelectedCustomerId: e.value,
        quoteSelectedCustomerName: e.label,
        quoteSelectedShipping: null,
        quoteSelectedShippingPH: ''
      });
    } else {
      this.setState({
        quoteSelectedCustomerId: null,
        quoteSelectedCustomerName: "",
        quoteSelectedShipping: null,
        quoteSelectedShippingPH: ''
      });
    }
  };

  onQuoteWarehouserChange = (e) => {
    if (e) {
      this.setState({
        quoteSelectedWarehouseId: e.value,
      });
    } else {
      this.setState({
        quoteSelectedWarehouseId: null,
      });
    }
  };

  onQuoteShippingChange = (e) => {
    if (e) {
      this.setState({
        quoteSelectedShipping: e.value,
        quoteSelectedShippingPH: e.label,
      });
    } else {
      this.setState({
        quoteSelectedShipping: null,
        quoteSelectedShippingPH: "",
      });
    }
  }
  onConfirmQuote() {
    const { salesOrders, quoteSelectedCustomerId, quoteSelectedWarehouseId, quoteSelectedShipping } = this.state;
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }

    if (isESC) {
      this.props.setQuoteOrderForEsc(salesOrderIds.join(","), quoteSelectedCustomerId, quoteSelectedWarehouseId, quoteSelectedShipping);
    } else {
      this.props.setQuoteOrder(salesOrderIds.join(","), quoteSelectedCustomerId, quoteSelectedWarehouseId, quoteSelectedShipping, this.state.isInvoice);
    }
    this.setState({ confirmQuoteOpen: false, setOrderLoading: false });
    const route = this.context.router.routes[1].path;
    const fromDate = this.state.FromDate
      ? this.formatDate(this.state.FromDate)
      : moment().format('YYYY-MM-DD');
    const toDate = this.state.ToDate
      ? this.formatDate(this.state.ToDate)
      : moment().format('YYYY-MM-DD');
    const days = this.state.days;
    const productNum = this.state.filterProductID;
    const seller = this.props.Seller;

    let filterParams = "";
    if (isOCM || isKM || isABBLE || isAGD || isSV) {
      const filterPaires = [];
      _.forOwn(salesOrders.filters, (value, key) => {
        filterPaires.push([key, value.filterTerm].join('='))
      });
      filterParams = filterPaires.join('&');
    }

    setTimeout(() => {
      this.refreshSOList();
        // this.props.fetchSalesOrdersByFilter(
        //   fromDate,
        //   toDate,
        //   days,
        //   this.state.Status,
        //   seller,
        //   productNum,
        //   route,
        //   null,
        //   null,
        //   this.state.dispatchDays,
        //   this.state.limit,
        //   this.state.currentPage,
        //   this.state.searchFilter,
        //   this.state.Type,
        //   filterParams,
        // );
    }, 1000);
  }

  setPendingConfirmModalVisibility = (confirmQuotePending = false) => this.setState({ confirmQuotePending });
  setQuoteConfirmModalVisibility = (confirmOpenToQuote = false) => this.setState({ confirmOpenToQuote });
  openShowDriverImage() {
    this.setState({ showDriverImageOpen: true });
  }
  closeShowDriverImage() {
    this.setState({ showDriverImageOpen: false });
  }
  openSignatureImage() {
    this.setState({ showSignatureImageOpen: true });
  }
  closeSignatureImage() {
    this.setState({ showSignatureImageOpen: false });
  }

  openSubmitImage() {
    this.setState({ submitImageOpen: true });
  }
  closeSubmitImage() {
    this.setState({ submitImageOpen: false });
  }
  onSubmitImage(successCallback) {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    this.props.submitBolImage(salesOrder_id, this.state.file);
    this.setState({ submitImageOpen: false });
  }

  openPrintBol() {
    this.setState({ printBolOpen: true });
  }
  closePrintBol() {
    this.setState({ printBolOpen: false });
  }
  onChangeBolAddress = (address) => {
    this.setState({ bolAddressFBA: address.value });
  };

  openChangePullSheet() {
    this.setState({ changePullSheetOpen: true });
  }
  closeChangePullSheet() {
    this.setState({ changePullSheetOpen: false });
  }
  onChangePullSheetSubmit() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length > 1) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }
    if (
      this.state.pullSheetAmount < 0 ||
      this.state.pullSheetAmount > salesOrders.selectedRows.length
    ) {
      alert("Invalid Value!");
      return;
    }
    this.props.printPickingListAFG(
      salesOrderIds.join(","),
      this.state.pullSheetAmount,
      this.state.pullSheetSort,
    );
    this.state.pullSheetAmount = null;
    this.setState({ changePullSheetOpen: false });
    // this.context.router.push(`/${this.context.router.routes[1].path}`);
  }
  onPullSheetChange = (e) => {
    this.state.pullSheetAmount = e.target.value;
  };

  handleResize() {
    this.setState({
      tableHeight: window.innerHeight - UI_HEIGHT.fiveLineButton,
    });
  }

  handleOptionChange = (changeEvent) => {
    if (changeEvent.target.value === 'invoiceNo' || changeEvent.target.value === 'customer_id' || changeEvent.target.value === 'customer_name') {
      this.setState({
        filteredByItem: false,
        suggestValue: "",
        filterProductID: null,
      })
    } else {
      this.setState({
        invoiceNoSearchTerm: "",
      })
    }
    this.setState({ productSearchType: changeEvent.target.value });
  };

  // Set product being selected to be currentProduct and navigate user to the edit page
  setCurrentSalesOrder(e) {
    e.preventDefault();
    this.setState({ clear: false });
    const currentSalesOrderId = this.state.salesOrders.selectedRows[0]
      .SalesOrder_id;
    const salesOrders = this.state.salesOrders.rows.filter((row) => {
      const match = row.SalesOrder_id === currentSalesOrderId;
      return match;
    });

    const FromDate = this.state.FromDate;
    const ToDate = this.state.ToDate;
    this.props.resetCurrentSalesOrder();

    this.props.selectSalesOrder(salesOrders[0]);
    const currentRows = Data.Selectors.getRows(this.state.salesOrders);
    const route = this.context.router.routes[1].path;
    this.props.setSalesOrdersFilter({
      Days: this.state.days,
      FromDate,
      ToDate,
      Status: this.state.Status,
      Seller: this.props.Seller,
      ProductNum: this.props.ProductNum,
      currentRows,
      currentPage: route,
      sortColumn: this.state.sortColumn,
      sortDirection: this.state.sortDirection,
    });
    // this.context.router.push('/salesOrders/'+currentSalesOrder.SalesOrder_id);
    this.context.router.push(
      `/${this.context.router.routes[1].path}/${currentSalesOrderId}`
    );
  }

  checkAuthorize(password) {
    this.props.checkPassword(password);
  }

  openCheckAuthorize(action) {
    this.props.clearCheckPassword();
    this.setState({ checkAuthorizeOpen: true, action });
  }

  closeCheckAuthorize() {
    this.setState({ checkAuthorizeOpen: false });
  }

  clickNew(e) {
    e.preventDefault();
    this.props.resetCurrentSalesOrder();
    // this.context.router.push('/salesOrders/new')
    this.context.router.push(`/${this.context.router.routes[1].path}/new`);
  }

  voidOrder() {
    let newRows = this.state.salesOrders.rows;
    if(((isLAP || isUSPrideMulti || isAPD) || isVAK) && this.state.salesOrders.selectedRows.length > 0) {
      let ids = [];
      this.state.salesOrders.selectedRows.map((row) => {
        newRows = newRows.filter((obj) => obj !== row);
        ids.push(row.SalesOrder_id);
      });
      if(isVAK) {
        this.props.voidSalesOrder(ids,this.context.router.routes[1].path, true, ()=> {
          let salesOrders = { ...this.state.salesOrders, rows: newRows };
          salesOrders = {...this.state.salesOrders, rows: newRows, selectedRows: []};
          this.setState({ salesOrders });
        })
      } else {
        this.props.voidSalesOrder(ids,this.context.router.routes[1].path)
      }
      return
    }
    this.state.salesOrders.selectedRows.map((row) => {
      this.props.voidSalesOrder(
        row.SalesOrder_id,
        this.context.router.routes[1].path,
      );
      newRows = newRows.filter((obj) => obj !== row);
      let salesOrders = { ...this.state.salesOrders, rows: newRows };
      this.setState({ salesOrders });
    });
  }

  shouldEditButtonDisable() {
    const { selectedRows } = this.state.salesOrders;

    // Always disable void if selected more than 1 row
    if (selectedRows.length !== 1) {
      return true;
    }

    // const status = selectedRows[0] ? selectedRows[0].SaleStatus : "disable";
    // const IsBypass = selectedRows[0] ? selectedRows[0].IsBypass : false
    // const PaymentStatus = selectedRows[0] ? selectedRows[0].PaymentStatus : undefined
    // if (isOLG && this.context.router.routes[1].path === "mobileSalesOrders") {
    //   if (IsBypass && status !== "Open") {
    //     return true
    //   }
    //   if (['Paid', 'Partially Paid'].includes(PaymentStatus)) {
    //     return true
    //   }
    //   if (['Not Paid'].includes(PaymentStatus) && status !== "Open") {
    //     return true
    //   }
    // }
    return false
  }

  shouldVoidButtonDisable() {
    const { selectedRows } = this.state.salesOrders;

    // Always disable void if selected more than 1 row
    if (selectedRows.length !== 1 && !((isLAP || isUSPrideMulti || isAPD) || isVAK) || (((isLAP || isUSPrideMulti || isAPD) || isVAK) && selectedRows.length < 1)) {
      return true;
    }

    let filterRows = selectedRows.filter(row => (row.SaleStatus === "Canceled" ||
    row.SaleStatus === "Refunded" ||
    row.SaleStatus === "Partially Refunded" ||
    row.SaleStatus === "Finalized" ||
    row.SaleStatus === "Released" || isVAK && row.SaleStatus === "Packing" ))

   if(filterRows.length) {
    return true;
   }
   return false;
  }

  shouldQuoteButtonDisable() {
    const { selectedRows } = this.state.salesOrders;
    if (selectedRows.length !== 1) {
      return true;
    }
    const status = selectedRows[0] ? selectedRows[0].SaleStatus : "disable";
    const disabled =
      status === "Canceled" ||
      status === "Refunded" ||
      status === "Partially Refunded" ||
      status === "Finalized" ||
      status === "Released" ||
      status === "Packing" ||
      status === "disable";
    return disabled;
  }

  printForm(e) {
    e.preventDefault();
  }

  loadsPost() {
    this.props.loadsPost(this.state.salesOrders.selectedRows[0].SalesOrder_id);
  }

  // seems like only abcff is using it
  quoteConversion = () => {
    const route = this.context.router.routes[1].path;
    const status = this.state.salesOrders.selectedRows[0].SaleStatus;
    // const id = this.state.salesOrders.selectedRows[0].SalesOrder_id;
    const { salesOrders } = this.state;
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }

    let filterParams = "";
    if (isOCM || isKM || isABBLE || isAGD || isSV) {
      const filterPaires = [];
      _.forOwn(this.state.salesOrders.filters, (value, key) => {
        filterPaires.push([key, value.filterTerm].join('='))
      });
      filterParams = filterPaires.join('&');
    }

    if (status === "Open") {
      this.props.orderToQuote(salesOrderIds.join(",")).then(() => {
        this.setState({ setOrderLoading: false });
        this.refreshSOList();
        const seller = this.props.Seller;
        const fromDate = this.state.FromDate
          ? this.formatDate(this.state.FromDate)
          : moment().format('YYYY-MM-DD');
        const toDate = this.state.ToDate
          ? this.formatDate(this.state.ToDate)
          : moment().format('YYYY-MM-DD');
        const days = this.state.days;
        const productNum = this.state.filterProductID;
        this.props.fetchSalesOrdersByFilter(
          fromDate,
          toDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          null,
          null,
          this.state.dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterParams,
        );
      });
    } else if (status === "Quote") {
      this.props.quoteToOrder(salesOrderIds.join(",")).then(() => {
        this.setState({ setOrderLoading: false });
        this.refreshSOList();
        const seller = this.props.Seller;
        const fromDate = this.state.FromDate
          ? this.formatDate(this.state.FromDate)
          : moment().format('YYYY-MM-DD');
        const toDate = this.state.ToDate
          ? this.formatDate(this.state.ToDate)
          : moment().format('YYYY-MM-DD');
        const days = this.state.days;
        const productNum = this.state.filterProductID;
        this.props.fetchSalesOrdersByFilter(
          fromDate,
          toDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          null,
          null,
          this.state.dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterparams,
        );
      });
    }
  };

  // not been used
  quoteButton = () => (
    <Button
      bsStyle="success"
      type="reset"
      disabled={this.shouldQuoteButtonDisable()}
      onClick={() => {
        this.quoteConversion();
      }}
    >
      <Translate value={this.state.title} />
    </Button>
  );

  handleSalesStatusClick = (row) => {
    this.setState({
      monitorRow: row,
    }, () => {
      if (row.IsMonitor) {
        this.setCancelMonitorModalVisibility(true);
      } else {
        this.setMonitorNoteModalVisibility(true);
      }
    });
  }

  setMonitorNoteModalVisibility = (isMonitorNoteModalVisible = false) => this.setState({ isMonitorNoteModalVisible });
  handleMonitorOrderSuccess = () => {
    this.setMonitorNoteModalVisibility();
    this.setCancelMonitorModalVisibility();
    // alert('order has been monitoring')
    // this.refreshSOList();
  }

  setCancelMonitorModalVisibility = (isCancelMonitorModalVisible = false) => this.setState({ isCancelMonitorModalVisible });

  handleUpdatePrepay = () => {
    let ids = this.state.salesOrders.selectedRows.map(row => {
      return row.SalesOrder_id;
    })

    const success = () => {
      alert('Success');
      this.refreshSOList();
    }

    this.props.updatePrepayStatus(ids, success);
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
  renderTable() {
    const route = this.context.router.routes[1].path;
    const isMobile = route === "mobileSalesOrders";
    if (this.props.isLoading && !this.props.error && !isOCM && !isKM && !isABBLE && !isAGD && !isSV && !isAP) return <WidgetsSpinner />;
    // else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>;

    // Parameters of the react-data-grid
    let tableHeight = window.innerHeight < 930 ? 270 : 270;
    if (isABC) {
      tableHeight = window.innerHeight < 930 ? 800 : 800;
    }

    let reData = [];
    if (isUSPrideMulti && this.state.salesOrders && this.state.salesOrders.rows) {
      this.state.salesOrders.rows.map((r,i) => {
        reData.push({...r, OrderDate: moment(r.OrderDate).format("MM-DD-YY HH:mm")})
      });
      this.state.salesOrders.rows = reData;
    }

    const getRows = () => Data.Selectors.getRows(this.state.salesOrders);
    const getSize = () => getRows().length;

    // smilinghome want to show all data without scrolling
    if (isSH || isAP) {
      if (getRows().length > 0) {
        tableHeight = Math.min(getRows().length * 25 + 55)
      }
    }

    const rowGetter = (rowIdx) => {
      let rows = getRows();

      if (isABBLE) {
        rows.map((r,i)=>{
          if (!r.Tracking && r.TTracking) {
            rows[i].Tracking = rows[i].TTracking;
          } else if (!r.Tracking && !r.TTracking) {
            rows[i].Tracking = "";
          } else {

          }
        })
        rows.map((r,i)=>{
          if (!r.carrierName && r.Carrier) {
            rows[i].carrierName = rows[i].Carrier;
          } else if (!r.carrierName && !r.Carrier) {
            rows[i].Tracking = "";
          } else {

          }
        })
      }

      if (isCCW) {
        rows.map((r,i)=>{
          if (r.ShippedQTY && r.TotalOrderQty) {
            rows[i].CompletePercent = Number(((r.ShippedQTY*100) / r.TotalOrderQty).toFixed(2));
          } else {
            rows[i].CompletePercent = 0;
          }
        })
      }

      // this.state.total = 0;
      // for (let i = 0; i < rows.length; i++) {
      //   this.state.total += rows[i].FinalPrice;
      // }
      let rowItem = rows[rowIdx];
      if((isABBLE || isUSPrideMulti) && rowItem && rowItem.SaleStatus == 'Open') {
        rowItem.InvoiceNum = null
      }
      return rowItem;
    };

    const onTrackingNumRouter = (trackingNum) => {
      const url =
        "https://www.fedex.com/apps/fedextrack/?tracknumbers=" + trackingNum;
      let win = window.open(url);
      if (win != null) {
        win.focus();
      }
    };

    const onClearFilters = () => {
      // all filters removed
      const salesOrders = { ...this.state.salesOrders, filters: {} };
      this.setState({ salesOrders }, () => {
        if (isOCM || isKM || isABBLE || isAGD || isSV || isSH || isAP) {
          handleOnPageChange({
            selected: 0,
          })
        }
      })
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.salesOrders, {
        sortColumn,
        sortDirection,
      });

      if (isOCM || isKM || isABBLE || isAGD || isSV || isAP) {
        // what is pullSheetSort?
        this.setState({ sortColumn, sortDirection });
        if (state.sortDirection === "ASC") {
          this.state.pullSheetSort = state.sortColumn;
        } else if (state.sortDirection === "DESC") {
          this.state.pullSheetSort = `-${state.sortColumn}`;
        } else {
          this.state.pullSheetSort = "";
        }

        this.setState({ salesOrders: state });

        const route = this.context.router.routes[1].path;
        let filterParams = "";
        const filterPaires = [];
        _.forOwn(this.state.salesOrders.filters, (value, key) => {
          filterPaires.push([key, value.filterTerm].join('='))
        });

        filterParams = filterPaires.join('&');
        if (['ASC', 'DESC'].includes(sortDirection)) {
          const key = getKeysMap(sortColumn, SALES_ORDER_SORT_KEY_OBJ);
          const sort = getSortVal(key,sortDirection === "DESC");
          this.setState({currentPage: 0, sort});
          filterParams += `&sort=${sort}`;
        } else {
          this.setState({sort: ''});
        }

        let productNum = null;
        if (this.state.filteredByItem === true) {
          productNum = this.state.filterProductID;
        }
        this.props.fetchSalesOrdersByFilter(
          this.state.FromDate,
          this.state.ToDate,
          this.state.days,
          this.state.Status,
          null,
          productNum,
          route,
          this.state.dispatchDateLT,
          this.state.dispatchDateGT,
          this.state.dispatchDays,
          this.state.limit,
          0,
          this.state.searchFilter,
          this.state.Type,
          filterParams,
        );
        this.setState({currentPage: 0, sort: ''});
      } else {
        const state = Object.assign({}, this.state.salesOrders, {
          sortColumn,
          sortDirection,
        });
        if (state.sortColumn === "OrderDateDisplay") {
          state.sortColumn = "OrderDate";
        }

        if (state.sortDirection === "ASC") {
          this.state.pullSheetSort = state.sortColumn;
        } else if (state.sortDirection === "DESC") {
          this.state.pullSheetSort = `-${state.sortColumn}`;
        } else {
          this.state.pullSheetSort = "";
        }
        this.setState({ salesOrders: state });
      }
    };

    const handleFilterChange = debounce(
      (filter) => {
        this.state.total = 0;
        this.state.salesOrders.rows = this.props.salesOrders.Orders;
        this.state.salesOrders.selectedRows = [];
        let filterParams = "";
        if(isGGI) {
          this.state.salesOrders.rows.map(row => {
            row.isSelected = false;
          })
          this.setState({salesOrders: {...this.state.salesOrders, selectedRows:[]}})
        }
        const newFilters = Object.assign({}, this.state.salesOrders.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }

        const salesOrders = { ...this.state.salesOrders, filters: newFilters };

        this.setState({ salesOrders }, () => {
          if (isCPG || isVIP || (!isOCM && !isKM && !isABBLE && !isAGD && !isSV)) return;
          // here filter by api
          // if (filter.column.key === "SONum" || filter.column.key === "InvoiceNum" ||
          //   filter.column.key === "Deliver_Customer_num" || filter.column.key === "Deliver_CustomerName" ||
          //   filter.column.key === "Sales_User_Name" || filter.column.key === "PONum" ||
          //   (isABBLE && filter.column.key === "Location")
          // ) {
            handleOnPageChange({
              selected: 0
            })
          // }
        });
      },
      500,
      { maxWait: 800 },
    );

    // Handle the row select function
    const onRowClick = (rowIdx, row) => {
      if (rowIdx !== -1) {
        const rows = getRows();
        /* Multi row select on row click
          let selectedRows = [...this.state.salesOrders.selectedRows];

          let id = rows[rowIdx].SalesOrder_id;
          let idx = selectedRows.indexOf(id);
          if (idx == -1) {
            rows[rowIdx].isSelected = true;
            selectedRows.push(id);
          } else {
            rows[rowIdx].isSelected = false;
            selectedRows.splice(idx, 1);
          }
        */

        /* Single row select on row click */
        rows.map((r) => {
          r.isSelected = false;
        });
        const selectedRows = [rows[rowIdx]];
        rows[rowIdx].isSelected = true;

        const salesOrders = { ...this.state.salesOrders, rows, selectedRows };
        this.setState({ salesOrders });
      }
    };


    const handleLimitChange = (el) => {
      this.state.currentPage = 0;
      this.state.limit = el.value;
      this.state.limitDisplay = el.label;
      const route = this.context.router.routes[1].path;

      let salesOrders = {
        ...this.state.salesOrders,
        selectedRows: [],
      };
      this.setState({ salesOrders });


      let filterParams = "";
      if (isOCM || isKM || isABBLE || isAGD || isSV) {
        const filterPaires = [];
        _.forOwn(salesOrders.filters, (value, key) => {
          filterPaires.push([key, value.filterTerm].join('='))
        });
        filterParams = filterPaires.join('&');
      }
      // salesOrders: {
      //   rows: [],
      //   selectedRows: [],
      //   filters: {},
      //   sortColumn: null,
      //   sortDirection: null,
      // },
      this.props.fetchSalesOrdersByFilter(
        this.state.FromDate,
        this.state.ToDate,
        this.state.days,
        this.state.Status,
        null,
        null,
        route,
        this.state.dispatchDateLT,
        this.state.dispatchDateGT,
        this.state.dispatchDays,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        filterParams,
      );
      // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    const handleOnPageChange = (data) => {
      this.state.currentPage = data.selected;
      const route = this.context.router.routes[1].path;
      let filterParams = "";
      let salesOrders = {
        ...this.state.salesOrders,
        selectedRows: [],
        rows: [],
      };
      if (isOCM || isKM || isABBLE || isAGD || isSV || isSH || isAP) {
        const filterPaires = [];
        _.forOwn(salesOrders.filters, (value, key) => {
          filterPaires.push([key, value.filterTerm].join('='))
        });

        filterParams = filterPaires.join('&');
        if (['ASC', 'DESC'].includes(salesOrders.sortDirection)) {
          const key = getKeysMap(salesOrders.sortColumn, SALES_ORDER_SORT_KEY_OBJ);
          const sort = getSortVal(key,salesOrders.sortDirection === "DESC");
          filterParams += `&sort=${sort}`;
        } else {
          this.setState({sort: ''});
        }
      }
      this.setState({ salesOrders });
      if (isVAK) {
        this.setState({ totalNetWeight: this.props.salesOrders.TotalWT});
      }

      if (this.state.sort) {
        filterParams += `&sort=${this.state.sort}`;
      }

      this.props.fetchSalesOrdersByFilter(
        this.state.FromDate,
        this.state.ToDate,
        this.state.days,
        this.state.Status,
        null,
        null,
        route,
        this.state.dispatchDateLT,
        this.state.dispatchDateGT,
        this.state.dispatchDays,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        filterParams,
      );

      // this.props.fetchSalesOrdersByFilter(
      //   this.state.FromDate,
      //   this.state.ToDate,
      //   this.state.days,
      //   this.state.Status,
      //   seller,
      //   productNum,
      //   route,
      //   this.state.dispatchDateLT,
      //   this.state.dispatchDateGT,
      //   dispatchDays,
      // );

      // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    const onRowSelect = (rows) => {
      const salesOrders = { ...this.state.salesOrders, selectedRows: rows };
      this.setState({ salesOrders });
    };

    const onCellSelected = (coordinates) => {
      const newRows = getRows();
      /* Multi row select on cell selected
        let selectedRows = [...this.state.salesOrders.selectedRows];
        newRows[coordinates.rowIdx].isSelected = true;
        let id = newRows[coordinates.rowIdx].SalesOrder_id;
        if (selectedRows.indexOf(id) == -1) {
            selectedRows.push(id);
        }
      */
      /* Single row select on cell selected */
      newRows.map((r) => {
        r.isSelected = false;
      });
      const selectedRows = [newRows[coordinates.rowIdx]];
      newRows[coordinates.rowIdx].isSelected = true;
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders });
    };

    const checkLabel = () => {
      const selectedRows = [...this.state.salesOrders.selectedRows];
      if (selectedRows[0].SaleStatus === "Quote") {
        this.setState({
          title: "Open",
        });
      } else if (selectedRows[0].SaleStatus !== "Quote") {
        this.setState({
          title: "Quote",
        });
      }
    };

    const onRowsSelected = (rows) => {
      this.setState({
        scrollTopPositionIndex: rows[0].rowIdx,
      });
      const newRows = getRows();
      const selectedRows = [...this.state.salesOrders.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
        if(isOLG || isGGI) {
          let isHave = false;
          selectedRows.map(item => {
            if(item.pk == r.row.pk) {
              isHave = true;
              return
            }
          })
          if(!isHave) {
            selectedRows.push(r.row);
          }
        } else {
          selectedRows.push(r.row);
        }
      });
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders }, () => {
        checkLabel();
      });
    };

    const onRowsDeselected = (rows) => {
      const newRows = [...this.state.salesOrders.rows];
      const selectedRows = [...this.state.salesOrders.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
        let rowIndex = selectedRows.findIndex(item => item.SalesOrder_id == r.row.SalesOrder_id);
        selectedRows.splice(rowIndex, 1);
      });
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders, title: "Quote" });
    };
    const handleClickPodColumn = debounce(() => {
      this.openManagePod();
    }, 500)

    // Custom Formatter component
    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const dateMap = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];
          const date = new Date(this.props.value);
          const index = dateMap.indexOf(date.toString().slice(4, 3));
          const localDate = index + date.toString().slice(8, 6);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const DateMonthFormatter = React.createClass({
      render() {
        if (isAGD && this.props.value) {
          return <span>{moment(this.props.value).format('MM-DD-YYYY')}</span>;
        } else if (isAGD) {
          return <span className="label label-danger">-</span>;
        }

        if (this.props.value) {
          const dateMap = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];
          const date = new Date(this.props.value);
          const index = dateMap.indexOf(date.toString().slice(4, 3));
          const localDate = index + date.toString().slice(8, 6);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const shippingAddressFormatter = React.createClass({
      render() {
        if (this.props.dependentValues) {
          return (
            <span>{`${this.props.dependentValues.Deliver_CustomerAddress} ${this.props.dependentValues.City} ${this.props.dependentValues.State}`}</span>
          );
        }
        return (
          <span></span>
        );
      },
    });

    const SecondsDateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = (isSDR || isCRW || isSC) ? moment(this.props.value).format("MM-DD-YY HH:mm:ss") : moment(this.props.value).format("MM-DD-YY HH:mm");
          return <span>{date}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const YuansferFormatter = React.createClass({
      render() {
        if (this.props.value === "alipay") {
          return <span>Alipay</span>;
        }
        if (this.props.value === "wechatpay") {
          return <span>WeChatPay</span>;
        } else {
          return <span>{this.props.value}</span>;
        }
      },
    });
    // Custom Delivery Time component

    const DeliveryTimeFormatter = React.createClass({
      render() {
        if (this.props.value) {
          let d1 = moment.utc(moment(this.props.value)).local().format("LT");
          let d2 = moment
            .utc(moment(this.props.value))
            .local()
            .subtract(2, "hours")
            .format("MM-DD-YY hh:mm A");
          // This is the old way Julie designed it. Keeping it here in case a new bug is discovered with my alterations.
          // d1 = moment(d1).format("h a");
          // d2 = moment(d2).subtract(2, 'hours').format('MM-DD-YY hh:mm:ss a');
          // d2 = moment(d2).format("h a");

          return <span>{`${d2}-${d1}`}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const VendorNameFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.Name}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const VendorNumFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const InvoiceNumFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const PromoCodeFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value}</span>;
        return <span>-</span>;
      },
    });

    const soNumWidth =
      this.context.router.routes[1].path === "mobileSalesOrders" ? 145 : 100;

    let finalWeightLBS = <Translate value="total_weight_lb" />;
    if (isSH || isAP) {
      finalWeightLBS = <Translate value="total_pcs" />
    }

    const columnsSV = [
      {
        key: "SONum",
        name: <Translate value="so_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
        getRowMetaData: row => row,
        formatter: ({ dependentValues, value }) => {
          return (
          <div
            style={{ color: value.includes('-') && dependentValues.SaleStatus === 'Canceled' ? 'red' : '#000000'}}
          >
            {value}
          </div>
        )
      },
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "OrderType",
        name: <Translate value="type" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Store",
        name: <Translate value="store" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "TypeRefNum",
        name: <Translate value="type_ref" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PONum",
        name: <Translate value="CPO" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: isGGI ? 60 : 95,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: "ShipVia",
        name: <Translate value="ship_via" />,
        resizable: true,
        sortable: true,
        width: 150,
        filterable: true,
      },
      {
        key: "TrackingNum",
        name: <Translate value="tracking_num" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: ({ value }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
            onDoubleClick={() => {
              if (value === "split") {
                this.openDisplayTracking();
              } else {
                onTrackingNumRouter(value);
              }
            }}
          >
            {value}
          </div>
        ),
      },
      {
        key: "Modifier_User_Name",
        name: <Translate value="modifier" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Picker_User_Name",
        name: <Translate value="picker" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: ({value}) => {
          return <span>{value && <Translate value={value} />}</span>
        }
      },
      {
        key: "PackingDate",
        name: <Translate value="packing_date" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "ShipDate",
        name: <Translate value="ship_date" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: DateMonthFormatter,
      },
      {
        key: "CancelDate",
        name: <Translate value="cancel_date" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: DateMonthFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="invoice_date" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];

  const apColumns = [
    {
      key: "SONum",
      name: <Translate value="so_no" />,
      resizable: true,
      sortable: true,
      filterable: true,
      width: soNumWidth,
      getRowMetaData: row => row,
      formatter: ({ value, dependentValues }) => {
        let showRed = Number(dependentValues.PickedQuantity || 0) < Number(dependentValues.OrderQuantity || 0) && Number(dependentValues.PickedQuantity || 0) != 0;
        return <div style={{ textAlign: 'center', backgroundColor: showRed ? "red" : "inherit", color: showRed ? 'white' : 'black'}}>
          {value}
        </div>
      }
    },
    {
      key: "InvoiceNum",
      name: <Translate value="invoice_no" />,
      resizable: true,
      sortable: true,
      filterable: true,
      width: 113,
      formatter: InvoiceNumFormatter,
    },
    {
      key: "transfered_ponum",
      name: <Translate value="related_po" />,
      resizable: true,
      sortable: true,
      width: 115,
      filterable: true,
    },
    {
      key: "CPONum",
      name: <Translate value="CPO" />,
      resizable: true,
      sortable: true,
      width: 100,
      filterable: true,
    },
    {
      key: "Deliver_CustomerName",
      name: <Translate value="cust_name" />,
      resizable: true,
      sortable: true,
      filterable: true,
      width: 115,
    },
    {
      key: "FinalPrice",
      name: <Translate value="final_dollarsign" />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true,
      formatter: CashFormatter,
    },
    {
      key: "OrderQuantity",
      name: <Translate value="total_qty" />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true,
    },
    {
      key: "PickedQuantity",
      name: <Translate value="total_picked_qty" />,
      resizable: true,
      sortable: true,
      width: 100,
      filterable: true,
    },
    {
      key: "Modifier_User_Name",
      name: <Translate value="modifier" />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true,
    },
    {
      key: "Sales_User_Name",
      name: <Translate value="sales" />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true,
    },
    {
      key: "SaleStatus",
      name: <Translate value="status" />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true,
      formatter: ({value}) => {
        return <span>{value && <Translate value={value} />}</span>
    }},
    {
      key: "DispatchDate",
      name: <Translate value="etd_date" />,
      resizable: true,
      sortable: true,
      width: 110,
      filterable: true,
      formatter: ({value}) => {
        return <div>
          {moment(value).format('MM-DD-YYYY')}
        </div>
      },
    },
    {
      key: "OrderDate",
      name: <Translate value="ordered" />,
      resizable: true,
      sortable: true,
      width: 95,
      filterable: true,
      formatter: ({value}) => {
        return <div>
          {moment(value).format('MM-DD-YYYY')}
        </div>
      },
    },
    {
      key: "ShipmentDate",
      name: <Translate value="shipped" />,
      resizable: true,
      sortable: true,
      width: 120,
      filterable: true,
      formatter: SecondsDateFormatter,
    },
    {
      key: isOLG ? "Picker_Name" :"Picker_User_Name",
      name: <Translate value="picker" />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true,
    },
    {
      key: "Deliver_Customer_num",
      name: <Translate value="cust_no" />,
      resizable: true,
      sortable: true,
      width: isGGI ? 60 : 95,
      filterable: true,
    }
  ];

    // Column difinition
    const columns = [
      ...isSH ? [
        {
          key: "SONum",
          name: <Translate value="so_no" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: soNumWidth,
          getRowMetaData: row => row,
          formatter: ({ value, dependentValues }) => {
            let showRed = Number(dependentValues.PickedQuantity || 0) < Number(dependentValues.OrderQuantity || 0) && Number(dependentValues.PickedQuantity || 0) != 0;
            return <div style={{ textAlign: 'center', backgroundColor: showRed ? "red" : "inherit", color: showRed ? 'white' : 'black'}}>
            {value}
          </div>
          }
        }
      ]:[
        {
          key: "SONum",
          name: <Translate value="so_no" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: soNumWidth,
        }
      ],
      ...isAGD && [{
        key: "PONum",
        name: <Translate value="CPO" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }],
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      ...isVAK && [{
        key: "ShippingMethod",
        name: <Translate value="shipping_method" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      }],
      ...isSW && [{
        key: "PONum",
        name: <Translate value="CPO" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }],
      ...isTQ ? [{
        key: "PONum",
        name: <Translate value="cust_po" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }] : [],
      ...(isVAK && isMobile) ? [{
        key: 'Platform_Num',
        name: <Translate value="platform_order"/>,
        resizable: true,
        sortable: true,
        width: 160,
        filterable: true
      },
      {
        key: 'Platform_Name',
        name: <Translate value="platform"/>,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true
      }] : [],
      ...isFIT ? [{
        key: "Quantity",
        name: <Translate value="total_qty" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },{
        key: "SKU",
        name: <Translate value="sku" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }] : [{
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: isGGI ? 60 : 95,
        filterable: true,
      }],
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: (isCPG || isVIP) ? 165 : 115,
      },
      ...(isSDR) && [{
        key: "Deliver_CustomerTelephone",
        name: <Translate value="cust_phone" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
      }],
      ...(isAPD) && [{
        key: "TPONum",
        name: <Translate value="dropship" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
      }],
      ... isCCW && [{
        key: "ShippedQTY",
        name: <Translate value="total_ship_qty" />,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "TotalOrderQty",
        name: <Translate value="total_order_qty" />,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "CompletePercent",
        name: <Translate value="complete_percent" />,
        sortable: true,
        width: 100,
        filterable: true,
         formatter: ({ value }) => (
          <div
            style={{ width: "100%", height: "100%" }}
          >
            {value}%
          </div>
        ),
      },
      {
        key: "ShippedWT",
        name: <Translate value="total_ship_wt" />,
        sortable: true,
        width: 80,
        filterable: true,
      }],
      ...(isCCW && this.state.Type==='IsRelocation') && [{
        key: "TPONum",
        name: <Translate value="RPO_Num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      }],
      ...isAGD && [{
        key: "DispatchDate",
        name: <Translate value="ship_start_date" />,
        resizable: true,
        sortable: true,
        width: 125,
        // filterable: true,
        formatter: DateMonthFormatter,
      }],
      ...(isKM && this.context.router.routes[1].path === "mobileSalesOrders") ? [
      {
        key: "SKU",
        name: <Translate value="sku" />,
        resizable: true,
        sortable: true,
        width: 170,
        filterable: true,
      },
      {
        key: "Quantity",
        name: <Translate value="quantity" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Store",
        name: <Translate value="store" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }, {
        key: "Seller",
        name: <Translate value="seller" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      }, {
        key: "ShippingMethod",
        name: <Translate value="shipping_method" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      }, {
        key: "Tracking",
        name: <Translate value="tracking" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: ({ value }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
            onDoubleClick={() => {
              if (!value) { this.openTrackingForm(); }
            }}
          >
            {value ? value : "-"}
          </div>
        ),
      }] : [],
      ...(isKM && this.context.router.routes[1].path === "mobileSalesOrders") && [
      {
        key: "WarehouseName",
        name: <Translate value="warehouse" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }],
      ...(isKM && this.context.router.routes[1].path === "mobileSalesOrders") && [{
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }, {
        key: "City",
        name: <Translate value="city" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      }, {
        key: "State",
        name: <Translate value="state" />,
        resizable: true,
        sortable: true,
        width: 50,
        filterable: true,
      }, {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }, {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      }],
      ...!(isAGD || isSH || isAP || isVIP) ? [] : [
        {
          key: "Description",
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: (isCPG || isVIP) ? 100 : 124,
        },
      ],
      ...isVAK ? [
        {
          key: "CommercialInvoice",
          name: <Translate value="commercial_invoice" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 120,
        },
        {
          key: "MfgNum",
          name: <Translate value="mfg_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: InvoiceNumFormatter,
        },
        {
          key: "PRNum",
          name: <Translate value="pr_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: InvoiceNumFormatter,
        }
      ] : [],
      ...(isLMH || isBRO || isSDR || isCRW || isSC || isGFD) ? [{
        key: "TPONum",
        name: <Translate value="dropship" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      }] : [],
      ...isSV ? [{
        key: "Deliver_CustomerAddress",
        name: <Translate value="delivery_address" />,
        resizable: true,
        sortable: true,
        width: 150,
        filterable: true,
      }, {
        key: "ShipVia",
        name: <Translate value="ship_via" />,
        resizable: true,
        sortable: true,
        width: 150,
        filterable: true,
      }] : [],
      ...(isCPG || isPRS || isVIP) && [{
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }],
      ...(isLMH || isBRO || isSDR || isCRW || isSC) ? [{
        key: "Note",
        name: <Translate value="note" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      }] : [],
      ...(!isKM) && [{
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      }],
      ...isCCW && [{
        key: "ShippedInvoiced",
        name: <Translate value="invoice_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: CashFormatter,
      }],
      ...(isSH || isAP) && [{
        key: "OrderQuantity",
        name: <Translate value="total_qty" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PickedQuantity",
        name: <Translate value="total_picked_qty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isSV || isPRS || isAGD || isSH || isAP) ? [] : [{
        key: "FinalNetWeight",
        name: <Translate value="final_weight_lbs" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }],
      ...(isAGD) && [
        {
          key: "Location",
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        {
          key: "TrayNum",
          name: <Translate value="tray_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: "CartLocation",
          name: <Translate value="cart_location" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: "Store",
          name: <Translate value="store" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: "SaleStatus",
          name: <Translate value="status" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
      }],
      ...isSKH ? [
        {
          key: "edi_status",
          name: <Translate value="edi_status" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        }
      ] : [],
      ...isSUN ? [{
        key: "Creator_User_Name",
        name: <Translate value="creator" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }] : [],
      // ...(isSDR) ? [{
      //   key: "PaymentType",
      //   name: <Translate value="payment_type" />,
      //   resizable: true,
      //   sortable: true,
      //   filterable: true,
      //   width: 90,
      // }] : [],
      // ...(isSDR) ? [{
      //   key: "CloverLastFour",
      //   name: <Translate value="last_4" />,
      //   resizable: true,
      //   sortable: true,
      //   filterable: true,
      //   width: 90,
      // }] : [],
      ...(isSDR || isCRW || isSC) ? [{
        key: "CreateTime",
        name: <Translate value="created" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      }] : [],
      ...isSDR && [{
        key: "platform",
        name: <Translate value="platform" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      }],
      ...(isSDR || isCRW || isSC) ? [{
        key: "UpdateTime",
        name: <Translate value="modified" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      }] : [],
      ...isPRS ? [{
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }, {
        key: "TimeRange",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 160,
        filterable: true,
      }, {
        key: "ShippingMethod",
        name: <Translate value="shipping_method" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      }] : [{
        key: "Modifier_User_Name",
        name: <Translate value="modifier" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }],
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      ...!isVIP && [{
        key: isOLG ? "Picker_Name" :"Picker_User_Name",
        name: <Translate value="picker" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }],
      ...(isCPG || isVIP) ? [{
        key: "OrderImage",
        name: <Translate value="orderImage" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: ({ value }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
            onDoubleClick={() => this.openShowDriverImage()}>
            {(value !== '' && value !== null) && <Translate value="show" />}
          </div>
        ),
      },
      {
        key: "SignatureImage",
        name: <Translate value="signature" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: ({ value }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
            onDoubleClick={() => this.openSignatureImage()}>
            {(value !== '' && value !== null) && <Translate value="show" />}
          </div>
        ),
      },
      {
        key: "ShippingStatus",
        name: <Translate value="shipping_status" />,
        resizable: true,
        sortable: true,
        width: 80,
      }] : [],
      ...isOCM ? [{
        key: "AdditionalOrder",
        name: <Translate value="additional_order" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: ({ value }) => (
          <div> {value === false ? "" : value } </div>
        ),
      }] : [],
      ...(isCPG || isVIP) ? [{
        key: "discountDisplay",
        name: <Translate value="discount" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      }] : ((!isPRS && !isKM && !isAGD) && [{
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: ({value}) => {
          return <span>{value && <Translate value={value} />}</span>
      }}]),
      ...(isVAK || isGFD) ? [{
        key: 'HasPod',
        name: <Translate value="has_pod" />,
        resizable: true,
        sortable: false,
        width: 80,
        formatter: ({ value }) => (
          <div onClick={() => handleClickPodColumn()} style={{cursor: "pointer", width: "100%", display: 'flex', justifyContent: 'center', color: value ? 'green' : 'red'}}>
            { value ? <em className="fa fa-check"></em> : <em className="fa fa-times"></em> }
          </div>
        ),
      }, {
        key: "Notation",
        name: <Translate value="cust" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      }, {
        key: "EmployeeNote",
        name: <Translate value="emp" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      }, {
        key: "RouteNote",
        name: <Translate value="route" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      }] : [],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isSV || isSUN || isSH || isAP) ? [] : [{
        key: "IsUnderBuffer",
        name: <Translate value="under_buffer" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => (
          <div style={{ textAlign: 'center', backgroundColor: dependentValues.IsUnderBuffer ? "orange" : "inherit"}}>
            { (value === true || value === 'true') ? "true" : "false" }
          </div>
        ),
      }],
      ...!(isSDR || isCRW || isSC) ? [{
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      }]:[],
      ...isPRS ? [{
        key: "FinalNetWeight",
        name: finalWeightLBS,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }] : [{
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }],
      ...(!isSV && !(isLAP || isUSPrideMulti || isAPD) && !isPRS && !isGGI) ? [{
        key: "DispatchDate",
        name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: isGGI ? 80 : 125,
        filterable: true,
        formatter: (isSDR || isCRW || isSC) ? SecondsDateFormatter : DateMonthFormatter,
      }] : [],
      ...isGGI?[{
        key: "DispatchDate",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        getRowMetaData: row => row,
        formatter: ({value, dependentValues}) => {
         return <div style={{ textAlign: 'center', backgroundColor: isGGiOver(dependentValues.SaleStatus, dependentValues.DispatchDate) ? "orange" : "inherit"}}>
          <DateMonthFormatter value={value}/>
        </div>
        },
      }]:[],
      ...isPRS && [{
        key: "Modifier_User_Name",
        name: <Translate value="modifier" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }],
      ...(isLAP || isUSPrideMulti || isAPD) ? [{
        key: "RouteID",
        name: <Translate value="route_id" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      }, {
        key: "DispatchDate",
        name: <Translate value="etd" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: DateMonthFormatter,
      }] : [],
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
      ...(isAGD) ? [{
        key: "Description",
        name: <Translate value="desc" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 200,
      },] : [],
    ];

    if (isOCM) {
      const CreateTime = {
        key: "CreateTime",
        name: <Translate value="modified" />,
        resizable: true,
        sortable: true,
        // width: 50,
        // filterable: true,
        getRowMetaData: row => row,
        formatter: (props) => {
          const modified = props.value !== props.dependentValues.UpdateTime;
          if (!modified) return <span />
          return <span style={{ display:'block', width: '100%', height: '22px', backgroundColor: 'orange' }}></span>
        }
      };
      const CPO = {
        key: "PONum",
        name: <Translate value="CPO" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };

      const SONumIndex = _.findIndex(columns, { key: 'SONum' });
      const Deliver_Customer_numIdx = _.findIndex(columns, { key: 'Deliver_Customer_num' });

      columns.splice(Deliver_Customer_numIdx, 0, CPO);
      columns.splice(SONumIndex, 0, CreateTime);

    }

    if (isGGI) {
      const warehouseCol = {
        key: "WarehouseName",
        name: <Translate value="warehouse" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      }
      const CPO = {
        key: "PONum",
        name: <Translate value="CPO" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }
      const file = {
        key: "file",
        name: <Translate value="file" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: (props) => {
          if (!props.value) return <span/>
          return <a href={props.value}>download</a>
        },
      }
      const IsOverCreditLimit = {
        key: "IsOverCreditLimit",
        name: <Translate value="over" />,
        resizable: true,
        sortable: true,
        width: 50,
        getRowMetaData: row => row,
        formatter: (props) => {
          const IsOverCreditLimit = props.value;
          if (!IsOverCreditLimit) return <span />
          return <span style={{ display:'block', width: '100%', height: '22px', backgroundColor: 'orange' }}></span>
        }
      }
      const IsLowerThanLowestPrice = {
        key: "IsLowerThanLowestPrice",
        name: <Translate value={"low"} />,
        resizable: true,
        sortable: true,
        width: 46,
        getRowMetaData: row => row,
        formatter: (props) => {
          const IsLowerThanLowestPrice = props.value;
          if (!IsLowerThanLowestPrice) return <span />
          return <span style={{ display:'block', width: '100%', height: '22px', backgroundColor: 'orange' }}></span>
        }
      };
      const TPO = {
        key: "TPONum",
        name: <Translate value="TPO" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }
      const FinalPriceIndex = _.findIndex(columns, { key: 'FinalPrice' });
      const exceedCreditLimitIndex = _.findIndex(columns, { key: "IsOverCreditLimit" });
      const Deliver_CustomerNameIndex = _.findIndex(columns, { key: 'Deliver_CustomerName' });
      const SONumIndex = _.findIndex(columns, { key: 'SONum' });
      columns.splice(exceedCreditLimitIndex + 1, 0, warehouseCol);
      columns.splice(columns.length - 1, 0, file);
      columns.splice(Deliver_CustomerNameIndex, 0, CPO, TPO);
      columns.splice(SONumIndex, 0, IsOverCreditLimit, IsLowerThanLowestPrice);
    }

    if (isABBLE) {
      const CPO = {
        key: "PONum",
        name: <Translate value="CPO" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }
      const Location = {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }
      const carrier = {
        key: "carrierName",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        getRowMetaData: row => row,
        formatter: (props) => {
          if (!props.value) {
            return <div>{props.dependentValues.Carrier}</div>
          } else {
            return <div>{props.value}</div>
          }
        }
      };
      const tracking = {
        key: "Tracking",
        name: <Translate value="tracking" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        getRowMetaData: row => row,
        formatter: (props) => {
          if (!props.value) {
            return <div>{props.dependentValues.TTracking}</div>
          } else {
            return <div>{props.value}</div>
          }
        }
      }
      const storeName = {
        key: "Store",
        name: <Translate value="store" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }
      const warehouseNum = {
        key: "warehouse_num",
        name: <Translate value="warehouse_num" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }
      const teapplixSynced = {
        key: "TeapplixSynced",
        name: <Translate value="teapplix_synced" />,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: ({ value, dependentValues }) => (
          <div>
            { (value === true || value === 'true') ? "Synced" : "Not Synced" }
          </div>
        ),
      }
      const resetStatus = {
        key: "isReset",
        name: <Translate value="has_reset" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
      }
      const salesStatus = {
        key: "SaleStatus",
        name: <Translate value="sales_status" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        getRowMetaData: row => row,
        formatter: (row) => {
          const IsMonitor = row.dependentValues.IsMonitor;
          const IsMonitorStyle = {
            color: 'orange',
            fontWeight: 'bold'
          }
          return <div style={{ width: '100', cursor: 'pointer', ...IsMonitor&&IsMonitorStyle }} onDoubleClick={() => this.handleSalesStatusClick(row.dependentValues)}>{row.value}</div>
        }
      }
      const currentSalesStatusIndex = _.findIndex(columns, { key: 'SaleStatus' });
      columns.splice(currentSalesStatusIndex, 1);
      const Deliver_CustomerNameIndex = _.findIndex(columns, { key: 'Deliver_CustomerName' });
      columns[Deliver_CustomerNameIndex].key = 'shipToName';
      columns.splice(Deliver_CustomerNameIndex, 0, CPO, Location, teapplixSynced, carrier, tracking, storeName, salesStatus, warehouseNum, resetStatus);
      const creatorIndex = columns.findIndex(column => column.key === 'Creator_User_Name');
      if(creatorIndex !== -1) {
        columns.splice(creatorIndex, 0 , {
          key: "TOTAL CBM",
          name: <Translate value="total_cbm" />,
          resizable: true,
          width: 80,
          sortable: true,
          formatter: ({ value }) => (
            <div style={{ width: "100%", height: "100%" }}>
              {value ? value.toFixed(3) : null}
            </div>
          )
        })
      }
    }

    if (isHO || isJRC || (isLAP || isUSPrideMulti || isAPD || isGFD)) {
      if ((isLAP || isUSPrideMulti || isAPD || isGFD)) {
        columns.push({
          key: "Profit",
          name: <Translate value="profit" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter:({value}) => (
            <span>${Math.round(value * 100) / 100}</span>
          )
        });
      }
      columns.push({
        key: "SalesMargin",
        name: <Translate value="sales_margin" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter:({value}) => (
          <span>{Math.round(value * 100) / 100}%</span>
        )
      })
    }
    if (isHO || isJRC || isRivera) {
      const finalPriceIndex = columns.findIndex(item => item.key === 'FinalNetWeight')
      if (finalPriceIndex !== -1) {
        columns.splice(finalPriceIndex, 0, {
          key: "TaxAmount",
          name: <Translate value="total_tax" />,
          resizable: true,
          width: 80,
          sortable: true,
        }, {
          key: "TotalCRV",
          name: <Translate value="total_crv" />,
          resizable: true,
          width: 80,
          sortable: true,
        })
      }
    }

    const MAGColumn = [
      {
        key: "SONum",
        name: <Translate value="so_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: "delivery_address",
        name: <Translate value="delivery_address" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 200,
      },
      {
        key: "delivery_eta",
        name: <Translate value="eta" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateMonthFormatter,
      },
      {
        key: "cntrNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: "bolNum",
        name: <Translate value="bol_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: "terminal",
        name: <Translate value="terminal" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: "delivery_lfd",
        name: <Translate value="lfd" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateMonthFormatter,
      },
      {
        key: "DeliveryStatus",
        name: <Translate value="hold_select" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 250,
      },
      {
        key: "DeliveryStatusOther",
        name: <Translate value="hold_other" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 200,
      },
      {
        key: "cntrLocation",
        name: <Translate value="cntr_location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 200,
      },
      {
        key: "mag_note",
        name: <Translate value="note_select" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 250,
      },
      {
        key: "mag_note_other",
        name: <Translate value="note_other" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 200,
      },
      {
        key: "size",
        name: <Translate value="size" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: "shipping_line",
        name: <Translate value="shipping_line" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: "cargo_weight",
        name: <Translate value="cargo_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: "contact_person",
        name: <Translate value="contact_person" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: "contact_email",
        name: <Translate value="contact_email" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      ...!isKM && [{
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }],
      {
        key: "DispatchDate",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateMonthFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];

    // For Ecity, add SalesMargin Column before SaleStatus
    if (isCT) {
      const indexSalesStatus = _.findIndex(columns, { key: "SaleStatus" });
      const salesMarginColumn = {
        key: "SalesMargin",
        name: <Translate value="sales_margin_percentsign" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: PercentFormatter,
      };
      columns.splice(indexSalesStatus, 0, salesMarginColumn);
    }

    if (isTN) {
      const indexTN = _.findIndex(columns, { key: "InvoiceNum" });
      const cpoCol = {
        key: "CPONum",
        name: <Translate value="cpo_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      }
      const refCol = {
        key: "RefNum",
        name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      }
      columns.splice(indexTN, 0, cpoCol, refCol);

      const orderCol = _.findIndex(columns, { key: "OrderDate" });
      const typeCol = {
        key: "Type",
        name: <Translate value="type" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      }
      columns.splice(orderCol, 0, typeCol);
    }

    // if (isAFG) {
      if (isSDR || isCRW || isSC) {
        // const indexOrderDate1 = _.findIndex(columns, { key: "CreateTime" });
        // const orderColum1 = {
        //   key: "CreateTime",
        // name: <Translate value="created" />,
        // resizable: true,
        // sortable: true,
        // filterable: true,
        // width: 100,
        // };
        // columns.splice(indexOrderDate1, 1, orderColum1);

        if (this.state.salesOrders && this.state.salesOrders.rows && this.state.salesOrders.rows.length > 0) {
          this.state.salesOrders.rows.map((row) => {
            row.CreateTime = moment(row.CreateTime).format("MM-DD-YY HH:mm:ss");
          });
        }

        if (this.state.salesOrders && this.state.salesOrders.rows && this.state.salesOrders.rows.length > 0) {
          this.state.salesOrders.rows.map((row) => {
            row.UpdateTime = moment(row.UpdateTime).format("MM-DD-YY HH:mm:ss");
          });
        }

        // if (this.state.salesOrders && this.state.salesOrders.rows && this.state.salesOrders.rows.length > 0) {
        //   this.state.salesOrders.rows.map((row) => {
        //     row.OrderDate = moment(row.OrderDate).format("MM-DD-YY HH:mm:ss");
        //   });
        // }

        if (this.state.salesOrders && this.state.salesOrders.rows && this.state.salesOrders.rows.length > 0) {
          this.state.salesOrders.rows.map((row) => {
            row.ShipDate = moment(row.ShipDate).format("MM-DD-YY HH:mm:ss");
          });
        }

      }


    if (true) {
      const indexOrderDate = _.findIndex(columns, { key: "OrderDate" });
      const orderColum = {
        key: "OrderDateDisplay",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      };
      columns.splice(indexOrderDate, 1, orderColum);

      if (this.state.salesOrders && this.state.salesOrders.rows && this.state.salesOrders.rows.length > 0) {
        this.state.salesOrders.rows.map((row) => {
          row.OrderDateDisplay = (isSDR || isCRW || isSC || (isLAP || isUSPrideMulti || isAPD)) ? moment(row.OrderDate).format("MM-DD-YY HH:mm:ss") : moment(row.OrderDate).format("MM-DD-YY");
          // row.OrderDateDisplay = moment(row.OrderDate).format("MM-DD-YY HH:mm");
        });
      }

      const jmlTrackingNumColumn = {
        key: "TrackingNum",
        name: <Translate value="tracking_num" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: ({ value }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
            onDoubleClick={() => {
              this.openDisplayTracking();
            }}
          >
            <Translate value="details" />
          </div>
        ),
      };
      if (isJML || isSY) {
        columns.splice(indexOrderDate, 0, jmlTrackingNumColumn);
      }
    }

    if (isMyuMyu || isAFG || isWecom ) {
      const indexEstDelivery = _.findIndex(columns, { key: "DispatchDate" });
      const estColum = {
        key: "DispatchDateDisplay",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 160,
        filterable: true,
      };
      columns.splice(indexEstDelivery, 1, estColum);
      if (this.state.salesOrders && this.state.salesOrders.rows && this.state.salesOrders.rows.length > 0) {
        this.state.salesOrders.rows.map((row) => {
          let date1 = moment
            .utc(moment(row.DispatchDate))
            .local()
            .format("HH:mm");
          let date2 = moment
            .utc(moment(row.DispatchDate))
            .local()
            .subtract(2, "hours")
            .format("MM-DD-YY HH:mm");
          row.DispatchDateDisplay = `${date2}-${date1}`;
        });
      }
    } else if (isAFM || isHMM) {
      const indexEstDelivery = _.findIndex(columns, { key: "DispatchDate" });
      const estColum = {
        key: "TimeRange",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 160,
        filterable: true,
      };
      const FinalNetWeightIndex = _.findIndex(columns, { key: 'FinalNetWeight' });
      const totalQty = {
        key: "TotalQuantity",
        name: <Translate value="total_qty" />,
        resizable: true,
        sortable: true,
        width: 60,
        filterable: true,
      }
      columns.splice(indexEstDelivery, 1, estColum);
      columns.splice(FinalNetWeightIndex, 1, totalQty);
    }
    // else if (isSDR) {
    //   const indexEstDelivery = _.findIndex(columns, { key: "DispatchDate" });
    //   const estColum = {
    //     key: "DispatchDateDisplay",
    //     name: <Translate value="est_delivery" />,
    //     resizable: true,
    //     sortable: true,
    //     width: 160,
    //     filterable: true,
    //   };
    //   columns.splice(indexEstDelivery, 1, estColum);
    //   if (this.state.salesOrders && this.state.salesOrders.rows && this.state.salesOrders.rows.length > 0) {
    //     this.state.salesOrders.rows.map((row) => {
    //       let date2 = moment
    //         .utc(moment(row.DispatchDate))
    //         .local()
    //         .format("MM-DD-YY HH:mm");
    //       row.DispatchDateDisplay = `${date2}`;
    //     });
    //   }
    // }

    if (isGV) {
      columns.splice(5, 0, {
        key: "GvTicketQRCodeUrl",
        name: <Translate value="qr_code" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
        formatter: ({ value }) => {
          if (value) {
            return <a href={value}>download</a>
          } else {
            return null;
          }
        },
      });
    };

    if (isAFM) {
      columns.splice(8, 0, {
        key: "ShippingStatus",
        name: <Translate value="shipping_status" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      });
      columns.splice(9, 0, {
        key: "OrderImage",
        name: <Translate value="order_image" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
        formatter: ({ value }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
            onDoubleClick={() => {
              if (value !== '') {
                this.openShowDriverImage();
              }
            }}
          >
            {value !== '' && <Translate value="show" />}
          </div>
        ),
      });
    }

    if (isTN) {
      const indexDispatchPrice = _.findIndex(columns, { key: "ShipmentDate" });
      const shipByColumn = {
        key: "ShipByDate",
        name: <Translate value="ship_by" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateMonthFormatter,
      };
      const createTimeColumn = {
        key: "CreateTime",
        name: <Translate value="create_time" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateMonthFormatter,
      };
      columns.splice(indexDispatchPrice, 0, shipByColumn, createTimeColumn);
    }
    if (!(isTN || isFIT || isCPG || isSH || isAP || isVIP)) {
      const indexFinalPrice = _.findIndex(columns, { key: "FinalPrice" });
      const discountColumn = {
        key: "discountDisplay",
        name: <Translate value="discount" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      };
      const promoCodeColumn = {
        key: "PromoCode",
        name: <Translate value="promo_code" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        // formatter: PromoCodeFormatter,
      };
      const channelColumn = {
        key: "Channel",
        name: <Translate value="channel" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      };

      if (!isOCM && !isSV && !isPRS && !isLMH && !isBRO && !isSDR && !isCRW && !isSC && !isKM && !isAGD) {
        columns.splice(indexFinalPrice, 0, promoCodeColumn);
      } else if (isPRS) {
        const indexIsUnderBuffer = _.findIndex(columns, { key: "IsUnderBuffer" });
        columns.splice(indexIsUnderBuffer, 0, promoCodeColumn);
      }
      if (this.state.salesOrders && this.state.salesOrders.rows && this.state.salesOrders.rows.length > 0) {
        this.state.salesOrders.rows.map((row) => {
          if (!row.PromoCode) {
            row.PromoCode = "-";
          }
        });
      }

      if (!isKM && !isAGD && !isSV) {
        columns.splice(indexFinalPrice, 0, discountColumn);
      }

      if (this.state.salesOrders && this.state.salesOrders.rows && this.state.salesOrders.rows.length > 0) {
        this.state.salesOrders.rows.map((row) => {
          if (row.Discount !== 0 && row.Savings) {
            row.discountDisplay =
              row.Discount + "% - $" + row.Savings.toFixed(2);
          } else if (row.Discount === 0 && row.Savings !== 0) {
            row.discountDisplay = "$" + row.Savings.toFixed(2);
          } else {
            row.discountDisplay = "-";
          }
        });
      }
      if (isSKH) {
        const promoCodeIdx = _.findIndex(columns, { key: "PromoCode" });
        const salesStatusIdx = _.findIndex(columns, { key: "SaleStatus" });
        const trackingCol = {
          key: "Tracking",
          name: <Translate value="tracking" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          getRowMetaData: row => row,
          formatter: (row) => (
            <div
              style={{ width: "100%", height: "100%", textAlign: "center" }}
              onDoubleClick={() => this.openChangeTrackingModal(row.dependentValues.SalesOrder_id)}
            >
              {row.value}
            </div>
          ),
        };
        const statusCol = {
          key: "SaleStatus",
          name: <Translate value="status" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        };
        const loadIdCol = {
          key: "LoadId",
          name: <Translate value="loadId" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        };
        const scmsynced = {
          key: "scm_synced",
          name: <Translate value="abc_sync" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          getRowMetaData: row => row,
          formatter: (row) => (
            <div
              style={{ width: "100%", height: "100%", textAlign: "center" }}
            >
              {row.value?"YES" : 'NO'}
            </div>
          ),
        };
        columns.splice(salesStatusIdx, 1);
        columns.splice(indexFinalPrice, 0, channelColumn);
        columns.splice(promoCodeIdx, 0, statusCol);
        columns.splice(promoCodeIdx, 0, loadIdCol);
        columns.splice(promoCodeIdx, 0, trackingCol);
        columns.splice(promoCodeIdx, 0, scmsynced);
      }
    }

    // For mobile sales order, replace Sales_User_Name with City
    if (this.context.router.routes[1].path === "mobileSalesOrders") {
      const indexFinalPrice = _.findIndex(columns, { key: "FinalPrice" });
      const groupBuyColumn = {
        key: "IsGroupBuyDisplay",
        name: <Translate value="group_buy" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: ({ value }) => (
          <div style={{ width: "100%", height: "100%", textAlign: "center" }}>
            {value}
          </div>
        ),
      };
      if (isWecom) {
        columns.splice(indexFinalPrice, 0, groupBuyColumn);
        if (this.state.salesOrders.rows.length > 0) {
          this.state.salesOrders.rows.map((row) => {
            if (row.IsGroupBuy === true) {
              row.IsGroupBuyDisplay = "yes";
            } else {
              row.IsGroupBuyDisplay = "no";
            }
          });
        }
      }

      if (isAFG) {
        const alcoholColumn = {
          key: "Alcohol",
          name: <Translate value="alcohol" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        };
        const platformColumn = {
          key: "platform",
          name: <Translate value="platform" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        };
        columns.splice(indexFinalPrice, 0, alcoholColumn);
        columns.splice(indexFinalPrice, 0, platformColumn);
      }

      // Find item index using _.findIndex
      const indexEstDeliveryName = _.findIndex(columns, {
        key: "DispatchDate",
      });
      const indexSalesUserName = _.findIndex(columns, {
        key: "Sales_User_Name",
      });
      const indexCreateTime = _.findIndex(columns, { key: "CreateTime" });
      const descriptionIndex = _.findIndex(columns, { key: "Description" });
      const cityColumn = {
        key: "City",
        name: <Translate value="city" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      };

      const stateColumn = {
        key: "State",
        name: <Translate value="state" />,
        resizable: true,
        sortable: true,
        width: 50,
        filterable: true,
      };

      const shippingWeight = {
        key: "FinalShippingWeight",
        name: <Translate value="shipping_weight" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: ({ value }) => (
          <div style={{ width: "100%", height: "100%" }}>
            {value ? value.toFixed(2) : null}
          </div>
        ),
      };

      const shippingmethodColumn = {
        key: "ShippingMethod",
        name: <Translate value="shipping_method" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      };

      const trackingNumColumn = {
        key: "TrackingNum",
        name: <Translate value="tracking_num" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: ({ value }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
            onDoubleClick={() => {
              if (value === "split") {
                this.openDisplayTracking();
              } else {
                onTrackingNumRouter(value);
              }
            }}
          >
            {value}
          </div>
        ),
      };

      if (isAFG) {
        columns.splice(indexEstDeliveryName, 1);
        columns.splice(indexEstDeliveryName, 0, trackingNumColumn);
      }

      if (!isRivera && !isPRS && !isKM) {
        columns.splice(
          indexSalesUserName,
          1,
          shippingWeight,
          cityColumn,
          stateColumn,
        );
      } else if (!isKM) {
        columns.splice(indexSalesUserName, 1, cityColumn, stateColumn);
      }
      if (!isPRS && !isKM) {
        columns.splice(indexCreateTime, 1, shippingmethodColumn);
      } else {
        columns.splice(indexCreateTime, 1, shippingWeight);
      }
      columns.splice(descriptionIndex, 1); // hide desc on mobile order
    } else {
      // const yuansferColName = _.findIndex(columns, { key: "PaymentType" });
      // columns.splice(yuansferColName, 1); // hide payment on sales order
    }
    if ((isLAP || isUSPrideMulti || isAPD)) {
      const indexETDate = _.findIndex(columns, { key: "ETDate" });
      if (indexETDate !== -1) {
        columns.splice(indexETDate, 0, {
          key: "ShippingMethod",
          name: <Translate value="shipping_method" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        });
      }
    }

    if (isFIT) {
      const trackingNumColumn = {
        key: "TrackingNum",
        name: <Translate value="tracking_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
      };
      const index = _.findIndex(columns, { key: "SaleStatus" });
      columns.splice(index+1, 0, trackingNumColumn);
    }

    const ABCColumn = [
      {
        key: "SONum",
        name: <Translate value="so_num" />,
        resizable: true,
        width: 120,
        filterable: true,
        locked: true,
      },
      {
        key: "CompanyName",
        name: <Translate value="company_name" />,
        resizable: true,
        width: 120,
        filterable: true,
        locked: true,
      },
      {
        key: "CreateTime",
        name: <Translate value="date" />,
        resizable: true,
        width: 120,
        filterable: true,
        locked: true,
        formatter: SecondsDateFormatter,
      },
      {
        key: "FBACode",
        name: <Translate value="FBA" />,
        resizable: true,
        width: 120,
        filterable: true,
        locked: true,
      },
      {
        key: "CustomerBOLNo",
        name: <Translate value="BOL" />,
        resizable: true,
        width: 120,
        filterable: true,
        locked: true,
      },
      {
        key: "TotalPalletQuantity",
        name: <Translate value="plt" />,
        resizable: true,
        width: 70,
        filterable: true,
      },
      {
        key: "TotalInboundQuantity",
        name: <Translate value="inbound_plt" />,
        resizable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "TotalOutboundQuantity",
        name: <Translate value="outbound_plt" />,
        resizable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "ESTInboundDate",
        name: <Translate value="EST_date" />,
        resizable: true,
        width: 150,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "IsaNo",
        name: <Translate value="ISA" />,
        resizable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "Reason",
        name: <Translate value="reason" />,
        resizable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div
            style={{color: value ? 'red' : ''}}
          >
            { value }
          </div>
        ),
      },
      {
        key: "TotalCartonQuantity",
        name: <Translate value="ctn" />,
        resizable: true,
        width: 70,
        filterable: true,
      },
      {
        key: "ShippingStatus",
        name: <Translate value="shpping_status" />,
        resizable: true,
        width: 70,
        filterable: true,
      },
      {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "PodFileUrl",
        name: <Translate value="pod" />,
        resizable: true,
        width: 90,
        filterable: true,
        formatter: ({ value }) => (
          <a
            style={{color: value ? 'green' : '', cursor: 'pointer'}}
            href={value}
          >
            { value && 'uploaded' }
          </a>
        ),
      },
      {
        key: "ContainerNo",
        name: <Translate value="container" />,
        resizable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "PickUpDriverName",
        name: <Translate value="inbound_driver" />,
        resizable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "OutboundDriverName",
        name: <Translate value="outbound_driver" />,
        resizable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "ShipFrom",
        name: <Translate value="ship_from" />,
        resizable: true,
        width: 200,
        filterable: true,
      },
      {
        key: "ShipTo",
        name: <Translate value="ship_to" />,
        resizable: true,
        width: 200,
        filterable: true,
      },
    ];

    const USPrideColumn = [
      {
        key: "SONum",
        name: <Translate value="SONum" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="store_name" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },

      {
        key: "PONum",
        name: <Translate value="CPO" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "OrderDate",
        name: <Translate value="po_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        // formatter: isUSPrideMulti ? SecondsDateFormatter : DateFormatter,
      },
      {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Tracking",
        name: <Translate value="tracking" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        // getRowMetaData: row => row,
        // formatter: (props) => {
        //   if (!props.value) {
        //     return <div>{props.dependentValues.TTracking}</div>
        //   } else {
        //     return <div>{props.value}</div>
        //   }
        // }
      },
      {
        key: "Store",
        name: <Translate value="store" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      // {
      //   key: "warehouse_num",
      //   name: <Translate value="warehouse_num" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 95,
      //   filterable: true,
      // },
      // {
      //   key: "TeapplixSynced",
      //   name: <Translate value="teapplix_synced" />,
      //   sortable: true,
      //   width: 95,
      //   filterable: true,
      //   formatter: ({ value, dependentValues }) => (
      //     <div>
      //       { (value === true || value === 'true') ? "Synced" : "Not Synced" }
      //     </div>
      //   ),
      // },
      // {
      //   key: "isReset",
      //   name: <Translate value="has_reset" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 70,
      //   filterable: true,
      // },
      {
        key: "SaleStatus",
        name: <Translate value="sales_status" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        getRowMetaData: row => row,
        formatter: (row) => {
          const IsMonitor = row.dependentValues.IsMonitor;
          const IsMonitorStyle = {
            color: 'orange',
            fontWeight: 'bold'
          }
          return <div style={{ width: '100', cursor: 'pointer', ...IsMonitor&&IsMonitorStyle }} onDoubleClick={() => this.handleSalesStatusClick(row.dependentValues)}>{row.value}</div>
        }
      },
      // {
      //   key: "SalesName",
      //   name: <Translate value="sales" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 100,
      //   filterable: true,
      // },
      // {
      //   key: "TrackingNum",
      //   name: <Translate value="tracking_num" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 160,
      //   filterable: true,
      //   getRowMetaData: (row) => row,
      //   formatter: ({ value, dependentValues }) => (
      //     <div
      //       style={{ width: "100%", height: "100%", textAlign: "center" }}
      //       onDoubleClick={() => {
      //         // uspride lala
      //         // if (isUSPride) {
      //         //   this.openChangeTracking(value, dependentValues);
      //         // }
      //       }}
      //     >
      //       {value}
      //     </div>
      //   ),
      // },
      // {
      //   key: "WarehouseName",
      //   name: <Translate value="warehouse" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 100,
      //   filterable: true,
      // },
      // {
      //   key: "poNum",
      //   name: <Translate value="po_num" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 100,
      //   filterable: true,
      // },
      // ...(this.context.router.routes[1].path === "mobileSalesOrders") ? [      {
      //   key: "ProductRefNums",
      //   name: <Translate value="SKUs" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 90,
      //   filterable: true,
      // }] : [],
      {
        key: "DispatchDate",
        name: <Translate value="must_ship_by" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
      // {
      //   key: "backorderDate",
      //   name: <Translate value="backorder_date" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 120,
      //   filterable: true,
      //   formatter: SecondsDateFormatter,
      // },
      // {
      //   key: "ExternalStatus",
      //   name: <Translate value="order_status" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 120,
      //   filterable: true,
      // },
      // {
      //   key: "SaleStatus",
      //   name: <Translate value="sale_status" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 100,
      //   filterable: true,
      // },
      {
        key: "ShippingStatus",
        name: <Translate value="shipping_status" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ShippingMethod",
        name: <Translate value="shipping_method" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      // {
      //   key: "carrierName",
      //   name: <Translate value="carrier_name" />,
      //   resizable: true,
      //   sortable: true,
      //   width: 100,
      //   filterable: true,
      // },
      {
        key: "shipToName",
        name: <Translate value="ship_to_name" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        name: <Translate value="ship_to_address" />,
        resizable: true,
        sortable: true,
        width: 250,
        filterable: true,
        getRowMetaData: (row) => row,
        formatter: shippingAddressFormatter,
      },
      {
        key: "Deliver_CustomerPhone",
        name: <Translate value="ship_to_phone" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "shipToSpeed",
        name: <Translate value="ship_to_speed" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "SalesName",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
    ];

    const ABCFFColumn = (this.context.router.routes[1].path === 'outboundOrders' || this.context.router.routes[1].path === 'mobileSalesOrders')  ?
    [
      {
        key: "SONum",
        name: <Translate value="ob_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      }, {
        key: "CPONum",
        name: <Translate value="cpo" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      }, {
        key: "TrackingNum",
        name: <Translate value="tracking_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: ({ value }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
            onDoubleClick={() => {
              if (!value) {
                this.openTrackingForm();
              }
            }}
          >
            {value ? value : "-"}
          </div>
        ),
      }, {
        key: "Channel",
        name: <Translate value="channel" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },  {
        key: "LoadId",
        name: <Translate value="loadId" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
      }, {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }, {
        key: "AddressName",
        name: <Translate value="name" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "Street",
        name: <Translate value="street" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "State",
        name: <Translate value="state" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
      }, {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: DateFormatter,
      }, {
        key: "DispatchDate",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      }, {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      }, {
        key: "OrderPalletQty",
        name: <Translate value="pallet_qty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },  {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      }, {
        key: "IsDirectShip",
        name: <Translate value="direct_ship" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "Port",
        name: <Translate value="port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "LFDate",
        name: <Translate value="LF_Date" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "IsDO",
        name: <Translate value="IsDO" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "IsBOL",
        name: <Translate value="IsBOL" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "IsPOD",
        name: <Translate value="IsPOD" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "TruckingCo",
        name: <Translate value="trucking_co" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "DeliverTo",
        name: <Translate value="deliver_to" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "IsReturnEmpty",
        name: <Translate value="return_empty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "ArrivalDate",
        name: <Translate value="arrival_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "ReturnDate",
        name: <Translate value="return_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "StorageOutDate",
        name: <Translate value="storage_out" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }, {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      }, {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      }, {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }, {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      }, {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ] : [
      {
        key: "SONum",
        name: <Translate value="ib_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      }, {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      }, {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }, {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      }, {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => {
          return (
            <div>
             {dependentValues.ContainerNum_lines ? dependentValues.ContainerNum_lines : value}
            </div>
          )
        }
      }, {
        key: "Appointment",
        name: <Translate value="apnt_time" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      }, {
        key: "AppointmentDate",
        name: <Translate value="apnt_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "ISANum",
        name: <Translate value="isa" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      }, {
        key: "OrderPalletQty",
        name: <Translate value="pallet_qty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "Port",
        name: <Translate value="port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "LFDate",
        name: <Translate value="LF_Date" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "TrackingNum",
        name: <Translate value="tracking_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      }, {
        key: "IsDO",
        name: <Translate value="IsDO" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "IsBOL",
        name: <Translate value="IsBOL" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "IsPOD",
        name: <Translate value="IsPOD" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "TruckingCo",
        name: <Translate value="trucking_co" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "DeliverTo",
        name: <Translate value="deliver_to" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: "IsReturnEmpty",
        name: <Translate value="return_empty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      }, {
        key: "ArrivalDate",
        name: <Translate value="arrival_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "ReturnDate",
        name: <Translate value="return_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "StorageInDate",
        name: <Translate value="storage_in" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      }, {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }, {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      }, {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      }, {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }, {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      }, {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      }, {
        key: "DispatchDate",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateFormatter,
      }, {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];

    const DSQColumn = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "SONum",
        name: <Translate value="ob_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "DSQID",
        name: <Translate value="dsq_id" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Appointment",
        name: <Translate value="apnt_time" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "AppointmentDate",
        name: <Translate value="apnt_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ISANum",
        name: <Translate value="isa" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "OrderPalletQty",
        name: <Translate value="pallet_qty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "IsDirectShip",
        name: <Translate value="direct_ship" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Port",
        name: <Translate value="port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "LFDate",
        name: <Translate value="LF_Date" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "IsDO",
        name: <Translate value="IsDO" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsBOL",
        name: <Translate value="IsBOL" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsPOD",
        name: <Translate value="IsPOD" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "TruckingCo",
        name: <Translate value="trucking_co" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DeliverTo",
        name: <Translate value="deliver_to" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "IsReturnEmpty",
        name: <Translate value="return_empty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "ArrivalDate",
        name: <Translate value="arrival_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ReturnDate",
        name: <Translate value="return_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageInDate",
        name: <Translate value="storage_in" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageOutDate",
        name: <Translate value="storage_out" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "DispatchDate",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateMonthFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ] : [
      {
        key: "SONum",
        name: <Translate value="ib_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "DSQID",
        name: <Translate value="dsq_id" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Appointment",
        name: <Translate value="apnt_time" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "AppointmentDate",
        name: <Translate value="apnt_date" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ISANum",
        name: <Translate value="isa" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "OrderPalletQty",
        name: <Translate value="pallet_qty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Port",
        name: <Translate value="port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "LFDate",
        name: <Translate value="LF_Date" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "IsDO",
        name: <Translate value="IsDO" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsBOL",
        name: <Translate value="IsBOL" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsPOD",
        name: <Translate value="IsPOD" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "TruckingCo",
        name: <Translate value="trucking_co" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DeliverTo",
        name: <Translate value="deliver_to" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "IsReturnEmpty",
        name: <Translate value="return_empty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "ArrivalDate",
        name: <Translate value="arrival_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ReturnDate",
        name: <Translate value="return_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageInDate",
        name: <Translate value="storage_in" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageOutDate",
        name: <Translate value="storage_out" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "DispatchDate",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateMonthFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];

    const JTBColumn = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "SONum",
        name: <Translate value="ob_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ContainerSize",
        name: <Translate value="container_size" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "OrderType",
        name: <Translate value="order_type" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropshipType",
        name: <Translate value="dropship_type" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Port",
        name: <Translate value="port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "BOL",
        name: <Translate value="BOL" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "POD",
        name: <Translate value="POD" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "FBARoute",
        name: <Translate value="fba_route" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Appointment",
        name: <Translate value="appointment" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "TruckingCo",
        name: <Translate value="trucking_co" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DeliverTo",
        name: <Translate value="deliver_to" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "IsReturnEmpty",
        name: <Translate value="return_empty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "ArrivalDate",
        name: <Translate value="arrival_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ReturnDate",
        name: <Translate value="return_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageInDate",
        name: <Translate value="storage_in" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageOutDate",
        name: <Translate value="storage_out" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "DispatchDate",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateMonthFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ] : [
      {
        key: "SONum",
        name: <Translate value="ib_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ContainerSize",
        name: <Translate value="container_size" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ReceiveType",
        name: <Translate value="receive_type" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ReceiveUnit",
        name: <Translate value="receive_unit" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Port",
        name: <Translate value="port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "BOL",
        name: <Translate value="BOL" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "POD",
        name: <Translate value="POD" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "FBARoute",
        name: <Translate value="fba_route" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Appointment",
        name: <Translate value="appointment" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "TruckingCo",
        name: <Translate value="trucking_co" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DeliverTo",
        name: <Translate value="deliver_to" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "IsReturnEmpty",
        name: <Translate value="return_empty" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "ArrivalDate",
        name: <Translate value="arrival_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "ReturnDate",
        name: <Translate value="return_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageInDate",
        name: <Translate value="storage_in" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "StorageOutDate",
        name: <Translate value="storage_out" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: isTN ? "ClientCustName" : "Description",
        name: isTN ? "Client.Cust" : <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "DispatchDate",
        name: isTN ? <Translate value="ship_date" /> : <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateMonthFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];

    const WIZColumn = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "SONum",
        name: <Translate value="ob_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "OutboundStatus",
        name: <Translate value="outbound_status" />,
        resizable: true,
        sortable: true,
        width: 130,
        filterable: true,
      },
      {
        key: "Trucker",
        name: <Translate value="trucker" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ReleaseDate",
        name: <Translate value="release_date" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateMonthFormatter,
      },
      {
        key: "ReadyDate",
        name: <Translate value="ready_date" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateMonthFormatter,
      },
      {
        key: "OutboundDate",
        name: <Translate value="outbound_date" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateMonthFormatter,
      },
      {
        key: "ShipmentID",
        name: <Translate value="shipment_id" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Destination",
        name: <Translate value="destination" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ISANum",
        name: <Translate value="isa" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Notation",
        name: <Translate value="customer_note" />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
      },
      {
        key: "EmployeeNote",
        name: <Translate value="employee_note" />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "DispatchDate",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateMonthFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ] : [
      {
        key: "SONum",
        name: <Translate value="ib_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: "ContainerSize",
        name: <Translate value="container_size" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Notation",
        name: <Translate value="customer_note" />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
      },
      {
        key: "EmployeeNote",
        name: <Translate value="employee_note" />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "DispatchDate",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateMonthFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="arrived" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];

    const FJCompleteBackground = (props) => {
      const rowBackground = props.dependentValues.IsComplete
        ? "#4caf50"
        : '';
      return (
        <div style={{ backgroundColor: rowBackground }}>
          <span>{ props.value }</span>
        </div>
      );
    };

    const FJColumn = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "SONum",
        name: <Translate value="ob_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
        formatter: FJCompleteBackground,
        getRowMetaData: row => row,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "Agent",
        name: <Translate value="agent" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Carrier",
        name: <Translate value="carrier" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DeliverByDate",
        name: <Translate value="deliver_by_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DeliverByTime",
        name: <Translate value="deliver_by_time" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ExtInvoiceNum",
        name: <Translate value="ext_invoice" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Broker",
        name: <Translate value="broker" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Truckload",
        name: <Translate value="truckload" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "TruckNum",
        name: <Translate value="truck_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupDriver",
        name: <Translate value="pickup_driver" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffDriver",
        name: <Translate value="dropoff_driver" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupTrailerNum",
        name: <Translate value="pickup_trailer" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffTrailerNum",
        name: <Translate value="dropoff_trailer" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupDate",
        name: <Translate value="pickup_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "PickupTime",
        name: <Translate value="pickup_time" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffDate",
        name: <Translate value="dropoff_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "DropoffTime",
        name: <Translate value="dropoff_time" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupCity",
        name: <Translate value="pickup_city" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffCity",
        name: <Translate value="dropoff_city" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupState",
        name: <Translate value="pickup_state" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffState",
        name: <Translate value="dropoff_state" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Dispatch",
        name: <Translate value="dispatch" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DetentionRate",
        name: <Translate value="detention_rate" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "LumperFee",
        name: <Translate value="lumper_fee" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ] : [
      {
        key: "SONum",
        name: <Translate value="ib_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
        formatter: FJCompleteBackground,
        getRowMetaData: row => row,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "Agent",
        name: <Translate value="agent" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ContainerNum",
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "ExtInvoiceNum",
        name: <Translate value="ext_invoice" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Broker",
        name: <Translate value="broker" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Truckload",
        name: <Translate value="truckload" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "TruckNum",
        name: <Translate value="truck_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupDriver",
        name: <Translate value="pickup_driver" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffDriver",
        name: <Translate value="dropoff_driver" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupTrailerNum",
        name: <Translate value="pickup_trailer" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffTrailerNum",
        name: <Translate value="dropoff_trailer" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupDate",
        name: <Translate value="pickup_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "PickupTime",
        name: <Translate value="pickup_time" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffDate",
        name: <Translate value="dropoff_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: DateFormatter2,
      },
      {
        key: "DropoffTime",
        name: <Translate value="dropoff_time" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupCity",
        name: <Translate value="pickup_city" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffCity",
        name: <Translate value="dropoff_city" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "PickupState",
        name: <Translate value="pickup_state" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DropoffState",
        name: <Translate value="dropoff_state" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Dispatch",
        name: <Translate value="dispatch" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "DetentionRate",
        name: <Translate value="detention_rate" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "LumperFee",
        name: <Translate value="lumper_fee" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },

      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];

    const olgColumn = this.context.router.routes && this.context.router.routes.length > 0 && this.context.router.routes[1].path === "mobileSalesOrders"?
    [
      {
        key: "SONum",
        name: <Translate value="so_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "ShippingMethod",
        name: <Translate value="shipping_method" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "discountDisplay",
        name: <Translate value="discount" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "PromoCode",
        name: <Translate value="promo_code" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Picker_Name",
        name: <Translate value="picker" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "FinalNetWeight",
        name: <Translate value="final_weight_lbs" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "FinalShippingWeight",
        name: <Translate value="shipping_weight" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: ({ value }) => (
          <div style={{ width: "100%", height: "100%" }}>
            {value ? value.toFixed(2) : null}
          </div>
        ),
      },
      {
        key: "Modifier_User_Name",
        name: <Translate value="modifier" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "IsUnderBuffer",
        name: <Translate value="under_buffer" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => (
          <div style={{ textAlign: 'center', backgroundColor: dependentValues.IsUnderBuffer ? "orange" : "inherit"}}>
            { (value === true || value === 'true') ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "City",
        name: <Translate value="city" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "State",
        name: <Translate value="state" />,
        resizable: true,
        sortable: true,
        width: 50,
        filterable: true,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "DispatchDate",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateMonthFormatter,
      },
    ]:[
      {
        key: "SONum",
        name: <Translate value="so_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: soNumWidth,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "ShippingMethod",
        name: <Translate value="shipping_method" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 115,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "discountDisplay",
        name: <Translate value="discount" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "PromoCode",
        name: <Translate value="promo_code" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Picker_Name",
        name: <Translate value="picker" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Description",
        name: <Translate value="desc" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 124,
      },
      {
        key: "FinalNetWeight",
        name: <Translate value="final_weight_lbs" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "Modifier_User_Name",
        name: <Translate value="modifier" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "IsUnderBuffer",
        name: <Translate value="under_buffer" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => (
          <div style={{ textAlign: 'center', backgroundColor: dependentValues.IsUnderBuffer ? "orange" : "inherit"}}>
            { (value === true || value === 'true') ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: (row) => {
          return<span>{converTimeUTCToLocal(row.value)}</span>
        }
      },
      {
        key: "DispatchDate",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: DateMonthFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];

    let limitSelection = [
      {
        label: '25',
        value: 25,
        name: 'limit',
      },
      {
        label: '50',
        value: 50,
        name: 'limit',
      },
      {
        label: '100',
        value: 100,
        name: 'limit',
      },
      {
        label: <Translate value="all" />,
        value: 99999,
        name: 'limit',
      },
    ]

    if (isSH || isAP) {
      limitSelection = [{
        label: '10',
        value: 10,
        name: 'limit',
      }, {
        label: '20',
        value: 20,
        name: 'limit',
      }, {
        label: '50',
        value: 50,
        name: 'limit',
      },{
       label: '100',
       value: 100,
       name: 'limit',
      }]
    }

    if (isOCM || isVAK) {
      limitSelection = [{
        label: '30',
        value: 30,
        name: 'limit',
      }]
    }
    if (isKM) {
      limitSelection = [{
        label: '100',
        value: 100,
        name: 'limit',
      }, {
        label: '200',
        value: 200,
        name: 'limit',
      }, {
        label: '500',
        value: 500,
        name: 'limit',
      }]
    }

    if (isABBLE || isAGD || isSV) {
      limitSelection = [{
        label: '100',
        value: 100,
        name: 'limit',
      }, {
        label: '200',
        value: 200,
        name: 'limit',
      }, {
        label: '500',
        value: 500,
        name: 'limit',
      },
      {
        label: 'all',
        value: 10000,
        name: 'limit',
      }]
    }

    if (isSKH) {
      const shippingMethodIdx = _.findIndex(columns, { key: 'ShippingMethod' });
      const trackingIdx = _.findIndex(columns, { key: "Tracking" });
      const ShippingMethodCol = {
        key: "ShippingMethod",
        name: <Translate value="shipping_method" />,
        resizable: true,
        sortable: true,
        width: 140,
        filterable: true,
      }
      columns.splice(shippingMethodIdx, 1);
      columns.splice(trackingIdx + 1, 0, ShippingMethodCol);
    }

    if (isCPG || isVIP) {
      const promoIndex = _.findIndex(columns, { key: "PromoCode" });
      const OrderImageIndex = _.findIndex(columns, { key: "OrderImage" });
      const OrderDateDisplayIndex = _.findIndex(columns, { key: "OrderDateDisplay" });
      const OrderDateCol = {
        key: "OrderDate", // OrderDateDisplay
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: SecondsDateFormatter,
      }
      const DispatchDateCol = {
        key: "DispatchDate",
        name: <Translate value="dispatch_date" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: SecondsDateFormatter,
      }

      const OrderDateIndex = _.findIndex(columns, { key: 'OrderDate' });
      columns.splice(OrderDateIndex, 1);
      columns.splice(promoIndex, 1);
      columns.splice(OrderDateDisplayIndex, 1);
      columns.splice(OrderImageIndex, 0, DispatchDateCol);
      columns.splice(OrderImageIndex, 0, OrderDateCol);
    }

    if (isSUN) {
      const customerNameIndex = _.findIndex(columns, { key: "Deliver_CustomerName" });
      const poNum = {
        key: "PONum",
        name: <Translate value="CPO" />,
        resizable: true,
        sortable: true,
        width: 140,
        filterable: true,
      }
      columns.splice(customerNameIndex, 0, poNum);

    }
    if (isVAK) {
      const statusIndex = columns.findIndex(column => column.key === 'SaleStatus');
      if (statusIndex !== -1) {
        columns.splice(statusIndex, 0, {
          key: "Review_Status",
          name: <Translate value="review_status" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          getRowMetaData: row => row,
          formatter: ({dependentValues}) => {
            if (dependentValues.SaleStatus === 'Quote') {
              return <span>{dependentValues.Req_Review_Status && <Translate value={dependentValues.Req_Review_Status} />}</span>
            } else {
              return <span>{dependentValues.Review_Status && <Translate value={dependentValues.Review_Status} />}</span>
            }
          }
        }, {
          key: "Approve_Status",
          name: <Translate value="approve_status" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          getRowMetaData: row => row,
          formatter: ({dependentValues}) => {
            if (dependentValues.SaleStatus === 'Quote') {
              return <span>{dependentValues.Req_Approve_Status && <Translate value={dependentValues.Req_Approve_Status} />}</span>
            } else {
              return <span>{dependentValues.Approve_Status && <Translate value={dependentValues.Approve_Status} />}</span>
            }
          }
        });
      }
    }
    const generateColumns = () => {
      if (isABC) {
        return ABCColumn;
      }
      if (isUSPrideMulti) {
        return USPrideColumn;
      }
      if (isDSQ) {
        return DSQColumn;
      }
      if (isJTB) {
        return JTBColumn;
      }
      if (isWIZ) {
        return WIZColumn;
      }
      if (isFJ) {
        return FJColumn;
      }
      if (isMAG) {
        return MAGColumn;
      }
      if (isABCFF) {
        return ABCFFColumn;
      }
      if (isOLG) {
        return olgColumn;
      }
      if (isSV) {
        return columnsSV;
      }
      if(isAP) {
        return apColumns;
      }
      return columns;
    }
    const renderTotalOrders = () => {
      let totalOrders = (isVAK || isOLG) ? this.state.totalOrders : this.state.rowsCount
      return `${totalOrders} - ${
        this.state.canceledOrders
      } = ${totalOrders - this.state.canceledOrders}`
    }
    const showPagination = (((isOCM || isSW || isAP) && !isMobile) || (isABC && this.context.router.routes[1].path !== 'salesOrders') || isVAK || isOLG || isKM || isAGD || isSV || isSH || ((isABBLE) && isMobile) );
    const totalPages = (isOCM || isKM || isSW || isABBLE || isAGD || isSV || isSH || isAP) ? this.props.totalPages : this.props.msoTotalPages

    let selectedOrderCount = 0;
    if (this.state.salesOrders && this.state.salesOrders.selectedRows && this.state.salesOrders.selectedRows.length > 0) {
      selectedOrderCount = this.state.salesOrders.selectedRows.length;
    }
    if(isGGI) {
      const descriptionIndex = _.findIndex(columns, { key: 'Description' });
      moveColumnToPosition(columns, {key: 'SaleStatus'}, descriptionIndex+1);
      moveColumnToPosition(columns, {key: 'OrderDateDisplay'}, descriptionIndex+2);
      moveColumnToPosition(columns, {key: 'DispatchDate'}, descriptionIndex+3);
      moveColumnToPosition(columns, {key: 'ShipmentDate'}, descriptionIndex+4);
    }
    let children = {}
    if(!(isGGI || isVAK || isOLG)) {
      children.rowRenderer=<RowRenderer />
    }
    return (
      // React Table Sales Order History Table
      <div id={!(isABBLE || isAGD || isUSPrideMulti) && "TNMSOTable"}>
        <Row>
          <Col xs={12}>
            {/* here */}
            <div id="salesOrders-dataGrid1o">
              {/*  */}
              <ReactDataGrid
                {...children}
                rowKey="SalesOrder_id"
                ref={(g) => {
                  this.grid = g;
                }}
                overScan={{rowsStart: 500, rowsEnd: 500}}
                onGridSort={handleGridSort}
                // sortColumn={this.state.salesOrders.sortColumn}
                // sortDirection={this.state.salesOrders.sortDirection}
                toolbar={isABC ? null : <ToolBarCustom />}
                onAddFilter={handleFilterChange}
                columns={generateColumns()}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onClearFilters={onClearFilters}
                minHeight={tableHeight - (isABC ? 100 : 0)}
                enableRowSelect="multi"
                rowSelection={{
                  showCheckbox: true,
                  enableShiftSelect: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: "isSelected",
                  },
                }}
                enableCellSelect
                onRowClick={onRowClick}
                onRowSelect={onRowSelect}
                onCellSelected={onCellSelected}
                onRowsSelected={onRowsSelected}
                onRowsDeselected={onRowsDeselected}
              />
            </div>
          </Col>
        </Row>
        {
          showPagination &&
          <Row>
            <Col xs={6} style={{display: 'flex'}}>
              <div style={{ width: '600px' }} id="react-pagination">
                <ReactPaginate
                  previousLabel={<Translate value="prev_page" />}
                  nextLabel={<Translate value="next_page" />}
                  containerClassName={'pagination'}
                  activeClassName={'active'}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  pageCount={totalPages}
                  onPageChange={handleOnPageChange}
                  forcePage={this.state.currentPage}
                />
              </div>
              <div  style={{ width: '100px', marginTop: '6px', marginLeft: '15px'}}>
                <Dropdown>
                  <Dropdown.Toggle style={{ height: '28px', width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                    {this.state.limitDisplay}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="super-colors">
                    {limitSelection.map(el => {
                      return (
                        <MenuItem onClick={() => handleLimitChange(el)}>{el.label}</MenuItem>
                      )
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>
            {/* <Col className="col-sm-3" style={{ width: '90px' }} > */}
            {/*<Col xs={6} >
              <Dropdown>
                <Dropdown.Toggle style={{ width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                  {this.state.limitDisplay}
                </Dropdown.Toggle>
                <Dropdown.Menu className="super-colors">
                  {limitSelection.map(el => {
                    return (
                      <MenuItem onClick={() => handleLimitChange(el)}>{el.label}</MenuItem>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </Col>*/}
          </Row>
        }
        { !isABC &&
          <Row>
            <Col xs={12}>
              <div>
                <Col xs={2}>
                  <label className="row-count">
                    <Translate value="total_orders" />
                    :&nbsp;
                    <span className="font-color-orange" id="row-count-equation">
                      {renderTotalOrders()}
                    </span>
                  </label>
                  <br/>
                  <label className="row-count" style={{marginTop: '0px'}}>
                    <Translate value="selected_sales_orders" />
                    :&nbsp;
                    <span className="font-color-orange" id="row-count-equation">
                      {selectedOrderCount}
                    </span>
                  </label>
                </Col>
                <Col xs={6}>
                  <label className="grand-total">
                    <span className="grand-total-label">
                      <Translate value="grand_total" />
                      :&nbsp;
                    </span>
                    <span className="font-color-grey" id="total-equation">
                      {`$${numberWithCommas(
                        (this.state.total || 0).toFixed(2)
                      )} - $${numberWithCommas(
                        (this.state.canceledTotal || 0).toFixed(2)
                      )} = $${numberWithCommas(
                        (this.state.total - this.state.canceledTotal).toFixed(2)
                      )}`}
                    </span>
                  </label>
                  <label className="grand-total" style={{ marginTop: '0px' }}>
                    <span className="grand-total-label">
                      <Translate value="total_weight" />
                      :&nbsp;
                    </span>
                    <span className="font-color-grey" id="total-equation">
                      {`${numberWithCommas(
                        (this.state.totalNetWeight || 0).toFixed(2)
                      )} - ${numberWithCommas(
                        (this.state.totalCancelledNetWeight || 0).toFixed(2)
                      )} = ${numberWithCommas(
                        (this.state.totalNetWeight - this.state.totalCancelledNetWeight).toFixed(2)
                      )}`}
                    </span>
                  </label>
                  {this.renderTotalQty()}
                </Col>
                <Col xs={4}>
                  <div className="mso-footnotes">
                    <span>
                      <Translate value="msg_total_orders_equation" />
                    </span>
                    <span>
                      <Translate value="msg_grand_total_equation" />
                    </span>
                    <span>
                      <Translate value="msg_total_weight_equation" />
                    </span>
                    {this.renderTotalQtyDestion()}
                  </div>
                </Col>
              </div>
            </Col>
          </Row>
        }
      </div>
    );
  }
  renderMobileTableVAK(isEzgo = false) {
    if(isVAK && this.props.isLoading && !isEzgo) {
      return <WidgetsSpinner />
    }
    let tableHeight = 500;
    const getRows = () => Data.Selectors.getRows(this.state.salesOrders);
    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      let rows = getRows();
      let rowItem = rows[rowIdx];
      return rowItem;
    };

    const onClearFilters = () => {
      // all filters removed
      const salesOrders = { ...this.state.salesOrders, filters: {} };
      this.setState({ salesOrders }, () => {
        handleOnPageChange({
          selected: 0,
        })
      })
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.salesOrders, {
        sortColumn,
        sortDirection,
      });
      if (state.sortColumn === "OrderDateDisplay") {
        state.sortColumn = "OrderDate";
      }
      if (isEzgo && state.sortColumn === "Customer_Info") {
        state.sortColumn = "Country";
      }

      if (state.sortDirection === "ASC") {
        this.state.pullSheetSort = state.sortColumn;
      } else if (state.sortDirection === "DESC") {
        this.state.pullSheetSort = `-${state.sortColumn}`;
      } else {
        this.state.pullSheetSort = "";
      }
      this.setState({ salesOrders: state });
      const route = this.context.router.routes[1].path;
      let filterParams = "";
      const filterPaires = [];
      if(this.state.pullSheetSort) {
        filterPaires.push(['order_by', this.state.pullSheetSort].join('='))
      }
      if(this.props.store_name && this.props.store_name.label != 'All') {
        filterPaires.push(['store_name', this.props.store_name.label].join('='))
      }
      _.forOwn(this.state.salesOrders.filters, (value, key) => {
        filterPaires.push([key, value.filterTerm].join('='))
      });
      filterParams = filterPaires.join('&');
      this.props.fetchSalesOrdersByFilter(
        this.state.FromDate,
        this.state.ToDate,
        this.state.days,
        this.state.Status,
          null,
          null,
          route,
          this.state.dispatchDateLT,
          this.state.dispatchDateGT,
          this.state.dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterParams,
      );
      this.setState({ salesOrders: state, currentPage: 0 });
    };

    const handleFilterChange = debounce(
      (filter) => {
        this.state.total = 0;
        this.state.salesOrders.rows = this.props.salesOrders.Orders;
        this.state.salesOrders.selectedRows = [];
        let filterParams = "";
        const newFilters = Object.assign({}, this.state.salesOrders.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const salesOrders = { ...this.state.salesOrders, filters: newFilters };
        this.setState({ salesOrders }, () => {
          if (filter.column.key === "SONum" || filter.column.key === "InvoiceNum" || filter.column.key === "Deliver_Customer_num" || filter.column.key === "Deliver_CustomerName" || filter.column.key === "Sales_User_Name" || filter.column.key === "PONum" || filter.column.key === "Platform_Num"
          || filter.column.key === "FinalPrice"|| filter.column.key === "EmployeeNote" || filter.column.key === "FinalNetWeight"|| filter.column.key === "tracking_num"||filter.column.key === "PKNum") {
            handleOnPageChange({
              selected: 0
            })
          }
        });
      },
      500,
      { maxWait: 800 },
    );
    // Handle the row select function
    const onRowClick = (rowIdx, row) => {
      if (rowIdx !== -1) {
        const rows = getRows();
        rows.map((r) => {
          r.isSelected = false;
        });
        const selectedRows = [rows[rowIdx]];
        rows[rowIdx].isSelected = true;
        const salesOrders = { ...this.state.salesOrders, rows, selectedRows };
        this.setState({ salesOrders });
      }
    };

    const handleLimitChange = (el) => {
      this.state.currentPage = 0;
      this.state.limit = el.value;
      this.state.limitDisplay = el.label;
      const route = this.context.router.routes[1].path;

      let salesOrders = {
        ...this.state.salesOrders,
        selectedRows: [],
      };
      this.setState({ salesOrders });


      let filterParams = "";
      const filterPaires = [];
      if(this.state.pullSheetSort) {
        filterPaires.push(['order_by', this.state.pullSheetSort].join('='))
      }
      if(this.props.store_name && this.props.store_name.label != 'All') {
        filterPaires.push(['store_name', this.props.store_name.label].join('='))
      }
      _.forOwn(this.state.salesOrders.filters, (value, key) => {
        filterPaires.push([key, value.filterTerm].join('='))
      });
      filterParams = filterPaires.join('&');
      this.props.fetchSalesOrdersByFilter(
        this.state.FromDate,
        this.state.ToDate,
        this.state.days,
        this.state.Status,
        null,
        null,
        route,
        this.state.dispatchDateLT,
        this.state.dispatchDateGT,
        this.state.dispatchDays,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        filterParams,
      );
      // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    const handleOnPageChange = (data) => {
      this.state.currentPage = data.selected;
      const route = this.context.router.routes[1].path;
      let filterParams = "";
      let salesOrders = {
        ...this.state.salesOrders,
        selectedRows: [],
        rows: [],
      };
      const isMobile = route === "mobileSalesOrders";
      if(isVAK && isMobile) {
        const filterPaires = [];
        if(this.state.pullSheetSort) {
          filterPaires.push(['order_by', this.state.pullSheetSort].join('='))
        }
        if(this.props.store_name && this.props.store_name.label != 'All') {
          filterPaires.push(['store_name', this.props.store_name.label].join('='))
        }
        _.forOwn(this.state.salesOrders.filters, (value, key) => {
          filterPaires.push([key, value.filterTerm].join('='))
        });
        filterParams = filterPaires.join('&');
      }
      this.setState({ salesOrders });
      this.setState({ totalNetWeight: this.props.salesOrders.TotalWT});
      this.props.fetchSalesOrdersByFilter(
        this.state.FromDate,
        this.state.ToDate,
        this.state.days,
        this.state.Status,
        null,
        null,
        route,
        this.state.dispatchDateLT,
        this.state.dispatchDateGT,
        this.state.dispatchDays,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        filterParams,
      );
    }

    const onRowSelect = (rows) => {
      const salesOrders = { ...this.state.salesOrders, selectedRows: rows };
      this.setState({ salesOrders });
    };

    const onCellSelected = (coordinates) => {
      const newRows = getRows();
      newRows.map((r) => {
        r.isSelected = false;
      });
      const selectedRows = [newRows[coordinates.rowIdx]];
      newRows[coordinates.rowIdx].isSelected = true;
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders });
    };

    const checkLabel = () => {
      const selectedRows = [...this.state.salesOrders.selectedRows];
      if (selectedRows[0].SaleStatus === "Quote") {
        this.setState({
          title: "Open",
        });
      } else if (selectedRows[0].SaleStatus !== "Quote") {
        this.setState({
          title: "Quote",
        });
      }
    };

    const onRowsSelected = (rows) => {
      this.setState({
        scrollTopPositionIndex: rows[0].rowIdx,
      });
      const newRows = getRows();
      const selectedRows = [...this.state.salesOrders.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
        if(isOLG || isGGI) {
          let isHave = false;
          selectedRows.map(item => {
            if(item.pk == r.row.pk) {
              isHave = true;
              return
            }
          })
          if(!isHave) {
            selectedRows.push(r.row);
          }
        } else {
          selectedRows.push(r.row);
        }
      });
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders }, () => {
        checkLabel();
      });
    };
    const onRowsDeselected = (rows) => {
      const newRows = [...this.state.salesOrders.rows];
      const selectedRows = [...this.state.salesOrders.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
        let rowIndex = selectedRows.findIndex(item => item.SalesOrder_id == r.row.SalesOrder_id);
        selectedRows.splice(rowIndex, 1);
      });
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders, title: "Quote" });
    };
    const InvoiceNumFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value}</span>;
        return <span className="label label-danger">-</span>;
      },
    });
    const BackNoFormatter = React.createClass({
      render() {
        let values;
        if(this.props.value) {
          values = this.props.value.split(',');
        } else {
          values = [];
        }
        return <div>
          {values.map(name=> {
            return <span>{name}<br/></span>
          })}
        </div>;
      },
    });
    const DateMonthFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const dateMap = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];
          const date = new Date(this.props.value);
          const index = dateMap.indexOf(date.toString().slice(4, 3));
          const localDate = index + date.toString().slice(8, 6);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });
    const SecondsDateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = moment(this.props.value).format("MM-DD-YY HH:mm");
          return <span>{date}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });
    const getRowHeight = (element, width) => {
      const container = document.createElement('div');
      ReactDOM.render(element, container);
      container.style.width = width + 'px';
      document.body.appendChild(container);
      const height = +window.getComputedStyle(container).height.replace('px', '');
      ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container);
      return height;
    }
    const renderProductLines = lines => {
      if(!lines) return
      return lines.map((line, index) => {
        const isWarningProduct = !line.SalesOrderLine_id || line.is_out_of_stock;
        return (
          <Row>
            <div className={'col-xs-3'}><p className={`product-cell ${isWarningProduct ? 'warning' : ''}`}>SKU: {line.RefNum}</p></div>
            <div className={'col-xs-7'}>
              <p className={`product-cell ${isWarningProduct ? 'warning' : ''}`}><Translate value={'name'}/>: {line.ProductName}<br/><Translate value={'desc'}/>: {line.ProductDescription}</p>
            </div>
            <div className={'col-xs-2'}>
              <span style={{fontWeight: 'bold', fontSize: 18}}>x{line.Quantity}</span> (${line.UnitPrice})<br />
              <Translate value={"total"}/>: ${line.TotalPrice}
            </div>
            {(index + 1) !== lines.length && <div className={'col-xs-10'} style={{ float: 'right' }}>
              <div style={{ background: '#555', flex: 1, height: 1 }} /></div>}
          </Row>
        );
      })
    }
    const renderCustomerInfo = detail => {
      let addressColorStyle = '';
      let addressAttribute = [];
      if (detail.Address_Status === 'invalid_address') {
        addressColorStyle = 'warning';
      }
      if (detail.Address_Status === 'multiple_addresses') {
        addressColorStyle = 'alert';
      }
      if(detail.Address_Attribute == 'MIXED') {
        addressAttribute.push({label:'home', classNmae: 'fa-green'});
        addressAttribute.push({label:'building', classNmae: 'fa-blue'});
      } else if(detail.Address_Attribute == 'RESIDENTIAL') {
        addressAttribute.push({label:'home', classNmae: 'fa-green'});
      } else if(detail.Address_Attribute == 'BUSINESS') {
        addressAttribute.push({label:'building', classNmae: 'fa-blue'});
      } else {
        addressAttribute.push({label:''});
      }
      return (
        <div>
          {
            isEzgo &&
            <Row>
              <div className={'col-xs-3'}><Translate value="id" />:</div>
              <div className={'col-xs-9'}><p className={'product-cell '}>{detail.Deliver_CustomerID}</p></div>
            </Row>
          }
          <Row>
            <div className={'col-xs-3'}><Translate value="contact" />:</div>
            <div className={'col-xs-9'}><p className={isEzgo ? 'contant-product-cell' : 'product-cell'}>{detail.Deliver_CustomerName}</p></div>
          </Row>
          <Row>
            <div className={'col-xs-3'}><Translate value="phone" />:</div>
            <div className={'col-xs-9'}><p className={'product-cell '}>{detail.Deliver_CustomerPhone}</p></div>
          </Row>
          <Row>
            <div className={'col-xs-3'}><Translate value="address" />:</div>
            <div className={'col-xs-9'}>
              <p className={`product-cell ${addressColorStyle}`}>
                {detail.Deliver_CustomerAddress}
              </p>
            </div>
            <div className={'col-xs-3'}>
              {addressAttribute.map(item => {
                return item.label ? <em className={`fa fa-${item.label} ${item.classNmae}`}></em> : ''
              })}
            </div>
          </Row>
          { isEzgo && detail.Country !== 'US' &&
              <Row>
                <div className={'col-xs-12 country-style'}>
                  {detail.Country}
                </div>
              </Row>
            }
        </div>
      )
    }
    const ProductLinesFormatter = React.createClass({
      render() {
        const {dependentValues: {sales_order_lines}} = this.props;
        return <div>
          {renderProductLines(sales_order_lines)}
        </div>
      }
    });
    const CustomerInfoFormatter = React.createClass({
      render() {
        const {dependentValues} = this.props;
        return <div>
          {renderCustomerInfo(dependentValues)}
        </div>
      }
    });
    const SONumFormatter = React.createClass({
      render() {
        return <div>
          <div style={{backgroundColor: this.props.dependentValues.to_deal ? '#FFC1C1' : 'rgba(0, 0, 0, 0)'}}>
            {this.props.value}
          </div>
          {this.props.dependentValues.Print_label_msg && this.props.dependentValues.Print_label_msg != 'Success'
          &&
           <p className='span-br'>
            {this.props.dependentValues.Print_label_msg}
          </p>
          }
        </div>;
      },
    });
    const columns = [
      {
        key: "SONum",
        name: <Translate value="so_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 140,
        getRowMetaData: row => row,
        formatter: SONumFormatter,
      },
      ...!isEzgo ? [{
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "Backorder_Num",
        name: <Translate value="back_no" />,
        resizable: true,
        width: 180,
        formatter: BackNoFormatter,
      }]:[],
      {
        key: "Product_Lines",
        name: <Translate value="products"/>,
        resizable: false,
        sortable: false,
        width: 500,
        filterable: false,
        getRowMetaData: row => row,
        formatter: ProductLinesFormatter,
      },
      {
        key: "Platform_Num",
        name: <Translate value="cpo_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Customer_Info",
        name: <Translate value="customer_info" />,
        resizable: false,
        sortable: isEzgo ? true : false,
        width: 200,
        filterable: false,
        getRowMetaData: row => row,
        formatter: CustomerInfoFormatter,
      },
      {
        key: "FinalPrice",
        name: <Translate value={"final_price"} />,
        resizable: true,
        sortable: true,
        width: isEzgo ? 100 : 80,
        filterable: true,
        formatter: ({value}) => {
          return <CashFormatter value={value} ezgoFlag={isEzgo} />
        }
      },
      ...isEzgo ? [
        {
          key: "ShippingAmount",
          name: <Translate value={"shipping_amount"} />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: ({value}) => {
            return <CashFormatter value={value} />
          }
        },
       ] :[],
      {
        key: "Notation",
        name: <Translate value={isEzgo ? "cust_note" : "cust"} />,
        resizable: true,
        sortable: true,
        width: 110,
      },
      ...isEzgo ? [{
        key: "EmployeeNote",
        name: <Translate value="emp_note" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      }] : [],
      {
        key: "FinalNetWeight",
        name: <Translate value="final_weight_lbs" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: 'carrier_list',
        name: <Translate value={'carrier'} />,
        resizable: true,
        sortable: false,
        width: 120,
        formatter: ({value}) => {
          if (isArray(value) && value.length > 0) {
            return <div>{value.map(carrierKey => {
              const option = vakLogisticCarrierOptions.find(option => option.value === carrierKey);
              if (option) {
                return option.text
              }
              return '';
            }).join("\n")}</div>
          }
          return <span />
        }
      },
      {
        key: "tracking_num",
        name: <Translate value="tracking_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: ({value}) => {
          return <Row>
            <Col xs={10}><p className={'product-cell '}>{(value || '').split(',').join(', ')}</p></Col>
          </Row>
        }
      },
      {
        key: "PKNum",
        name: <Translate value="picking_lt_num" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: InvoiceNumFormatter,
      },
      {
        key: 'Modifier_User_Name',
        name: <Translate value="modifier" />,
        resizable: true,
        sortable: false,
        width: 80,
      },
      {
        key: "Picker_User_Name",
        name: <Translate value="picker" />,
        resizable: true,
        sortable: false,
        width: 80,
      },
      {
        key: "IsUnderBuffer",
        name: <Translate value="under_buffer" />,
        resizable: true,
        sortable: false,
        width: 80,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => (
          <div style={{ textAlign: 'center', backgroundColor: dependentValues.IsUnderBuffer ? "orange" : "inherit"}}>
            { (value === true || value === 'true') ? "true" : "false" }
          </div>
        ),
      },
      ...isEzgo ? [
        {
          key: "InvoiceNum",
          name: <Translate value="invoice_no" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 113,
          formatter: InvoiceNumFormatter,
        },
        {
          key: "Backorder_Num",
          name: <Translate value="back_no" />,
          resizable: true,
          width: 180,
          formatter: BackNoFormatter,
        },
      ]:[],
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        formatter: DateMonthFormatter,
      },
      {
        key: "DispatchDate",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: false,
        width: 125,
        formatter: DateMonthFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="arrived" />,
        resizable: true,
        sortable: false,
        width: 110,
        formatter: SecondsDateFormatter,
      },
      ...!isEzgo ? [
      {
        key: "EmployeeNote",
        name: <Translate value="emp" />,
        resizable: true,
        sortable: true,
        width: 110,
      }] : []
    ];
    const renderTotalOrders = () => {
      let totalOrders = this.state.totalOrders;
      return `${totalOrders} - ${
        this.state.canceledOrders
      } = ${totalOrders - this.state.canceledOrders}`
    }
    let selectedOrderCount = 0;
    if (this.state.salesOrders && this.state.salesOrders.selectedRows && this.state.salesOrders.selectedRows.length > 0) {
      selectedOrderCount = this.state.salesOrders.selectedRows.length;
    }
    const limitSelection = [{
      label: '30',
      value: 30,
      name: 'limit',
    },
    {
      label: '50',
      value: 50,
      name: 'limit',
    },
    {
      label: '200',
      value: 200,
      name: 'limit',
    },
    {
      label:<Translate value="all" />,
      value: 99999,
      name: 'limit',
    }]
    const totalPages = this.props.msoTotalPages;
    const rowHeights = getRows().map(row => {
      const productColumn = columns.find(column => column.key === 'Product_Lines');
      const customerColumn = columns.find(column => column.key === 'Customer_Info');
      let productRowHeight = 35;
      let customerRowHeight = 35;
      const ProductElem = () => <div>{renderProductLines(row.sales_order_lines)}</div>;
      const productHeight = getRowHeight(<ProductElem />, productColumn.width - 11);
      if (productHeight) {
        productRowHeight = productHeight + (5 * row.sales_order_lines.length)
      }
      const CustomerInfoElem = () => renderCustomerInfo(row);
      const customerHeight = getRowHeight(<CustomerInfoElem />, customerColumn.width - 11);
      if (customerHeight) {
        customerRowHeight = customerHeight + 5;
      }
      return Math.max(productRowHeight, customerRowHeight);
    });

    const RowRenderer = React.createClass({
      setScrollLeft(scrollBy) {
        this.refs.row.setScrollLeft(scrollBy);
      },
      getRowStyle() {
        return {
          color: this.getRowBackground()
        };
      },
      getRowBackground() {
        return this.props.idx % 2 ?  'green' : 'blue';
      },
      render() {
        let rowHeight = rowHeights[this.props.idx];
        return <ReactDataGrid.Row {...this.props} ref="row" height={rowHeight} style={this.getRowStyle()} />;
      }
    });

    return (
      // React Table Sales Order History Table
      <div id={"TNMSOTable"}>
        <Row>
          <Col xs={12}>
            <div id="salesOrders-dataGrid1">
              <ReactDataGrid
                rowKey="SalesOrder_id"
                ref={(g) => {
                  this.grid = g;
                }}
                onGridSort={handleGridSort}
                toolbar={<ToolBarCustom />}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={rowHeights.reduce((total, height) => total + height, 0) / getSize()}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onClearFilters={onClearFilters}
                minHeight={tableHeight}
                enableRowSelect="multi"
                rowSelection={{
                  showCheckbox: true,
                  enableShiftSelect: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: "isSelected",
                  },
                }}
                rowRenderer={RowRenderer}
                enableCellSelect={false}
                // onRowClick={onRowClick}
                onCellSelected={onCellSelected}
                overScan={{rowsStart:30, rowsEnd: 30, colsStart: columns.length, colsEnd: -columns.length}}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={6} style={{display: 'flex'}}>
            <div style={{ width: '600px' }} id="react-pagination">
              <ReactPaginate
                previousLabel={<Translate value="prev_page" />}
                nextLabel={<Translate value="next_page" />}
                containerClassName={'pagination'}
                activeClassName={'active'}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                pageCount={totalPages}
                onPageChange={handleOnPageChange}
                forcePage={this.state.currentPage}
              />
            </div>
            <div  style={{ width: '100px', marginTop: '6px', marginLeft: '15px'}}>
              <Dropdown>
                <Dropdown.Toggle style={{ height: '28px', width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                  {this.state.limitDisplay}
                </Dropdown.Toggle>
                <Dropdown.Menu className="super-colors">
                  {limitSelection.map(el => {
                    return (
                      <MenuItem onClick={() => handleLimitChange(el)}>{el.label}</MenuItem>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div>
              <Col xs={2}>
                <label className="row-count">
                  <Translate value="total_orders" />
                  :&nbsp;
                  <span className="font-color-orange" id="row-count-equation">
                      {renderTotalOrders()}
                    </span>
                </label>
                <br/>
                <label className="row-count" style={{marginTop: '0px'}}>
                  <Translate value="selected_sales_orders" />
                  :&nbsp;
                  <span className="font-color-orange" id="row-count-equation">
                      {selectedOrderCount}
                    </span>
                </label>
              </Col>
              <Col xs={6}>
                <label className="grand-total">
                    <span className="grand-total-label">
                      <Translate value="grand_total" />
                      :&nbsp;
                    </span>
                  <span className="font-color-grey" id="total-equation">
                      {`$${numberWithCommas(
                        (this.state.total || 0).toFixed(2)
                      )} - $${numberWithCommas(
                        (this.state.canceledTotal || 0).toFixed(2)
                      )} = $${numberWithCommas(
                        (this.state.total - this.state.canceledTotal).toFixed(2)
                      )}`}
                    </span>
                </label>
                <label className="grand-total" style={{ marginTop: '0px' }}>
                    <span className="grand-total-label">
                      <Translate value="total_weight" />
                      :&nbsp;
                    </span>
                  <span className="font-color-grey" id="total-equation">
                      {`${numberWithCommas(
                        (this.state.totalNetWeight || 0).toFixed(2)
                      )} - ${numberWithCommas(
                        (this.state.totalCancelledNetWeight || 0).toFixed(2)
                      )} = ${numberWithCommas(
                        (this.state.totalNetWeight - this.state.totalCancelledNetWeight).toFixed(2)
                      )}`}
                    </span>
                </label>
              </Col>
              <Col xs={4}>
                <div className="mso-footnotes">
                    <span>
                      <Translate value="msg_total_orders_equation" />
                    </span>
                  <span>
                      <Translate value="msg_grand_total_equation" />
                    </span>
                  <span>
                      <Translate value="msg_total_weight_equation" />
                    </span>
                </div>
              </Col>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  renderTableVAK() {
    let tableHeight = 500;
    const getRows = () => Data.Selectors.getRows(this.state.salesOrders);
    const getSize = () => getRows().length;
    const isEzgo = (this.props.selectedCompany || {value: ''}).value == 6;

    const rowGetter = (rowIdx) => {
      let rows = getRows();
      let rowItem = rows[rowIdx];
      return rowItem;
    };

    const onClearFilters = () => {
      // all filters removed
      const salesOrders = { ...this.state.salesOrders, filters: {} };
      this.setState({ salesOrders }, () => {
        handleOnPageChange({
          selected: 0,
        })
      })
    };

    const YuansferFormatter = React.createClass({
      render() {
        if (this.props.value === "alipay") {
          return <span>Alipay</span>;
        }
        if (this.props.value === "wechatpay") {
          return <span>WeChatPay</span>;
        } else {
          return <span>{this.props.value}</span>;
        }
      },
    });

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.salesOrders, {
        sortColumn,
        sortDirection,
      });
      if (state.sortColumn === "OrderDateDisplay") {
        state.sortColumn = "OrderDate";
      }

      if (state.sortDirection === "ASC") {
        this.state.pullSheetSort = state.sortColumn;
      } else if (state.sortDirection === "DESC") {
        this.state.pullSheetSort = `-${state.sortColumn}`;
      } else {
        this.state.pullSheetSort = "";
      }
      this.setState({ salesOrders: state });
      const route = this.context.router.routes[1].path;
      let filterParams = "";
      const filterPaires = [];
      if(this.state.pullSheetSort) {
        filterPaires.push(['order_by', this.state.pullSheetSort].join('='))
      }
      if(this.props.store_name && this.props.store_name.label != 'All') {
        filterPaires.push(['store_name', this.props.store_name.label].join('='))
      }
      _.forOwn(this.state.salesOrders.filters, (value, key) => {
        filterPaires.push([key, value.filterTerm].join('='))
      });
      filterParams = filterPaires.join('&');
      this.props.fetchSalesOrdersByFilter(
        this.state.FromDate,
        this.state.ToDate,
        this.state.days,
        this.state.Status,
          null,
          null,
          route,
          this.state.dispatchDateLT,
          this.state.dispatchDateGT,
          this.state.dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterParams,
      );
      this.setState({ salesOrders: state, currentPage: 0 });
    };

    const handleFilterChange = debounce(
      (filter) => {
        this.state.total = 0;
        this.state.salesOrders.rows = this.props.salesOrders.Orders;
        this.state.salesOrders.selectedRows = [];
        let filterParams = "";
        const newFilters = Object.assign({}, this.state.salesOrders.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const salesOrders = { ...this.state.salesOrders, filters: newFilters };
        this.setState({ salesOrders }, () => {
          if (filter.column.key === "SONum" || filter.column.key === "InvoiceNum" || filter.column.key === "Deliver_Customer_num" || filter.column.key === "Deliver_CustomerName" || filter.column.key === "Sales_User_Name" || filter.column.key === "PONum" || filter.column.key === "Platform_Num"
          || filter.column.key === "FinalPrice"|| filter.column.key === "EmployeeNote" || filter.column.key === "FinalNetWeight"|| filter.column.key === "tracking_num"||filter.column.key === "PKNum") {
            handleOnPageChange({
              selected: 0
            })
          }
        });
      },
      500,
      { maxWait: 800 },
    );
    // Handle the row select function
    const onRowClick = (rowIdx, row) => {
      if (rowIdx !== -1) {
        const rows = getRows();
        rows.map((r) => {
          r.isSelected = false;
        });
        const selectedRows = [rows[rowIdx]];
        rows[rowIdx].isSelected = true;
        const salesOrders = { ...this.state.salesOrders, rows, selectedRows };
        this.setState({ salesOrders });
      }
    };

    const handleLimitChange = (el) => {
      this.state.currentPage = 0;
      this.state.limit = el.value;
      this.state.limitDisplay = el.label;
      const route = this.context.router.routes[1].path;

      let salesOrders = {
        ...this.state.salesOrders,
        selectedRows: [],
      };
      this.setState({ salesOrders });


      let filterParams = "";
      const filterPaires = [];
      if(this.state.pullSheetSort) {
        filterPaires.push(['order_by', this.state.pullSheetSort].join('='))
      }
      if(this.props.store_name && this.props.store_name.label != 'All') {
        filterPaires.push(['store_name', this.props.store_name.label].join('='))
      }
      _.forOwn(this.state.salesOrders.filters, (value, key) => {
        filterPaires.push([key, value.filterTerm].join('='))
      });
      filterParams = filterPaires.join('&');
      this.props.fetchSalesOrdersByFilter(
        this.state.FromDate,
        this.state.ToDate,
        this.state.days,
        this.state.Status,
        null,
        null,
        route,
        this.state.dispatchDateLT,
        this.state.dispatchDateGT,
        this.state.dispatchDays,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        filterParams,
      );
      // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    const handleOnPageChange = (data) => {
      this.state.currentPage = data.selected;
      const route = this.context.router.routes[1].path;
      let filterParams = "";
      let salesOrders = {
        ...this.state.salesOrders,
        selectedRows: [],
        rows: [],
      };
      const isMobile = route === "mobileSalesOrders";
      const filterPaires = [];
      if(this.state.pullSheetSort) {
        filterPaires.push(['order_by', this.state.pullSheetSort].join('='))
      }
      if(this.props.store_name && this.props.store_name.label != 'All') {
        filterPaires.push(['store_name', this.props.store_name.label].join('='))
      }
      _.forOwn(this.state.salesOrders.filters, (value, key) => {
        if (key === 'EmployeeNote') {
          filterPaires.push([key, value.filterTerm].join('='))
        }
      });
      filterParams = filterPaires.join('&');
      this.setState({ salesOrders });
      this.setState({ totalNetWeight: this.props.salesOrders.TotalWT});
      this.props.fetchSalesOrdersByFilter(
        this.state.FromDate,
        this.state.ToDate,
        this.state.days,
        this.state.Status,
        null,
        null,
        route,
        this.state.dispatchDateLT,
        this.state.dispatchDateGT,
        this.state.dispatchDays,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        filterParams,
      );
    }

    const onRowSelect = (rows) => {
      const salesOrders = { ...this.state.salesOrders, selectedRows: rows };
      this.setState({ salesOrders });
    };

    const onCellSelected = (coordinates) => {
      const newRows = getRows();
      newRows.map((r) => {
        r.isSelected = false;
      });
      const selectedRows = [newRows[coordinates.rowIdx]];
      newRows[coordinates.rowIdx].isSelected = true;
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders });
    };

    const checkLabel = () => {
      const selectedRows = [...this.state.salesOrders.selectedRows];
      if (selectedRows[0].SaleStatus === "Quote") {
        this.setState({
          title: "Open",
        });
      } else if (selectedRows[0].SaleStatus !== "Quote") {
        this.setState({
          title: "Quote",
        });
      }
    };

    const onRowsSelected = (rows) => {
      this.setState({
        scrollTopPositionIndex: rows[0].rowIdx,
      });
      const newRows = getRows();
      const selectedRows = [...this.state.salesOrders.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
        if(isOLG || isGGI) {
          let isHave = false;
          selectedRows.map(item => {
            if(item.pk == r.row.pk) {
              isHave = true;
              return
            }
          })
          if(!isHave) {
            selectedRows.push(r.row);
          }
        } else {
          selectedRows.push(r.row);
        }
      });
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders }, () => {
        checkLabel();
      });
    };
    const onRowsDeselected = (rows) => {
      const newRows = [...this.state.salesOrders.rows];
      const selectedRows = [...this.state.salesOrders.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
        let rowIndex = selectedRows.findIndex(item => item.SalesOrder_id == r.row.SalesOrder_id);
        selectedRows.splice(rowIndex, 1);
      });
      const salesOrders = {
        ...this.state.salesOrders,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrders, title: "Quote" });
    };
    const InvoiceNumFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value}</span>;
        return <span className="label label-danger">-</span>;
      },
    });
    const DateMonthFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const dateMap = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];
          const date = new Date(this.props.value);
          const index = dateMap.indexOf(date.toString().slice(4, 3));
          const localDate = index + date.toString().slice(8, 6);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });
    const SecondsDateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = moment(this.props.value).format("MM-DD-YY HH:mm");
          return <span>{date}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });
    const getRowHeight = (element, width) => {
      const container = document.createElement('div');
      ReactDOM.render(element, container);
      container.style.width = width + 'px';
      document.body.appendChild(container);
      const height = +window.getComputedStyle(container).height.replace('px', '');
      ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container);
      return height;
    }
    const renderTrackingNum = detail => {
      return (
        <div>
          <Row>
          <Col xs={10}><p className={'product-cell '}>{(detail.tracking_num || '').split(',').join(', ')}</p></Col>
          </Row>
        </div>
      )
    }

    const trackingFormatter = React.createClass({
      render() {
        const {dependentValues} = this.props;
        return <div>
          {renderTrackingNum(dependentValues)}
        </div>
      }
    });

    const SONumFormatter = React.createClass({
      render() {
        return <div style={{backgroundColor: this.props.dependentValues.to_deal ? '#FFC1C1' : 'rgba(0, 0, 0, 0)'}}>{this.props.value}</div>;
      },
    });
    const columns = [
      {
        key: "SONum",
        name: <Translate value="so_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 140,
        getRowMetaData: row => row,
        formatter: SONumFormatter,
      },
      {
        key: "ShippingMethod",
        name: <Translate value="shipping_method" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "AddressName",
        name: <Translate value="shipping_name" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      },
      {
        key: "Deliver_Customer_num",
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
      },
      {
        key: "Deliver_CustomerName",
        name: <Translate value="cust_name" />,
        resizable: false,
        sortable: false,
        width: 115,
        filterable: false,
      },
      {
        key: "Country",
        name: <Translate value="country" />,
        resizable: true,
        sortable: true,
        width: 80,
      },
      {
        key: "CommercialInvoice",
        name: <Translate value="commercial_invoice" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      ...isEzgo ? [] : [{
        key: "MfgNum",
        name: <Translate value="mfg_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: InvoiceNumFormatter,
      }],
      {
        key: "PRNum",
        name: <Translate value="pr_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "FinalPrice",
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: "Notation",
        name: <Translate value="cust_note" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      },
      {
        key: "EmployeeNote",
        name: <Translate value="emp_note" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      },
      {
        key: "FinalNetWeight",
        name: <Translate value="final_weight_lbs" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'carrier_list',
        name: <Translate value={'carrier'} />,
        resizable: true,
        sortable: false,
        width: 120,
        getRowMetaData: row => row,
        formatter: ({value}) => {
          if (isArray(value) && value.length > 0) {
            return <div>{value.map(carrierKey => {
              const option = vakLogisticCarrierOptions.find(option => option.value === carrierKey);
              if (option) {
                return option.text
              }
              return '';
            }).join("\n")}</div>
          }
          return <span />
        }
      },
      {
        key: "tracking_num",
        name: <Translate value="tracking_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 160,
        getRowMetaData: row => row,
        formatter: trackingFormatter,
      },
      {
        key: "PKNum",
        name: <Translate value="picking_lt_num" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "SyncStatus",
        name: <Translate value="qb_status" />,
        resizable: true,
        sortable: true,
        width: 110,
        formatter: ({value})=>{
          if(value && value.length > 0) {
            let qbStatus = value.map(item => {
              if(item == 0) {
                return 'Unsynced'
              }
              if(item == 1 || item == 3) {
                return 'Synced'
              }
              if(item == 2) {
                return 'Failed'
              }
            })
            return <div>{qbStatus.toString()}</div>
          }
          return <div></div>
        },
      },
      {
        key: "QBError",
        name: <Translate value="qb_msg" />,
        resizable: true,
        sortable: true,
        width: 110,
        formatter: ({value})=>{
          return <div>{(value || []).toString()}</div>
        },
      },
      {
        key: "Sales_User_Name",
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Modifier_User_Name",
        name: <Translate value="modifier" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "Picker_User_Name",
        name: <Translate value="picker" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: "InvoiceNum",
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 113,
        formatter: InvoiceNumFormatter,
      },
      {
        key: "SaleStatus",
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        getRowMetaData: row => row,
        formatter: ({dependentValues, value}) => {
          if(dependentValues.Is_Prepay && (value == 'Open' || value == 'Packing')) {
            if(dependentValues.PrepayStatus == 'WaitForPay') {// invoiced
              return <span>{<Translate value={'invoiced'} />}</span>
            } else if(dependentValues.PrepayStatus == 'ReadyToShip') {// Paid
              return <span>{<Translate value={'paid'} />}</span>
            } else if(dependentValues.PrepayStatus == 'PartialShip') {// PartialShip
              return <span>{<Translate value={'partial_ship'} />}</span>
            } else {
              return <span>{value && <Translate value={value} />}</span>
            }
          }
          return <span>{value && <Translate value={value} />}</span>
        }
      },
      {
        key: 'HasPod',
        name: <Translate value="has_pod" />,
        resizable: true,
        sortable: false,
        width: 80,
        formatter: ({ value }) => (
          <div onClick={() => handleClickPodColumn()} style={{cursor: "pointer", width: "100%", display: 'flex', justifyContent: 'center', color: value ? 'green' : 'red'}}>
            { value ? <em className="fa fa-check"></em> : <em className="fa fa-times"></em> }
          </div>
        ),
      },
      {
        key: "RouteNote",
        name: <Translate value="route" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      },
      {
        key: "IsUnderBuffer",
        name: <Translate value="under_buffer" />,
        resizable: true,
        sortable: false,
        width: 80,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => (
          <div style={{ textAlign: 'center', backgroundColor: dependentValues.IsUnderBuffer ? "orange" : "inherit"}}>
            { (value === true || value === 'true') ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "PaymentType",
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: YuansferFormatter,
      },
      {
        key: "OrderDate",
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 95,
        filterable: true,
        formatter: DateMonthFormatter
      },
      {
        key: "DispatchDate",
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        width: 125,
        filterable: true,
        formatter: (isSDR || isCRW || isSC) ? SecondsDateFormatter : DateMonthFormatter,
      },
      {
        key: "ShipmentDate",
        name: <Translate value="shipped" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: SecondsDateFormatter,
      },
    ];
    const renderTotalOrders = () => {
      let totalOrders = this.state.totalOrders;
      return `${totalOrders} - ${
        this.state.canceledOrders
      } = ${totalOrders - this.state.canceledOrders}`
    }
    let selectedOrderCount = 0;
    if (this.state.salesOrders && this.state.salesOrders.selectedRows && this.state.salesOrders.selectedRows.length > 0) {
      selectedOrderCount = this.state.salesOrders.selectedRows.length;
    }
    const limitSelection = [{
      label: '30',
      value: 30,
      name: 'limit',
    },
    {
      label: '50',
      value: 50,
      name: 'limit',
    },
    {
      label: '200',
      value: 200,
      name: 'limit',
    },
    {
      label:<Translate value="all" />,
      value: 99999,
      name: 'limit',
    },
  ]
    const totalPages = this.props.msoTotalPages;
    const rowHeights = getRows().map(row => {
      const TrackingNumColumn = columns.find(column => column.key === 'tracking_num');
      let trackingRowHeight = 35;
      const TrackingNumElem = () => renderTrackingNum(row);
      const trackingHeight = getRowHeight(<TrackingNumElem />, TrackingNumColumn.width - 11);
      if (trackingHeight) {
        trackingRowHeight = trackingHeight + 5;
      }
      return Math.max(trackingRowHeight, 35);
    });

    const RowRenderer = React.createClass({
      setScrollLeft(scrollBy) {
        this.refs.row.setScrollLeft(scrollBy);
      },
      getRowStyle() {
        return {
          color: this.getRowBackground()
        };
      },
      getRowBackground() {
        return this.props.idx % 2 ?  'green' : 'blue';
      },
      render() {
        let rowHeight = rowHeights[this.props.idx];
        return <ReactDataGrid.Row {...this.props} ref="row" height={rowHeight} style={this.getRowStyle()} />;
      }
    });

    return (
      // React Table Sales Order History Table
      <div id={"TNMSOTable"}>
        <Row>
          <Col xs={12}>
            <div id="salesOrders-dataGrid1">
              <ReactDataGrid
                rowKey="SalesOrder_id"
                ref={(g) => {
                  this.grid = g;
                }}
                onGridSort={handleGridSort}
                toolbar={<ToolBarCustom />}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={rowHeights.reduce((total, height) => total + height, 0) / getSize()}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onClearFilters={onClearFilters}
                minHeight={tableHeight}
                enableRowSelect="multi"
                rowSelection={{
                  showCheckbox: true,
                  enableShiftSelect: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: "isSelected",
                  },
                }}
                rowRenderer={RowRenderer}
                enableCellSelect={false}
                // onRowClick={onRowClick}
                onCellSelected={onCellSelected}
                overScan={{rowsStart:30, rowsEnd: 30}}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={6} style={{display: 'flex'}}>
            <div style={{ width: '600px' }} id="react-pagination">
              <ReactPaginate
                previousLabel={<Translate value="prev_page" />}
                nextLabel={<Translate value="next_page" />}
                containerClassName={'pagination'}
                activeClassName={'active'}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                pageCount={totalPages}
                onPageChange={handleOnPageChange}
                forcePage={this.state.currentPage}
              />
            </div>
            <div  style={{ width: '100px', marginTop: '6px', marginLeft: '15px'}}>
              <Dropdown>
                <Dropdown.Toggle style={{ height: '28px', width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                  {this.state.limitDisplay}
                </Dropdown.Toggle>
                <Dropdown.Menu className="super-colors">
                  {limitSelection.map(el => {
                    return (
                      <MenuItem onClick={() => handleLimitChange(el)}>{el.label}</MenuItem>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div>
              <Col xs={2}>
                <label className="row-count">
                  <Translate value="total_orders" />
                  :&nbsp;
                  <span className="font-color-orange" id="row-count-equation">
                      {renderTotalOrders()}
                    </span>
                </label>
                <br/>
                <label className="row-count" style={{marginTop: '0px'}}>
                  <Translate value="selected_sales_orders" />
                  :&nbsp;
                  <span className="font-color-orange" id="row-count-equation">
                      {selectedOrderCount}
                    </span>
                </label>
              </Col>
              <Col xs={6}>
                <label className="grand-total">
                    <span className="grand-total-label">
                      <Translate value="grand_total" />
                      :&nbsp;
                    </span>
                  <span className="font-color-grey" id="total-equation">
                      {`$${numberWithCommas(
                        (this.state.total || 0).toFixed(2)
                      )} - $${numberWithCommas(
                        (this.state.canceledTotal || 0).toFixed(2)
                      )} = $${numberWithCommas(
                        (this.state.total - this.state.canceledTotal).toFixed(2)
                      )}`}
                    </span>
                </label>
                <label className="grand-total" style={{ marginTop: '0px' }}>
                    <span className="grand-total-label">
                      <Translate value="total_weight" />
                      :&nbsp;
                    </span>
                  <span className="font-color-grey" id="total-equation">
                      {`${numberWithCommas(
                        (this.state.totalNetWeight || 0).toFixed(2)
                      )} - ${numberWithCommas(
                        (this.state.totalCancelledNetWeight || 0).toFixed(2)
                      )} = ${numberWithCommas(
                        (this.state.totalNetWeight - this.state.totalCancelledNetWeight).toFixed(2)
                      )}`}
                    </span>
                </label>
              </Col>
              <Col xs={4}>
                <div className="mso-footnotes">
                    <span>
                      <Translate value="msg_total_orders_equation" />
                    </span>
                  <span>
                      <Translate value="msg_grand_total_equation" />
                    </span>
                  <span>
                      <Translate value="msg_total_weight_equation" />
                    </span>
                </div>
              </Col>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
  renderTotalQtyDestion () {
    if(isGGI) {
      return <span>
      <Translate value="msg_total_qty_equation" />
    </span>
    }
    return <div></div>
  }

  renderDatePickers() {
    if (this.state.days === -1) {
      return (
        <div className="form-group date-picker-positioner">
          <label className="col-xs-2 from-label col-xs-offset-5">
            <Translate value="from" />
          </label>
          <div className="col-xs-2 control-date-picker">
            <Field name="FromDate" component={DatePicker} />
          </div>
          <label className="col-xs-1 to-label">
            <Translate value="to" />
          </label>
          <div className="col-xs-2 control-date-picker">
            <Field name="ToDate" component={DatePicker} />
          </div>
        </div>
      );
    }
  }

  renderStore() {
    if (this.props.usersIsLoading) return <WidgetsSpinner />; // If group is loading, show a spinner.
    const {mobileAccounts} = this.state;
    return (
      <div style={{ marginRight: "10px", width: '200px' }}>
        <Field name="store_name" component={Selection} options={mobileAccounts} />
      </div>
    );
  }

  renderUsers() {
    if (this.props.usersIsLoading) return <WidgetsSpinner />; // If group is loading, show a spinner.
    const Users = this.getUsers();
    return (
      <div style={{ marginRight: "10px" }} className="control-dropdown">
        <Field name="Seller" component={Selection} options={Users} />
      </div>
    );
  }

  getUsers() {
    const Users = [];
    this.props.users.map((user) => {
      Users.push({ value: user.user_id, label: user.username });
    });
    return Users;
  }

  getPackers() {
    // for ocm
    const Packers = [];
    this.props.packers.map((packer) => {
      Packers.push({ value: packer.packer_id, label: packer.name });
    });
    return Packers;
  }

  renderTotalQty () {
    if(isGGI) {
      return <label className="grand-total" style={{ marginTop: '0px' }}>
      <span className="grand-total-label">
        <Translate value="total_qty" />
        :&nbsp;
      </span>
      <span className="font-color-grey" id="total-equation">
        {
          (this.state.totalQty || 0)
        } - {
          (this.state.totalCancelledQty || 0)
        } = {
          (this.state.totalQty - this.state.totalCancelledQty)
        }
      </span>
    </label>
    }
    return <div></div>
  }

  renderAddresses() {
    const Addresses = this.getAddress();
    return (
      <div style={{ margin: "10px" }} className="control-dropdown">
        <Field
          name="Warehouse"
          component={SelectionWithProps}
          options={Addresses}
          onChange={this.onChangeBolAddress}
        />
      </div>
    );
  }

  getAddress() {
    const Addresses = [];
    this.props.bolAddress.map((address) => {
      Addresses.push({
        value: address.FBACode,
        label: address.FBACode + " - " + address.Address,
      });
    });
    return Addresses;
  }

  setToDate = (e) => {
    if (e < this.state.FromDate) {
      return;
    }
    this.setState({ ToDate: e });
  };

  setFromDate = (e) => {
    if ((this.state.ToDate || !(isUSPrideMulti)) && (e > this.state.ToDate)) {
      return;
    }
    this.setState({ FromDate: e });
  };

  setFromDispatchDate = (e) => {
    if ((this.state.dispatchDateGT || !(isUSPrideMulti)) && (e > this.state.dispatchDateGT)) {
      return;
    }
    this.setState({ dispatchDateLT: e });
  };

  setToDispatchDate = (e) => {
    if (e < this.state.dispatchDateLT) {
      return;
    }
    this.setState({
      dispatchDateGT: e,
    });
  };

  setToRangeSearch = () => {
    let otherParams = {};
    if((this.state.days != -1 && this.state.days != '-1') && isAP) {
      otherParams.FromDate = new Date(moment().startOf('year'));
      otherParams.ToDate = new Date(moment().endOf('day'));
      this.setState({ days: "-1", ...otherParams }, () => {
        this.fetchSalesOrdersByDetails(-1)
      });
      return
    }
    if((isLAP || isUSPrideMulti || isAPD) && this.state.days == '-1' && this.state.days != '-2') {
      this.setState({ days: '-2', FromDate: undefined, ToDate: undefined});
      if (isUSPrideMulti) {
        this.setState({dispatchDays: null, dispatchDateLT: null, dispatchDateGT: null });
      }
      this.props.fetchSalesOrdersByFilter(
        '',
        '',
        '-2',
        this.state.Status,
        this.props.Seller,
        this.props.ProductNum,
        this.context.router.routes && this.context.router.routes.length> 1 ? this.context.router.routes[1].path : '',
        this.state.dispatchDateLT,
        this.state.dispatchDateGT,
        this.state.dispatchDays,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        '',
      );
      return
    }
    this.setState({ days: "-1", ...otherParams });
  };

  setToDispatchRangeSearch = () => {
    if((isGGI || isAPD) && this.state.dispatchDays == '-1' && this.state.dispatchDays != null) {
      this.setState({ dispatchDays: null, dispatchDateLT: undefined, dispatchDateGT: undefined}, () => {
        this.fetchSalesOrdersByDispatch()
      });
      return
    }
    if (isUSPrideMulti) {
      this.setState({days: null, FromDate: null, ToDate: null });
    }
    this.setState({ dispatchDays: "-1" });
  };

  fetchSalesOrdersByDispatch(Days) {
    let dispatchDays = Days;
    if (isUSPrideMulti) {
      this.state.FromDate = null;
      this.state.ToDate = null;
      this.state.days = null;
    }
    if((isGGI || isAPD) && this.state.dispatchDays == Days && this.state.dispatchDays != '-1') {
      dispatchDays = null;
      this.setState({dispatchDays: null})
    }
    if (isAPD) {
      if (dispatchDays != '-1') {
        this.setState({
          dispatchDateGT: undefined,
          dispatchDateLT: undefined,
        })
      }
    }
    if (this.state.filteredByItem) {
      this.setState({ dispatchDays, }, () => {
        this.fetchSalesOrdersByProduct(this.state.filterProductID);
      });
      return;
    }
    let seller = this.props.Seller;
    const productNum = this.props.ProductNum;
    const route = this.context.router.routes[1].path;
    if (this.props.Seller) {
      seller = this.props.Seller.value;
    }

    let filterParams = "";
    if (isOCM || isKM) {
      const filterPaires = [];
      _.forOwn(this.state.salesOrders.filters, (value, key) => {
        filterPaires.push([key, value.filterTerm].join('='))
      });
      filterParams = filterPaires.join('&');
    }

    if (dispatchDays === "-1" || dispatchDays === -1) {
      this.setState({ dispatchDays }, () => {
        this.props.fetchSalesOrdersByFilter(
          this.state.FromDate,
          this.state.ToDate,
          this.state.days,
          this.state.Status,
          seller,
          productNum,
          route,
          this.state.dispatchDateLT,
          this.state.dispatchDateGT,
          dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterParams,
        );
      });
    } else {
      this.setState(
        { dispatchDays, dispatchDateLT: undefined, dispatchDateGT: undefined },
        () => {
          this.props.fetchSalesOrdersByFilter(
            this.state.FromDate,
            this.state.ToDate,
            this.state.days,
            this.state.Status,
            seller,
            productNum,
            route,
            this.state.dispatchDateLT,
            this.state.dispatchDateGT,
            dispatchDays,
            this.state.limit,
            this.state.currentPage,
            this.state.searchFilter,
            this.state.Type,
            filterParams
          );
        },
      );
    }
  }

  fetchSalesOrdersByDetails(day, toggleFilterRowBtn) {
    if (isUSPrideMulti) {
      this.state.dispatchDateLT = null;
      this.state.dispatchDateGT = null;
      this.state.dispatchDays = null;
    }
    let days = day;
    if((isLAP || isUSPrideMulti || isAPD) && days == this.state.days && this.state.days != '-2' && this.state.days != '-1') {
      days = '-2';
    }
    // if (toggleFilterRowBtn) {
    //   if (!_.isEmpty(this.state.salesOrders.filters)) {
    //     const filterRowBtn = document.querySelectorAll('#sales-orders-list .react-grid-Container .react-grid-Toolbar .btn');
    //     filterRowBtn[0].click();
    //   }
    // }
    this.setState({currentPage: 0});
    let salesOrders = {
      ...this.state.salesOrders,
      selectedRows: [],
    };
    let filterParams = "";
    if (isOCM || isKM || isVAK) {
      const filterPaires = [];
      if(isVAK) {
        if(this.state.pullSheetSort) {
          filterPaires.push(['order_by', this.state.pullSheetSort].join('='))
        }
        if(this.props.store_name && this.props.store_name.label != 'All') {
          filterPaires.push(['store_name', this.props.store_name.label].join('='))
        }
      }
      const isEzgo = (this.props.selectedCompany || {value: ''}).value == 6;
      if(isEzgo && this.state.checkedKeys && this.state.checkedKeys.length) {
        filterPaires.push(['group_ids', this.state.checkedKeys.join(',')].join('='))
      }
      if(isEzgo && this.state.checkedChildKeys && this.state.checkedChildKeys.length) {
        filterPaires.push(['store_ids', this.state.checkedChildKeys.join(',')].join('='))
      }
      _.forOwn(salesOrders.filters, (value, key) => {
        filterPaires.push([key, value.filterTerm].join('='))
      });
      filterParams = filterPaires.join('&');
    }
    if (isABC || isABBLE || isAGD || isSV || isSH || isAP) {
      this.setState({ salesOrders });
    }

    if (this.state.filteredByItem) {
      this.setState({ days }, () => {
        this.fetchSalesOrdersByProduct(this.state.filterProductID);
      });
      return;
    }
    let FromDate = (isAPD && this.state.FromDate || !isAPD) ? moment().format('YYYY-MM-DD') : '1900-01-01';
    let ToDate = (isAPD && this.state.FromDate || !isAPD) ? moment().format('YYYY-MM-DD') : '3000-01-01';
    let seller = this.props.Seller;
    const productNum = this.props.ProductNum;
    const route = this.context.router.routes[1].path;
    if (this.state.FromDate != null) {
      FromDate = this.state.FromDate;
    }

    if (this.state.ToDate != null) {
      ToDate = this.state.ToDate;
    }

    if (this.props.Seller) {
      seller = this.props.Seller.value;
    }

    // if (isOCM) {
    //   this.setState({
    //     salesOrders: {
    //       ...this.state.salesOrders,
    //       filters: {},
    //     }
    //   })
    // }
    if (this.state.productSearchType === 'customer_id' || this.state.productSearchType === 'customer_name') {
      filterParams += `&${this.state.productSearchType}=${this.state.invoiceNoSearchTerm}`
    }


    if (days === "-1" || days === -1) {
      this.setState({ days }, () => {
        this.props.fetchSalesOrdersByFilter(
          FromDate,
          ToDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          this.state.dispatchDateLT,
          this.state.dispatchDateGT,
          this.state.dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterParams,
        );
      });
    } else {
      this.setState({ days, FromDate: undefined, ToDate: undefined }, () => {
        this.props.fetchSalesOrdersByFilter(
          FromDate,
          ToDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          this.state.dispatchDateLT,
          this.state.dispatchDateGT,
          this.state.dispatchDays,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterParams,
        );
      });
    }
  }

  fetchSalesOrdersByProduct = (productID) => {
    let dateRange = -1;
    let FromDate = moment().format('YYYY-MM-DD');
    let ToDate = moment().format('YYYY-MM-DD');
    let seller = this.props.Seller;
    const route = this.context.router.routes[1].path;
    const productNum = productID;
    if (this.state.FromDate != null) {
      FromDate = this.formatDate(this.state.FromDate);
    }

    if (this.state.ToDate != null) {
      ToDate = this.formatDate(this.state.ToDate);
    }

    if (this.state.days != null) {
      dateRange = this.state.days;
    }
    if (this.props.Seller) {
      seller = this.props.Seller.value;
    }

    let filterParams = "";
    if (isOCM || isKM || isABBLE || isAGD || isSV || isSH || isAP) {
      const filterPaires = [];
      _.forOwn(this.state.salesOrders.filters, (value, key) => {
        filterPaires.push([key, value.filterTerm].join('='))
      });
      filterParams = filterPaires.join('&');
    }

    this.setState({
      filteredByItem: true,
      selectedRows: [{}],
      filterProductID: productID,
    });
    this.props.fetchSalesOrdersByFilter(
      FromDate,
      ToDate,
      dateRange,
      this.state.Status,
      seller,
      productNum,
      route,
      null,
      null,
      this.state.dispatchDays,
      this.state.limit,
      this.state.currentPage,
      this.state.searchFilter,
      this.state.Type,
      filterParams
    );
  };

  formatDate(date) {
    if (isUSPrideMulti) {
      if (date === "1900-01-01") { return "1900-01-01" }
      if (date === "3000-01-01") { return "3000-01-01" }
    }
    let formattedDate = `${date.getFullYear()}-`;

    formattedDate += `${date.getMonth() + 1}-`;
    if (date.getDate() < 10) {
      formattedDate += `0${date.getDate()}`;
    } else {
      formattedDate += date.getDate();
    }
    return formattedDate;
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
  renderProductsTable() {
    if (this.props.salesOrderIsLoading && !this.props.salesOrderError)
      return <WidgetsSpinner />;
    else if (this.props.salesOrderError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            {JSON.stringify(this.props.salesOrderError)}
          </div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid
    let tableHeight = window.innerHeight < 930 ? 185 : 185;

    const getRows = () => Data.Selectors.getRows(this.state.salesOrderDetail);
    const getSize = () => getRows().length;

    // smilinghome want to show all data without scrolling
    if (isSH || isAP) {
      if (getRows().length > 0) {
        tableHeight = Math.min(getRows().length * 25 + 55)
      }
    }

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.salesOrderDetail, {
        sortColumn,
        sortDirection,
      });
      this.setState({ salesOrderDetail: state });
    };

    const onClearFilters = () => {
      // all filters removed
      const salesOrderDetail = { ...this.state.salesOrderDetail, filters: {} };
      this.setState({ salesOrderDetail });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.salesOrderDetail.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        filters: newFilters,
      };
      this.setState({ salesOrderDetail });
    };

    // Handle the row select function
    const onRowSelect = (rows) => {
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        selectedRows: rows,
      };
      this.setState({ salesOrderDetail });
    };

    const VendorNameFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.Name}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const VendorNumFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    // Column definition
    const showProductCost = () => {
      // if (isHMM || isJML) {
      //   return false;
      // }
      // if ((isJML || isChinaTown) && checkPermissionLocal('no_show_product_cost')) {
      //   return false;
      // }
      return !checkPermissionLocal('no_show_product_cost')
      // return true;
    }

    let netWeightName = <Translate value="net_weight" />;
    let totalWeightName = <Translate value="total_weight" />;

    const columns = [
      ...!(isSV || isOLG) && [{
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      }],
      ...isEKC ? [] : [{
        key: "RefNum",
        name: isSV ? <Translate value="item_num" /> : <Translate value={isOLG ? "item_no" : isVAK ? "sku" : "ref_num"} />,
        resizable: true,
        sortable: true,
        width: (isSV || isLMH || isBRO) ? 120 : 70,
      }],
      ...isAFM && [{
        key: 'Brand',
        name: <Translate value="brand" />,
        resizable: true,
        sortable: true,
        width: 100,
      }],
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 250,
      },
      ...!isSV ? [{
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: isOLG ? 300 : 100,
      }] : [],
      ...(isEKC || isLMH || isBRO || isSV || isSDR || isCRW || isSC) ? [] : [{
        key: "PackageSize",
        name: <Translate value={isSKH ? "case_pack_quantity" : "package_size"} />,
        resizable: true,
        sortable: true,
        width: 120,
      }],
      ...isSKH ? [{
        key: "Quantity",
        name: <Translate value="case_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
        getRowMetaData: row => row,
        formatter: (row) => {
          return (
            <div
              style={{ width: "100%", height: "100%", textAlign: "center" }}
              onDoubleClick={() => this.openChangeShipQtyModal(row.dependentValues.SalesOrderLine_id) }>
              <span>{row.value}</span>
            </div>
          )
        },
      }, {
        key: "UnitQuantity",
        name: <Translate value="unit_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      }, {
        key: "PerBoxQty",
        name: <Translate value="unit/case" />,
        resizable: true,
        width: 80,
        sortable: true,
      }] : [{
        key: "Quantity",
        name: isABC ? <Translate value="inbound_qty" /> : isJML ? <Translate value="box" /> : isSV ? <Translate value="order_qty" /> : <Translate value="qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      }],
      ...isABBLE && [{
        key: "ConvertUnit",
        name: <Translate value="convert_quantity" />,
        resizable: true,
        width: 100,
        sortable: true,
      }],
      ...isCCW ? [{
        key: "ShippedWT",
        name: <Translate value="shipped_wt" />,
        resizable: true,
        width: 80,
        sortable: true,
      }, {
        key: "ShippedQTY",
        name:<Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      }] : [{
        key: "PickupQuantity",
        name: isSKH ? <Translate value="shipped_case_qty" /> : <Translate value="shipped_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      }],
      ...(isSV || isCRW || isSC) ? [{
        key: 'IsCombo',
        name: <Translate value="combo_prod" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: ({ value }) => (
          <div style={{color: (value === true || value === "true") ? "green": "black"}}>
            { (value === true || value === 'true') ? "true" : "false" }
          </div>
        ),
        getRowMetaData: row => row,
      }, {
        key: "IsChild",
        name: <Translate value="child_prod" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: ({ value }) => (
          <div style={{color: (value === true || value === "true") ? "green": "black"}}>
            { (value === true || value === 'true') ? "true" : "false" }
          </div>
        ),
        getRowMetaData: row => row,
      }, {
        key: 'ParentRefNum',
        name: <Translate value="parent" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }] : [],
      ...isSV && [{
        key: "BackorderQuantity",
        name: <Translate value="BO_qty" />,
        resizable: true,
        sortable: true,
        width: 100,
      }],
      ...isOCM && [{
        key: "BatchExpiredDate",
        name: <Translate value="exp_date" />,
        resizable: true,
        width: 80,
        sortable: true,
        filterable: true,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => (
          <div style={{ textAlign: 'center', backgroundColor: dependentValues.IsUnderBufferLine ? "orange" : "inherit"}}>
            {value ? moment(value).format("MM-DD-YY") : value}
          </div>
        ),
      }],
      {
        key: "BatchLocation",
        name: <Translate value="location" />,
        resizable: true,
        width: 90,
        sortable: true,
        filterable: true,
      },
      ...isSV && [{
        key: "IsCombo",
        name: <Translate value="is_combo" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { (value === true || value === 'true') ? "true" : "false" }
          </div>
        ),
      }, {
        key: "IsChild",
        name: <Translate value="is_child" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { (value === true || value === 'true') ? "true" : "false" }
          </div>
        ),
      }, {
        key: "ParentRefNum",
        name: <Translate value="parent" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }],
      ...(!isSV && !isEKC && !isLMH && !isBRO && !isSDR && !isCRW && !isTQ && !isSC) && [{
        key: "IsNoReturn",
        name: <Translate value="no_return" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { (value === true || value === 'true') ? "true" : "false" }
          </div>
        ),
      }],
      ...isJML && [{
        key: "PackageSize_1",
        name: <Translate value="pcs/box" />,
        resizable: true,
        width: 80,
        sortable: true,
      }],
      ...isJML ? [{
        name: <Translate value="total_pcs" />,
        resizable: true,
        width: 80,
        sortable: true,
        getRowMetaData: row => row,
        formatter: ({ dependentValues }) => {
          return <span>{dependentValues.Quantity * dependentValues.PackageSize_1}</span>
        }
      }] : [],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSV || isSC) ? [] : [{
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      }],
      ...(isLMH || isBRO) ? [{
        key: "OriginalPrice",
        name: <Translate value="orig_price" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      }] : [],
      ...(isLMH || isBRO) ? [{
        key: "LineDiscount",
        name: <Translate value="discount_p" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...(showProductCost() && !isSV && !isHMM) ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      ...isCCW && [{
        key: "ShippedTotalPrice",
        name: <Translate value="invoice_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: CashFormatter,
      }],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...isSV && [{
        key: "Remark",
        name: <Translate value="note" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 150,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSV || isSC) ? [] : [{
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      }],
    ];

    if (isABBLE) {
      const totalNetWtIdx = columns.findIndex(item => item.key === 'TotalNetWeight');
      const totalShippingWt = {
        key: "TotalShippingWeight",
        name: <Translate value="total_s_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      }
      columns.splice(totalNetWtIdx, 0, totalShippingWt)
    }

    if (isHO || isJRC || (isLAP || isUSPrideMulti || isAPD || isGFD)) {
      if ((isLAP || isUSPrideMulti || isAPD || isGFD)) {
        columns.push({
          key: "Profit",
          name: <Translate value="profit" />,
          resizable: true,
          width: 100,
          sortable: true,
          formatter:({value}) => (
            <span>${Math.round(value * 100) / 100}</span>
          )
        })
      }
      columns.push({
        key: "SalesMargin",
        name: <Translate value="sales_margin" />,
        resizable: true,
        width: 100,
        sortable: true,
        formatter:({value}) => (
          <span>{Math.round(value * 100) / 100}%</span>
        )
      })
    }
    if (isHO || isJRC || isRivera) {
      const totalWTIndex = columns.findIndex(item => item.key === 'TotalNetWeight');
      if (totalWTIndex !== -1) {
        columns.splice(totalWTIndex, 0, {
          key: "ProductTax",
          name: <Translate value="total_tax" />,
          resizable: true,
          width: 70,
          sortable: true,
        }, {
          name: <Translate value="total_crv" />,
          resizable: true,
          width: 80,
          sortable: true,
          getRowMetaData: row => row,
          formatter: ({ dependentValues }) => {
            return <span>{dependentValues.Quantity * dependentValues.CRV}</span>
          }
        })
      }
    }

    if (isJML) {
      const index1 = _.findIndex(columns, { key: "NetWeight" });
      columns.splice(index1, 1);
      const index2 = _.findIndex(columns, { key: "TotalNetWeight" });
      columns.splice(index2, 1);
    }

    if (isABC) {
      const indexABC = _.findIndex(columns, { key: "PickupQuantity" });
      const temp = {
        key: "OriginalQuantity",
        name: <Translate value="original_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      };
      columns.splice(indexABC, 0, temp);
    }

    if (isGGI) {
      const col = {
        key: 'smallUnitPrice',
        name: <Translate value="small_unit_price" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        getRowMetaData: row => row,
        formatter: ({ dependentValues }) => {
          // if (dependentValues.ProductType !== "Fixed") return null;
          // const smallUnitPrice = roundTo(dependentValues.UnitPrice / dependentValues.PackageSize_1, 2);
          // if (isNaN(smallUnitPrice)) return 0;
          return <span>${dependentValues.SmallUnitPrice}</span>
        },
      };
      const index1 = _.findIndex(columns, { key: "UnitPrice" });
      columns.splice(index1, 0, col);
    }

    if (isTN) {
      const invCol = {
        key: "Inventory",
        name: <Translate value="inventory" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const handCol = {
        key: "OnHand",
        name: <Translate value="on_hand" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const convertNumCol = {
        key: "pc_box",
        name: <Translate value="pack" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const totalBoxNumCol = {
        key: "total_box",
        name: <Translate value="carton" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const indexTN = _.findIndex(columns, { key: "PickupQuantity" });
      columns.splice(indexTN, 0, invCol, handCol, convertNumCol, totalBoxNumCol);
    }

    if (isDAICHEONG) {
      const temp = {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => {
          const markItRed = parseFloat(dependentValues.UnitPrice) < parseFloat(dependentValues.LowestSalePrice)
          return <CashFormatter className={markItRed ? 'text-danger' : ''} value={value} />
        },
      };
      const indexDAICHEONG = _.findIndex(columns, { key: "UnitPrice" });
      columns.splice(indexDAICHEONG, 1, temp);

    }

    const isMobile = this.context.router && this.context.router.routes && this.context.router.routes.length > 2 && this.context.router.routes[1] && this.context.router.routes[1].path === "mobileSalesOrders";
    if (isOLG) {
      moveColumnToPosition(columns, {key: 'PackageSize'});
      moveColumnToPosition(columns, {key: 'BatchLocation'});
      moveColumnToPosition(columns, {key: 'IsNoReturn'});
      moveColumnToPosition(columns, {key: 'Name'});
    }
    if (isVAK) {
      columns.push({
        key: "Remark",
        name: <Translate value="notation" />,
        resizable: true,
        width: 120,
        sortable: true,
      })
    }

    const dsqColumnBottom = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "ReceivedQuantity",
        name: <Translate value="received_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "FBACode",
        name: <Translate value="fba_code" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "FBARoute",
        name: <Translate value="fba_route" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "TrailerNum",
        name: <Translate value="trailer" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POList",
        name: <Translate value="po_list" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POD",
        name: <Translate value="pod" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "InnerLabelQty",
        name: <Translate value="inner_label" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "OuterLabelQty",
        name: <Translate value="outer_label" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "DimUnit",
        name: <Translate value="dim_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "WeightUnit",
        name: <Translate value="weight_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletLength",
        name: "Plt L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletWidth",
        name: "Plt W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletHeight",
        name: "Plt H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletVol",
        name: <Translate value="plt_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "Quantity",
        name: <Translate value="qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ] : [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "ReceivedQuantity",
        name: <Translate value="received_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "FBACode",
        name: <Translate value="fba_code" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "FBARoute",
        name: <Translate value="fba_route" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "TrailerNum",
        name: <Translate value="trailer" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POList",
        name: <Translate value="po_list" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POD",
        name: <Translate value="pod" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "DimUnit",
        name: <Translate value="dim_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "WeightUnit",
        name: <Translate value="weight_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "Quantity",
        name: <Translate value="box_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletQuantity",
        name: <Translate value="plt_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletLength",
        name: "Plt L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletWidth",
        name: "Plt W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletHeight",
        name: "Plt H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletVol",
        name: <Translate value="plt_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ];

    const wizColumnBottom = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="sku" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "FBACode",
        name: <Translate value="fba" />,
        resizable: true,
        sortable: true,
        width: 80,
      },
      {
        key: "Quantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "CustomerBoxQty",
        name: <Translate value="customer_box" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "OutsideLabelQty",
        name: <Translate value="outside_label" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "InsideLabelQty",
        name: <Translate value="inside_label" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "SpecialHandling",
        name: <Translate value="special_handling" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 150,
      },
      {
        key: "CustomerNote",
        name: <Translate value="customer_note" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 150,
      },
      {
        key: "InboundCustomer",
        name: <Translate value="inbound_customer" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
      },
      {
        key: "InboundContainer",
        name: <Translate value="inbound_container" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
      },
      {
        key: "InboundDate",
        name: <Translate value="inbound_date" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
        formatter: DateFormatter2,
      },
      {
        key: "ReceivedQuantity",
        name: <Translate value="customer_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "ShipmentID",
        name: <Translate value="shipment_id" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BillablePallets",
        name: <Translate value="billable_pallets" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletQuantity",
        name: <Translate value="real_pallets" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        editable: true,
      },
      {
        key: "BoxPerPallet",
        name: <Translate value="box_per_plt" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        editable: true,
      },
      {
        key: "DispatchType",
        name: <Translate value="dispatch_type" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_vol" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "IsOversize",
        name: <Translate value="IsOversize" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsOverweight",
        name: <Translate value="IsOverweight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "PortDray",
        name: <Translate value="port_dray" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ] : [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="sku" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Quantity",
        name: isABC ? <Translate value="inbound_qty" /> : <Translate value="rcvd_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "ReceivedQuantity",
        name: <Translate value="customer_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "ShipmentID",
        name: <Translate value="customer_note" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BillablePallets",
        name: <Translate value="billable_pallets" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletQuantity",
        name: <Translate value="real_pallets" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        editable: true,
      },
      {
        key: "BoxPerPallet",
        name: <Translate value="box_per_plt" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        editable: true,
      },
      {
        key: "IsOversize",
        name: <Translate value="oversize" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsOverweight",
        name: <Translate value="overweight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "DispatchType",
        name: <Translate value="warehouse_note" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "DrayageTrucker",
        name: <Translate value="dray_trucker" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_vol" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PortDray",
        name: <Translate value="port_dray" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ];

    const jtbColumnBottom = [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 350,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Quantity",
        name: <Translate value="qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      }
    ];

    const lapColumnBottom = [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      }, {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: isSV ? 120 : 70,
      }, {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 250,
      }, {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: isOLG ? 300 : 100,
      }, {
        key: "PackageSize",
        name: <Translate value="package_size" />,
        resizable: true,
        sortable: true,
        width: 120,
      }, {
        key: "Quantity",
        name: <Translate value="qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      }, {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      }, {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      }, {
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }, {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      }, {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      }, {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      }, {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      }, {
        key: "IsNoReturn",
        name: <Translate value="no_return" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { (value === true || value === 'true') ? "true" : "false" }
          </div>
        ),
      }, {
        key: "BatchLocation",
        name: <Translate value="location" />,
        resizable: true,
        width: 90,
        sortable: true,
        filterable: true,
      }, {
        key: "Profit",
        name: <Translate value="profit" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter:({value}) => (
          <span>${Math.round(value * 100) / 100}</span>
        )
      }, {
        key: "SalesMargin",
        name: <Translate value="sales_margin" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter:({value}) => (
          <span>{Math.round(value * 100) / 100}%</span>
        )
      }
    ];

    const abcffColumnBottom = this.context.router.routes[1].path === 'outboundOrders' ? [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "UPC",
        name: <Translate value="upc" />,
        resizable: true,
        sortable: true,
        width: 126,
      },
      {
        key: "GTIN",
        name: <Translate value="gtin" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Quantity",
        name: <Translate value="case_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PerBoxQty",
        name: <Translate value="unit_case" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_case_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "POD",
        name: <Translate value="pod" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "InnerLabelQty",
        name: <Translate value="inner_label" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "OuterLabelQty",
        name: <Translate value="outer_label" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "DimUnit",
        name: <Translate value="dim_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "StoreReady",
        name: <Translate value="store_ready" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "Preticketed",
        name: <Translate value="preticketed" />,
        resizable: true,
        sortable: true,
        width: 120,
      },
      {
        key: "CantonNum",
        name: <Translate value="canton" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "OriginCountry",
        name: <Translate value="country" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "VendorStyleNum",
        name: <Translate value="vendor_style" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "TJXStyleNum",
        name: <Translate value="tjx_style" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "Color",
        name: <Translate value="color" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "Size",
        name: <Translate value="size_ratio" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "WeightUnit",
        name: <Translate value="weight_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletLength",
        name: "Plt L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletWidth",
        name: "Plt W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletHeight",
        name: "Plt H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "PalletVol",
        name: <Translate value="plt_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "UnitLength",
        name: "Unit L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "UnitWidth",
        name: "Unit W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "UnitHeight",
        name: "Unit H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "UnitVol",
        name: <Translate value="unit_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "FBACode",
        name: <Translate value="fba_code" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "FBARoute",
        name: <Translate value="fba_route" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "TrailerNum",
        name: <Translate value="trailer" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POList",
        name: <Translate value="po_list" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
    ] : [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Remark",
        name: <Translate value="notation" />,
        resizable: true,
        sortable: true,
        width: 160,
      },
      {
        key: "UnitQuantity",
        name: <Translate value="unit_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "Quantity",
        name: <Translate value="case_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      }, {
        key: "PerBoxQty",
        name: <Translate value="unit_case" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      }, {
        key: "ReceivedCaseQty",
        name: <Translate value="received_case_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        getRowMetaData: (row) => row,
        formatter: ({ value, dependentValues }) => (
          <div>
            {dependentValues.PerBoxQty ? dependentValues.ReceivedQuantity / dependentValues.PerBoxQty : ""}
          </div>
        ),
      }, {
        key: "ReceivedQuantity",
        name: <Translate value="received_unit_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }, {
        key: "PalletQuantity",
        name: <Translate value="plt_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      }, {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }, {
        key: "FBACode",
        name: <Translate value="fba_code" />,
        resizable: true,
        sortable: true,
        width: 90,
      }, {
        key: "FBARoute",
        name: <Translate value="fba_route" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "TrailerNum",
        name: <Translate value="trailer" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POList",
        name: <Translate value="po_list" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "POD",
        name: <Translate value="pod" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "DimUnit",
        name: <Translate value="dim_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "PalletStackable",
        name: <Translate value="stackable" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "StoreReady",
        name: <Translate value="store_ready" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "Preticketed",
        name: <Translate value="preticketed" />,
        resizable: true,
        sortable: true,
        width: 120,
      },
      {
        key: "CantonNum",
        name: <Translate value="canton" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "OriginCountry",
        name: <Translate value="country" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "VendorStyleNum",
        name: <Translate value="vendor_style" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "TJXStyleNum",
        name: <Translate value="tjx_style" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "UPC",
        name: <Translate value="upc" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "Color",
        name: <Translate value="color" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "Size",
        name: <Translate value="size_ratio" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "WeightUnit",
        name: <Translate value="weight_unit" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletLength",
        name: "Plt L",
        resizable: true,
        sortable: true,
      },
      {
        key: "PalletVol",
        name: <Translate value="plt_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },

      {
        key: "UnitLength",
        name: "Unit L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "UnitWidth",
        name: "Unit W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "UnitHeight",
        name: "Unit H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "UnitVol",
        name: <Translate value="unit_cbm" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_case_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ];

    const smColumnBottom = [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: 130,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 300,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 100,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => (
          <div>{dependentValues.ProductDescription || value}</div>
        )
      },
      {
        key: "Quantity",
        name: <Translate value="qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "PickedQuantity",
        name: <Translate value="pickedQty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        // formatter: CashFormatter,
        formatter:({ value }) => {
          if ((isSH || isAP) && (value===0 || value ==='0')){
            return (
              <span style={{'font-weight': 'bold', backgroundColor: 'rgb(255, 120, 111)', display:'inline-block', width:'100%'}}>
                {
                  (value !== null && !isNaN(value) && `$${numberWithCommas(value)}`)
                }
              </span>)
          } else {
            return (
              <span style={{'font-weight': 'bold'}}>
                {
                  (value !== null && !isNaN(value) && `$${numberWithCommas(value)}`)
                }
              </span>)
          }
        }
      },
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "Color",
        name: <Translate value="color" />,
        resizable: true,
        width: 80,
      }
    ];

    if (isGFD) {
      const QuantityCol = _.findIndex(columns, { key: 'Quantity' });
      const UnitPriceCol = _.findIndex(columns, { key: 'UnitPrice' });

      columns[QuantityCol].name = <Translate value="case_qty" />;
      columns[UnitPriceCol].name = <Translate value="case_price" />;

      const converNumCol = {
        key: "ConvertNum",
        name: <Translate value="unit_per_case" />,
        resizable: true,
        sortable: true,
        filterable: true,
        // width: 100,
        // formatter: ({ value, dependentValues }) => {
        //   return  <div>
        //   {value || dependentValues.barcode}
        // </div>
        // },
        // getRowMetaData: row => row,
      }
      const totalUnit = {
        key: "totalUnits",
        name: <Translate value="total_units" />,
        resizable: true,
        sortable: true,
        filterable: true,
        // width: 100,
        formatter: ({ value, dependentValues }) => {
          return  <div>
          {dependentValues.ConvertNum * dependentValues.Quantity}
        </div>
        },
        getRowMetaData: row => row,
      }
      columns.splice(QuantityCol + 1, 0, totalUnit);
      columns.splice(QuantityCol + 1, 0, converNumCol);
    }

    const generateColumnsBottom = () => {
      if (isDSQ) {
        return dsqColumnBottom;
      }
      if (isWIZ) {
        return wizColumnBottom;
      }
      if (isJTB) {
        return jtbColumnBottom;
      }
      if (isSH || isAP) {
        return smColumnBottom;
      }
      if (isABCFF) {
        return abcffColumnBottom;
      }
      if ((isLAP || isUSPrideMulti || isAPD)) {
        return lapColumnBottom;
      }
      return columns;
    };

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <div id="salesOrders-dataGrid2">
            <ReactDataGrid
              rowKey="SalesOrder_id"
              rowRenderer={props =>
                <ReactDataGrid.Row
                  {...props}
                  cellRenderer={cellProps =>
                    <ReactDataGrid.Cell
                      {...cellProps}
                      className={isVAK && !props.row.SalesOrderLine_id ? 'warning-Cell' : null}
                    />
                  }
                />
              }
              onGridSort={handleGridSort}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              // columns={columns}
              columns={generateColumnsBottom()}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              headerRowHeight={45}
              minHeight={tableHeight}
              onRowUpdated={this.handleRowUpdated}
              onRowSelect={onRowSelect}
            />
          </div>
        </Col>
      </Row>
    );
  }


  saveMagStuff() {
    if (!this.state.magSalesOrderDetail) {
      return;
    }

    const {mag1, mag2} = this.state;

    let magNoteTemp = [];
    if (mag1.DRYRUN) { magNoteTemp.push('DRYRUN')}
        if (mag1.OFFHIRE) { magNoteTemp.push('OFFHIRE')}
        if (mag1.EXTRA_STOP) { magNoteTemp.push('EXTRA_STOP')}
        if (mag1.EXAM) { magNoteTemp.push('EXAM')}
        if (mag1.EXTRA_DELIVERY) { magNoteTemp.push('EXTRA_DELIVERY')}
        if (mag1.STORAGE) { magNoteTemp.push('STORAGE')}
        if (mag1.BOBTAIL_FEE) { magNoteTemp.push('BOBTAIL_FEE')}
        this.state.magSalesOrderDetail.mag_note = magNoteTemp.join(',');

        let magDeliveryStatusTemp = [];
        if (mag2.FREIGHT_HOLD) { magDeliveryStatusTemp.push('FREIGHT_HOLD')}
        if (mag2.CUSTOM_HOLD) { magDeliveryStatusTemp.push('CUSTOM_HOLD')}
        if (mag2.PIERPASS_HOLD) { magDeliveryStatusTemp.push('PIERPASS_HOLD')}
        if (mag2.EXAM) { magDeliveryStatusTemp.push('EXAM')}
        if (mag2.CLOSED_AREA) { magDeliveryStatusTemp.push('CLOSED_AREA')}
        this.state.magSalesOrderDetail.DeliveryStatus = magDeliveryStatusTemp.join(',');

    axios.put(
      (SALES_ORDERS_URL + this.state.magSalesOrderDetail.SalesOrder_id),
      this.state.magSalesOrderDetail,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Order Saved");
      this.fetchSalesOrdersByDetails(
        this.state.days
      );
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));

    });
  }

  savePicker() {
    let {SelectedPicker, salesOrders} = this.state;
    let {Picker} = this.props;
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }
    const salesOrderIdsString = salesOrderIds.join(',');

    let data = null;
    if (Picker) {
      data = { Picker_User_id: Picker.value };
    }
    axios.put(
      (PICKER_URL + salesOrderIdsString),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Picker Assigned");
      this.fetchSalesOrdersByDetails(
        this.state.days
      );
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));

    });
  }

  renderMagContainer() {
    let {magSalesOrderDetail, mag1, mag2} = this.state;

    magSalesOrderDetail.delivery_lfd = magSalesOrderDetail.delivery_lfd ? new Date(magSalesOrderDetail.delivery_lfd) : null;

    const handleContainerChange = (e) => {
      magSalesOrderDetail[e.name] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleContainerDate = (e, keyname) => {
      magSalesOrderDetail[keyname] = e;
      this.setState( { magSalesOrderDetail });
    }

    const handleContainerDrop = (e, keyname) => {
      magSalesOrderDetail[keyname] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleContainerCheck1 = (keyname) => {
      mag1[keyname] = !mag1[keyname];
      this.setState( { mag1 });
    }

    const handleContainerCheck2 = (keyname) => {
      mag2[keyname] = !mag2[keyname];
      this.setState( { mag2 });
    }

    const magTerminalOptions = [
      {label: "EVERPORT", value: "EVERPORT"},
      {label: "LBCT", value: "LBCT"},
      {label: "shippers-MIDDLE", value: "shippers-MIDDLE"},
      {label: "SHIPPERS-ALAMEDA", value: "SHIPPERS-ALAMEDA"},
      {label: 'SHIPPERS-LONGBEACH', value: "SHIPPERS-LONGBEACH"},
      {label: "TRAPAC", value: "TRAPAC"},
      {label: "WBCT", value: "WBCT"},
      {label: 'PCT', value: "PCT"},
      {label: "ITS", value: "ITS"},
      {label: "APM", value: "APM"},
      {label: "C60-MATSON", value: "C60-MATSON"},
      {label: "TTI", value: "TTI"},
      {label: "YUSEN", value: "YUSEN"},
      {label: "FMS", value: "FMS"},
      {label: "PIER-A", value: "PIER-A"},
    ];

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <Col xs={4}>
            <label className="col-xs-4"><Translate value="container_num" /></label>
            <div className="col-xs-8">
              <Input disabled={true} value={magSalesOrderDetail.cntrNum ? magSalesOrderDetail.cntrNum : ""} name="cntrNum" type="text" onChange={(e) => handleContainerChange(e.target)} />
            </div>
            <label className="col-xs-4"><Translate value="bol_num" /></label>
            <div className="col-xs-8">
              <Input disabled={true} value={magSalesOrderDetail.bolNum ? magSalesOrderDetail.bolNum : ""} name="bolNum" type="text" onChange={(e) => handleContainerChange(e.target)} />
            </div>
            <label className="col-xs-4" style={{marginBottom: '15px'}}><Translate value="terminal" /></label>
            <div className="col-xs-8" style={{marginBottom: '15px'}}>
              <Dropdown>
                <Dropdown.Toggle style={{ height: '25px', width: '200px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                  {magSalesOrderDetail.terminal ? magSalesOrderDetail.terminal : 'SELECT'}
                </Dropdown.Toggle>
                <Dropdown.Menu className="super-colors">
                  {magTerminalOptions.map(el => {
                    return (
                      <MenuItem onClick={() => handleContainerDrop(el, 'terminal')}>{el.label}</MenuItem>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <label className="col-xs-4" style={{marginBottom: '15px'}}>LFD</label>
            <div className="col-xs-8" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleContainerDate(e, 'delivery_lfd')
                }}
                time={false}
                value={magSalesOrderDetail.delivery_lfd}
              />
            </div>
          </Col>
          <Col xs={5}>
            <label className="col-xs-3">HOLD (Select)</label>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="FREIGHT_HOLD"
                checked={mag2.FREIGHT_HOLD}
                onClick={() => {
                  handleContainerCheck2('FREIGHT_HOLD');
                }}
              />
              <span>Freight Hold</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="CUSTOM_HOLD"
                checked={mag2.CUSTOM_HOLD}
                onClick={() => {
                  handleContainerCheck2('CUSTOM_HOLD');
                }}
              />
              <span>Custom Hold</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="PIERPASS_HOLD"
                checked={mag2.PIERPASS_HOLD}
                onClick={() => {
                  handleContainerCheck2('PIERPASS_HOLD');
                }}
              />
              <span>Pierpass Hold</span>
            </div>
            <label style={{marginBottom: '15px'}} className="col-xs-3"></label>
            <div style={{marginBottom: '15px'}} className="col-xs-3">
              <input
                type="checkbox"
                name="EXAM"
                checked={mag2.EXAM}
                onClick={() => {
                  handleContainerCheck2('EXAM');
                }}
              />
              <span>Exam</span>
            </div>
            <div style={{marginBottom: '15px'}} className="col-xs-3">
              <input
                type="checkbox"
                name="CLOSED_AREA"
                checked={mag2.CLOSED_AREA}
                onClick={() => {
                  handleContainerCheck2('CLOSED_AREA');
                }}
              />
              <span>Closed Area</span>
            </div>
            <label style={{marginBottom: '15px'}} className="col-xs-3">&nbsp;</label>
            <label className="col-xs-3">HOLD (Other)</label>
            <div className="col-xs-9">
              <Input value={magSalesOrderDetail.DeliveryStatusOther ? magSalesOrderDetail.DeliveryStatusOther : ""} name="DeliveryStatusOther" type="text" onChange={(e) => handleContainerChange(e.target)} />
            </div>

            <label className="col-xs-3">Note (Select)</label>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="DRYRUN"
                checked={mag1.DRYRUN}
                onClick={() => {
                  handleContainerCheck1('DRYRUN');
                }}
              />
              <span>Dryrun</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="OFFHIRE"
                checked={mag1.OFFHIRE}
                onClick={() => {
                  handleContainerCheck1('OFFHIRE');
                }}
              />
              <span>Offhire</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="EXTRA_STOP"
                checked={mag1.EXTRA_STOP}
                onClick={() => {
                  handleContainerCheck1('EXTRA_STOP');
                }}
              />
            <span>Extra Stop</span>
            </div>

            <label className="col-xs-3"></label>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="EXAM"
                checked={mag1.EXAM}
                onClick={() => {
                  handleContainerCheck1('EXAM');
                }}
              />
              <span>Exam</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="EXTRA_DELIVERY"
                checked={mag1.EXTRA_DELIVERY}
                onClick={() => {
                  handleContainerCheck1('EXTRA_DELIVERY');
                }}
              />
              <span>Extra Delivery</span>
            </div>
            <div className="col-xs-3">
              <input
                type="checkbox"
                name="STORAGE"
                checked={mag1.STORAGE}
                onClick={() => {
                  handleContainerCheck1('STORAGE');
                }}
              />
              <span>Storage</span>
            </div>

            <label style={{marginBottom: '15px'}} className="col-xs-3"></label>
            <div style={{marginBottom: '15px'}} className="col-xs-3">
              <input
                type="checkbox"
                name="BOBTAIL_FEE"
                checked={mag1.BOBTAIL_FEE}
                onClick={() => {
                  handleContainerCheck1('BOBTAIL_FEE');
                }}
              />
              <span>Bobtail Fee</span>
            </div>
            <label style={{marginBottom: '15px'}} className="col-xs-3">&nbsp;</label>
            <label style={{marginBottom: '15px'}} className="col-xs-3">&nbsp;</label>

            <label className="col-xs-3">Note (Other)</label>
            <div className="col-xs-9">
              <Input value={magSalesOrderDetail.mag_note_other ? magSalesOrderDetail.mag_note_other : ""} name="mag_note_other" type="text" onChange={(e) => handleContainerChange(e.target)} />
            </div>
          </Col>
          <Col xs={3}></Col>
        </Col>
      </Row>
    );
  }

  renderMagLoad() {
    let {magSalesOrderDetail} = this.state;

    magSalesOrderDetail.delivery_lfd = magSalesOrderDetail.delivery_lfd ? new Date(magSalesOrderDetail.delivery_lfd) : null;

    magSalesOrderDetail.pick_appt_date = magSalesOrderDetail.pick_appt_date ? new Date(magSalesOrderDetail.pick_appt_date) : null;
    magSalesOrderDetail.loadout_date = magSalesOrderDetail.loadout_date ? new Date(magSalesOrderDetail.loadout_date) : null;
    magSalesOrderDetail.portwaiting_start_time = magSalesOrderDetail.portwaiting_start_time ? new Date(magSalesOrderDetail.portwaiting_start_time) : null;
    magSalesOrderDetail.portwaiting_finish_time = magSalesOrderDetail.portwaiting_finish_time ? new Date(magSalesOrderDetail.portwaiting_finish_time) : null;

    // if (this.props.salesOrderIsLoading && !this.props.salesOrderError)
    //   return <Spinner />;
    // else if (this.props.salesOrderError) {
    //   return (
    //     <ContentWrapper>
    //       <div className="alert alert-danger">
    //         {JSON.stringify(this.props.salesOrderError)}
    //       </div>
    //     </ContentWrapper>
    //   );
    // }
    // const tableHeight = window.innerHeight < 930 ? 185 : 185;
    // const getRows = () => Data.Selectors.getRows(this.state.salesOrderDetail);
    // const getSize = () => getRows().length;
    // const rowGetter = (rowIdx) => {
    //   const rows = getRows();
    //   return rows[rowIdx];
    // };

    // const generateColumnsBottom = () => {
    //   if (isWIZ) {
    //     return wizColumnBottom;
    //   }
    //   if (isJTB) {
    //     return jtbColumnBottom;
    //   }
    //   return columns;
    // };
    const handleLoadChange = (e) => {
      magSalesOrderDetail[e.name] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleLoadDate = (e, keyname) => {
      magSalesOrderDetail[keyname] = e;
      this.setState( { magSalesOrderDetail });
    }

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <Col xs={4}>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="pickup_appt_date" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleLoadDate(e, 'pick_appt_date')
                }}
                time={false}
                value={magSalesOrderDetail.pick_appt_date}
              />
            </div>
            <label className="col-xs-4"><Translate value="pickup_appt_time" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.pick_appt_time ? magSalesOrderDetail.pick_appt_time : ""} name="pick_appt_time" type="text" onChange={(e) => handleLoadChange(e.target)} />
            </div>
            <label className="col-xs-4"><Translate value="pickup_appt_#" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.pick_appt_num ? magSalesOrderDetail.pick_appt_num : ""} name="pick_appt_num" type="text" onChange={(e) => handleLoadChange(e.target)} />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="loadout_date" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleLoadDate(e, 'loadout_date')
                }}
                time={false}
                value={magSalesOrderDetail.loadout_date}
              />
            </div>
            <label className="col-xs-4"><Translate value="chassis_num" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.chassis_num ? magSalesOrderDetail.chassis_num : ""} name="chassis_num" type="text" onChange={(e) => handleLoadChange(e.target)} />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-4"><Translate value="loadout_port_waiting" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.LOADOUT_PORT_WAITING ? magSalesOrderDetail.LOADOUT_PORT_WAITING : ""} name="LOADOUT_PORT_WAITING" type="text" onChange={(e) => handleLoadChange(e.target)} />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="portwaiting_start" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleLoadDate(e, 'portwaiting_start_time')
                }}
                time={true}
                value={magSalesOrderDetail.portwaiting_start_time}
              />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="portwaiting_finish" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleLoadDate(e, 'portwaiting_finish_time')
                }}
                time={true}
                value={magSalesOrderDetail.portwaiting_finish_time}
              />
            </div>
          </Col>
        </Col>
      </Row>
    );
  }

  renderMagDelivery() {
    let {magSalesOrderDetail} = this.state;

    magSalesOrderDetail.SCHEDULED_DELIVERY_DATE = magSalesOrderDetail.SCHEDULED_DELIVERY_DATE ? new Date(magSalesOrderDetail.SCHEDULED_DELIVERY_DATE) : null;
    magSalesOrderDetail.ACTUAL_DELIVERY_DATE = magSalesOrderDetail.ACTUAL_DELIVERY_DATE ? new Date(magSalesOrderDetail.ACTUAL_DELIVERY_DATE) : null;
    magSalesOrderDetail.DETENTTION_START_TIME = magSalesOrderDetail.DETENTTION_START_TIME ? new Date(magSalesOrderDetail.DETENTTION_START_TIME) : null;
    magSalesOrderDetail.DETENTION_FINISH_TIME = magSalesOrderDetail.DETENTION_FINISH_TIME ? new Date(magSalesOrderDetail.DETENTION_FINISH_TIME) : null;

    const handleDeliveryChange = (e) => {
      magSalesOrderDetail[e.name] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleDeliveryDrop = (e, keyname) => {
      magSalesOrderDetail[keyname] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleDeliveryDate = (e, keyname) => {
      magSalesOrderDetail[keyname] = e;
      this.setState( { magSalesOrderDetail });
    }

    const magDeliveryTypeOptions = [
      {
        label: 'DROP_HOOK',
        value: 'DROP_HOOK',
      },
      {
        label: 'LIVE_UNLOADING',
        value: 'LIVE_UNLOADING',
      },
    ]

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <Col xs={4}>
            {/* <label className="col-xs-4"><Translate value="delivery_test" /></label>
                  <div className="col-xs-8">
                  <Input name="Test2" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
                  </div> */}
            <label className="col-xs-4" style={{marginBottom: '15px'}}><Translate value="delivery_type" /></label>
            <div className="col-xs-8" style={{marginBottom: '15px'}}>
              <Dropdown>
                <Dropdown.Toggle style={{ height: '25px', width: '150px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                  {magSalesOrderDetail.DELIVERY_TYPE ? magSalesOrderDetail.DELIVERY_TYPE : 'SELECT'}
                </Dropdown.Toggle>
                <Dropdown.Menu className="super-colors">
                  {magDeliveryTypeOptions.map(el => {
                    return (
                      <MenuItem onClick={() => handleDeliveryDrop(el, 'DELIVERY_TYPE')}>{el.label}</MenuItem>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>


            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="scheduled_delivery" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleDeliveryDate(e, 'SCHEDULED_DELIVERY_DATE')
                }}
                time={true}
                value={magSalesOrderDetail.SCHEDULED_DELIVERY_DATE}
              />
            </div>
            <label className="col-xs-4" ><Translate value="appointment_#" /></label>
            <div className="col-xs-8" >
              <Input value={magSalesOrderDetail.SCHEDULED_DELIVERY_APPT_NUM ? magSalesOrderDetail.SCHEDULED_DELIVERY_APPT_NUM : ""} name="SCHEDULED_DELIVERY_APPT_NUM" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
            </div>

            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="actual_delivery" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleDeliveryDate(e, 'ACTUAL_DELIVERY_DATE')
                }}
                time={true}
                value={magSalesOrderDetail.ACTUAL_DELIVERY_DATE}
              />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-4" ><Translate value="detention_waiting_time" /></label>
            <div className="col-xs-8" >
              <Input value={magSalesOrderDetail.DETENTION_WAITING_TIME ? magSalesOrderDetail.DETENTION_WAITING_TIME : ""} name="DETENTION_WAITING_TIME" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
            </div>
            {/* <label className="col-xs-4" ><Translate value="detention_start_time" /></label>
            <div className="col-xs-8" >
            <Input name="DETENTTION_START_TIME" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
            </div>
            <label className="col-xs-4" ><Translate value="detention_finish_time" /></label>
            <div className="col-xs-8" >
            <Input name="DETENTION_FINISH_TIME" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
            </div> */}
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="detention_start_time" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleDeliveryDate(e, 'DETENTTION_START_TIME')
                }}
                time={true}
                value={magSalesOrderDetail.DETENTTION_START_TIME}
              />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="detention_finish_time" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleDeliveryDate(e, 'DETENTION_FINISH_TIME')
                }}
                time={true}
                value={magSalesOrderDetail.DETENTION_FINISH_TIME}
              />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-4" >POD</label>
            <div className="col-xs-8" >
              <Input value={magSalesOrderDetail.POD ? magSalesOrderDetail.POD : ""} name="POD" type="text" onChange={(e) => handleDeliveryChange(e.target)} />
            </div>
          </Col>
        </Col>
      </Row>
    );
  }

  renderMagEmpty() {
    let {magSalesOrderDetail} = this.state;

    magSalesOrderDetail.EMPTY_NOTIFICATION_DATE = magSalesOrderDetail.EMPTY_NOTIFICATION_DATE ? new Date(magSalesOrderDetail.EMPTY_NOTIFICATION_DATE) : null;
    magSalesOrderDetail.EMPTY_PICKUP_DATE = magSalesOrderDetail.EMPTY_PICKUP_DATE ? new Date(magSalesOrderDetail.EMPTY_PICKUP_DATE) : null;
    magSalesOrderDetail.EMPTYIN_APPT_DATETIME = magSalesOrderDetail.EMPTYIN_APPT_DATETIME ? new Date(magSalesOrderDetail.EMPTYIN_APPT_DATETIME) : null;
    magSalesOrderDetail.Empty_Return_FINAL_Date = magSalesOrderDetail.Empty_Return_FINAL_Date ? new Date(magSalesOrderDetail.Empty_Return_FINAL_Date) : null;

    const handleEmptyChange = (e) => {
      magSalesOrderDetail[e.name] = e.value;
      this.setState( { magSalesOrderDetail });
    }

    const handleEmptyDate = (e, keyname) => {
      magSalesOrderDetail[keyname] = e;
      this.setState( { magSalesOrderDetail });
    }
    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <Col xs={4}>
            <label className="col-xs-4"><Translate value="empty_status" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.EMPTY_STATUS ? magSalesOrderDetail.EMPTY_STATUS : ""} name="EMPTY_STATUS" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="empty_notification" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleEmptyDate(e, 'EMPTY_NOTIFICATION_DATE')
                }}
                time={false}
                value={magSalesOrderDetail.EMPTY_NOTIFICATION_DATE}
              />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="empty_pickup_date" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleEmptyDate(e, 'EMPTY_PICKUP_DATE')
                }}
                time={false}
                value={magSalesOrderDetail.EMPTY_PICKUP_DATE}
              />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-4"><Translate value="empty_location" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.EMPTY_LOCATION ? magSalesOrderDetail.EMPTY_LOCATION : ""} name="EMPTY_LOCATION" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
            <label className="col-xs-4"><Translate value="empty-in_terminal" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.EMPTY_IN_TERMINAL ? magSalesOrderDetail.EMPTY_IN_TERMINAL : ""} name="EMPTY_IN_TERMINAL" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="empty_appt" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY HH:mm"
                // max={Today}
                step={10}
                onChange={(e) => {
                  handleEmptyDate(e, 'EMPTYIN_APPT_DATETIME')
                }}
                time={true}
                value={magSalesOrderDetail.EMPTYIN_APPT_DATETIME}
              />
            </div>
            <label className="col-xs-4"><Translate value="empty_appt#" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.EMPTY_APPT_NUM ? magSalesOrderDetail.EMPTY_APPT_NUM : ""} name="EMPTY_APPT_NUM" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
          </Col>
          <Col xs={4}>
            <label className="col-xs-5" style={{marginBottom: '15px'}}><Translate value="return_final_date" /></label>
            <div className="col-xs-7" style={{marginBottom: '15px'}}>
              <DateTimePicker
                id="all-register-datepicker"
                format="MM-DD-YY"
                // max={Today}
                // step={10}
                onChange={(e) => {
                  handleEmptyDate(e, 'Empty_Return_FINAL_Date')
                }}
                time={false}
                value={magSalesOrderDetail.Empty_Return_FINAL_Date}
              />
            </div>
            <label className="col-xs-4"><Translate value="return_final_terminal" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.Empty_Return_FINAL_TERMINAL ? magSalesOrderDetail.Empty_Return_FINAL_TERMINAL : ""} name="Empty_Return_FINAL_TERMINAL" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
            <label className="col-xs-4"><Translate value="empty_portwaiting" /></label>
            <div className="col-xs-8">
              <Input value={magSalesOrderDetail.EMPTYIN_PORTWAITING ? magSalesOrderDetail.EMPTYIN_PORTWAITING : ""} name="EMPTYIN_PORTWAITING" type="text" onChange={(e) => handleEmptyChange(e.target)} />
            </div>
          </Col>
        </Col>
      </Row>
    );
  }

  renderProductsTableFJ() {
    if (this.props.salesOrderIsLoading && !this.props.salesOrderError)
      return <WidgetsSpinner />;
    else if (this.props.salesOrderError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            {JSON.stringify(this.props.salesOrderError)}
          </div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid
    const tableHeight = window.innerHeight < 930 ? 185 : 185;

    const getRows = () => Data.Selectors.getRows(this.state.salesOrderDetail);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.salesOrderDetail, {
        sortColumn,
        sortDirection,
      });
      this.setState({ salesOrderDetail: state });
    };

    const onClearFilters = () => {
      // all filters removed
      const salesOrderDetail = { ...this.state.salesOrderDetail, filters: {} };
      this.setState({ salesOrderDetail });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.salesOrderDetail.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        filters: newFilters,
      };
      this.setState({ salesOrderDetail });
    };

    // Handle the row select function
    const onRowSelect = (rows) => {
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        selectedRows: rows,
      };
      this.setState({ salesOrderDetail });
    };

    const VendorNameFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.Name}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    const VendorNumFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    // Column definition
    const showProductCost = () => {
      return !checkPermissionLocal('no_show_product_cost')
    };

    const columns = [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: isTN ? <Translate value="sku" /> : <Translate value={isOLG ? "item_no" : "ref_num"} />,
        resizable: true,
        sortable: true,
        width: isJML ? 200 : 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 350,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Quantity",
        name: isABC ? <Translate value="inbound_qty" /> : <Translate value="qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ];

    if (isJML) {
      const index1 = _.findIndex(columns, { key: "NetWeight" });
      columns.splice(index1, 1);
      const index2 = _.findIndex(columns, { key: "TotalNetWeight" });
      columns.splice(index2, 1);
    }

    if (isABC) {
      const indexABC = _.findIndex(columns, { key: "PickupQuantity" });
      const temp = {
        key: "OriginalQuantity",
        name: <Translate value="original_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      };
      columns.splice(indexABC, 0, temp);
    }

    if (isHMM) {
      const temp = {
        key: "PackageSize",
        name: <Translate value="package_size" />,
        resizable: true,
        width: 100,
        sortable: true,
      };
      columns.splice(5, 0, temp);
    }

    if (isTN) {
      const invCol = {
        key: "Inventory",
        name: <Translate value="inventory" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const handCol = {
        key: "OnHand",
        name: <Translate value="on_hand" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const convertNumCol = {
        key: "pc_box",
        name: <Translate value="pack" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const totalBoxNumCol = {
        key: "total_box",
        name: <Translate value="carton" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      };
      const indexTN = _.findIndex(columns, { key: "PickupQuantity" });
      columns.splice(indexTN, 0, invCol, handCol, convertNumCol, totalBoxNumCol);
    }
    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";

    const jtbColumnBottom = [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
        resizable: true,
        sortable: true,
        width: isJML ? 200 : 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 350,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Quantity",
        name: <Translate value="qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "PalletQuantity",
        name: <Translate value="pallet_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ];

    const wizColumnBottom = [
      {
        key: "ProductNum",
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "RefNum",
        name: <Translate value="sku" />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: "ReceivedQuantity",
        name: <Translate value="received_qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "ShipmentID",
        name: <Translate value="shipment_id" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BillablePallets",
        name: <Translate value="billable_pallets" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletQuantity",
        name: <Translate value="real_pallets" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        editable: true,
      },
      {
        key: "BoxPerPallet",
        name: <Translate value="box_per_plt" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        editable: true,
      },
      {
        key: "DispatchType",
        name: <Translate value="dispatch_type" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxLength",
        name: "Box L",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxWidth",
        name: "Box W",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxHeight",
        name: "Box H",
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: "BoxVol",
        name: <Translate value="box_vol" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "BoxWeight",
        name: <Translate value="box_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "PalletWeight",
        name: <Translate value="pallet_weight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "IsOversize",
        name: <Translate value="IsOversize" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "IsOverweight",
        name: <Translate value="IsOverweight" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
        formatter: ({ value }) => (
          <div>
            { value ? "true" : "false" }
          </div>
        ),
      },
      {
        key: "PortDray",
        name: <Translate value="port_dray" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "Location",
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: "Quantity",
        name: <Translate value="qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "PickupQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "PackageType",
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      ...showProductCost() ? [{
        key: "CostPrice",
        name: <Translate value="cost_price" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "ProductTax",
        name: <Translate value="tax" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "NetWeight",
        name: <Translate value="net_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: "TotalNetWeight",
        name: <Translate value="total_weight" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
    ];

    const generateColumnsBottom = () => {
      if (isWIZ) {
        return wizColumnBottom;
      }
      if (isJTB) {
        return jtbColumnBottom;
      }
      return columns;
    };

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <div id="salesOrders-dataGrid2">
            <ReactDataGrid
              rowKey="SalesOrder_id"
              onGridSort={handleGridSort}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              // columns={columns}
              columns={generateColumnsBottom()}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              headerRowHeight={45}
              minHeight={tableHeight}
              onRowUpdated={this.handleRowUpdated}
              onRowSelect={onRowSelect}
            />
          </div>
        </Col>
      </Row>
    );
  }

  shippingIFrameIsLoaded = () => {
    if (!this.state.shippingPdfFrameLoaded) {
      const pdfFrame = window.frames.shippingPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ shippingPdfFrameLoaded: true });
    }
  };

  renderShippingIFrame() {
    if (this.props.shippingListPDF) {
      const file = window.URL.createObjectURL(this.props.shippingListPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.shippingIFrameIsLoaded}
          id="shippingPdf"
          name="shippingPdf"
          src={file}
        />
      );
    }
  }

  packingIFrameIsLoaded = () => {
    if (!this.state.packingListPdfFrameLoaded) {
      const pdfFrame = window.frames.packingPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ packingListPdfFrameLoaded: true });
    }
  };

  renderPackingIFrame() {
    if (this.props.packingListPDF) {
      const file = window.URL.createObjectURL(this.props.packingListPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.packingIFrameIsLoaded}
          id="packingPdf"
          name="packingPdf"
          src={file}
        />
      );
    }
  }

  pickingIFrameIsLoaded = () => {
    if (!this.state.pickingListPdfFrameLoaded) {
      const pdfFrame = window.frames.pickingPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ pickingListPdfFrameLoaded: true });
    }
  };

  renderPickingIFrame() {
    if (this.props.pickingListPDF) {
      const file = window.URL.createObjectURL(this.props.pickingListPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.pickingIFrameIsLoaded}
          id="pickingPdf"
          name="pickingPdf"
          src={file}
        />
      );
    }
  }

  salesOrderIFrameIsLoaded = () => {
    if (!this.state.salesOrderPdfFrameLoaded) {
      const pdfFrame = window.frames.salesOrderPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ salesOrderPdfFrameLoaded: true });
    }
  };

  renderSalesOrderIFrame() {
    if (this.props.salesOrderPDF) {
      const file = window.URL.createObjectURL(this.props.salesOrderPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.salesOrderIFrameIsLoaded}
          id="salesOrderPdf"
          name="salesOrderPdf"
          src={file}
        />
      );
    }
  }

  bolByIdIFrameIsLoaded = () => {
    if (!this.state.bolIdPdfFrameLoaded) {
      const pdfFrame = window.frames.bolIdPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ bolIdPdfFrameLoaded: true });
    }
  };
  renderBolByIdIFrame() {
    if (this.props.bolIdPDF) {
      const file = window.URL.createObjectURL(this.props.bolIdPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.bolByIdIFrameIsLoaded}
          id="bolIdPdf"
          name="bolIdPdf"
          src={file}
        />
      );
    }
  }

  bolWithoutLogIFrameIsLoaded = () => {
    if (!this.state.bolWithoutLogPdfFrameLoaded) {
      const pdfFrame = window.frames.bolWithoutLogPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ bolWithoutLogPdfFrameLoaded: true });
    }
  };

  renderBolWithoutLogIFrame() {
    if (this.props.bolWithoutLogPDF) {
      const file = window.URL.createObjectURL(this.props.bolWithoutLogPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.bolWithoutLogIFrameIsLoaded}
          id="bolWithoutLogPdf"
          name="bolWithoutLogPdf"
          src={file}
        />
      );
    }
  }

  bolLabelIFrameIsLoaded = () => {
    if (!this.state.bolLabelFrameLoaded) {
      const pdfFrame = window.frames.bolLabel;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ bolLabelFrameLoaded: true });
    }
  };

  renderBolLabelIFrame() {
    if (this.props.bolLabel) {
      const file = window.URL.createObjectURL(this.props.bolLabel);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.bolLabelIFrameIsLoaded}
          id="bolLabel"
          name="bolLabel"
          src={file}
        />
      );
    }
  }

  bolByFbaIFrameIsLoaded = () => {
    if (!this.state.bolFbaPdfFrameLoaded) {
      const pdfFrame = window.frames.bolFbaPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ bolFbaPdfFrameLoaded: true });
    }
  };

  PODIframLoaded = () => {
    if (!this.state.PODIframeLoaded) {
      const pdfFrame = window.frames.podPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ PODIframeLoaded: true });
    }
  }
  renderBolByFbaIFrame() {
    if (this.props.bolFbaPDF) {
      const file = window.URL.createObjectURL(this.props.bolFbaPDF);
      return (
        <iframe
          style={{ display: "none" }}
          onLoad={this.bolByFbaIFrameIsLoaded}
          id="bolFbaPdf"
          name="bolFbaPdf"
          src={file}
        />
      );
    }
  }

  renderPrint() {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    const salesOrderIds = [];
    if(isOLG) {
      const { salesOrders } = this.state;
      if (salesOrders && salesOrders.selectedRows) {
        salesOrders.selectedRows.map((row) => {
          salesOrderIds.push(row.SalesOrder_id);
        });
      }
    }
    const saleStatus =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SaleStatus;

    // if(!salesOrder_id)
    //   return;
    const url = `${ROOT_URL}v1/sale/printorder/${salesOrder_id}?Bearer=${localStorage.getItem(
      "token"
    )}`;
    const picking_url = `${ROOT_URL}v1/sale/printpickinglist/${salesOrder_id}?Bearer=${localStorage.getItem(
      "token"
    )}`;
    const shipping_url = `${ROOT_URL}v1/sale/printshippinglist/${salesOrder_id}?Bearer=${localStorage.getItem(
      "token"
    )}`;
    const packing_url = `${ROOT_URL}v1/sale/printpackinglist/${salesOrder_id}?Bearer=${localStorage.getItem(
      "token"
    )}`;
    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";
    const shouldDisablePrintBtn = () => {
      //(isOLG && salesOrderIds.length == 0) || (!isOLG && !salesOrder_id) || !checkPermission("print_sales_order")
      const { salesOrders } = this.state;
      if (isOLG) {
        return salesOrderIds.length === 0;
      } else {
        if (isVAK) {
          const selectedSalesOrder = salesOrders.selectedRows[0]
          if (selectedSalesOrder
            && (selectedSalesOrder.Req_Review_Status !== 'Confirm' || selectedSalesOrder.Req_Approve_Status !== 'Confirm')
            && (selectedSalesOrder.Review_Status !== 'Confirm' || selectedSalesOrder.Approve_Status !== 'Confirm')
            || isMobile && this.state.salesOrders.selectedRows.filter(row => row.SaleStatus === 'Incomplete').length
          ) {
            return true;
          }
        }
        if (!salesOrder_id) {
          return true;
        }
      }
      if ((!isVAK || isVAK && !isMobile) && !checkPermission('print_sales_order') || isVAK && isMobile && !checkPermission('print_mobile_order')) {
        return true;
      }
      return false;
    }
    return (
      <div className="padLeft" id={isABC && "buttonsContainer-padLeft"}>
        { !isABCFF &&
          <Button
            bsStyle="primary"
            className="print-btn"
            disabled={shouldDisablePrintBtn()}
            type="button"
            onClick={() => {
              if(isOLG) {
                this.props.printSalesOrder(salesOrderIds.join(","));
              } else {
                this.props.printSalesOrder(salesOrder_id, this.state.Status);
              }
            }}
          >
            <em className="fa fa-print" />
            <Translate value={(isLAP || isUSPrideMulti || isAPD) ? "download_so" : "print_so"} />
          </Button>
        }
        { false &&
        <Button
        bsStyle="primary"
        className="print-btn"
        disabled={!salesOrder_id || !checkPermission("print_sales_order")}
        type="button"
        onClick={() => {
          this.props.printSalesOrder(salesOrder_id, this.state.Status, true);
        }}
      >
        <em className="fa fa-print" />
        <Translate value="print_bo" />
      </Button>
        }

        { (isSV && !isABCFF ) && this.renderPickingListPrint2() }
        { !(isABC || isSV || isABCFF || isAPD) && this.renderPickingListPrint() }
        { !(isABC || isSV || isABCFF) && this.renderPackingListPrint() }
        {isAP && this.renderMergeToPOButton()}
        {/* { isSV && this.renderPackingListPrint(true) } */}
        { isSV && this.renderPickingListPrint3() }
        { isSV && this.renderPickingListPrint2(true) }
        { !(isABC || isSV || isSKH || isSH || isAP || isABCFF || isAPD ) && this.renderShippingListPrint() }
        { this.renderPickingListButton() }
        {this.renderPrePayButtons()}
        {isAGD && this.renderPickingListButtonAGD()}

        { (isABCFF && this.context.router.routes[1].path === "outboundOrders") && this.renderPickingListPrint() }
        { (isABCFF && this.context.router.routes[1].path === "outboundOrders") && this.renderPackingListPrint() }
        { (isABCFF && this.context.router.routes[1].path !== "outboundOrders") && this.renderReceivingReportPrint() }
        { (isABCFF && this.context.router.routes[1].path === "outboundOrders") && this.renderDscoShipmentButton() }
        { (isABCFF && this.context.router.routes[1].path === "outboundOrders") && this.renderWalmartShipmentButton2() }

        { (isCO || isABC) && this.renderSubmitBolImageButton() }
        { (isABC) && this.renderUploadPODButton() }
        {/* { isABC && this.renderLocatioinChangeButton() } */}
        { isABC && this.renderInboundDateEditButton() }
        { isABC &&
          <Button
            style={{ float: 'right' }}
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.setState({
                abcDatePickerShow: !this.state.abcDatePickerShow,
              });
            }}
          >
            <Translate value="advanced_search" />
          </Button>
        }
      </div>
    );
  }

  renderPickingListPrint3() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }

    const hasQuote = salesOrders.selectedRows.some(el => el.SaleStatus === 'Quote');
    const svPendingDisable = salesOrders.selectedRows.some(el => el.SaleStatus === 'Pending');

    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={hasQuote || salesOrderIds.length === 0 || !checkPermission("print_sales_order") || svPendingDisable }
        type="button"
        onClick={() => {
          this.props.printPickingList(salesOrderIds.join(","), false, true);
        }}
      >
        <em className="fa fa-print" />
       <Translate
         value={isSV ? 'ecom_picking_list_location' : "picking_list_location"}
       />
      </Button>
    );
  }

  renderPickingListPrint2(location) {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }

    const hasQuote = salesOrders.selectedRows.some(el => el.SaleStatus === 'Quote');
    const svPendingDisable = salesOrders.selectedRows.some(el => el.SaleStatus === 'Pending');

    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={hasQuote || salesOrderIds.length === 0 || !checkPermission("print_sales_order") || svPendingDisable }
        type="button"
        onClick={() => {
          this.props.printPickingList(salesOrderIds.join(","), location);
        }}
      >
        <em className="fa fa-print" />
       <Translate
         value={
           (isSV && location) ? "picking_list_location" : "picking_list"
          }
       />
      </Button>
    );
    // if (isAFG || isMyuMyu || isWecom) {
    //   return (
    //     <Button
    //       bsStyle="primary"
    //       className="print-btn"
    //       type="button"
    //       disabled={!checkPermission("print_sales_order")}
    //       onClick={() => {
    //         // this.props.printPickingList(salesOrderIds.join(','));
    //         this.openChangePullSheet();
    //       }}
    //     >
    //       <em className="fa fa-print" />
    //       <Translate value="pull_sheet" />
    //     </Button>
    //   );
    // }
    // return (
    //   <Button
    //     bsStyle="primary"
    //     className="print-btn"
    //     type="button"
    //     disabled={!checkPermission("print_sales_order") || hasQuote || svPendingDisable}
    //     onClick={() => {
    //       this.props.printPickingList(salesOrderIds.join(","));
    //     }}
    //   >
    //     <em className="fa fa-print" />
    //     <Translate
    //       value={
    //         (isSV && location) ? "packing_list_location" : "packing_list"
    //       }
    //     />      </Button>
    // );
  }

  renderPickingListPrint() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    const salesOrder_id =
      salesOrders.selectedRows.length === 1 &&
      salesOrders.selectedRows[0].SalesOrder_id;
    if (salesOrders && salesOrders.selectedRows.length > 1) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }

    const hasQuote = salesOrders.selectedRows.some(el => el.SaleStatus === 'Quote');
    const svPendingDisable = salesOrders.selectedRows.some(el => el.SaleStatus === 'Pending');
    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";
    if (salesOrders.selectedRows.length <= 1) {
      return (
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={hasQuote || !salesOrder_id || (!isVAK || isVAK && !isMobile) && !checkPermission("print_sales_order") || isVAK && isMobile && (!checkPermission("print_mobile_order") || this.state.salesOrders.selectedRows.filter(row => row.SaleStatus === 'Incomplete').length) || svPendingDisable}
          type="button"
          onClick={() => {
            this.props.printPickingList(salesOrder_id);
          }}
        >
          <em className="fa fa-print" />
          <Translate
            value={isMyuMyu || isAFG || isWecom ? "pull_sheet" : "picking_list"}
          />
        </Button>
      );
    }
    if (isAFG || isMyuMyu || isWecom) {
      return (
        <Button
          bsStyle="primary"
          className="print-btn"
          type="button"
          disabled={!checkPermission("print_sales_order")}
          onClick={() => {
            // this.props.printPickingList(salesOrderIds.join(','));
            this.openChangePullSheet();
          }}
        >
          <em className="fa fa-print" />
          <Translate value="pull_sheet" />
        </Button>
      );
    }
    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        type="button"
        disabled={(!isVAK || isVAK && !isMobile) && !checkPermission("print_sales_order") || isVAK && isMobile && (!checkPermission("print_mobile_order") || this.state.salesOrders.selectedRows.filter(row => row.SaleStatus === 'Incomplete').length) || hasQuote || svPendingDisable}
        onClick={() => {
          this.props.printPickingList(salesOrderIds.join(","));
        }}
      >
        <em className="fa fa-print" />
      <Translate value="picking_list" />
      </Button>
    );
  }

  renderPackingListPrint(location) {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    const hasQuote = salesOrders.selectedRows.some(el => el.SaleStatus === 'Quote');
    const svPendingDisable = salesOrders.selectedRows.some(el => el.SaleStatus === 'Pending');
    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";

    let allHaveInvoiceNum = true;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
        if (!salesOrder.InvoiceNum && (isHMM || isBRO)) {
          allHaveInvoiceNum = false;
        }
      });
    }

    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={
          salesOrderIds.length === 0 ||
          (!isVAK || isVAK && !isMobile) && !checkPermission("print_sales_order") ||
          isVAK && isMobile && (!checkPermission("print_mobile_order") || this.state.salesOrders.selectedRows.filter(row => row.SaleStatus === 'Incomplete').length) ||
          !allHaveInvoiceNum ||
          hasQuote ||
          svPendingDisable
        }
        type="button"
        onClick={() => {
          this.props.printPackingList(salesOrderIds.join(","), location);
        }}
      >
        <em className="fa fa-print" />
        <Translate
          value={
            (isSV && location) ? "packing_list_location" : "packing_list"
          }
        />
      </Button>
    );
  }

  renderReceivingReportPrint() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }
    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={
          salesOrderIds.length === 0 || !checkPermission("print_sales_order")
        }
        type="button"
        onClick={() => {
          this.props.printPackingList(salesOrderIds.join(","));
          // this.props.printReceivingReport(salesOrderIds.join(","));
        }}
      >
        <em className="fa fa-print" />
        <Translate value={"receiving_report"} />
      </Button>
    );
  }

  renderShippingListPrint() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }
    const hasQuote = salesOrders.selectedRows.some(el => el.SaleStatus === 'Quote');
    const svPendingDisable = salesOrders.selectedRows.some(el => el.SaleStatus === 'Pending');
    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";

    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={
          salesOrderIds.length === 0 || (!isVAK || isVAK && !isMobile) && !checkPermission("print_sales_order") || isVAK && isMobile && (!checkPermission("print_mobile_order") || this.state.salesOrders.selectedRows.filter(row => row.SaleStatus === 'Incomplete').length) || hasQuote || svPendingDisable
        }
        type="button"
        onClick={() => {
          this.props.printShippingList(salesOrderIds.join(","));
        }}
      >
        <em className="fa fa-print" />
        <Translate value="shipping_list" />
      </Button>
    );
  }

  renderPickingListButton() {
    if(!isVAK || (this.props.selectedCompany || {value: ''}).value != 6) return null
    const salesOrderIds = [];
    const { salesOrders, isPickingLoading } = this.state;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }
    const svDisable = !salesOrders.selectedRows.every(el => el.SaleStatus == 'Packing' && !!el.tracking_num);
    const success = (pknum) => {
      this.setState({
        isPickingLoading: false,
        salesOrders: {...this.state.salesOrders,selectedRows:[]}
      }, () => {
        this.refreshSOList()
        alert(`${I18n.t('success_created_pick')}${pknum}`)
      })

    }
    const failed = () => {
      this.setState({
        isPickingLoading: false,
      })
    }
    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";

    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={
          salesOrderIds.length == 0 || svDisable || isPickingLoading || isVAK && isMobile && this.state.salesOrders.selectedRows.filter(row => row.SaleStatus === 'Incomplete').length
        }
        type="button"
        onClick={() => {
          this.props.createPickingList(salesOrderIds, success, failed)
        }}
      >
        <Translate value="create_picking" />
      </Button>
    );
  }

  renderPrePayButtons = () => {
    if (!isVAK || this.state.Type != 'Prepay') return null;
    let disabled = this.state.salesOrders.selectedRows.length == 0 || this.state.salesOrders.selectedRows.findIndex(order => order.PrepayStatus != 'WaitForPay' || !order.Is_Prepay) != -1;
    return <Button
        bsStyle="primary"
        type="button"
        className="print-btn"
        disabled={disabled}
        onClick={() => {
          this.handleUpdatePrepay();
        }}
      >
        <Translate value="prepay_approved" />
      </Button>
  }

  renderPickingListButtonAGD() {
    // if(this.context.router.routes[1].path != 'mobileSalesOrders') return null
    const salesOrderIds = [];
    const { salesOrders, isPickingLoading } = this.state;
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.forEach((salesOrder) => {
        salesOrderIds.push(salesOrder.SalesOrder_id);
      });
    }
    const svDisable = salesOrders.selectedRows.every(el => el.SaleStatus == 'Picking');
    const success = (pknum) => {
      this.setState({
        isPickingLoading: false,
        salesOrders: {...this.state.salesOrders,selectedRows:[]}
      }, () => {
        this.refreshSOList()
        alert(`${I18n.t('success_created_pick')}${pknum}`)
      })

    }
    const failed = () => {
      this.setState({
        isPickingLoading: false,
      })
    }

    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={
          salesOrderIds.length == 0 || svDisable || isPickingLoading
        }
        type="button"
        onClick={() => {
          this.props.createPickingList(salesOrderIds, success, failed)
        }}
      >
        <Translate value="create_picking" />
      </Button>
    );
  }

  renderSubmitBolImageButton() {
    const { selectedRows } = this.state.salesOrders;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={
          selectedRows.length !== 1
        }
        type="button"
        onClick={() => {
          this.openSubmitImage();
        }}
      >
        <em className="fa fa-upload" />
        <Translate value="upload_image" />
      </Button>
    );
  }
  openManagePod() {
    this.fetchPod();
    this.setState({ managePodOpen: true });
  }
  closeManagePod() {
    this.setState({ managePodOpen: false });
  }
  renderPodDelete = () => {
    const { podImageRows } = this.state;
    let id = null;
    if (podImageRows && podImageRows.selectedRows && podImageRows.selectedRows.length === 1) {
      id = podImageRows.selectedRows[0].id;
    }
    const onhandleDelete = (e) => {
      axios({
        method: 'DELETE',
        url: `${ROOT_URL}v2/upload_sales_file/${id}`,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
        .then((res) => {
          if (res.error) {
            alert(JSON.stringify(res.error));
          } else {
            this.fetchPod();
            if(res.status === 200) {
              this.refreshSOList()
              if (isGFD) {
                this.setState({
                  onlyRefreshCurrentItem: true
                })
              }
            }
          }
        });
    }
    return (
      <div>
        <Button
          style={{ marginLeft: '5px' }}
          bsStyle="danger"
          type="button"
          onClick={() => { onhandleDelete() }}
          disabled={!id}
        >
          <em className="fa fa-trash" /><Translate value="delete" />
        </Button>
      </div>
    )
  }

  renderPodUpload = () => {
    const { selectedRows } = this.state.salesOrders;

    const onInputClick = (event) => {
      event.target.value = ''
    }
    const handleChange = (e) => {
      const formData = new FormData();
      for (const key of Object.keys(e.target.files)) {
        formData.append('images', e.target.files[key]);
      }
      axios({
        method: 'POST',
        data: formData,
        url: `${ROOT_URL}v2/upload_sales_file/${selectedRows[0].SalesOrder_id}?type=1`,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
        .then((res) => {
          if (res.error) {
            alert(JSON.stringify(res.error));
          } else {
            this.fetchPod();
            if(res.status === 200) {
              this.refreshSOList()
              if (isGFD) {
                this.setState({
                  onlyRefreshCurrentItem: true
                })
              }
            }
          }
        });

    }
    return (
      <div>
        <input id="lap_pod_ref" ref='lap_pod_ref' type="file" style={{ visibility: 'hidden', width: '0px', height: '0px' }} onClick={onInputClick} onChange={(e) => { handleChange(e) }} multiple />
        <Button
          style={{ marginLeft: '5px' }}
          bsStyle="success"
          type="button"
          onClick={() => { this.refs.lap_pod_ref.click(); }}
          disabled={false}
        >
          <em className="fa fa-plus" /><Translate value="create" />
        </Button>
      </div>
    )
  }
  fetchPod() {
    let {salesOrders, podImageRows} = this.state;
    let {selectedRows} = salesOrders
    podImageRows.rows = [];
    if (selectedRows && selectedRows.length > 0) {
      axios.get(
        `${ROOT_URL}v2/upload_sales_file/${selectedRows[0].SalesOrder_id}?type=1`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      )
      .then(res => {
        // podImageRows.rows = res.data;
        res && res.data && res.data.map((r,i) => {
          podImageRows.rows.push({ImageURL2: r.ImageURL, ...r});
        });
        this.setState({podImageRows});
      }, (err) => {
        if (err.data) {
          alert(err.data);
        } else {
          alert("Server issue detected, please contact admin.");
        }
      })
    }
  }
  renderPodTable() {
    // Parameters of the react-data-grid
    // const tableHeight = window.innerHeight < 930 ? 185 : 185;
    const tableHeight = 470;

    const getRows = () => Data.Selectors.getRows(this.state.podImageRows);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      newRows.map((r) => {
        r.isSelected = false;
      });
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
      });
      const podImageRows = {
        ...this.state.podImageRows,
        rows: newRows,
        selectedRows: [rows[0].row],
      };
      this.setState({ podImageRows });
    };

    const onRowsDeselected = (rows) => {
      const newRows = getRows();
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
      });
      const podImageRows = {
        ...this.state.podImageRows,
        rows: newRows,
        selectedRows: [],
      };
      this.setState({ podImageRows });
    };

    const handleRowUpdated = (e) => {
      // merge updated row with current row and rerender by setting state
      const rows = getRows();
      Object.assign(rows[e.rowIdx], e.updated);
      const podImageRows = {
        ...this.state.podImageRows,
        rows,
      };
      this.setState({ podImageRows });
    };

    let columns =
      [
        {
          key: 'ImageURL2',
          name: <Translate value="operation" />,
          resizable: true,
          sortable: true,
          width: 110,
          filterable: true,
          // getRowMetaData: row => row,
          formatter: ({ value }) => {
            if (!value) return <span />
            return <a href={value} style={{width: '100%', display: 'flex', justifyContent: 'center'}}>Download</a>;
          }
        }, {
          key: "ImageURL",
          name: <Translate value="file_name" />,
          resizeable: true,
          width: 300,
          sortable: false,
          editable: false,
          filterable: false,
          formatter: (row) => {
            let imgFlag = row.dependentValues.ImageURL.endsWith('jpg') || row.dependentValues.ImageURL.endsWith('jpeg') || row.dependentValues.ImageURL.endsWith('png') || row.dependentValues.ImageURL.endsWith('gif')
            return(
            <div style={{width: '100%', textAlign:'center',wordBreak: 'break-all',textWrap: 'wrap'}}>
              {imgFlag ?
                <div>
                  <img
                    style={{ width: "150px", height: "70px", objectFit: 'contain', }}
                    src={row.dependentValues.ImageURL}
                  />
                  <div>{row.dependentValues.file_name}</div>
                </div> :
                <div>
                  <em className="fa fa-file-text" style={{fontSize: "55px"}}/>
                  <div>{row.dependentValues.file_name}</div>
                </div>
              }
            </div>
          )},
          getRowMetaData: (row) => row,
        }
      ];

    // React Table Purchase Order Details
    return (
      <Row>
        <Col xs={12}>
          <div className="recat-customizer" id="PurchaseOrderList-dataGrid2">
            <ReactDataGrid
              enableCellSelect
              headerRowHeight={45}
              // onGridSort={handleGridSort}
              // onAddFilter={handleFilterChange}
              // onClearFilters={onClearFilters}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={100}
              minHeight={tableHeight}
              enableRowSelect="single"
              rowSelection={{
                showCheckbox: true,
                enableShiftSelect: true,
                onRowsSelected,
                onRowsDeselected,
                selectBy: {
                  isSelectedKey: 'isSelected',
                },
              }}
              onRowUpdated={handleRowUpdated}
            />
          </div>
        </Col>
      </Row>
    );
  }
  renderUploadPODButton = () => {
    const { selectedRows } = this.state.salesOrders;

    return (
      <div>
        <input
          type='file'
          ref='uploadPODRef'
          onChange={(e) => {
            const file = e.target.files[0];
            const formData = new FormData();
            formData.append('PODFile', file);
            const succes = () => {
              this.fetchSalesOrdersByDetails(this.state.days);
            };
            podUpload(selectedRows[0].SalesOrder_id, formData, succes);
          }}
          style={{ display: 'none' }}
        />
        <Button
          bsStyle="success"
          className="print-btn"
          type="button"
          disabled={selectedRows.length !== 1}
          onClick={() => {
            this.refs.uploadPODRef.click();
          }}
        >
          <em className="fa fa-upload" />
          <Translate value="upload_pod" />
        </Button>
      </div>
    );
  }

  renderUploadPODMultiButton = () => {
    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";
    const { selectedRows } = this.state.salesOrders;
    return (
      <div>
        <Button
          bsStyle="success"
          className="print-btn"
          type="button"
          disabled={selectedRows.length !== 1 || isVAK && isMobile && this.state.salesOrders.selectedRows.filter(row => row.SaleStatus === 'Incomplete').length}
          onClick={() => this.openManagePod()}
        >
          <em className="fa fa-upload" />
          <Translate value="upload_pod" />
        </Button>
      </div>
    );
  }

  renderSplitSo = () => {
    const isMobile = this.context.router.routes.length > 1 && this.context.router.routes[1].path === "mobileSalesOrders";
    if(isMobile) return null;
    const { selectedRows } = this.state.salesOrders;
    const disable = selectedRows.length !== 1 || selectedRows.some((item)=> (item.SaleStatus != 'Open' && item.SaleStatus != 'Packing'))
    return (
      <div>
        <Button
          bsStyle="success"
          className="print-btn"
          type="button"
          disabled={disable}
          onClick={() => {
            this.openSplitSo();
          }}
        >
          <Translate value="split_so" />
        </Button>
      </div>
    );
  }
  renderDealButton = () => {
    const isMobile = this.context.router.routes.length > 1 && this.context.router.routes[1].path === "mobileSalesOrders";
    if(!isMobile) return null;
    const { selectedRows } = this.state.salesOrders;
    const success = () => {
      this.refreshSOList();
      alert('Order processed successfully');
    }
    return (
      <div>
        <Button
          bsStyle="success"
          className="print-btn"
          type="button"
          disabled={selectedRows.length !== 1 || isVAK && isMobile && this.state.salesOrders.selectedRows.filter(row => row.SaleStatus === 'Incomplete').length}
          onClick={() => this.props.mobileSoDealApi(selectedRows[0].SalesOrder_id, {to_deal: selectedRows[0].to_deal ? 0:1}, success)}
        >
          <Translate value="handle_pending" />
        </Button>
      </div>
    );
  }
  renderProcessedButton = () => {
    const { selectedRows } = this.state.salesOrders;
    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";
    const disabled = selectedRows.length === 0 || selectedRows.some(row => row.SaleStatus === 'Quote' && row.EmployeeNote === 'processed') || isVAK && isMobile && this.state.salesOrders.selectedRows.filter(row => row.SaleStatus === 'Incomplete').length;
    const ids = selectedRows.map(r => r.SalesOrder_id).join(',');
    const handleSuccess = res => {
      this.refreshSOList();
      alert('Order processed successfully');
    }
    return (
      <div>
        <Button
          bsStyle="success"
          className="print-btn"
          type="button"
          disabled={disabled}
          onClick={() => this.props.mobileSoDealQuote(ids, handleSuccess)}
        >
          <Translate value="processed" />
        </Button>
      </div>
    );
  }
  renderSetToDoButton = () => {
    const { selectedRows } = this.state.salesOrders;
    const disabled = selectedRows.length === 0 || selectedRows.filter(row => row.SaleStatus !== 'Open').length;
    const ids = selectedRows.map(r => r.SalesOrder_id);
    const handleSuccess = res => {
      this.refreshSOList();
    }
    return (
      <div>
        <Button
          bsStyle="success"
          className="print-btn"
          type="button"
          disabled={disabled}
          onClick={() => this.props.mobileSoSetToDoOrOpen({order_ids: ids}, handleSuccess, false)}
        >
          <Translate value="set_to_do" />
        </Button>
      </div>
    );
  }
  renderSetToOpenButton = () => {
    const { selectedRows } = this.state.salesOrders;
    const disabled = selectedRows.length === 0 || selectedRows.filter(row => row.SaleStatus !== 'Incomplete').length;
    const ids = selectedRows.map(r => r.SalesOrder_id);
    const handleSuccess = res => {
      this.setState({topIds: ids}, ()=>{
        this.handleStatusFilterChange('open', true);
      })
    }
    return (
      <div>
        <Button
          bsStyle="success"
          className="print-btn"
          type="button"
          disabled={disabled}
          onClick={() => this.props.mobileSoSetToDoOrOpen({order_ids: ids}, handleSuccess, true)}
        >
          <Translate value="set_to_open" />
        </Button>
      </div>
    );
  }
  renderStoreSelectButton = () => {
    return (
      <div>
        <Button
          bsStyle="success"
          className="print-btn"
          type="button"
          onClick={() => {
            this.setState({
              storeModalVisibility: true,
            })
          }}
        >
          <Translate value="select_store" />
        </Button>
      </div>
    );
  }
  renderStoreTreeData = () => {
    if (!this.state.mobileAccountsTree.length) return;
    let {expandedNodes, checkedKeys, checkedChildKeys, mobileAccountsTree} = this.state
    let expandedNodesData =  expandedNodes;
    let checkedKeysData = checkedKeys
    let checkedChildKeysData = checkedChildKeys
    return mobileAccountsTree.map((item, i) => {
      return (
        <div>
          <div>
            <input
              type="checkbox"
              name="store"
              checked={checkedKeysData.includes(item.id)}
              onClick={(e) => {
                if (e.target.checked) {
                  checkedKeysData.push(item.id)
                }else {
                  checkedKeysData = checkedKeysData.filter(checkedItem => checkedItem !== item.id)
                }
                this.setState({ checkedKeys: checkedKeysData })
              }}
            />
            {item.group_name}
            {!expandedNodesData.includes(item.id) && item.stores && item.stores.length &&
              <span id={i} onClick={(value) => {
                expandedNodesData.push(item.id);
                this.setState({ expandedNodes: expandedNodesData })
              }}><em className="fa fa-angle-right" style={{fontWeight: "bold", marginLeft: '5px'}} />
              </span>
            }
            {expandedNodesData.includes(item.id) && item.stores && item.stores.length &&
              <span id={i} onClick={(value) => {
                expandedNodesData = expandedNodesData.filter(nodeItem => nodeItem !== item.id);
                this.setState({ expandedNodes: expandedNodesData })
              }}><em className="fa fa-angle-down" style={{fontWeight: "bold", marginLeft: '5px'}} />
              </span>
            }
          </div>
          {expandedNodesData.includes(item.id) && item.stores && item.stores.length &&
            <div name="store" id={'g' + item.id}
            >
              {
                item.stores.map(secondItem => (
                  <div style={{ marginLeft: '10px' }}>
                    <input
                      type="checkbox"
                      name="secondStore"
                      checked={checkedChildKeysData.includes(secondItem.id)}
                      onClick={(e) => {
                        if (e.target.checked) {
                          checkedChildKeysData.push(secondItem.id)
                        }else {
                          checkedChildKeysData = checkedChildKeysData.filter(checkedItemKeys => checkedItemKeys !== secondItem.id)
                        }
                        this.setState({ checkedChildKeys: checkedChildKeysData })
                      }}
                    />
                    {secondItem.system_name}
                  </div>
                ))
              }
            </div>
          }
        </div>
      );
    })
  }
  setLocationChangeModalVisibility = (isLocationChangeModalVisible = false) => this.setState({ isLocationChangeModalVisible });
  setInboundDateChangeModalVisibility = (isInboundDateChangeModalVisibile = false) => this.setState({ isInboundDateChangeModalVisibile });

  handleLocationChangeSuccess = () => {
    this.refreshSOList();
    this.setLocationChangeModalVisibility();
    this.setInboundDateChangeModalVisibility();
  }
  renderLocatioinChangeButton = () => {
    const { selectedRows } = this.state.salesOrders;

    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        type="button"
        disabled={selectedRows.length !== 1}
        onClick={() => {
          this.setLocationChangeModalVisibility(true);
        }}
      >
        <em className="fa fa-pencil" />
        <Translate value="location_edit" />
      </Button>
    );
  }
  renderInboundDateEditButton = () => {
    const { selectedRows } = this.state.salesOrders;

    return (
      <Button
      bsStyle="primary"
      className="print-btn"
      type="button"
      disabled={selectedRows.length !== 1}
      onClick={() => {
        this.setInboundDateChangeModalVisibility(true);
      }}
    >
      <em className="fa fa-pencil" />
      <Translate value="other_info_edit" />
    </Button>
    )
  }

  renderPrintLabelButton() {
    if (isSKH) {
      return null;
    }
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        // href={exportUrl}
        disabled={!salesOrder_id || !checkPermission("print_sales_order")}
        onClick={() => {
          this.props.printSalesOrderLabel(salesOrder_id);
        }}
      >
        <em className="fa fa-print" />
        <Translate value="print_label" />
      </Button>
    );
  }

  renderPrintLabelButtonDSQ() {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        disabled={!checkPermission("print_sales_order") || this.state.salesOrders.selectedRows.length !== 1}
        onClick={() => {
          this.openDSQPrint();
          // this.props.printSalesOrderLabel(salesOrder_id);
        }}
      >
        <em className="fa fa-print" />
        <Translate value="print_label" />
      </Button>
    );
  }

  renderMergeToPOButton = () => {
    const {
      salesOrders: {
        selectedRows,
      }
    } = this.state;
    let selectedRowsSameCustomer = false;
    let selectedRowsDifferentEtdDate = false;
    if (selectedRows.length) {
      const Deliver_Customer_id = selectedRows[0].Deliver_Customer_id;
      const rowDispathcDate = moment(selectedRows[0].DispatchDate).format('MM-DD-YYYY');
      let filterRows = selectedRows.filter(row => row.Deliver_Customer_id != Deliver_Customer_id || (row.SaleStatus != 'Open' && row.SaleStatus != 'Packing'));
      let filterDispathRows = selectedRows.filter(row => moment(row.DispatchDate).format('MM-DD-YYYY') != rowDispathcDate);
      if(filterRows.length > 0) {
        selectedRowsSameCustomer = true;
      }
      if(filterDispathRows.length > 0) {
        selectedRowsDifferentEtdDate = true;
      }
    }
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        disabled={selectedRows.length < 1 || selectedRowsSameCustomer}
        onClick={() => {
          if(selectedRowsDifferentEtdDate) {
            let result = confirm('The ETD DATE of the sales order is different. Are you sure to convert it to PO')
            if(result) {
              const ids = _.map(selectedRows, row => row.pk);
              this.setState({
                salesOrderIds: ids,
                isDropshipOpen: true,
              })
            }
            return
          }
          const ids = _.map(selectedRows, row => row.pk);
          this.setState({
            salesOrderIds: ids,
            isDropshipOpen: true,
          })
        }}
      >
        <Translate value="po_convert" />
      </Button>
    );
  }

  renderUploadFileButton = () => {
    const {
      salesOrders: {
        selectedRows,
      }
    } = this.state;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        disabled={selectedRows.length !== 1}
        onClick={() => {
          this.refs["file-upload-ref"].click();
          // this.openDSQPrint();
          // this.props.printSalesOrderLabel(salesOrder_id);
        }}
      >
        <em className="fa fa-upload" />
        <Translate value="upload_file" />
      </Button>
    );
  }

  renderImportSoButton = () => {
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        onClick={()=>{
          this.refs["import-so-ref"].click();
        }}
      >
        <em className="fa fa-upload" />
        <input
        type='file'
        ref='import-so-ref'
        style={{ display: 'none' }}
        onChange={(e) => {
          const file = e.target.files[0];
          const formData = new FormData();
          formData.append('file', file);
          formData.append('company_id', (this.props.selectedCompany || {value: 1}).value);
          formData.append('warehouse_id', (this.props.selectedWarehouse || {value: 1}).value);
          this.props.importSOFile(formData, this.refreshSOList)
        }}
        />
        <Translate value="import_so" />
      </Button>
    );
  }

  renderMergeSOButton = () => {
    const {
      salesOrders: {
        selectedRows,
      }
    } = this.state;
    let selectedRowsSameCustomer = true;
    if (selectedRows.length) {
      const Deliver_Customer_id = selectedRows[0].Deliver_Customer_id;
      for(let i = 0; i < selectedRows.length; i ++) {
        if (selectedRows[i].Deliver_Customer_id !== Deliver_Customer_id ||
          (isOLG && selectedRows[i].SaleStatus != 'Open' && selectedRows[i].SaleStatus != 'Packing' && selectedRows[i].SaleStatus != 'Packed' && selectedRows[i].SaleStatus != 'Partial')) {
          selectedRowsSameCustomer = false;
          break
        }
      }
    }
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        disabled={selectedRows.length < 2 || !selectedRowsSameCustomer}
        onClick={() => {
          const ids = _.map(selectedRows, row => row.pk).join(',');
          const soNums = _.map(selectedRows, row => row.SONum).join(',')
          const success = (mergeSODetails) => {
            this.setState({isMergeSo: true}, () => {
              this.setState({
                mergeSODetails,
                showShippingOpen: true,
                mergeSOLines: mergeSODetails.Sales_Order_Lines,
                mergeSOIds: ids,
                mergeSONums: soNums,
              });
            })
          }
          this.props.fetchMultiSOLines(ids, success);
        }}
      >
        {/* <em className="fa fa-merge" /> */}
        <Translate value="merge_so" />
      </Button>
    );
  }

  renderDuplicateSOButton = () => {
    const {
      salesOrders: {
        selectedRows,
      }
    } = this.state;
    return (
      <SpinnerButton
        bsStyle="success"
        disabled={selectedRows.length !== 1 || this.state.duplicateSOLoading}
        icon="fa-copy"
        translation={<Translate value="duplicate_so" />}
        loading={this.state.duplicateSOLoading}
        onClick={() => {
          this.setState({
            duplicateSOLoading: true,
          })
          const success = () => {
            alert('Success!');
            this.refreshSOList();
            this.setState({
              duplicateSOLoading: false,
            })
          }
          const failed = () => {
            this.setState({
              duplicateSOLoading: false,
            })
          }
          this.props.duplicateSOAPI(selectedRows[0].pk, success, failed);
        }}
      />
    );
  }

  renderPrintLabelUSPride = () => {
    const {
      selectedRows,
    } = this.state.salesOrders;

    let hasTracking = false;
    selectedRows.map(r=> {
      if (r.TrackingNum) {
        hasTracking = true;
      }
    });

    // if (!this.props.requestingSalesOrderPDF) {
      return (
        <Button
          bsStyle="success"
          type="button"
          className="print-btn"
          disabled={selectedRows.length < 1 || this.props.requestingSalesOrderPDF}
          onClick={() => {
            const salesOrder_id = [];
            selectedRows.forEach(({ SalesOrder_id }) => {
              salesOrder_id.push(SalesOrder_id)
            });
            if (hasTracking) {
              this.openPridePrint();
            } else {
              this.props.printSalesOrderLabelUSPride({ salesOrder_id });
            }
          }}
        >
          <em className="fa fa-print" />
          <Translate value="new_shipping" />
        </Button>
      );
    // } else {
    //   return (
    //     <SpinnerButton
    //       bsStyle="success"
    //       disabled={true}
    //       icon="fa-print"
    //       translation={<Translate value="new_shipping" />}
    //       loading={true}
    //       onClick={() => {
    //         console.log('loading');
    //       }}
    //     />
    //   )
    // }
  }

  renderReprintLabelUSPride = () => {
    const {
      selectedRows,
    } = this.state.salesOrders;
    let missingTracking = false;
    selectedRows.map(r=> {
      if (!r.TrackingNum) {
        missingTracking = true;
      }
    });

    return (
      <Button
        bsStyle="success"
        type="button"
        className="print-btn"
        disabled={selectedRows.length < 1 || missingTracking}
        onClick={() => {
          const salesOrder_id = [];
          selectedRows.forEach(({ SalesOrder_id }) => {
            salesOrder_id.push(SalesOrder_id);
          });
          this.props.reprintSalesOrderLabelUSPride({ salesOrder_id });
        }}
      >
        <em className="fa fa-print" />
        <Translate value="reprint_shipping" />
      </Button>
    );
  }

  renderPrintLabelButtonAFG() {
    const SalesOrder_id = [];
    const SalesOrder_trackingNum = [];
    let hasInvoice = true;
    const { salesOrders } = this.state;
    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";
    if (salesOrders && salesOrders.selectedRows) {
      salesOrders.selectedRows.map((r) => {
        if ((r.InvoiceNum === "" || !r.InvoiceNum) && (isAFG) === true) {
          hasInvoice = false;
        }
        SalesOrder_id.push(r.SalesOrder_id);
        if (r.TrackingNum) {
          SalesOrder_trackingNum.push(r.TrackingNum);
        }
      });
    }
    this.state.trackingNumberSelected = SalesOrder_id;
    let disabled = hasInvoice === false ||
      SalesOrder_id.length === 0 ||
      !isVAK && !checkPermission("print_sales_order")
    if (isVAK) {
      disabled = disabled
      || !isMobile && (!checkPermission("print_sales_order") || salesOrders.selectedRows.filter(row => row.Is_Prepay && row.PrepayStatus != 'ReadyToShip').length)
      || isMobile && (!checkPermission("print_mobile_order") || salesOrders.selectedRows.filter(row => row.SaleStatus === 'Incomplete').length)
      || salesOrders.selectedRows.some(row => ['Quote', 'Released', 'Cancelled'].includes(row.SaleStatus));
    }

    return (
      <Button
        bsStyle="success"
        type="button"
        className="print-btn"
        // href={exportUrl}
        disabled={disabled}
        onClick={() => {
          if (isVAK) {
            return this.openAutoPrintModal();
          }
          if (
            SalesOrder_trackingNum[0] &&
            SalesOrder_trackingNum[0].length > 0 &&
            (isAFG || isNBT)
          ) {
            this.openPrintTrackingConfirm();
          } else {
            this.props.printSalesOrderLabelBatch(SalesOrder_id);
          }
        }}
      >
        <em className="fa fa-print" />
        <Translate value={isVAK ? "auto_print_button" : "print_label"} />
      </Button>
    );
  }

  renderSendEmailButton = () => {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;

    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1}
        type="button"
        onClick={() => {
          this.setState({
            emailSubjectTemplate: this.genSubjectTemplate(),
            emailContentTemplate: this.genContentTemplate(),
            emailContentModalVisibility: true,
            source: "SO",
          })
        }}
      >
        <Translate value={((isLAP || isUSPrideMulti || isAPD) || isGFD || isSDR) ? "send_so" : "email_so"} />
      </Button>
    );
  }
  renderSyncToMesButton = () => {
    const { selectedRows } = this.state.salesOrders;
    const isKabiCompany = (this.props.selectedCompany || {value: ''}).value == 2;
    const isKabiWarehouse = (this.props.selectedWarehouse || {value: ''}).value == 4;

    return (isLMHST || isBRO) && isKabiCompany && isKabiWarehouse ? (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1 || selectedRows && selectedRows.length === 1 && selectedRows[0].is_sync_mes }
        type="button"
        onClick={() => {
          this.setState({
            mesModalVisibility: true,
          })
        }}
      >
        <Translate value={"sync_to_mes"} />
      </Button>
    ) : null;
  }

  renderResetLocationButton = () => {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    const saleStatus =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SaleStatus;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1 || !(saleStatus==='Quote' || saleStatus==='Open' || saleStatus==='Packing')}
        type="button"
        onClick={() => {
          this.props.resetLocation(salesOrder_id);
        }}
      >
        <Translate value="reset_location" />
      </Button>
    );
  }

  renderSOUploadButton = () => {
    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";

    if ((isABBLE || isSV) && isMobile) {
      const handleUpload = (platform, formData) => {
        const success = () => {
          alert('success');
          this.refreshSOList();
        }
        const failed = (err) => {
          alert(JSON.stringify(err));
        }
        axios({
          method: 'post',
          url:  `${ROOT_URL}v2/abble_import_order?platform=${platform}`,
          data: formData,
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
        .then(res => {
          success();
        })
        .catch(err => {
          failed(err.data);
        })
      }

      return (
        <div>
          <input
            ref='hayneedle_po_upload_ref'
            type='file'
            name='hayneedle'
            id="hayneedle_po_upload_ref"
            onChange={(e) => {
              const files = e.target.files;
              const formData = new FormData();
              formData.append('FILE', files[0]);
              handleUpload('hayneedle', formData);
              e.target.value = null;
            }}
            style={{ display: 'none' }}
          />
          <input
            id="faire_po_upload_ref"
            ref='faire_po_upload_ref'
            type='file'
            name='faire'
            onChange={(e) => {
              const files = e.target.files;
              const formData = new FormData();
              formData.append('FILE', files[0]);
              handleUpload('faire', formData);
              e.target.value = null;
            }}
            style={{ display: 'none' }}
          />
          <input
            id="dropship_upload_ref"
            ref='dropship_upload_ref'
            type='file'
            name='dropship'
            onChange={(e) => {
              const files = e.target.files;
              const formData = new FormData();
              formData.append('FILE', files[0]);
              handleUpload('dropship', formData);
              e.target.value = null;
            }}
            style={{ display: 'none' }}
          />
          <input
            id="wfcg_upload_ref"
            ref='wfcg_upload_ref'
            type='file'
            name='wfcg'
            onChange={(e) => {
              const files = e.target.files;
              const formData = new FormData();
              formData.append('FILE', files[0]);
              handleUpload('wfcg', formData);
              e.target.value = null;
            }}
            style={{ display: 'none' }}
          />
          <input
            ref='homedepot_excel_ref'
            type='file'
            name='homedepot'
            id="homedepot_excel_ref"
            onChange={(e) => {
              const files = e.target.files;
              const formData = new FormData();
              formData.append('FILE', files[0]);
              handleUpload('homedepot', formData);
              e.target.value = null;
            }}
            style={{ display: 'none' }}
          />
          {
            !isSV &&
            <DropdownButton
              bsStyle="success"
              style={{ marginLeft: '5px' }}
              // disabled={!this.props.currentSalesOrder}
              title={
                <span>
                  {/* <i className="fa fa-print" /> */}
                  <Translate value="upload_so" />
                </span>
              }
            >
              {/* <MenuItem onClick={() => {
                this.refs.hayneedle_po_upload_ref.click();
              }}>
                <Translate value="hayneedle" />
              </MenuItem> */}
              <MenuItem onClick={() => {
                this.refs.faire_po_upload_ref.click();
              }}>
                <Translate value="faire" />
              </MenuItem>
              <MenuItem onClick={() => {
                this.refs.dropship_upload_ref.click();
              }}>
                <Translate value="dropship" />
              </MenuItem>
              <MenuItem onClick={() => {
                this.refs.wfcg_upload_ref.click();
              }}>
                <Translate value="wfcg" />
              </MenuItem>
              <MenuItem onClick={() => {
                this.refs.homedepot_excel_ref.click();
              }}>
                <Translate value="home_depot" />
              </MenuItem>
            </DropdownButton>
          }
        </div>
      )
    }
    return <span />
  }

  setShippingRateVisibility = (isShipingRateVisible = false) => this.setState({ isShipingRateVisible });
  handleTeapplixPrintClick = (row) => {
    const { salesOrders } = this.state;
    this.props.selectTeapplixShipping(row.Code, salesOrders.selectedRows[0].SalesOrder_id);
    this.setShippingRateVisibility();
  }
  renderTeapplixButton  = () => {
    const { salesOrders } = this.state;
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }
    const salesOrderIdsString = salesOrderIds.join(',');

    const successDelete = () => {
      alert('Success on delete teapplix label');
      if (isABBLE) return;
      this.refreshSOList();
    }

    // sunset
    let hasInvoice = true;
    let invoiceIds = [];
    if (isSV && salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        if (!row.SalesInvoice_id) {
          hasInvoice = false;
        }
        invoiceIds.push(row.SalesInvoice_id);
      });
    }

    // abcff, silkhome disable print if one order has tracking
    let hasTracking = false;
    if ((isABCFF || isSKH) && salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        if (isSKH && row.Tracking !== null) {
          hasTracking = true;
        }
        if (isABCFF && row.TrackingNum !== null) {
          hasTracking = true;
        }
      });
    }

    const invoiceIdsString = invoiceIds.join(',');

    let shouldDisable = false;
    let shouldDisableReprint = false;
    let hasQuote = false;
    if (isUSPrideMulti && salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((r) => {
        if (r.Deliver_CustomerName !== 'Teapplix Import') {
          shouldDisable = true;
        }
        if (!r.Tracking && !r.TrackingNum) {
          shouldDisableReprint = true;
        }
        if (r.Tracking || r.TrackingNum) {
          hasTracking = true;
        }
        if (r.SaleStatus === 'Quote') {
          hasQuote = true;
        }
        });
    }

    // ABCFF and Silkhome popup for amazon order
    // sunset with differnet api, based on invoice id

    if (isABCFF || isSKH || isSV || isKM) {
      return <div>
        <DropdownButton
          bsStyle="success"
          style={{ marginLeft: '5px' }}
          disabled={!salesOrders.selectedRows.length}
          title={
            <span>
              <Translate value="teapplix" />
            </span>
          }
        >
          <Button
            bsStyle="primary"
            className="print-btn"
            disabled={!salesOrders.selectedRows.length || this.props.requestingSalesOrderPDF || hasTracking }
            type="button"
            onClick={() => {
              if (isSV) {
                this.props.selectTeapplixShipping2(salesOrderIdsString);
              } else {
                if (salesOrders.selectedRows[0].Channel === "amazon-US" && salesOrders.selectedRows.length === 1) {
                  this.setShippingRateVisibility(true);
                } else {
                  this.props.selectTeapplixShipping('', salesOrderIdsString);
                }
              }
            }}
          >
            <i className="fa fa-print" />
            <Translate value="print_label" />
          </Button>
          <Button
            bsStyle="primary"
            className="print-btn"
            disabled={!salesOrders.selectedRows.length || this.props.requestingSalesOrderPDF || !hasInvoice}
            type="button"
            onClick={() => {
              if (isSV) {
                this.props.printTeapplixLabel(invoiceIdsString);
              } else {
                this.props.printTeapplixLabel(salesOrderIdsString);
              }
            }}
          >
            <i className="fa fa-print" />
            <Translate value="reprint_label" />
          </Button>
          <Button
            bsStyle="danger"
            className="print-btn"
            disabled={!salesOrders.selectedRows.length || !hasInvoice }
            type="button"
            onClick={() => {
              if (isSV) {
                this.props.deleteTeapplixShipping(invoiceIdsString, successDelete);
              } else {
                this.props.deleteTeapplixShipping(salesOrderIdsString, successDelete);
              }
            }}
          >
            <em className="fa fa-trash" />
            <Translate value="cancel_label" />
          </Button>
        </DropdownButton>
      </div>
    }

    if (isUSPrideMulti) {
      return (
        <div>
          <DropdownButton
            bsStyle="success"
            style={{ marginLeft: '5px' }}
            disabled={(!salesOrders.selectedRows.length) || shouldDisable}
            title={
              <span>
                <Translate value="teapplix" />
              </span>
            }
          >
            <Button
              bsStyle="primary"
              className="print-btn"
              disabled={!salesOrders.selectedRows.length || hasTracking || hasQuote || this.props.requestingSalesOrderPDF}
              type="button"
              onClick={() => { this.props.selectTeapplixShipping('', salesOrderIdsString); }}
            >
              <i className="fa fa-print" />
              <Translate value="print_label" />
            </Button>

            <Button
              bsStyle="primary"
              className="print-btn"
              disabled={salesOrders.selectedRows.length !== 1 || hasTracking || hasQuote || this.props.requestingSalesOrderPDF}
              type="button"
              onClick={() => { this.setMultiplePackagelVisibility(true); }}
            >
              <i className="fa fa-print" />
              <Translate value="print_multi_pkg" />
            </Button>

            <Button
              bsStyle="primary"
              className="print-btn"
              disabled={!salesOrders.selectedRows.length || shouldDisableReprint || this.props.requestingSalesOrderPDF}
              type="button"
              onClick={() => { this.props.printTeapplixLabel(salesOrderIdsString); }}
            >
              <i className="fa fa-print" />
              <Translate value="reprint_label" />
            </Button>
            <Button
              bsStyle="danger"
              className="print-btn"
              disabled={!salesOrders.selectedRows.length || shouldDisableReprint}
              type="button"
              onClick={() => {
                this.openCheckAuthorize("cancelLabel");
              }}
            >
              <em className="fa fa-trash" />
              <Translate value="cancel_label" />
            </Button>
          </DropdownButton>
        </div>
      )
    }

    if (isABBLE) {
      return (
        <div>
          <DropdownButton
            bsStyle="success"
            style={{ marginLeft: '5px' }}
            disabled={(!salesOrders.selectedRows.length) || shouldDisable}
            title={
              <span>
                <Translate value="teapplix" />
              </span>
            }
          >
            <Button
              bsStyle="primary"
              className="print-btn"
              disabled={!salesOrders.selectedRows.length|| this.props.requestingSalesOrderPDF}
              type="button"
              onClick={() => { this.props.printTeapplixLabel(salesOrderIdsString); }}
            >
              <i className="fa fa-print" />
              <Translate value="reprint_label" />
            </Button>

            <Button
              bsStyle="primary"
              className="print-btn"
              disabled={!salesOrders.selectedRows.length || this.props.requestingSalesOrderPDF}
              type="button"
              onClick={() => { this.props.selectTeapplixShipping('', salesOrderIdsString); }}
            >
              <i className="fa fa-print" />
              <Translate value="print_label" />
            </Button>
            {/* <Button
              bsStyle="primary"
              className="print-btn"
              disabled={!salesOrders.selectedRows.length || this.props.requestingSalesOrderPDF}
              type="button"
              onClick={() => { this.props.selectTeapplixShipping('FEDEX_GROUND', salesOrderIdsString); }}
            >
              <i className="fa fa-print" />
              <Translate value="print_fedex_ground" />
            </Button>
            <Button
              bsStyle="primary"
              className="print-btn"
              disabled={!salesOrders.selectedRows.length || this.props.requestingSalesOrderPDF}
              type="button"
              onClick={() => { this.props.selectTeapplixShipping('FEDEX_HOME', salesOrderIdsString); }}
            >
              <i className="fa fa-print" />
              <Translate value="print_fedex_home" />
            </Button>
            <Button
              bsStyle="primary"
              className="print-btn"
              disabled={!salesOrders.selectedRows.length || this.props.requestingSalesOrderPDF}
              type="button"
              onClick={() => { this.props.selectTeapplixShipping('FEDEX_2DAY', salesOrderIdsString); }}
            >
              <i className="fa fa-print" />
              <Translate value="print_fedex_2_day" />
            </Button>
            <Button
              bsStyle="primary"
              className="print-btn"
              disabled={!salesOrders.selectedRows.length || this.props.requestingSalesOrderPDF}
              type="button"
              onClick={() => { this.props.selectTeapplixShipping('UPS_GROUND', salesOrderIdsString); }}
            >
              <i className="fa fa-print" />
              <Translate value="print_ups_ground" />
            </Button> */}

            <Button
              bsStyle="danger"
              className="print-btn"
              disabled={!salesOrders.selectedRows.length || !checkPermission('cancel_shipping_lable')}
              type="button"
              onClick={() => {
                this.openCheckAuthorize("cancelLabel");
              }}
            >
              <em className="fa fa-trash" />
              <Translate value="cancel_label" />
            </Button>
          </DropdownButton>
        </div>
      )
    }

    return <span />
  }

  renderTeapplixResyncButton = () => {
    const { salesOrders } = this.state;
    const handleResyncClick = () => {
      if (salesOrders.selectedRows.length === 1) {
        this.resyncTeapplix(salesOrders.selectedRows[0].PONum);
      } else {
        this.setTeapplixResyncModalVisibility(true);
      }
    }

    let shouldDisable = false;
    if (isUSPrideMulti && salesOrders && salesOrders.selectedRows && salesOrders.selectedRows[0] && salesOrders.selectedRows[0].Deliver_CustomerName !== 'Teapplix Import') {
      shouldDisable = true;
    }

    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={salesOrders.selectedRows.length > 1 || shouldDisable}
        type="button"
        onClick={handleResyncClick}
      >
        <Translate value="tp_resync" />
      </Button>
    )
  }

  renderTeapplixSyncButton = () => {
    const { salesOrders } = this.state;
    const success = (message = 'Success!') => {
      alert(message);
      this.refreshSOList();
    }
    const failed = (errMsg = 'Unknown') => {
      alert(errMsg);
    }
    const handleSyncClick = () => {
      let ids = [];
      if (salesOrders && salesOrders.selectedRows.length > 0) {
        salesOrders.selectedRows.map((row) => {
          ids.push(row.PONum);
        });
        this.props.teapplixSyncWithPONum(ids, success, failed);
      }
    }

    // let shouldDisable = false;
    // if (isUSPrideMulti && salesOrders && salesOrders.selectedRows.length > 0) {
    //   salesOrders.selectedRows.map((r) => {
    //     if (r.Deliver_CustomerName !== 'Teapplix Import') {
    //       shouldDisable = true;
    //     }

    //   });
    // }

    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={salesOrders.selectedRows.length === 0}
        type="button"
        onClick={handleSyncClick}
      >
        <Translate value="sync_to_tp" />
      </Button>
    )
  }

  rollBackButton = () => {
    let salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length >= 1) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }
    const handleRollBackClick = () => {
      this.rollBack(salesOrderIds.join(','));
    }
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={!(salesOrders.selectedRows.length && this.state.Status === 'Canceled' && salesOrders.selectedRows.filter(item => item.SONum.includes('-')).length === salesOrders.selectedRows.length )}
        type="button"
        onClick={handleRollBackClick}
      >
        <Translate value="roll_back" />
      </Button>
    )
  }


  renderStuff = () => {
    const { salesOrders } = this.state;
    const handleNuorderClick = () => {
      this.setState({resyncType: "nuorder"});
      if (salesOrders.selectedRows.length === 1) {
        this.resyncStuff(salesOrders.selectedRows[0].PONum, "nuorder");
      } else {
        this.setStuffResyncModalVisibility(true);
      }
    }
    const handleShipstationClick = () => {
      this.setState({resyncType: "shipstation"});
      if (salesOrders.selectedRows.length === 1) {
        this.resyncStuff(salesOrders.selectedRows[0].PONum, "shipstation");
      } else {
        this.setStuffResyncModalVisibility(true);
      }
    }
    return (
      <div>
        <DropdownButton
          bsStyle="success"
          // disabled={!(salesOrders.selectedRows.length === 1 || salesOrders.selectedRows.length === 0)}
          disabled={false}
          title={
            <span>
              <Translate value="resync" />
            </span>
          }
        >
           <Button
        bsStyle="success"
        className="print-btn"
        disabled={!(salesOrders.selectedRows.length === 1 || salesOrders.selectedRows.length === 0)}
        type="button"
        onClick={handleNuorderClick}
      >
        <Translate value="nuorder" />
      </Button>
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={!(salesOrders.selectedRows.length === 1 || salesOrders.selectedRows.length === 0)}
        type="button"
        onClick={handleShipstationClick}
      >
        <Translate value="shipstation" />
      </Button>
        </DropdownButton>
      </div>
    )
  }

  renderWalmartPkgLabelButton = () => {
    const { selectedRows } = this.state.salesOrders;
    let isWalmartOrder = false;
    selectedRows.map((r) => {
      if (r.Channel === "walmartb2b") {
        isWalmartOrder = true;
      }
    });

    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    const url = `${ROOT_URL}v1/sale/printshippinglabel/${salesOrder_id}?Bearer=${localStorage.getItem(
      "token"
    )}`;
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={ !isWalmartOrder || selectedRows.length !== 1}
        href={url}
      >
        <em className="fa fa-download" />
        <Translate value="walmart_pkg_label" />
      </Button>
    );
  }

  renderAcknowledgeOrdersButton = () => {
    const {
      salesOrders,
    } = this.state;
    const handleAcknowledgeClick = () => {
      const ids = salesOrders.selectedRows.map(r => r.SalesOrder_id).join(',');
      const success = () => {
        alert('Orders Acknowledge Success');
      }
      this.props.acknowledgeApi(ids, success)
    }

    return (
      <Button
      bsStyle="success"
      className="print-btn"
      disabled={!salesOrders.selectedRows.length}
      type="button"
      onClick={handleAcknowledgeClick}
    >
      {/* <em className="fa fa-sync" /> */}
      <Translate value="acknowledge" />
    </Button>
    )
  }

  // for silkhome
  renderWalmartShipmentButton = () => {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }
    const exportUrl = `${ROOT_URL}v1/sale/export_shipment_confirmation/${salesOrderIds.join(",")}?Bearer=${localStorage.getItem("token")}`
    return (
      <Button
        bsStyle="primary"
        className="print-btn"
        disabled={(!salesOrderIds || salesOrderIds.length < 1)}
        type="button"
        href={exportUrl}
      >
        <Translate value="walmart_shipment" />
      </Button>
    )
  }

  // for abcff
  renderWalmartShipmentButton2() {
    return (
      <Button
        style={{ marginLeft: '5px' }}
        bsStyle="success"
        type="button"
        onClick={() => { this.refs.walmartb2b_ref.click(); }}
        disabled={false}
      >
        <em className="fa fa-upload" /><Translate value="walmart_shipment" />
      </Button>
    );
  }


  renderChangeShipMethodButton = () => {
    const { selectedRows } = this.state.salesOrders;

    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1}
        type="button"
        onClick={() => {this.openChangeShipMethodModal()}}
      >
        <Translate value="ship_method" />
      </Button>
    )
  }

  renderPickerButton = () => {
    const {
      salesOrders,
    } = this.state;

    return (
      <Button
      bsStyle="success"
      className="print-btn"
      disabled={salesOrders.selectedRows.length < 1}
      type="button"
      onClick={() => this.openPicker()}
    >
      {/* <em className="fa fa-sync" /> */}
      <Translate value="assign_picker" />
    </Button>
    )
  }

  resyncTeapplix = (PONum, successCallBack = () => {}) => {
    const success = (message = 'Success!') => {
      alert(message);
      successCallBack();
      this.refreshSOList();
    }
    const failed = (errMsg = 'Unknown') => {
      alert(errMsg);
    }
    this.props.teapplixResyncWithPONum(PONum, success, failed)
  }
  rollBack = (SOIds, successCallBack = () => {}) => {
    const success = (message = 'Success!') => {
      alert(message);
      successCallBack();
      this.refreshSOList();
    }
    const failed = (errMsg = 'Unknown') => {
      alert(errMsg);
    }
    this.props.rollBackWithSOIds(SOIds, success, failed)
  }

  resyncStuff = (PONum, resyncType, successCallBack = () => {}) => {
    const success = (message = 'Orders Synced!') => {
      alert(message);
      successCallBack();
      this.refreshSOList();
    }
    const failed = (errMsg = 'Unknown') => {
      alert(errMsg);
    }
    this.props.stuffResyncWithPONum(PONum, resyncType, success, failed)
  }

  setTeapplixResyncModalVisibility = (isTeapplixResyncModalVisibile = false) => this.setState({ isTeapplixResyncModalVisibile });
  setStuffResyncModalVisibility = (isStuffResyncModalVisibile = false) => this.setState({ isStuffResyncModalVisibile });

  syncABCFF = (SOIds, successCallBack = () => {}) => {
    const success = (message = 'Success!') => {
      alert(message);
      successCallBack();
      this.refreshSOList();
    }
    const failed = (errMsg = 'Unknown') => {
      alert(errMsg);
    }
    this.props.abcffSync(SOIds.join(","), success, failed)
  }


  renderMissingSKUsButton = () => {
    const { salesOrders } = this.state;
    const handleMissingSKUsClick = () => {
      this.setMissingSKUsModalVisibility(true);
    }

    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={salesOrders.selectedRows.length !== 1}
        type="button"
        onClick={handleMissingSKUsClick}
      >
        {/* <em className="fa fa-sync" /> */}
        <Translate value="missing_skus" />
      </Button>
    )
  }

  renderASNButton = () => {
    const salesOrderIds = [];
    const salesOrderN = [];

    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }

    const downloadASN = (pks) => {
      this.props.fetchSalesOrderPDFFetch();
      axios({
        method: 'post',
        url: `${ROOT_URL}v1/sale/export_asn/`,
        data: { order_ids: pks },
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      })
        .then((res) => {
          if (res.error) {
            alert(JSON.stringify(res.error));
          } else {
            const a = document.createElement('a');
            a.style = "display: none";
            document.body.appendChild(a);
            const url = window.URL.createObjectURL(res.data);
            a.href = url;
            a.download = this.state.salesOrders.selectedRows[0].SONum;
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            this.props.fetchSalesOrderPDFSuccess('');
          }
        });
    }

    if (!this.props.requestingSalesOrderPDF) {
      return (
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={(!salesOrderIds || salesOrderIds.length < 1)}
          type="button"
          onClick={() => {downloadASN(salesOrderIds)}}
        >
          <Translate value="Walmart_ASN" />
        </Button>
      );
    } else {
      return (
        <SpinnerButton
          bsStyle="primary"
          disabled={true}
          icon="fa-print"
          translation={<Translate value="Walmart_ASN" />}
          loading={true}
          onClick={() => {
            console.log('loading');
          }}
        />
      )
    }
  }

  renderUploadWalmartButtons = () => {
    if (!isSKH) return null;
    return (
      <div id="third-row-contaner" style={{ marginLeft: '147px' }}>
        <input
          type="file"
          ref="file-walmart-upload-ref"
          style={{ display: 'none' }}
          onChange={(e) => {
            const file = e.target.files[0];
            const formData = new FormData();
            formData.append('File', file);
            this.props.uploadSOWalmartFile(formData)
            this.refs["file-walmart-upload-ref"].value = '';
          }}
        />
          <Button
          bsStyle="primary"
          className="print-btn"
          type="button"
          onClick={() => {
            this.refs["file-walmart-upload-ref"].click();
          }}
        >
          <Translate value="Walmart_Upload_Shipment" />
        </Button>
      </div>
    )
  }
  renderSendWalmartButtons = () => {
    if (!isSKH) return null;
    return (
      <div id="third-row-contaner" style={{ marginLeft: '147px' }}>
          <Button
          bsStyle="primary"
          className="print-btn"
          type="button"
          disabled={this.state.salesOrders.selectedRows.length == 0 || this.state.salesOrders.selectedRows.findIndex(item => item.SaleStatus != 'Open' || item.Channel != 'walmartb2b') != -1}
          onClick={() => {
            this.props.sendSOWalmartFile(this.state.salesOrders.selectedRows.map(item => item.SalesOrder_id));
          }}
        >
          <Translate value="Send_Walmart_Shipment" />
        </Button>
      </div>
    )
  }

  renderABCFFSyncButton = () => {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }
    const handleRecyncClick = () => {
      this.syncABCFF(salesOrderIds);
    }
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={(!salesOrderIds || salesOrderIds.length < 1)}
        type="button"
        onClick={handleRecyncClick}
      >
        <Translate value="abcff_sync" />
      </Button>
    )
  }

  setMissingSKUsModalVisibility = (isMissingSKUsModalVisible = false) => this.setState({ isMissingSKUsModalVisible });

  renderAssignDriverButton = () => {
    const {
      salesOrders: { selectedRows },
    } = this.state;
    return (
      <DropdownButton
        bsStyle="primary"
        title={
          <span>
            <i className="fa fa-print" />
            <Translate value=" Assign_to_driver" />
          </span>
        }
        className='assign_to_driver_dropdown'
      >
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={selectedRows.length !== 1}
          type="button"
          onClick={() => {
            this.setState({
              assigningInboundDriver: true,
              assigningOutboundDriver: false,
            }, () => this.setDriverListModalVisibility(true));
          }}
        >
          <em className="fa fa-car" />
          <Translate value="Assign_inbound_driver" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={selectedRows.length !== 1}
          type="button"
          onClick={() => {
            this.setState({
              assigningInboundDriver: false,
              assigningOutboundDriver: true,
            }, () => this.setDriverListModalVisibility(true))
          }}
        >
          <em className="fa fa-car" />
          <Translate value="Assign_outbound_driver" />
        </Button>
      </DropdownButton>
    );
  };

  renderUpdateNumberButton() {
    const {
      salesOrders: { selectedRows },
    } = this.state;
    return (
      <DropdownButton
        bsStyle="primary"
        title={
          <span>
            <i className="fa fa-print" />
            <Translate value="update_no" />
          </span>
        }
      >
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={selectedRows.length !== 1}
          type="button"
          onClick={() => {
            this.setISAEditModalVisibility(true);
          }}
        >
          <em className="fa fa-pencil" />
          <Translate value="update_customer_bol" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={selectedRows.length !== 1}
          type="button"
          onClick={() => {
            this.setCTNEditModalVisibility(true);
          }}
        >
          <em className="fa fa-pencil" />
          <Translate value="update_ctn_no" />
        </Button>
      </DropdownButton>
    );
  }
  renderImportedTemplateBtn() {
    const exportUrl = `${ROOT_URL}v2/so-template/?Bearer=${localStorage.getItem("token")}`

    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        <Translate value="download_template" />
      </Button>
    );
  }

  renderImportedBtn() {
    const handleUpload = (formData) => {
      const success = () => {
        alert('success');
        this.refreshSOList();
      }
      const failed = (err) => {
        alert(JSON.stringify(err));
      }
      axios({
        method: 'post',
        url:  `${ROOT_URL}v2/import_sales_order?warehouse_id=${this.props.selectedWarehouse && this.props.selectedWarehouse.value}`,
        data: formData,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
      .then(res => {
        this.setState({ importUploadLoading: false });
        success();
      })
      .catch(err => {
        this.setState({ importUploadLoading: false });
        failed(err.data);
      })
    }

    return (
      <div>
        <input
          ref='imported_ref'
          type='file'
          name='imported'
          id="imported_ref"
          onChange={(e) => {
            const files = e.target.files;
            const formData = new FormData();
            formData.append('FILE', files[0]);
            handleUpload(formData);
            e.target.value = null;
          }}
          style={{ display: 'none' }}
        />
        <Button
          style={{ marginLeft: '5px' }}
          bsStyle="success"
          type="button"
          disabled={this.state.importUploadLoading}
          onClick={() => {
            this.setState({ importUploadLoading: true });
            this.refs.imported_ref.click();
          }}
        >
          <em className={`fa ${this.state.importUploadLoading === true ? 'fa-spinner fa-spin' : 'fa-upload'}`} />
          <Translate value="upload_orders" />
        </Button>
      </div>
    );
  }

  renderExportButton(qb = undefined) {
    const { FromDate, ToDate, days } = this.state;
    const status =
      this.state.Status === "all" ? "" : `&SaleStatus=${this.state.Status}`;
    const dateRange = days || -1;
    const { fromDate, toDate } = toFromDates(dateRange, FromDate, ToDate);
    const route = this.props.route.path;
    const orderType =
      route === "salesOrders" ? "sales_order" : "sales_mobile_order";

    let salesOrderIds = "";
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length >= 1) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds += `${row.SalesOrder_id},`;
      });
    }
    salesOrderIds = salesOrderIds.substring(0, salesOrderIds.length - 1);

    let filterParams = "";
    if (isOCM || isKM || isABBLE || isAGD || isSV || isSH || isAP) {
      const filterPaires = [];
      _.forOwn(salesOrders.filters, (value, key) => {
        filterPaires.push([key, value.filterTerm].join('='))
      });
      if (filterPaires.length) {
        filterParams = `&${filterPaires.join('&')}`;
      }
    }

    let exportUrl = `${ROOT_URL}v1/sale/${orderType}/search/${
      !qb ? "export" : "export_for_quick_books"
    }/?OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}${status}${filterParams}&Company_id=${this.props.selectedCompany && this.props.selectedCompany.value}&Pickup_Warehouse_id_id=${this.props.selectedWarehouse && this.props.selectedWarehouse.value}&Bearer=${localStorage.getItem(
      "token"
    )}`;

    let exportUrl1 = `${ROOT_URL}v1/sale/${orderType}/search/${
      !qb ? "export" : "export_for_quick_books"
    }/${salesOrderIds}?Bearer=${localStorage.getItem("token")}`;
    if(isGGI || (isLAP || isUSPrideMulti || isAPD)) {
      const {dispatchDateGT, dispatchDateLT} = toFromDispatchDates(this.state.dispatchDays, this.state.dispatchDateGT, this.state.dispatchDateLT)
      exportUrl += `&DispatchDate__gte=${dispatchDateGT}&DispatchDate__lte=${dispatchDateLT}&IsRelocation=${this.state.Type == 'IsRelocation'}`;
    }

    if(isVAK && this.state.Type === "IsImported") {
      exportUrl += `&IsImported=true`;
    }

    return (
      <Button
        bsStyle="success"
        type="button"
        href={salesOrderIds === "" ? exportUrl : exportUrl1}
        disabled={(!isVAK || isVAK && route === "salesOrders") && !checkPermission("print_sales_order") || isVAK && route !== "salesOrders" && (!checkPermission("print_mobile_order") || this.state.salesOrders.selectedRows.filter(row => row.SaleStatus === 'Incomplete').length || this.state.Status === 'Incomplete')}
      >
        <em className="fa fa-download" />
        <Translate value={qb ? "excel_qb" : "excel"} />
      </Button>
    );
  }
  renderImportTemplateGFD() {
    const handleClick = () => {
      const token = localStorage.getItem("token");
      axios.get(`${ROOT_API_URL}v1/sale/so_excel_template/`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      }).then(response => {
        fileDownload(response.data, 'so_template.xlsx');
      }).catch(error => {
        alert(error.statusText)
      });
    }
    return (
      <Button
        bsStyle="success"
        type="button"
        onClick={handleClick}
      >
        <em className="fa fa-download" />
        <Translate value={"so_template"} />
      </Button>
    );
  }
  renderExportExcelLinesGFD() {
    const token = localStorage.getItem("token");
    const companyId = this.props.selectedCompany && this.props.selectedCompany.value;
    const warehouseId = this.props.selectedWarehouse && this.props.selectedWarehouse.value
    const handleClick = () => {
      const { FromDate, ToDate, days, salesOrders, productSearchType, invoiceNoSearchTerm, filterProductID, Status} = this.state;
      const dateRange = days || -1;
      const { fromDate, toDate } = toFromDates(dateRange, FromDate, ToDate);
      let salesOrderIds = [];
      if (salesOrders && salesOrders.selectedRows.length >= 1) {
        salesOrderIds = salesOrders.selectedRows.map(row => row.SalesOrder_id);
      }
      const isRelocation = this.state.Type === 'IsRelocation'
      const data = {
        start_date: fromDate,
        end_date: toDate,
        company_id: companyId,
        warehouse_id: warehouseId,
        is_relocated: isRelocation,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      }

      if (salesOrderIds.length > 0) {
        data.so_ids = salesOrderIds;
      } else {
        if (Status) {
          data.status = Status;
        }
        if (productSearchType === 'invoiceNo') {
          if (invoiceNoSearchTerm) {
            data.so_num = invoiceNoSearchTerm;
          }
        } else {
          if (filterProductID) {
            data.product_num = filterProductID;
          }
        }
      }
      axios.post(`${ROOT_API_URL}v1/sale/so_export/`, data, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      }).then(response => {
        fileDownload(response.data, moment().format('YYYY-MM-DD') + '.xlsx');
      }).catch(error => {
        alert(error.statusText)
      });
    }
    return (
      <Button
        bsStyle="success"
        type="button"
        onClick={handleClick}
        disabled={!warehouseId}
      >
        <em className="fa fa-download" />
        <Translate value={"excel_line_details"} />
      </Button>
    );
  }

  renderImportGFD() {
    const token = localStorage.getItem("token");
    const companyId = this.props.selectedCompany && this.props.selectedCompany.value
    const warehouseId = this.props.selectedWarehouse && this.props.selectedWarehouse.value
    const handleClick = () => {
      fileUpload((files) => {
        const formData = new FormData();
        formData.append('file', files[0]);
        formData.append('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
        formData.append('company_id', companyId);
        formData.append('warehouse_id', warehouseId);
        axios.post(`${ROOT_API_URL}v1/sale/so_import/`, formData, {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
          responseType: 'blob',
        }).then(response => {
          if (response.status === 202) {
            fileDownload(response.data, 'error_results.xlsx');
            alert('Upload has Failure: Pls open the downloaded error report to make changes and upload again. ');
          }
          if (response.status === 200) {
            alert('Upload Successful');
            this.refreshSOList();
          }
        });
      }, { accept: '.xlsx', multiple: false });
    }
    return (
      <Button
        bsStyle="success"
        type="button"
        onClick={handleClick}
        disabled={!warehouseId}
      >
        <em className="fa fa-upload" />
        <Translate value={"upload_so"} />
      </Button>
    );
  }

  renderDc1(qb = undefined) {
    const { FromDate, ToDate, days } = this.state;
    const status =
      this.state.Status === "all" ? "" : `&SaleStatus=${this.state.Status}`;
    const dateRange = days || -1;
    const { fromDate, toDate } = toFromDates(dateRange, FromDate, ToDate);
    const route = this.props.route.path;
    const orderType =
      route === "salesOrders" ? "sales_order" : "sales_mobile_order";

    let salesOrderIds = "";
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length >= 1) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds += `${row.SalesOrder_id},`;
      });
    }
    salesOrderIds = salesOrderIds.substring(0, salesOrderIds.length - 1);

    // let filterParams = "";
    // if (isOCM || isKM || isABBLE || isAGD || isSV) {
    //   const filterPaires = [];
    //   _.forOwn(salesOrders.filters, (value, key) => {
    //     filterPaires.push([key, value.filterTerm].join('='))
    //   });
    //   if (filterPaires.length) {
    //     filterParams = `&${filterPaires.join('&')}`;
    //   }
    // }

    // let exportUrl = `${ROOT_URL}v1/sale/${orderType}/search/${
    //   !qb ? "export" : "export_for_quick_books"
    // }/?OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}${status}${filterParams}&Company_id=${this.props.selectedCompany && this.props.selectedCompany.value}&Pickup_Warehouse_id_id=${this.props.selectedWarehouse && this.props.selectedWarehouse.value}&Bearer=${localStorage.getItem(
    //   "token"
    // )}`;
    let exportUrl = `${ROOT_URL}/v1/sale/sales_order/search/export/${salesOrderIds}?detail_level=lines&Bearer=${localStorage.getItem("token")}`

    // let exportUrl1 = `${ROOT_URL}v1/sale/${orderType}/search/${
    //   !qb ? "export" : "export_for_quick_books"
    // }/${salesOrderIds}?Bearer=${localStorage.getItem("token")}`;

    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={!checkPermission("print_sales_order") || !salesOrderIds}
      >
        <em className="fa fa-download" />
        <Translate value={"excel_lines"} />
      </Button>
    );
  }

  renderDc2(qb = undefined) {
    const { FromDate, ToDate, days } = this.state;
    const status =
      this.state.Status === "all" ? "" : `&SaleStatus=${this.state.Status}`;
    const dateRange = days || -1;
    const { fromDate, toDate } = toFromDates(dateRange, FromDate, ToDate);
    const route = this.props.route.path;
    const orderType =
      route === "salesOrders" ? "sales_order" : "sales_mobile_order";

    let salesOrderIds = "";
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length >= 1) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds += `${row.SalesOrder_id},`;
      });
    }
    salesOrderIds = salesOrderIds.substring(0, salesOrderIds.length - 1);

    // let filterParams = "";
    // if (isOCM || isKM || isABBLE || isAGD || isSV) {
    //   const filterPaires = [];
    //   _.forOwn(salesOrders.filters, (value, key) => {
    //     filterPaires.push([key, value.filterTerm].join('='))
    //   });
    //   if (filterPaires.length) {
    //     filterParams = `&${filterPaires.join('&')}`;
    //   }
    // }

    // let exportUrl = `${ROOT_URL}v1/sale/${orderType}/search/${
    //   !qb ? "export" : "export_for_quick_books"
    // }/?OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}${status}${filterParams}&Company_id=${this.props.selectedCompany && this.props.selectedCompany.value}&Pickup_Warehouse_id_id=${this.props.selectedWarehouse && this.props.selectedWarehouse.value}&Bearer=${localStorage.getItem(
    //   "token"
    // )}`;
    let exportUrl = `${ROOT_URL}/v1/sale/sales_order/search/export/${salesOrderIds}?detail_level=lines&backlog=true&Bearer=${localStorage.getItem("token")}`

    // let exportUrl1 = `${ROOT_URL}v1/sale/${orderType}/search/${
    //   !qb ? "export" : "export_for_quick_books"
    // }/${salesOrderIds}?Bearer=${localStorage.getItem("token")}`;

    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={!checkPermission("print_sales_order") || !salesOrderIds}
      >
        <em className="fa fa-download" />
        <Translate value={"excel_backlog_lines"} />
      </Button>
    );
  }

  renderBacklogExport() {
    const { salesOrders } = this.state;
    const salesOrderIds = [];
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }
    const salesOrderIdsString = salesOrderIds.join(',');

    const exportUrl = `${ROOT_URL}v1/sale/printbacklogorder/${salesOrderIdsString}/?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={salesOrderIds.length === 0}
      >
        <em className="fa fa-download" />
        <Translate value="export_backlog" />
      </Button>
    );
  }

  renderCreateExportButton() {
    const route = this.props.route.path;
    const orderType = route === "salesOrders" ? "sales_order" : "sales_mobile_order";

    const handleUpload = (platform, formData) => {
      const success = () => {
        alert('success');
        this.refreshSOList();
      }
      const failed = (err) => {
        alert(JSON.stringify(err));
      }
      axios({
        method: 'post',
        url:  `${ROOT_URL}v2/import_sales_order/?platform=${platform}&warehouse_id=${this.props.selectedWarehouse && this.props.selectedWarehouse.value}`,
        data: formData,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
      .then(res => {
        this.setState({ createExcelLoading: false });
        success();
      })
      .catch(err => {
        this.setState({ createExcelLoading: false });
        failed(err.data);
      })
    }

    return (
      <div>
        <input
          ref='kohlsb2b_excel_ref'
          type='file'
          name='kohlsb2b'
          id="kohlsb2b_excel_ref"
          onChange={(e) => {
            const files = e.target.files;
            const formData = new FormData();
            formData.append('FILE', files[0]);
            handleUpload('kohlsb2b', formData);
            e.target.value = null;
          }}
          style={{ display: 'none' }}
        />
        <input
          ref='belk_excel_ref'
          type='file'
          name='belk'
          id="belk_excel_ref"
          onChange={(e) => {
            const files = e.target.files;
            const formData = new FormData();
            formData.append('FILE', files[0]);
            handleUpload('belk', formData);
            e.target.value = null;
          }}
          style={{ display: 'none' }}
        />
        <input
          ref='walmartb2b_excel_ref'
          type='file'
          name='walmartb2b'
          id="walmartb2b_excel_ref"
          onChange={(e) => {
            const files = e.target.files;
            const formData = new FormData();
            formData.append('FILE', files[0]);
            handleUpload('walmartb2b', formData);
            e.target.value = null;
          }}
          style={{ display: 'none' }}
        />
        <input
          ref='costco_excel_ref'
          type='file'
          name='costco'
          id="costco_excel_ref"
          onChange={(e) => {
            const files = e.target.files;
            const formData = new FormData();
            formData.append('FILE', files[0]);
            handleUpload('costco', formData);
            e.target.value = null;
          }}
          style={{ display: 'none' }}
        />
        <DropdownButton
          bsStyle="success"
          title={
            <span>
              <em className={`fa ${this.state.createExcelLoading === true ? 'fa-spinner fa-spin' : 'fa-download'}`} />
              <Translate value="create_excel" />
            </span>
          }
        >
          {
            (orderType==='sales_order') ?
              <div>
                <MenuItem onClick={() => {
                  this.setState({ createExcelLoading: true });
                  this.refs.kohlsb2b_excel_ref.click();
                }}>
                  <Translate value="kohlsb2b" />
                </MenuItem>
                <MenuItem onClick={() => {
                  this.setState({ createExcelLoading: true });
                  this.refs.belk_excel_ref.click();
                }}>
                  <Translate value="belk" />
                </MenuItem>
                <MenuItem onClick={() => {
                  this.setState({ createExcelLoading: true });
                  this.refs.walmartb2b_excel_ref.click();
                }}>
                  <Translate value="walmartb2b" />
                </MenuItem>
              </div>
            :
              <MenuItem onClick={() => {
                this.refs.costco_excel_ref.click();
              }}>
                <Translate value="costco" />
              </MenuItem>
          }
        </DropdownButton>
      </div>
    );
  }

  renderCreateExportButtonOCM() {
    const route = this.props.route.path;
    // const orderType = route === "salesOrders" ? "sales_order" : "sales_mobile_order";

    const handleUpload = (platform, formData) => {
      const success = () => {
        alert('success');
        this.refreshSOList();
      }
      const failed = (err) => {
        alert(JSON.stringify(err));
      }
      const selectedCompany = this.props.selectedCompany;
      const selectedWarehouse = this.props.selectedWarehouse;

      axios({
        method: 'post',
        url:  `${ROOT_URL}v2/import_sales_order/?platform=${platform}&company_id=${selectedCompany.value}&warehouse_id=${selectedWarehouse.value}`,
        data: formData,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
      .then(res => {
        success();
      })
      .catch(err => {
        failed(err.data);
      })
    }
    // 'hongmall', 'yamibuy', 'weee'
    return (
      <div style={{ marginLeft: '220px' }}>
        {/* <input
          ref="hongmall_excel_ref"
          type='file'
          name='hongmall'
          id="hongmail_excel_ref"
          onChange={(e) => {
            const files = e.target.files;
            const formData = new FormData();
            formData.append('FILE', files[0]);
            handleUpload('hongmall', formData);
            e.target.value = null;
          }}
          style={{ display: 'none' }}
        />
        <input
          ref='yamibuy_excel_ref'
          type='file'
          name='yamibuy'
          id="yamibuy_excel_ref"
          onChange={(e) => {
            const files = e.target.files;
            const formData = new FormData();
            formData.append('FILE', files[0]);
            handleUpload('yamibuy', formData);
            e.target.value = null;
          }}
          style={{ display: 'none' }}
        />
        <input
          ref='weee_excel_ref'
          type='file'
          name='weee'
          id="weee_excel_ref"
          onChange={(e) => {
            const files = e.target.files;
            const formData = new FormData();
            formData.append('FILE', files[0]);
            handleUpload('weee', formData);
            e.target.value = null;
          }}
          style={{ display: 'none' }}
        /> */}
        {/* <DropdownButton
          bsStyle="success"
          title={
            <span>
              <i className="fa fa-downloa" />
              <Translate value="create_excel" />
            </span>
          }
        >
          <div>
            <MenuItem onClick={() => {
              this.refs.hongmall_excel_ref.click();
            }}>
              <Translate value="HongMall" />
            </MenuItem>
            <MenuItem onClick={() => {
              this.refs.yamibuy_excel_ref.click();
            }}>
              <Translate value="yamibuy" />
            </MenuItem>
            <MenuItem onClick={() => {
              this.refs.weee_excel_ref.click();
            }}>
              <Translate value="weee" />
            </MenuItem>
          </div>
        </DropdownButton> */}
        <Button
          bsStyle="success"
          type="button"
          onClick={() => {
            this.setCreateExcelOCMModalVisibility(true)
          }}
        >
          <em className="fa fa-file" />
          <Translate value="create_excel" />
        </Button>
      </div>
    );
  }

  renderSOExport = () => {
    if (!isOCM) return null;
    const selectedCompany = this.props.selectedCompany;
    const selectedWarehouse = this.props.selectedWarehouse;
    const { FromDate, ToDate, days } = this.state;
    const status =
      this.state.Status === "all" ? "" : `&SaleStatus=${this.state.Status}`;
    const dateRange = days || -1;
    const { fromDate, toDate } = toFromDates(dateRange, FromDate, ToDate);
    let transferRelocation = "&IsRelocation=false&IsTransfer=false";
    if (this.state.Type === "IsRelocation") {
      transferRelocation = `&IsRelocation=true&IsTransfer=false`
    }
    if (this.state.Type === "IsTransfer") {
      transferRelocation = `&IsRelocation=false&IsTransfer=true`
    }
    if (isVAK && this.state.Type === "IsImported") {
      transferRelocation = `&IsRelocation=false&IsTransfer=false&IsImported=true`
    }

    const url = `${ROOT_URL}v1/sale/export_order_details?OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}${status}${transferRelocation}&Pickup_Warehouse_id_id=${this.props.selectedWarehouse && this.props.selectedWarehouse.value}&Company_id=${this.props.selectedCompany && this.props.selectedCompany.value}&Bearer=${localStorage.getItem("token")}`;
    return <div style={{ marginLeft: '342px' }}>
      <Button
        bsStyle="success"
        type="button"
        href={url}
      >
        <em className="fa fa-download" />
        <Translate value="orders_export" />
      </Button>
    </div>

  }

  setCreateExcelOCMModalVisibility = (createExcelModalVisible = false) => this.setState({ createExcelModalVisible });
  handleOCMCreateExcelSuccess = () => {
    this.setCreateExcelOCMModalVisibility(false);
    this.refreshSOList();
  }

  renderDscoShipmentButton() {
    return (
      <Button
        style={{ marginLeft: '5px' }}
        bsStyle="success"
        type="button"
        onClick={() => { this.refs.dsco_ref.click(); }}
        disabled={false}
      >
        <em className="fa fa-upload" /><Translate value="dsco_shipment" />
      </Button>
    );
  }

  renderExportSelectedButton() {
    const salesOrderIds = [];
    const { salesOrders } = this.state;
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
    }

    const exportUrl = `${ROOT_URL}v2/so-line-export/${salesOrderIds.join(",")}?Bearer=${localStorage.getItem("token")}`

    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={(!salesOrderIds || salesOrderIds.length < 1)}
      >
        <em className="fa fa-print" />
        <Translate value={(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? "excel_line_details" : "excel_lines"} />
      </Button>
    );
  }

  dsqExcelTemplate() {
    const exportUrl = `${ROOT_URL}v2/so-template?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        MSO Template
      </Button>
    );
  }

  abcffMsoTemplate() {
    const exportUrl = `${ROOT_URL}v2/customer-so-template?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        MSO Template
      </Button>
    );
  }

  dsqOutboundTemplate() {
    const exportUrl = `${ROOT_URL}v2/ob-template?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        OB Template
      </Button>
    );
  }

  magExcelTemplate() {
    const exportUrl = `${ROOT_URL}v2/so-template?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        <Translate value="excel_template" />
      </Button>
    );
  }

  jtbExcelTemplate() {
    const exportUrl = `${ROOT_URL}v2/so-template?Bearer=${localStorage.getItem("token")}`
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        <Translate value="ib_excel_template" />
      </Button>
    );
  }

  wizExcelTemplate() {
    const exportUrl = `${ROOT_URL}v2/so-template?Bearer=${localStorage.getItem("token")}`
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        <Translate value="ib_excel_template" />
      </Button>
    );
  }

  bolList() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        type="button"
        onClick={() => {
          this.openbolListModal();
        }}
        disabled={false}
        >
        <em className="fa fa-list" />
        <Translate value="bol_list" />
      </Button>
    );
  }

  generateBOL() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        type="button"
        onClick={() => {
          this.openGenerateBOLModal();
        }}
        disabled={selectedRows.length < 1}
      >
        <em className="fa fa-plus" />
        <Translate value="bol" />
      </Button>
    );
  }

  fjExcelTemplate() {
    const exportUrl = `${ROOT_URL}v2/so-template?Bearer=${localStorage.getItem("token")}`
    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={false}
      >
        <em className="fa fa-download" />
        <Translate value="ib_excel_template" />
      </Button>
    );
  }

  renderCreateTaskButton() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          this.context.router.routes[1].path !== "mobileSalesOrders" ||
          selectedRows.length !== 1
        }
        onClick={() => {
          this.props.createMobileTask(salesOrder_id);
        }}
      >
        <Translate value="on_fleet" />
      </Button>
    );
  }

  renderChangeWeightButton(isMobile) {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    let disabled = !isVAK && this.context.router.routes[1].path !== 'mobileSalesOrders' ||
      selectedRows.length !== 1 || ['Quote', 'Cancelled'].includes(selectedRows[0].SaleStatus)
      || isVAK &&
      (isMobile && selectedRows.filter(row => row.SaleStatus === 'Incomplete').length ||
      !isMobile && (selectedRows[0].Is_Prepay && selectedRows[0].PrepayStatus != 'ReadyToShip')
      );
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={disabled}
        onClick={() => {
          this.openChangeWeight();
        }}
      >
        <em className="fa fa-print"/>
        <Translate value={isVAK ? 'manual_print_button' : 'change_weight_button'}/>
      </Button>
    );
  }

  renderAddTracking() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    let val = null;
    let dep = null;
    if (selectedRows && selectedRows.length === 1) {
    val = selectedRows[0].TrackingNum;
    dep = selectedRows[0];
    }
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          // this.context.router.routes[1].path !== "mobileSalesOrders" ||
          selectedRows &&
          selectedRows.length !== 1
        }
        onClick={() => {
          // this.openAddTracking();
          this.openChangeTracking(val, dep);
        }}
      >
        <em className="fa fa-plus" />
        <Translate value="tracking" />
      </Button>
    );
  }

  renderChowbusImportButton() {
    return (
      <Button
        bsStyle="success"
        type="button"
        onClick={() => {
          this.openChowbusModal();
        }}
      >
        <Translate value="chowbus" />
      </Button>
    );
  }

  renderPaymentMethodChangeButton() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          this.context.router.routes[1].path !== "mobileSalesOrders" ||
          selectedRows.length !== 1
        }
        onClick={() => {
          // this.openChangeWeight();
          this.openChangePaymentMethodModal();
        }}
      >
        <Translate value="change_payment_method" />
      </Button>
    );
  }

  renderReshipButton() {
    const { selectedRows } = this.state.salesOrders;
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    let hasInvoice = true;
    if (
      selectedRows[0] &&
      (!selectedRows[0].InvoiceNum || selectedRows[0].InvoiceNum === "")
    ) {
      hasInvoice = false;
    }
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={
          hasInvoice === false ||
          this.context.router.routes[1].path !== "mobileSalesOrders" ||
          selectedRows.length !== 1 || isVAK
        }
        onClick={() => {
          this.openConfirmReship();
        }}
      >
        <Translate value="reship" />
      </Button>
    );
  }

  renderQuoteButton() {
    if(isOLG || isVAK) {
      return
    }
    const { selectedRows } = this.state.salesOrders;
    let onlyQuote = true;
    selectedRows.map((r) => {
      // ggi
      if ((r.SaleStatus !== "Pending" || !checkPermissionLocal('sales_order_approve')) && isGGI) {
        onlyQuote = false;
      }
      // kimi
      if (r.SaleStatus !== "Quote" && r.SaleStatus !== "Open" && isKM) {
        onlyQuote = false;
      }
      // other
      if (r.SaleStatus !== "Quote") {
        onlyQuote = false;
      }
      // if (r.SaleStatus !== "Quote" && !(isGGI || isKM || isSH || isAP || (isLAP || isUSPrideMulti || isAPD))) {
      //   onlyQuote = false;
      // }
      // if ((isSH || isAP || (isLAP || isUSPrideMulti || isAPD)) && r.SaleStatus === "Released") {
      //   onlyQuote = false;
      // }
    });

    // sunset
    if (isSV || isAGD || isCRW || isSC) {
      onlyQuote = true
    }

    if (isABCFF) {
      return (
        <SpinnerButton
          bsStyle="success"
          disabled={ !onlyQuote }
          translation={<Translate value="set_order" />}
          loading={this.state.setOrderLoading}
          onClick={() => {
            this.setState({ setOrderLoading: true });
            this.quoteConversion();
          }}
        />
      );
    }

    if (isSKH) {
      return (
        <SpinnerButton
          bsStyle="success"
          disabled={ !onlyQuote }
          translation={<Translate value="set_order" />}
          loading={this.state.setOrderLoading}
          onClick={() => {
            this.setState({ setOrderLoading: true });
            this.onConfirmQuote();
          }}
        />
      );
    }
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={!onlyQuote || selectedRows.length !== 1}
        onClick={() => {
          this.openConfirmQuote();
        }}
      >
        <Translate value={(isSDR || isCRW || isSC) ? "set_invoice" : "set_order"} />
      </Button>
    );
  }

  renderSetInvoiceButton() {
    const { selectedRows } = this.state.salesOrders;
    let onlyOpen = true;
    selectedRows.map((r) => {
      if (r.SaleStatus !== "Open") {
        onlyOpen = false;
      }
    });

    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={!onlyOpen || selectedRows.length === 0}
        onClick={() => {
          this.openConfirmQuote(true);
        }}
      >
        <Translate value="set_invoice" />
      </Button>
    );
  }

  renderPendingButton = () => {
    const { selectedRows } = this.state.salesOrders;
    let onlyQuote = true;
    let disabled = false;
    if (selectedRows.length !== 1) {
      disabled = true;
    }
    if(isGGI && !checkPermission('change_sales_order')) {
      disabled = true;
    }
    if (selectedRows.length === 1 && selectedRows[0].SaleStatus !== "Quote") {
      disabled = true;
    }
    if (!checkPermissionLocal('sales_order_approve')) {
      // disabled = true;
    }
    if (isVAK) {
      if (this.context.router.routes[1].path === "mobileSalesOrders") return; //isMobile
      if (selectedRows.length === 1 && selectedRows[0].Req_Review_Status !== 'Confirm' && selectedRows[0].Req_Approve_Status !== 'Confirm' || !checkPermissionLocal('set_pending_sales_order')) {
        disabled = true;
      }
    }
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={disabled}
        onClick={() => {
          this.setPendingConfirmModalVisibility(true);
        }}
      >
        <Translate value="set_pending" />
      </Button>
    );
  }

  onConfirmApproveOrders = () => {
    let { salesOrders } = this.state;
    let salesOrderIds = [];
    let salesOrderIdsString = '';
    if (salesOrders && salesOrders.selectedRows.length >= 1) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
      salesOrderIdsString = salesOrderIds.join(',');
    }

    axios
    .post(
      `${ROOT_URL}v1/sale/sales_order/approve_pending/${salesOrderIdsString}`,
      // formData,
      null,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "token"
          )}`,
        },
      },
    )
    .then(
      (res) => {
        alert("Orders Approved!");
        this.fetchSalesOrdersByDetails(
          this.state.days
        );
      },
      (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
        }
        alert(JSON.stringify(err.data));
      }
    );
  }

  renderApprovePendingButtonSV = () => {
    const { selectedRows } = this.state.salesOrders;
    let disabled = false;

    if (selectedRows && selectedRows.length >= 1) {
      selectedRows.map((row) => {
        if (row.SaleStatus !== 'Pending') {
          disabled = true;
        }
      });
    }
    if (selectedRows && selectedRows.length < 1) {
      disabled = true;
    }

    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={disabled}
        onClick={() => {
         this.onConfirmApproveOrders();
        }}
      >
        <Translate value="approve_pending" />
      </Button>
    );
  }

  renderToQuoteButton = () => {
    if (!isOCM && !isGGI) return null;
    const { selectedRows } = this.state.salesOrders;
    let disabled = true;
    if (selectedRows.length === 1 && (selectedRows[0].SaleStatus === "Open" || selectedRows[0].SaleStatus === "Pending")) {
      disabled = false;
    }
    if(isGGI && !checkPermission('change_sales_order')) {
      disabled = true;
    }
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={disabled}
        onClick={() => {
          this.setQuoteConfirmModalVisibility(true);
        }}
      >
        <Translate value="set_quote" />
      </Button>
    );
  }

  renderDavisPO() {
    const { selectedRows } = this.state.salesOrders;
    let onlyOpen = true;
    // selectedRows.map(r=> {
    //   if (r.SaleStatus !== 'Open') {
    //     onlyOpen = false;
    //   }
    // });
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={!onlyOpen || selectedRows.length !== 1}
        onClick={() => {
          this.openDavisPO();
        }}
      >
        <Translate value="davis_po" />
      </Button>
    );
  }

  renderDriverImageButton() {
    const { selectedRows } = this.state.salesOrders;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1}
        type="button"
        onClick={() => {
          this.openShowDriverImage();
        }}
      >
        <em className="fa fa-print" />
        <Translate value="show_image" />
      </Button>
    );
  }

  renderPrintBolButton() {
    const salesOrder_id =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    return (
      <DropdownButton
        bsStyle="primary"
        title={
          <span>
            <i className="fa fa-print" />
            <Translate value=" print_bol" />
          </span>
        }
      >
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={!salesOrder_id}
          type="button"
          onClick={() => {
            this.props.printBolById(salesOrder_id);
          }}
        >
          <em className="fa fa-print" />
          <Translate value="print_bol_by_id" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={!salesOrder_id}
          type="button"
          onClick={() => {
            this.openPrintBol();
          }}
        >
          <em className="fa fa-print" />
          <Translate value="print_bol_by_address" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={!salesOrder_id}
          type="button"
          onClick={() => {
            this.props.printBolWithoutLog(salesOrder_id);
          }}
        >
          <em className="fa fa-print" />
          <Translate value="print_bol_without_log" />
        </Button>
        <Button
          bsStyle="primary"
          className="print-btn"
          disabled={!salesOrder_id}
          type="button"
          onClick={() => {
            this.props.printBolLabel(salesOrder_id);
          }}
        >
          <em className="fa fa-print" />
          <Translate value="print_bol_label" />
        </Button>
      </DropdownButton>
    );
  }

  renderDriverImage() {
    let imageFile = "/img/dummy.png";
    if (this.state.salesOrders.selectedRows[0]) {
      imageFile = this.state.salesOrders.selectedRows[0].OrderImage;
    }
    return (
      <div style={{ position: "relative" }}>
        <img
          style={{ width: "200px", height: "200px" }}
          src={imageFile}
          onClick={() => window.open(imageFile, "_blank")}
        />
      </div>
    );
  }
  renderSignatureImage() {
    let imageFile = "/img/dummy.png";
    if (this.state.salesOrders.selectedRows[0]) {
      imageFile = this.state.salesOrders.selectedRows[0].SignatureImage;
    }
    return (
      <div style={{ position: "relative" }}>
        <img
          style={{ width: "200px", height: "200px" }}
          src={imageFile}
          onClick={() => window.open(imageFile, "_blank")}
        />
      </div>
    );
  }

  onDrop(row, files) {
    if (!files) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const index = row.props.rowIdx;
      const newRows = this.state.salesOrders.selectedRows;
      newRows[index].BolImageUrl = reader.result;
      this.setState({ rows: newRows, file: files[0] });
    };
    // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
    const blob = files[0].slice(0, files[0].size, files[0].type);
    reader.readAsDataURL(blob);
  }

  onRowValueChange = (event, rowValues, type) => {
    // merge updated row with current row and rerender by setting state
    this.setState({ sortColumn: null, sortDirection: null });
    const rows = JSON.parse(JSON.stringify(this.state.rows));
    const editedRows = this.state.editedRows.slice(0);
    rows[rowValues.Index][type] = event.target.value;
    editedRows.forEach((element, idx) => {
      if (element.Index === rows[rowValues.Index].Index) {
        editedRows.splice(idx, 1);
      }
    }, this);
    // push the row into the editedRows array
    editedRows.push(rows[rowValues.Index]);
    this.setState({
      rows,
      editedRows,
    });
  };

  renderAutoSuggest() {
    if (!this.state.filteredByItem) {
      return (
        <div className="control-dropdown">
          <GenericProductSuggest
            value={this.state.suggestValue}
            onChange={(e, { newValue }) => {
              this.setState({ suggestValue: newValue });
            }}
            SearchType={this.state.productSearchType}
            fetchOrdersByProduct={this.fetchSalesOrdersByProduct}
          />
        </div>
      );
    }
    return (
      <div id="suggestion-box">
        {this.state.suggestValue}
        <em
          className="fa fa-times pull-right"
          onClick={() => {
            this.setState(
              {
                filteredByItem: false,
                suggestValue: "",
                filterProductID: null,
              },
              () => {
                this.fetchSalesOrdersByDetails(this.state.days);
              },
            );
          }}
        />
      </div>
    );
  }

  renderInvoiceNoSearchInput = () => {
    return (
      <input
        placeholder={this.state.productSearchType === "CustName" ?  I18n.t('cust_name.') : this.state.productSearchType === "phonenumber" ?  I18n.t('cust_phone') : I18n.t('order_num')}
        value={this.state.invoiceNoSearchTerm}
        onChange={(e) =>
          this.setState({
            invoiceNoSearchTerm: e.target.value,
          })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (this.state.invoiceNoSearchTerm) {
              if (this.state.productSearchType === 'invoiceNo') {
                const pathname = this.context.router.location.pathname;
                this.props.searchInvoicesByInvoiceNo(
                  this.state.invoiceNoSearchTerm,
                  pathname
                );
              } else if (this.state.productSearchType === 'CustName') {
                const pathname = this.context.router.location.pathname;
                this.props.searchInvoicesByInvoiceNo(
                  this.state.invoiceNoSearchTerm,
                  pathname,
                  null,
                  null,
                  'CustName'
                );
              }  else if (this.state.productSearchType === 'phonenumber') {
                const pathname = this.context.router.location.pathname;
                this.props.searchInvoicesByInvoiceNo(
                  this.state.invoiceNoSearchTerm,
                  pathname,
                  null,
                  null,
                  'phonenumber'
                );
              } else if (this.state.productSearchType === 'customer_id' || this.state.productSearchType === 'customer_name') {
                this.fetchSalesOrdersByDetails(this.state.days);
              }
            } else {
              this.fetchSalesOrdersByDetails(this.state.days);
            }
          }
        }}
        style={{
          outline: "none",
          width: "100%",
          height: "24px",
          padding: "10px 10px",
          fontFamily: "Helvetica, sans-serif",
          fontWeight: "300",
          fontSize: "12px",
          border: "1px solid #aaa",
          borderRadius: "4px",
        }}
      />
    );
  };

  renderTrackingNoSearchInput = () => {
    return (
      <input
        placeholder="Tracking No."
        value={this.state.trackingNoSearchTerm}
        onChange={(e) =>
          this.setState({
            trackingNoSearchTerm: e.target.value,
          })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (this.state.trackingNoSearchTerm) {
              const pathname = this.context.router.location.pathname;
              this.props.searchInvoicesByTrackingNo(
                this.state.trackingNoSearchTerm,
                pathname,
              );
            } else {
              this.fetchSalesOrdersByDetails(this.state.days);
            }
          }
        }}
        style={{
          outline: "none",
          width: "100%",
          height: "24px",
          padding: "10px 10px",
          fontFamily: "Helvetica, sans-serif",
          fontWeight: "300",
          fontSize: "12px",
          border: "1px solid #aaa",
          borderRadius: "4px",
        }}
      />
    );
  };

  handleStatusFilterChange = (status, canFilterTopRows = false) => {
    // if (toggleFilterRowBtn) {
    //   if (!_.isEmpty(this.state.salesOrders.filters)) {
    //     // running this block will call fetch list api twice
    //     // bug: click will run onClearFilters method which makes api call
    //     const filterRowBtn = document.querySelectorAll('#sales-orders-list .react-grid-Container .react-grid-Toolbar .btn');
    //     filterRowBtn[0].click();
    //   }
    // }
    this.setState({currentPage: 0});
    let salesOrders = {
      ...this.state.salesOrders,
      selectedRows: [],
    };
    const isEzgo = (this.props.selectedCompany || {value: ''}).value == 6;
    if (isEzgo) {
      salesOrders.sortColumn = null
    }
    let filterParams = "";
    if (isOCM || isKM || isABBLE || isAGD || isSV || isVAK) {
      const filterPaires = [];
      if(isVAK) {
        if(this.state.pullSheetSort) {
          filterPaires.push(['order_by', this.state.pullSheetSort].join('='))
        }
        if(this.props.store_name && this.props.store_name.label != 'All') {
          filterPaires.push(['store_name', this.props.store_name.label].join('='))
        }
        if(isEzgo && this.state.checkedKeys && this.state.checkedKeys.length) {
          filterPaires.push(['group_ids', this.state.checkedKeys.join(',')].join('='))
        }
        if(isEzgo && this.state.checkedChildKeys && this.state.checkedChildKeys.length) {
          filterPaires.push(['store_ids', this.state.checkedChildKeys.join(',')].join('='))
        }
      }
      _.forOwn(salesOrders.filters, (value, key) => {
        filterPaires.push([key, value.filterTerm].join('='))
      });
      filterParams = filterPaires.join('&');
    }
    if (isABC || isABBLE || isAGD || isSV || isSH || isAP || isEzgo) {
      this.setState({ salesOrders });
    }

    const salesOrdersFilter = this.props.salesOrdersFilter;
    if (!salesOrdersFilter) {
      const route = this.context.router.routes[1].path;
      let seller = this.props.Seller;
      if (this.props.Seller) {
        seller = this.props.Seller.value;
      }
      const fromDate = this.state.FromDate
        ? this.formatDate(this.state.FromDate)
        : moment().format('YYYY-MM-DD');
      const toDate = this.state.ToDate
        ? this.formatDate(this.state.ToDate)
        : moment().format('YYYY-MM-DD');
      let days = this.state.days;
      if (days == null && !isUSPrideMulti) {
        days = 7;
      }
      const productNum = this.props.ProductNum;
      let isNoPage = canFilterTopRows && this.state.topIds.length > 0 && status == 'open';
      this.setState({ Status: status }, () => {
        if ((!this.state.FromDate || !this.state.ToDate) && this.state.days === '-1') return;
        this.props.fetchSalesOrdersByFilter(
          fromDate,
          toDate,
          days,
          this.state.Status,
          seller,
          productNum,
          route,
          (isUSPrideMulti || isLAP) ? this.state.dispatchDateLT : null,
          (isUSPrideMulti || isLAP) ? this.state.dispatchDateGT : null,
          (isUSPrideMulti || isLAP) ? this.state.dispatchDays : null,
          this.state.limit,
          this.state.currentPage,
          this.state.searchFilter,
          this.state.Type,
          filterParams,
          ()=>{},
          isNoPage,
        );
      });
    } else {
      this.setState({ Status: status });
    }
  };

  handleTypeFilterChange = (Type, toggleFilterRowBtn) => {
    // if (toggleFilterRowBtn) {
    //   if (!_.isEmpty(this.state.salesOrders.filters)) {
    //     // running this block will call fetch list api twice
    //     // bug: click will run onClearFilters method which makes api call
    //     const filterRowBtn = document.querySelectorAll('#sales-orders-list .react-grid-Container .react-grid-Toolbar .btn');
    //     filterRowBtn[0].click();
    //   }
    // }
    let { salesOrders } = this.state;
    let filterParams = "";
    const isEzgo = (this.props.selectedCompany || {value: ''}).value == 6;
    if (isOCM || isKM || isABBLE || isAGD || isSV || isSH || isAP || isEzgo) {
      const filterPaires = [];
      if(isEzgo && this.state.checkedKeys && this.state.checkedKeys.length) {
        filterPaires.push(['group_ids', this.state.checkedKeys.join(',')].join('='))
        filterParams = filterPaires.join('&');
      }
      if(isEzgo && this.state.checkedChildKeys && this.state.checkedChildKeys.length) {
        filterPaires.push(['store_ids', this.state.checkedChildKeys.join(',')].join('='))
        filterParams = filterPaires.join('&');
      }
      _.forOwn(salesOrders.filters, (value, key) => {
        filterPaires.push([key, value.filterTerm].join('='))
      });
      filterParams = filterPaires.join('&');
    }

    if (isABBLE || isAGD || isSV || isSH || isAP) {
      salesOrders.selectedRows = [];
      this.setState({salesOrders});
    }

    this.setState({ currentPage: 0 });
    const route = this.context.router.routes[1].path;
    let seller = this.props.Seller;
    if (this.props.Seller) {
      seller = this.props.Seller.value;
    }
    const fromDate = this.state.FromDate
      ? this.formatDate(this.state.FromDate)
      : moment().format('YYYY-MM-DD');
    const toDate = this.state.ToDate
      ? this.formatDate(this.state.ToDate)
      : moment().format('YYYY-MM-DD');
    let days = this.state.days;
    if (days == null) {
      days = 7;
    }

    const productNum = this.props.ProductNum;
    this.setState({ Type }, () => {
      if ((!this.state.FromDate || !this.state.ToDate) && this.state.days === '-1') return;
      this.props.fetchSalesOrdersByFilter(
        fromDate,
        toDate,
        days,
        this.state.Status,
        seller,
        productNum,
        route,
        this.state.dispatchDateLT,
        this.state.dispatchDateGT,
        this.state.dispatchDays,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        Type,
        filterParams,
      );
    });
  }

  refreshSOList = (callback = () => {}, withSearch = false) => {
    // const fromDate = this.state.FromDate
    //   ? this.formatDate(this.state.FromDate)
    //   : "1900-01-01";
    // const toDate = this.state.ToDate
    //   ? this.formatDate(this.state.ToDate)
    //   : "3000-01-01";
    if (this.state.invoiceNoSearchTerm && withSearch) {
      if (this.state.productSearchType === 'invoiceNo') {
        const pathname = this.context.router.location.pathname;
        this.props.searchInvoicesByInvoiceNo(
          this.state.invoiceNoSearchTerm,
          pathname,
          null,
          null,
          'search',
          callback,
        );
      } else if (this.state.productSearchType === 'CustName') {
        const pathname = this.context.router.location.pathname;
        this.props.searchInvoicesByInvoiceNo(
          this.state.invoiceNoSearchTerm,
          pathname,
          null,
          null,
          'CustName',
          callback
        );
      }
    } else {
      const fromDate = this.state.FromDate
        ? this.formatDate(this.state.FromDate)
        : moment(new Date())
          .format('YYYY-MM-DD');
      const toDate = this.state.ToDate
        ? this.formatDate(this.state.ToDate)
        : moment(new Date())
          .format('YYYY-MM-DD');
      let days = this.state.days;
      let seller = this.props.Seller;
      const route = this.context.router.routes[1].path;
      const productNum = this.props.ProductNum;

      let filterParams = "";
      let salesOrders = {
        ...this.state.salesOrders,
        selectedRows: [],
        rows: [],
      };
      if (isOCM || isKM | isABBLE || isAGD || isSV || isSH || isAP) {
        const filterPaires = [];
        _.forOwn(salesOrders.filters, (value, key) => {
          filterPaires.push([key, value.filterTerm].join('='))
        });
        filterParams = filterPaires.join('&');
      }

      this.props.fetchSalesOrdersByFilter(
        fromDate,
        toDate,
        days,
        this.state.Status,
        seller,
        productNum,
        route,
        null,
        null,
        this.state.dispatchDays,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        filterParams,
        callback
      );
    }
  }

  handleBreadCrumbTitle = () => {
    if (isDSQ || isWIZ || isFJ || isJTB || isABCFF) {
      if (this.context.router.routes[1].path === "salesOrders") {
        this.setState(() => ({ breadcrumbTitle: "inbound_order" }));
      } else if (this.context.router.routes[1].path === "outboundOrders") {
        this.setState(() => ({ breadcrumbTitle: "outbound_order" }));
      } else if (this.context.router.routes[1].path === "mobileSalesOrders") {
        this.setState(() => ({ breadcrumbTitle: "mobile_sales_order" }));
      }
    } else {
      if (this.context.router.routes[1].path === "salesOrders") {
        this.setState(() => ({ breadcrumbTitle: "sales_orders" }));
      } else if (this.context.router.routes[1].path === "mobileSalesOrders") {
        this.setState(() => ({ breadcrumbTitle: "mobile_sales_order" }));
      }
    }
  };

  genSubjectTemplate = () => {
    if(isOCM || isEKC || isLMH || isBRO || isSDR || isCRW || isSC || (isLAP || isUSPrideMulti || isAPD) || isCCW || isGFD) {
      const row = this.state.salesOrders.selectedRows[0];
      const activeCompany = getLocalStorageData('selectedCompany').label;
      if(row) {
        const soNum = row.SONum;
        return `Sales Order ${soNum} from ${activeCompany.toUpperCase()}`
      }
    }
    return ''
  }

  genContentTemplate = () => {
    if(isOCM || isEKC || isLMH || isBRO || isSDR || isCRW || isSC || (isLAP || isUSPrideMulti || isAPD) || isGFD || isCCW) {
      const activeCompany = getLocalStorageData('selectedCompany').label;
      return `Dear Customer:

        Your sales order is attached. Please review the list of items on order.
        Thank you for your business - we appreciate it very much

        Sincerely,
        ${activeCompany.toUpperCase()}.`
    }
    return ''
  }

  handleEmailContentConfirm = (subject, content, email, phone, sendEmail, source) => {
    const row = this.state.salesOrders.selectedRows[0];
    if(row) {
      if ((isLAP || isUSPrideMulti || isAPD) || isGFD || isBRO) {
        this.props.emailPOPost(row.SalesOrder_id, subject, content, email, phone, sendEmail, source);
      } else {
        this.props.emailSO(row.SalesOrder_id, subject, content, email, phone, sendEmail, source);
      }
      this.handleEmailContentClose();
    }
  }

  handleEmailContentClose = () => {
    this.setState({
      emailContentModalVisibility: false,
      emailSubjectModalTemplate: '',
      emailContentModalTemplate: ''
    })
  }

  // renderTesting = () => {

  //   const handleTestClick = (e) => {
  //     let { salesOrders } = this.state;
  //     let salesOrderIds = [];
  //     let salesOrderIdsString = '';
  //     if (salesOrders && salesOrders.selectedRows.length > 0) {
  //       salesOrders.selectedRows.map((row) => {
  //         salesOrderIds.push(row.SalesOrder_id + '_' + row.SONum);
  //       });
  //       salesOrderIdsString = salesOrderIds.join(',');
  //     }
  //     alert(salesOrderIdsString);
  //     console.log('testing', salesOrderIdsString);
  //   }

  //   return (
  //     <div id="third-row-contaner" style={{ marginTop: '40px', marginLeft: '147px' }}>
  //       <ButtonToolbar className="table-buttons-thrid-row">
  //         <Button
  //           bsStyle="success"
  //           className="print-btn"
  //           type="button"
  //           onClick={() => {
  //             handleTestClick();
  //           }}
  //         >
  //           <Translate value="test" />
  //         </Button>
  //       </ButtonToolbar>
  //     </div>
  //   )
  // }


  render3rdRowButtonsAbble = () => {
    if (!(isABBLE || isAGD || isUSPrideMulti)) return null;

    const { salesOrders } = this.state;
    let salesOrderIds = [];
    let salesOrderIdsString = '';
    if (salesOrders && salesOrders.selectedRows.length > 0) {
      salesOrders.selectedRows.map((row) => {
        salesOrderIds.push(row.SalesOrder_id);
      });
      salesOrderIdsString = salesOrderIds.join(',');
    }

    const handleResetLocation = (e) => {
      axios.post(
        `${ROOT_URL}v1/sale/reset_batch_location/${salesOrderIdsString}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "token"
            )}`,
          },
        },
      )
      .then(
        (res) => {
          alert("Order Location Reset!");
          this.refreshSOList();
          // this.fetchSalesOrdersByDetails(
          //   this.state.days
          // );
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
          }
          alert(JSON.stringify(err.data));
        }
      );
    }

    const handleReconcileSKU = (e) => {
      let data = {sales_order_ids: salesOrderIds}
      axios.post(
        `${ROOT_URL}v1/sale/reconcile_missing_skus`,
        data,
        {
          headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
        },
      )
      .then(
        (res) => {
          alert("Reconcile SKU!");
          this.refreshSOList();
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
          }
          alert(JSON.stringify(err.data));
        }
      );
    }

    return (
      <div id="third-row-contaner" style={{ marginTop: isUSPrideMulti ? '67px' : '40px', marginLeft: '147px' }}>
        {(isABBLE || isUSPrideMulti) &&
          <ButtonToolbar className="table-buttons-thrid-row">
            { !isUSPrideMulti && this.renderMissingSKUsButton()}
            { !isUSPrideMulti &&
            <Button
              bsStyle="success"
              className="print-btn"
              type="button"
              onClick={() => {
                this.setMonitorListModalVisibility(true);
              }}
            >
              <Translate value="monitor_orders" />
            </Button>
  }
              {!isUSPrideMulti &&

            <Button
              bsStyle="success"
              className="print-btn"
              type="button"
              onClick={() => {
                handleResetLocation();
              }}
            >
              <Translate value="reset_location" />
            </Button>
  }
              {!isUSPrideMulti &&
            <Button
              bsStyle="success"
              className="print-btn"
              type="button"
              disabled={salesOrderIds.length === 0}
              onClick={() => {
                handleReconcileSKU();
              }}
            >
              <Translate value="reconcile_sku" />
            </Button>
  }
          </ButtonToolbar>
        }
      </div>
    )
  }

  setMonitorListModalVisibility = (isMonitorListModalVisible = false) => this.setState({ isMonitorListModalVisible });

  renderGGIButtons = () => {
    if (!isGGI) return null;
    return (
      <div id="third-row-contaner" style={{ marginTop: '40px', marginLeft: '147px' }}>
        <input
          type="file"
          ref="file-upload-ref"
          style={{ display: 'none' }}
          onChange={(e) => {
            const {
              salesOrders: {
                selectedRows,
              }
            } = this.state;

            const file = e.target.files[0];
            const formData = new FormData();
            formData.append('File', file);
            this.props.uploadSOFile(selectedRows[0].SalesOrder_id, formData, this.refreshSOList)
          }}
        />
        <ButtonToolbar className="table-buttons-thrid-row">
          {this.renderUploadFileButton()}
        </ ButtonToolbar>
      </div>
    )
  }

  renderOCMButtons = () => {
    if (!isOCM) return null;
    return (
      <div id="third-row-contaner" style={{ marginTop: '40px', marginLeft: '147px' }}>
        <ButtonToolbar>
          {this.renderMergeSOButton()}
          {this.renderDuplicateSOButton()}
          {this.renderCreateExportButtonOCM()}
          {this.renderSOExport()}
        </ButtonToolbar>
      </div>
    )
  }

  closeShipping= () => {
    // this.props.clearConvertingToInvoice();
    // this.props.clearUpdateSalesInvoice();
    this.setState({ showShippingOpen: false });
    this.refreshSOList();
  }

  generateOrderTypeRadioOptions = (isMobile = false, isEzgo = false) => {
    const options = [
      {
        option: null,
        id: "normal-radio-filter",
        name: "typeFilterRadios",
        labelName: "normal",
      },
      {
        option: "IsRelocation",
        id: "relocated-radio-filter",
        name: "typeFilterRadios",
        labelName: (isLAP || isUSPrideMulti || isAPD) ? "transfer" : "relocated_so",
      },
    ]
    if(isGGI) {
      options.map(item=>{
        if(item.labelName == "relocated_so") {
          item.labelName = "transfer"
        }
      })
    }
    if(isVAK && !isMobile && isEzgo) {
      options.push({
        option: "Prepay",
        id: "prepay-radio-filter",
        name: "typeFilterRadios",
        labelName: "prepay",
      })
    }
    if(isVAK) {
      options.push({
        option: "IsImported",
        id: "imported-radio-filter",
        name: "typeFilterRadios",
        labelName: "imported",
      })
    }
    if (!isOCM) {
      return options;
    }
    options.push({
      option: "IsTransfer",
      id: "transfer-radio-filter",
      name: "typeFilterRadios",
      labelName: "transfer",
    })
    return options;
  }

  expressOLG = (soId, success) => {
    const route = this.context.router.routes && this.context.router.routes.length > 1 && this.context.router.routes[1].path
    const successDetail = (detail) => {
      if(detail.SaleStatus != 'Open' && detail.SaleStatus != 'Packing') {
        alert('The Order status is not open')
        return
      }
      let isHavNonFixed = false;
      detail.Sales_Order_Lines.map(item => {
        if(item.ProductType == 'Non-Fixed') {
          isHavNonFixed = true;
        }
      })
      if(!isHavNonFixed) {
        expressMultipleSOInvoices(soId, success);
        return
      }
      // this.props.clearConvertingToInvoice();
      // this.props.clearUpdateSalesInvoice();
      this.setState({
        currentSalesOrder: detail,
        isMergeSo: false,
      }, () => {
        this.setState({
          showShippingOpen: true,
        })
      })
      // this.refreshSOList();
    }
    this.props.fetchSalesOrderDetail(soId, route, '', successDetail);
  }
  openAutoPrintModal = () => {
    this.setState({
      autoPrintModalVisibility: true,
    })
  }
  closeAutoPrintModal = () => {
    this.setState({
      autoPrintModalVisibility: false,
    })
  }
  closeStoreModal = (callback = () => {}) => {
    this.setState({
      storeModalVisibility: false,
    }, callback);
  }
  searchStoreModal = (callback = () => {}) => {
    this.setState({
      storeModalVisibility: false,
    }, callback);
    this.props.setValue("salesOrders", "store_name", '');
      const route = this.context.router.routes[1].path;
      let filterParams = "";
      const filterPaires = [];
      this.state.checkedKeys && this.state.checkedKeys.length && filterPaires.push(['group_ids', this.state.checkedKeys.join(',')].join('='));
      this.state.checkedChildKeys && this.state.checkedChildKeys.length && filterPaires.push(['store_ids', this.state.checkedChildKeys.join(',')].join('='));
      filterParams = filterPaires.join('&');
      this.props.fetchSalesOrdersByFilter(
        this.state.FromDate,
        this.state.ToDate,
        this.state.days,
        this.state.Status,
        null,
        null,
        route,
        this.state.dispatchDateLT,
        this.state.dispatchDateGT,
        this.state.dispatchDays,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        filterParams,
      );
  }
  confirmSyncToMES = (callback = () => {}) => {
    const {
      selectedRows,
    } = this.state.salesOrders;
    let salesOrder_id = selectedRows[0].SalesOrder_id;
    const success = () => {
      alert('Success!');
      this.setState({
        mesModalVisibility: false,
      })
    }
    const failed = () => {
      this.closeMesModal();
    }
    this.props.handleSyncToMES(salesOrder_id, success, failed);

  }
  closeMesModal = (callback = () => {}) => {
    this.setState({
      mesModalVisibility: false,
    }, callback);
  }

  closeDropship = () => {
    this.setState({
      isDropshipOpen: false,
      salesOrderIds: '',
    })
  }
  handleAutoPrint = response => {
    this.closeAutoPrintModal();
    this.refreshSOList(() => {
      if (response.data instanceof Blob) {
        this.props.fetchSalesOrderPDFSuccess(response);
      }
      if (isString(response.data)) {
        alert(response.data);
      }
    }, true);
  }
  render() {

    let tempcustnum = [];
    if ((isLAP || isUSPrideMulti || isAPD) && this.state.salesOrders && this.state.salesOrders.rows && this.state.salesOrders.rows.length > 0) {
      this.state.salesOrders.rows.map((r) => {
        tempcustnum.push({...r, Deliver_Customer_num: Number(r.Deliver_Customer_num) ? Number(r.Deliver_Customer_num) : r.Deliver_Customer_num});
      });
      this.state.salesOrders.rows = tempcustnum;
    }

    const isMobile = this.context.router.routes[1].path === "mobileSalesOrders";
    const isSalesOrder = this.context.router.routes[1].path === "salesOrders";
    const isEzgo = (this.props.selectedCompany || {value: ''}).value == 6;
    // const handleFilterChangePage = (event) => {
    //   // this.setState({currentPage: 0});
    //   this.state.currentPage = 0;
    //   let salesOrders = {
    //     ...this.state.salesOrders,
    //     selectedRows: [],
    //   };
    //   this.setState({ salesOrders });
    //   const route = this.context.router.routes[1].path;

    //   let keys = Object.keys(this.state.searchFilter);
    //   for (let i = 0; i < keys.length; i++) {
    //     if (event.target.name === keys[i]) {
    //       this.state.searchFilter[keys[i]] = event.target.value;
    //     }
    //   }

    //   this.props.fetchSalesOrdersByFilter(
    //     this.state.FromDate,
    //     this.state.ToDate,
    //     this.state.days,
    //     this.state.Status,
    //     null,
    //     null,
    //     route,
    //     this.state.dispatchDateLT,
    //     this.state.dispatchDateGT,
    //     null,
    //     this.state.limit,
    //     this.state.currentPage,
    //     this.state.searchFilter,
    //   );
    //   // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    // }

    const handleFilterChangePage = debounce(
      (event) => {
        // this.setState({currentPage: 0});
        this.state.currentPage = 0;
        let salesOrders = {
          ...this.state.salesOrders,
          selectedRows: [],
        };
        this.setState({ salesOrders });
        const route = this.context.router.routes[1].path;

        let keys = Object.keys(this.state.searchFilter);
        for (let i = 0; i < keys.length; i++) {
          if (event.name === keys[i]) {
            this.state.searchFilter[keys[i]] = event.value;
          }
        }

      let filterParams = "";
      if (isOCM || isKM || isABBLE || isAGD || isSV || isSH || isAP) {
        const filterPaires = [];
        _.forOwn(salesOrders.filters, (value, key) => {
          filterPaires.push([key, value.filterTerm].join('='))
        });
        filterParams = filterPaires.join('&');
      }

      this.props.fetchSalesOrdersByFilter(
        this.state.FromDate,
        this.state.ToDate,
        this.state.days,
        this.state.Status,
        null,
        null,
        route,
        this.state.dispatchDateLT,
        this.state.dispatchDateGT,
        this.state.dispatchDays,
        this.state.limit,
        this.state.currentPage,
        this.state.searchFilter,
        this.state.Type,
        filterParams,
      );
      // this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    },
    200,
    { maxWait: 300 },
  );

    const singleSalesOrderId =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;

    const singleSalesOrderNum =
      this.state.salesOrders.selectedRows.length === 1 &&
      this.state.salesOrders.selectedRows[0].SONum;

    let multiSalesOrderId = [];
    let multiSalesOrderNum = [];
    let salesOrderIdString = "";
    let salesOrderNumString = "";
      if (this.state.salesOrders && this.state.salesOrders.selectedRows.length >= 1) {
        this.state.salesOrders.selectedRows.map((row) => {
          multiSalesOrderId.push(row.SalesOrder_id);
          multiSalesOrderNum.push(row.SONum);
        });
        salesOrderIdString = multiSalesOrderId.join(",");
        salesOrderNumString = multiSalesOrderNum.join(",");
      }

      let svPendingDisable = false;
      let svReleasedDisable = false;
      let svIsMobile = false;

      if (isSV) {
        if (this.state.salesOrders && this.state.salesOrders.selectedRows.length >= 1) {
          this.state.salesOrders.selectedRows.map((row) => {
            if (row.SaleStatus === 'Pending') {
              svPendingDisable = true;
            }
            if (row.SaleStatus === 'Released') {
              svReleasedDisable = true;
            }
            if (row.IsMobile === true) {
              svIsMobile = true;
            }
          });
        }
      }

    // let dsqTempOrder = [];
    // if (this.state.salesOrders && this.state.salesOrders.selectedRows) {
    //   dsqTempOrder = this.state.salesOrders.selectedRows[0];
    // }
    const managePodDialogue = {
      width: "500px",
      height: "600px",
      marginLeft: "-15%",
      marginTop: '-350px'
    };
    const DriverListModalStyle = {
      width: "550px",
      height: "200px",
      marginLeft: "-15%",
    };
    const createDialogStyle = {
      width: "550px",
      height: (isSV || isKM || isSH || isAP || (isLAP || isUSPrideMulti || isAPD)) ? "450" : "350px",
      marginLeft: "-15%",
    };
    const syncToMESDialogStyle = {
      width: "410px",
      height: "148px",
      marginLeft: "-15%",
    };
    const bolImageDialogue = {
      width: "700px",
      height: "600px",
      marginLeft: "-15%",
    };
    const createWeightDialogStyle = {
      width: isVAK ? "1040px" : "600px",
      height: isVAK ? "500px" : "360px",
      marginLeft: isVAK ? "-32%" : "-10%",
    };
    const minDialogStyle = {
      width: "300px",
      height: "110px",
      marginLeft: "-32%",
      marginTop: "-20%",
    };
    const createPickerDialogStyle = {
      width: "600px",
      height: "200px",
      marginLeft: "-10%",
    };
    const bolListDialogStyle = {
      width: "1050px",
      height: "635px",
      marginLeft: "-27%",
      marginTop: "-310px",
    };
    const generateBOLStyle = {
      width: '500px',
      height: '515px',
      marginLeft: '-10%'
    };
    const dsqPrintDialogStyle = {
      width: "1050px",
      height: "550px",
      marginLeft: "-27%",
      marginTop: "-310px",
    };
    const wizPODDialogStyle = {
      width: "620px",
      height: "550px",
      marginLeft: "-10%",
      marginTop: "-310px",
    };
    const createTrackingDialogStyle = {
      width: "700px",
      height: "290px",
      marginLeft: "-10%",
    };
    const changeBOLDialogStyle = {
      width: "500px",
      height: "300px",
      marginLeft: "-10%",
    };
    const changeTrackingDialogStyle = {
      width: "500px",
      height: "200px",
      marginLeft: "-10%",
    };
    const createPullSheetDialogStyle = {
      width: "500px",
      height: "300px",
      marginLeft: "-10%",
    };
    const voidNoteDialogStyle = {
      width: "550px",
      height: "330px",
      marginLeft: "-10%",
    };
    const chowbusDialogStyle = {
      width: "500px",
      height: "300px",
      marginLeft: "-10%",
    };
    const splitSoDialogStyle = {
      width: "60%",
      height: "60%",
    };
    const confirmDialogStyle = {
      width: '500px',
      height: 'auto',
      marginLeft: '-15%',
      marginTop: '-320px'
    }
    const voidReasonSelection = [
      {
        value: "Items Out of Stock",
        label: "Items Out of Stock",
      },
      {
        value: "Customer Request",
        label: "Customer Request",
      },
      {
        value: "Items Damaged",
        label: "Items Damaged",
      },
      {
        value: "Duplicated Order",
        label: "Duplicated Order",
      },
      {
        value: "Invalid Shipping Address",
        label: "Invalid Shipping Address",
      },
      {
        value: "Other",
        label: "Other",
      },
    ];
    let USPridePlatformOptions = [
      // {label: '123 Store', value: '123store',},
      // {label: 'Amazon', value: 'amazon',},
      {label: 'TikTok', value: 'tiktok',},
      {label: 'Gigacloud', value: 'gigacloud',},
      {label: 'shein', value: 'shein',},
      {label: 'Home Depot', value: 'homedepot',},
      // {label: 'Houzz', value: 'houzz',},
      // {label: 'Overstock', value: 'overstock',},
      {label: 'Walmart', value: 'walmart',},
      // {label: 'Wayfair', value: 'wayfair',},
      // {label: 'Cymax', value: 'cymax',},
      // {label: 'BBB', value: 'bbb',},
    ];
    if (isABCFF) {
      USPridePlatformOptions = [
        // {label: 'Other', value: 'other',},
        {label: 'SILB2C', value: 'SILB2C',},
        {label: 'Amazon', value: 'amazon',},
        {label: 'Home Depot', value: 'homedepot',},
        {label: 'Costco', value: 'costco',},
        {label: 'Overstock', value: 'overstock',},
        {label: 'Walmart', value: 'walmart',},
        {label: 'Wayfair', value: 'wayfair',},
        {label: 'Cymax', value: 'cymax',},
        {label: 'BBB', value: 'bbb',},
      ];
    }
    if (isSV) {
      USPridePlatformOptions = [
        {label: 'Manual', value: 'manual',},
        {label: 'OMS', value: 'oms',},
        {label: 'Fosters', value: 'fosters',},
        {label: 'Walmart', value: 'walmart',},
        {label: 'Wayfair', value: 'wayfair',},
        {label: 'Faire', value: 'faire',},
        {label: 'CAMEO EZ', value: 'cameo',},
        {label: 'Tundra', value: 'tundra',},
        {label: 'QVC', value: 'qvc',},
        {label: 'Overstock', value: 'overstock',},
        {label: 'Home Depot', value: 'homedepot',},
        {label: 'Amazon', value: 'amazon',},
      ];
    }
    const { USPridePlatform, SelectedPicker, USPrideCustomer, salesOrders } = this.state;
    const userOptions = this.getUsers();
    const changeWeight = <Translate value={isVAK ? "manual_print" : "change_ship_weight"} />;
    const changePaymentMethod = <Translate value="payment_method_change" />;
    const changeShipMethod = <Translate value="shipping_method_change" />;
    const changeShipQty = <Translate value="shipping_qty_change" />;
    const changeTracking = <Translate value="tracking_change" />;
    const displayTrackingTitle = <Translate value="split_tracking_numbers" />;
    const splitSOTitle = <Translate value="split_so" />;
    const displayTrackingTitle2 = <Translate value="tracking_nums" />;
    const changePullSheet = <Translate value="pull_sheet_format" />;
    const reshipTitle = <Translate value="reship" />;
    const quoteTitle = <Translate value={(isSDR || isCRW || isSC) ? "set_invoice" : "set_order"} />;
    const pendingTitle = <Translate value="set_pending" />;
    const setQuoteTitle = <Translate value="set_quote" />;
    const davisPOTitle = <Translate value="so_to_po" />;
    const pridePrintTitle = <Translate value="pride_print" />;
    const showImageTitle = <Translate value="show_image" />;
    const submitImageTitle = <Translate value="submit_image" />;
    const printBolTitle = <Translate value="print_bol" />;
    const voidNoteTitle = <Translate value="void_note" />;
    const chowbusImportTitle = <Translate value="chowbus_import" />;
    let salesOrder_id =
      this.state.salesOrders &&
      this.state.salesOrders.selectedRows[0] &&
      this.state.salesOrders.selectedRows[0].SalesOrder_id;
    salesOrder_id = salesOrder_id || "";
    const height = ((this.state.tableHeight / 3) * 2 + 70).toString();
    const tableCollapseFix = { height };
    const detailsTableHeight = (this.state.tableHeight / 2.5 + 45).toString();
    const detailsTableCollapseFix = { height: detailsTableHeight };
    const listPurchasers = [{ value: "", label: "" }];
    const inputFieldKey = Math.random();

    let enableCustomerSearch = false;
    let statusFilterContents = [
      {
        option: "all",
        id: "all-radio-filter",
        name: "statusFilterRadios",
        labelName: "all",
      },
      ...(!isVAK && !isSDR) && [{
        option: "open",
        id: "open-radio-filter",
        name: "statusFilterRadios",
        labelName: "open",
      }],
      ...!isOLG && [{
        option: "Quote",
        id: "quote-radio-filter",
        name: "statusFilterRadios",
        labelName: "quote",
      }],
      ...isVAK && [{
        option: "open",
        id: "open-radio-filter",
        name: "statusFilterRadios",
        labelName: "open",
      }],
      ...isVAK ? isEzgo ? [{
        option: 'Unshippedng',
        id: 'unshippedng-radio-filter',
        name: 'statusFilterRadios',
        labelName: 'packing_mrfng',
        style: {width: "176px"}
      },{
        option: 'Unshippedg',
        id: 'unshippedg-radio-filter',
        name: 'statusFilterRadios',
        labelName: 'packing_mrfg',
        style: {width: "176px"}
      }] : [{
        option: "Pending",
        id: "pending-radio-filter",
        name: "statusFilterRadios",
        labelName: "Pending",
      }] : [],
      {
        option: "Released",
        id: "released-radio-filter",
        name: "statusFilterRadios",
        labelName: "released",
      },
      {
        option: "Canceled",
        id: "canceled-radio-filter",
        name: "statusFilterRadios",
        labelName: "canceled",
      },
      ...isVAK && [{
        option: "Backorder",
        id: "backlog-radio-filter",
        name: "statusFilterRadios",
        labelName: "backorder",
        style:{marginTop: isEzgo ? 4 : 0},
      }],
      ...(isEzgo && isMobile) && [{
        option: "Incomplete",
        id: "incomplete-radio-filter",
        name: "statusFilterRadios",
        labelName: "incomplete",
        style:{ marginTop: isEzgo ? 4 : 0},
      }]
    ];
    if (isSV) {
      statusFilterContents = [
        {
          option: "all",
          id: "all-radio-filter",
          name: "statusFilterRadios",
          labelName: "all",
        },
        {
          option: "Pending",
          id: "quote-radio-filter",
          name: "statusFilterRadios",
          labelName: "pending",
        },
        {
          option: "Quote",
          id: "quote-radio-filter",
          name: "statusFilterRadios",
          labelName: "quote",
        },
        {
          option: "open",
          id: "open-radio-filter",
          name: "statusFilterRadios",
          labelName: "open",
        },
        {
          option: "Released",
          id: "released-radio-filter",
          name: "statusFilterRadios",
          labelName: "released",
        },
        {
          option: "Canceled",
          id: "canceled-radio-filter",
          name: "statusFilterRadios",
          labelName: "canceled",
        },
        {
          option: "Backorder",
          id: "backlog-radio-filter",
          name: "statusFilterRadios",
          labelName: "backorder",
        }
      ];
    }
    if (isOCM && (this.props.selectedCompany.value === 2)) {
      const canceledIdx = statusFilterContents.findIndex(status => status.option === 'Canceled');
      const packFilter = {
        option: "Packed",
        id: "packed-radio-filter",
        name: "statusFilterRadios",
        labelName: "packed",
      };
      statusFilterContents.splice(canceledIdx, 0, packFilter);
    }
    if(isSH || isAP) {
      const quoteIndex = statusFilterContents.findIndex(status => status.option === 'Quote');
      if(quoteIndex !== -1) {
        statusFilterContents.splice(quoteIndex, 1);
      }
    }
    if(isDAICHEONG || (isLAP || isUSPrideMulti || isAPD)) {
      statusFilterContents.push({
        option: "Backlog",
        id: "backlog-radio-filter",
        name: "statusFilterRadios",
        labelName: "backlog",
      })
    }
    if (isABBLE || isUSPrideMulti) {
      const ReleasedIndex = _.findIndex(statusFilterContents, { option: "Released" });
      const packingOption = {
        option: "Packing",
        id: "packing-radio-filter",
        name: "statusFilterRadios",
        labelName: "packing",
      };
      statusFilterContents.splice(ReleasedIndex, 0, packingOption);
    }
    if(isVAK && this.state.Type == 'Prepay' && !isMobile && isEzgo) {
      statusFilterContents = [
        {
          option: "all",
          id: "all-radio-filter",
          name: "statusFilterRadios",
          labelName: "all",
        },
        {
          option: "Quote",
          id: "quote-radio-filter",
          name: "statusFilterRadios",
          labelName: "quote",
        },
        {
          option: "Pending",
          id: "pending-radio-filter",
          name: "statusFilterRadios",
          labelName: "Pending",
        },
        {
          option: "open",
          id: "open-radio-filter",
          name: "statusFilterRadios",
          labelName: "open",
        },
        {
          option: "Invoiced",
          id: "invoiced-radio-filter",
          name: "statusFilterRadios",
          labelName: "invoiced",
        },
        {
          option: "Paid",
          id: "paid-radio-filter",
          name: "statusFilterRadios",
          labelName: "paid",
        },
        {
          option: 'Unshippedng',
          id: 'unshippedng-radio-filter',
          name: 'statusFilterRadios',
          labelName: 'packing_mrfng',
          style: {width: "170px"}
        },{
          option: 'Unshippedg',
          id: 'unshippedg-radio-filter',
          name: 'statusFilterRadios',
          labelName: 'packing_mrfg',
          style: {width: "170px", marginTop: '4px'}
        },
        {
          option: "PartialShip",
          id: "partial-ship-radio-filter",
          name: "statusFilterRadios",
          labelName: "partial_ship",
          style: {width: "130px", marginTop: '4px'}
        },
        {
          option: "Released",
          id: "released-radio-filter",
          name: "statusFilterRadios",
          labelName: "released",
          style:{marginTop: '4px'},
        },
        {
          option: "Canceled",
          id: "canceled-radio-filter",
          name: "statusFilterRadios",
          labelName: "canceled",
          style:{marginTop: '4px'},
        },
      ]
    }
    // if (isSV) {
    //   const ReleasedIndex = _.findIndex(statusFilterContents, { option: "Released" });
    //   const partialOption = {
    //     option: "Partial",
    //     id: "partial-radio-filter",
    //     name: "statusFilterRadios",
    //     labelName: "partial",
    //   };
    //   statusFilterContents.splice(ReleasedIndex, 0, partialOption);
    // }
    if (isGGI) {
      const ReleasedIndex = _.findIndex(statusFilterContents, { option: "Released" });
      const moreOptions = [{
        option: "Pending",
        id: "pending-radio-filter",
        name: "statusFilterRadios",
        labelName: "pending",
      }, {
        option: "Packing",
        id: "packing-radio-filter",
        name: "statusFilterRadios",
        labelName: "packing",
      }]
      statusFilterContents.splice(ReleasedIndex, 0, ...moreOptions);
    }
    if (isOCM || isSV) {
      enableCustomerSearch = true
    }
    if (isMobile) {
      if (isABBLE || isAGD || isUSPrideMulti) {
        enableCustomerSearch = true
      }
    }

    const kmCarrierOptions = [
      {label: "USPS", value: "USPS"},
      {label: "UPS", value: "UPS"},
      {label: "FedEX", value: "FedEX"},
    ];


    let kmShipOptions = [];
    if (this.state.trackingformCarrier === 'USPS') {
      kmShipOptions = [
        {label: "FirstClass Parcel", value: "FIRST/RECTPARCEL"},
        {label: "First Class Flat", value: "FIRST/FLAT"},
        {label: "NonMachinable Flat", value: "FIRST/FLAT/N"},
        {label: "ParcelSelect", value: "PARCELSELECT/RECTPARCEL"},
        {label: "ParcelSelect Oversize", value: "PARCELSELECT/RECTPARCEL/O"},
        {label: "Priority Mail", value: "PRIORITY/RECTPARCEL"},
        {label: "Pri. Envelope", value: "PRIORITY/ENVELOPE"},
        {label: "Pri. Oversize", value: "PRIORITY/RECTPARCEL/O"},
        {label: "Pri. Non-Rect", value: "PRIORITY/NONRECTPARCEL/O"},
        {label: "Priority Cubic Pricing", value: "PRIORITY/CUBIC"},
        {label: "Pri. FlatRateSmallBox", value: "PRIORITY/FLATRATESMALLBOX"},
        {label: "Pri. FlatRateMediumBox", value: "PRIORITY/FLATRATEBOX"},
        {label: "Pri. FlatRateLargeBox", value: "PRIORITY/FLATRATELARGEBOX"},
        {label: "Pri. FlatRateRegionBoxA", value: "PRIORITY/REGIONALRATEBOXA"},
        {label: "Pri. FlatRateRegionBoxB", value: "PRIORITY/REGIONALRATEBOXB"},
        {label: "Pri. FlatRateRegionBoxC", value: "PRIORITY/REGIONALRATEBOXC"},
      ];
    } else if (this.state.trackingformCarrier === 'UPS') {
      kmShipOptions = [
        {label: "UPS Ground", value: "GND"},
        {label: "UPS Next Day Air Early A.M", value: "1DM"},
        {label: "UPS Next Day Air", value: "1DA"},
        {label: "UPS Next Day Air Saver", value: "1DP"},
        {label: "UPS 2nd Day Air A.M.", value: "2DM"},
        {label: "UPS 2nd Day Air", value: "2DA"},
        {label: "UPS 3 Day Select", value: "3DS"},
      ];
    } else if (this.state.trackingformCarrier === 'FedEX') {
      kmShipOptions = [
        {label: "FedEx Ground", value: "Ground"},
        {label: "FedEx Home Delivery", value: "Home"},
        {label: "FedEx First Overnight", value: "FirstOvernight"},
        {label: "FedEx Priority Overnight", value: "PriorityOvernight"},
        {label: "FedEx Standard Overnight", value: "StandardOvernight"},
        {label: "FedEx 2Day", value: "2Day"},
        {label: "FedEx 2Day A.M.", value: "2DayAM"},
        {label: "FedEx Express Saver", value: "ExpressSaver"},
        {label: "FedEx SmartPost", value: "SmartPost"},
      ];
    }
    const hasNoTracking = salesOrders.selectedRows.some(el => el.Tracking === null);
    const showExpressInvoice = isVAK && isEzgo;
    let isDisabledExpressInvoice = false;
    if(showExpressInvoice) {
      isDisabledExpressInvoice = salesOrders.selectedRows.length === 0
      || isMobile && (!salesOrders.selectedRows.every(row => !!row.tracking_num && !row.IsShipped)
      || salesOrders.selectedRows.filter(row => row.SaleStatus === 'Incomplete').length
      )
      || !isMobile && salesOrders.selectedRows.findIndex(row => row.SaleStatus != 'Open' && row.SaleStatus != 'Packing') != -1
    }

    let expressText = this.state.Type == 'Prepay'
    && (this.state.Status == 'Paid'
    || this.state.Status == 'Unshippedng'
    || this.state.Status == 'Unshippedg'
    || this.state.Status == 'PartialShip')
    ? "ship" : "express_invoice";
    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="sales_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value={this.state.breadcrumbTitle} />
          </Breadcrumb.Item>
        </Breadcrumb>{" "}
        {/* End Nav Trail */}
        <Grid id="sales-orders-list" style={isABC ? { width: '100%' } : {}}>
          {/* Date Range Picker */}
          { (!isABC || this.state.abcDatePickerShow === true) && <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                  {!isAPD &&
                  <Col xs={2}>
                    <h3 className="filter-title">
                      <Translate value="order_type" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  }
                  {!isAPD &&
                  <Col xs={10}>
                    <div id="statusFilterRadios" className="form-horizontal">
                      {/* <Field name='Status' component={ renderStatusRadios }  /> */}
                      {genericRadioFilter({
                        content: this.generateOrderTypeRadioOptions(isMobile, isEzgo),
                        value: this.state.Type,
                        handleOnClick: type => this.handleTypeFilterChange(type),
                        type: "buttons",
                      })}
                    </div>
                  </Col>
                  }
                  <Col xs={2}>
                    <h3 className="filter-title">
                      <Translate value="order_status" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  <Col xs={10}>
                    <div id="statusFilterRadios" className="form-horizontal">
                      {/* <Field name='Status' component={ renderStatusRadios }  /> */}
                      {genericRadioFilter({
                        content: statusFilterContents,
                        value: this.state.Status,
                        handleOnClick: status => this.handleStatusFilterChange(status, isMobile && isEzgo),
                        type: "buttons",
                      })}
                    </div>
                  </Col>
                  <Col xs={2}>
                    <h3 className="filter-title">
                      <Translate value="order_date" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  <Col xs={10}>
                    {dateFilterRadios({
                      handleOnClick: (days) => this.fetchSalesOrdersByDetails(days),
                      setFromDate: this.setFromDate,
                      setToDate: this.setToDate,
                      setToRangeSearch: this.setToRangeSearch,
                      FromDate: this.state.FromDate,
                      ToDate: this.state.ToDate,
                      Days: this.state.days,
                      ... (isLAP || isUSPrideMulti || isAPD) ? {dateId:'dateRange-radio-filter2'} :{}
                    })}
                  </Col>
                  {/* </Row> */}
                </Row>
                { (isCalco || (isLAP || isUSPrideMulti || isAPD) || isGGI || isAGD) && (
                  <Row>
                    <Col xs={2}>
                      <h3 className="filter-title">
                        <Translate value={(isLAP || isAPD) ? "ETD_date" : isGGI ? 'eta_date' : isAGD ? "ship_start_date" : isUSPrideMulti ? "import_date" : "order_delivered"} />
                        <span className="colon">:</span>
                      </h3>
                    </Col>
                    <Col xs={10}>
                      {dispatchFilterRadios({
                        handleOnClick: this.fetchSalesOrdersByDispatch,
                        setFromDate: this.setFromDispatchDate,
                        setToDate: this.setToDispatchDate,
                        setToRangeSearch: this.setToDispatchRangeSearch,
                        FromDate: this.state.dispatchDateLT,
                        ToDate: this.state.dispatchDateGT,
                        Days: this.state.dispatchDays,
                        ... isGGI ? {dateId:'dateRange-radio-filter'} : isAPD ? {dateId:'dateRange-radio-filter3'} : {}
                      })}
                    </Col>
                  </Row>
                )}
              </Panel>
            </Col>
          </Row>}
          {" "}
          {/* End Date Range Picker */}
          {/* Sales Order Full Table  */}
          <Row>
            <Col xs={12}>
              <Panel
                className="position-relative table-collapse-fix"
                id={
                  (isTN || isUSPrideMulti || isDSQ || isWIZ || isFJ || isJTB)
                  ? "table-collapse-fix-450" : isSV ? "table-collapse-fix-500"
                  : isABC ? "table-collapse-fix-940" : (isGGI || isOCM || isABBLE || isAGD || isUSPrideMulti) ? "table-collapse-fix-525" : ""
                }
                style={{marginBottom: (isSH || isAP) ? '' : isABC ? '80px': '0px', height: (isVAK && (isEzgo || isMobile)) ? '730px' : (isABBLE || isUSPrideMulti || isAGD) ? '520px' : (isSH || isAP) ? 'auto' : '490px'}}
              >
                <div style={{ position: "relative" }}>
                  <ButtonToolbar className="table-buttons">
                    {!isABCFF &&
                      <Button
                        bsStyle="success"
                        type="submit"
                        onClick={(event) => {
                          this.clickNew(event);
                        }}
                        disabled={
                          this.context.router.routes[1].path ===
                            "mobileSalesOrders" ||
                          !checkPermission("add_sales_order")
                        }
                      >
                        <em className="fa fa-plus" />
                        <Translate value="create" />
                      </Button>
                    }
                    {
                      isUSPrideMulti &&
                      <div style={{ marginLeft: '89px' }}>
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {this.openUSPrideCreate(); }}
                          disabled={!checkPermission("add_sales_order")}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="create_with_excel" />
                        </Button>
                      </div>
                    }
                    {
                      (isSV || (isABCFF && this.context.router.routes[1].path === "mobileSalesOrders")) &&
                      <div style={{ marginLeft: '89px' }}>
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {this.openUSPrideCreate(); }}
                          disabled={!checkPermission("add_sales_order")}
                        >
                          <em className="fa fa-plus" />
                          &nbsp;Excel Create
                        </Button>
                      </div>
                    }
                    {
                      (((isABCFF) && this.context.router.routes[1].path === "mobileSalesOrders") && this.state.USPrideCreateLoading) &&
                      <div style={{ marginLeft: '89px' }}>
                        <SpinnerButton
                          bsStyle="success"
                          disabled={true}
                          icon="fa-plus"
                          translation={<Translate value="creating_orders" />}
                          loading={true}
                          onClick={() => {
                            console.log('loading');
                          }}
                        />
                      </div>
                    }
                    {(isDSQ || isWIZ || isFJ || isJTB || isMAG) &&
                      (this.context.router.routes[1].path ===
                        "salesOrders") && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {
                            this.refs.msoCreateInputRef2.click();
                          }}
                          // disabled={!checkPermission("add_sales_order")}
                          disabled={false}
                        >
                          <em className="fa fa-plus" />
                          &nbsp;Excel Create (SO)
                        </Button>
                      )
                      }
                      {(isDSQ || isWIZ || isFJ || isJTB || isMAG) &&
                        (this.context.router.routes[1].path ===
                        "mobileSalesOrders") && (
                          <Button
                            bsStyle="success"
                            type="submit"
                            onClick={() => {
                              this.refs.msoCreateInputRef2MSO.click();
                            }}
                            // disabled={!checkPermission("add_sales_order")}
                            disabled={false}
                          >
                            <em className="fa fa-plus" />
                            &nbsp;Excel Create (MSO)
                          </Button>
                        )
                      }
                      {/* {(isSV) &&
                      (this.context.router.routes[1].path ===
                        "mobileSalesOrders") && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {
                            this.refs.msoCreateInputRef2.click();
                          }}
                          // disabled={!checkPermission("add_sales_order")}
                          disabled={false}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="create_with_excel" />
                        </Button>
                      )
                      } */}
                      {(isDSQ) &&
                        (this.context.router.routes[1].path ===
                        "outboundOrders") && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => {
                            this.refs.msoCreateInputRef3.click();
                          }}
                          // disabled={!checkPermission("add_sales_order")}
                          disabled={false}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="outbound_with_excel" />
                        </Button>
                      )}
                      { isABCFF && (this.context.router.routes[1].path === "outboundOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null; }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("File", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  `${ROOT_URL}v2/sales/upload_dsco_shipment?platform=dsco`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => { alert('success'); },
                                  (err) => {
                                    alert(JSON.stringify(err.data));
                                  }
                                );
                            }
                          }}
                          ref="dsco_ref"
                        />
                      )}
                      { isABCFF && (this.context.router.routes[1].path === "outboundOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null; }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("File", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  `${ROOT_URL}v2/sales/upload_dsco_shipment?platform=walmartb2b`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => { alert('success'); },
                                  (err) => {
                                    alert(JSON.stringify(err.data));
                                  }
                                );
                            }
                          }}
                          ref="walmartb2b_ref"
                        />
                      )}
                      {
                      (isDSQ || isWIZ || isFJ || isJTB || isMAG || isSV || isABCFF) &&
                      (this.context.router.routes[1].path ===
                        "salesOrders" || this.context.router.routes[1].path ===
                        "mobileSalesOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null; }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  `${ROOT_URL}v2/import-so-xls`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => {
                                    alert("Orders imported successfully");
                                    this.fetchSalesOrdersByDetails(
                                      this.state.days
                                    );
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRef2"
                        />
                      )}
                      { isSKH && (this.context.router.routes[1].path === "mobileSalesOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null; }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("File", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  `${ROOT_URL}v2/sales/upload_dsco_shipment`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => {
                                     alert('success');
                                  },
                                  (err) => {
                                    alert(JSON.stringify(err.data));
                                  }
                                );
                            }
                          }}
                          ref="dsco_ref"
                        />
                      )}
                      {
                    (isDSQ || isWIZ || isFJ || isJTB || isMAG || isSV) &&
                      (this.context.router.routes[1].path ===
                        "salesOrders" || this.context.router.routes[1].path ===
                        "mobileSalesOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null; }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  `${ROOT_URL}v2/import-mso-xls`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => {
                                    alert("Orders imported successfully");
                                    this.fetchSalesOrdersByDetails(
                                      this.state.days
                                    );
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRef2MSO"
                        />
                      )}
                      {
                        (isDSQ || isWIZ || isFJ || isJTB || isMAG || isABCFF) &&
                        (this.context.router.routes[1].path === "outboundOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null; }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  `${ROOT_URL}v2/import-outbound-xls`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => {
                                    alert("Outbound Orders imported successfully");
                                    this.fetchSalesOrdersByDetails(
                                      this.state.days
                                    );
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRef3"
                        />
                      )}
                      {
                      (isWIZ) && (this.context.router.routes[1].path ===
                        "outboundOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null; }}
                          onChange={(e) => {
                            let wURL = `${ROOT_URL}v2/sales/pod/` + this.state.salesOrders.selectedRows[0].SalesOrder_id + `/`;
                            const formData = new FormData();
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  wURL,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => {
                                    alert("POD uploaded successfully");
                                    this.fetchSalesOrdersByDetails(
                                      this.state.days
                                    );
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRef4"
                        />
                      )}
                    {isTN &&
                      (this.context.router.routes[1].path ===
                        "salesOrders") && (
                        <Button
                          bsStyle="success"
                          type="submit"
                          onClick={() => { this.refs.msoCreateInputRef.click(); }}
                          disabled={!checkPermission("add_sales_order")}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="create_with_excel" />
                        </Button>
                      )}
                    {isTN &&
                      (this.context.router.routes[1].path ===
                        "salesOrders") && (
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> { e.target.value = null }}
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  // `${ROOT_URL}v2/import_orders_xls`,
                                  `${ROOT_URL}v2/import_orders_tn`,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  }
                                )
                                .then(
                                  (res) => {
                                    alert("SO Imported Successfully");
                                    this.fetchSalesOrdersByDetails(
                                      this.state.days,
                                    );
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRef"
                        />
                      )}
                      {
                        !(isABCFF && this.context.router.routes[1].path === 'outboundOrders') &&
                        <Button
                          bsStyle="warning"
                          type="button"
                          disabled={
                            this.shouldEditButtonDisable() ||
                            (!isVAK || isVAK && !isMobile) && !checkPermission("change_sales_order") ||
                            isVAK && isMobile && !checkPermission("change_mobile_order")
                          }
                          onClick={(event) => {
                            this.setCurrentSalesOrder(event);
                          }}
                        >
                          <em className="fa fa-pencil" />
                          <Translate value="edit" />
                        </Button>
                      }
                    {
                      !isABCFF &&
                      <Button
                        bsStyle="danger"
                        type="reset"
                        disabled={
                          this.shouldVoidButtonDisable() ||
                          (!isVAK || isVAK && !isMobile) && !checkPermission("delete_sales_order") || isVAK && isMobile && !checkPermission("delete_mobile_order")
                        }
                        onClick={() => {
                          this.openCheckAuthorize("void");
                        }}
                      >
                        <em className="fa fa-trash" />
                        <Translate value="void" />
                      </Button>
                    }
                    {
                      (isTN || isDSQ || isWIZ || isUSPrideMulti || isSKH || (isFJ && this.context.router.routes[1].path !== 'outboundOrders') || isJTB || isOLG ||
                        (isABCFF && this.context.router.routes[1].path === 'outboundOrders') || showExpressInvoice
                      ) && <Button
                      bsStyle="primary"
                      // type="reset"
                      disabled={!this.state.salesOrders.selectedRows.length || (isOLG && (this.state.salesOrders.selectedRows.length != 1 || (this.state.salesOrders.selectedRows[0].SaleStatus != 'Open' && this.state.salesOrders.selectedRows[0].SaleStatus != 'Packing'))) || isDisabledExpressInvoice}
                      onClick={() => {
                        const soPKs = this.state.salesOrders.selectedRows.map(row => row.SalesOrder_id);
                        const success = () => {
                          this.refreshSOList();
                        }
                        if(isOLG) {
                          this.expressOLG(soPKs, success);
                          return
                        }
                        expressMultipleSOInvoices(soPKs, success);
                      }}
                    >
                      <em className="fa fa-file" />
                      <Translate value={expressText} />
                    </Button>
                    }
                    {
                      ((isABBLE || isKM) && checkPermission("view_express_invoice")) &&
                      <Button
                        bsStyle="primary"
                        // type="reset"
                        disabled={!this.state.salesOrders.selectedRows.length || (isKM && hasNoTracking)}
                        onClick={() => {
                          const soPKs = this.state.salesOrders.selectedRows.map(row => row.SalesOrder_id);
                          const success = () => {
                            this.refreshSOList();
                          }
                          expressMultipleSOInvoices(soPKs, success);
                        }}
                      >
                        <em className="fa fa-file" />
                        <Translate value="express_invoice" />
                      </Button>
                     }
                    {
                      isSV &&
                      <Button
                        bsStyle="primary"
                        // type="reset"
                        disabled={!this.state.salesOrders.selectedRows.length || svPendingDisable || !svIsMobile || svReleasedDisable}
                        onClick={() => {
                          const soPKs = this.state.salesOrders.selectedRows.map(row => row.SalesOrder_id);
                          const success = () => {
                            this.refreshSOList();
                          }
                          expressMultipleSOInvoices(soPKs, success);
                        }}
                      >
                        <em className="fa fa-file" />
                        <Translate value="express_invoice" />
                      </Button>
                    }
                    {/* padLeft */}
                    {this.renderPrint()}
                    {this.renderShippingIFrame()}
                    {this.renderPackingIFrame()}
                    {this.renderPickingIFrame()}
                    {this.renderSalesOrderIFrame()}
                    {this.renderBolByIdIFrame()}
                    {this.renderBolWithoutLogIFrame()}
                    {this.renderBolLabelIFrame()}
                    {this.renderBolByFbaIFrame()}
                  </ButtonToolbar>
                  <div className="table-filters" style={{ zIndex: 1 }}>
                    {
                      !(isWIZ || isABCFF) &&
                      <label
                        style={{ marginRight: "0px" }}
                        className="control-label"
                      >
                        {/* <Translate value="select_seller" /> */}
                        <Translate value={isVAK && isMobile ? "store" : "sales"} />:
                      </label>
                    }
                    {!(isWIZ || isVAK && isMobile) && this.renderUsers()}
                    {isVAK && isMobile && this.renderStore()}

                    <ButtonToolbar className="table-buttons">
                      {/* <Button bsStyle='primary' disabled={this.state.salesOrders.selectedRows.length != 1} onClick={this.loadsPost}>
                                  <Translate value="loads_post" />
                                </Button> */}
                      {/* { this.quoteButton() } */}
                      { (isVAK && this.state.Type==='IsImported' && isSalesOrder) && this.renderImportedTemplateBtn() }
                      { (isVAK && this.state.Type==='IsImported' && isSalesOrder) && this.renderImportedBtn() }
                      { !(isABCFF && isSalesOrder) && this.renderExportButton() }
                      { (isDAICHEONG && isSalesOrder) && this.renderDc1()}
                      { (isDAICHEONG && isSalesOrder) && this.renderDc2()}
                      { isGFD && isSalesOrder && this.renderExportExcelLinesGFD()}
                      { isGFD && isSalesOrder && this.renderImportTemplateGFD()}
                      { isGFD && isSalesOrder && this.renderImportGFD()}
                      { isSKH && this.renderCreateExportButton() }
                      { isSKH && isMobile && this.renderDscoShipmentButton() }
                      { (isTN) && this.renderExportSelectedButton() }
                      { (isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isUSPrideMulti) && this.renderExportSelectedButton() }
                      { isCalco && this.renderExportButton("qb") }
                      { isMyuMyu && this.renderCreateTaskButton() }
                      { (isAFG || (isVAK && (this.props.selectedCompany || {value: ''}).value == 6)) && this.renderChangeWeightButton(isMobile) }
                      { isRivera && this.renderPaymentMethodChangeButton() }
                      { (!isSKH && !isPRS && !isABCFF && !isVAK && !isUSPrideMulti) && this.renderReshipButton() }
                      { (!(isABCFF || isUSPrideMulti)) && this.renderQuoteButton() }
                      { isBRO && this.renderSetInvoiceButton()}
                      { (isABCFF && this.context.router.routes[1].path === 'outboundOrders') && this.renderQuoteButton() }
                      { (isABCFF && this.context.router.routes[1].path === 'outboundOrders') && this.renderTeapplixButton()}
                      { (isABCFF && this.context.router.routes[1].path === 'outboundOrders') && this.renderWalmartPkgLabelButton()}
                      { (isGGI || isVAK) && this.renderPendingButton()}
                      {isSV && this.renderApprovePendingButtonSV()}
                      {this.renderToQuoteButton()}
                      {/* { isABC && this.renderAssignDriverButton() } */}
                      {/* { isABC && this.renderUpdateNumberButton() } */}
                      { (isCO || isABC) && this.renderPrintBolButton() }
                      { (isCalco || isCT) && this.renderDriverImageButton() }
                      { isMyuMyu && this.renderChowbusImportButton() }
                      { (isMyuMyu || isAFG) && this.renderDavisPO() }
                      { !isUSPrideMulti && !isCalco && !isAFG && !isABC && !isFIT && !isDSQ && !isNBT && !isABBLE && !isSV && !isABCFF && !isVAK && this.renderPrintLabelButton() }
                      {isOLG && this.renderMergeSOButton()}
                      { (isAFG || isFIT || isNBT || (isVAK && (this.props.selectedCompany || {value: ''}).value == 6)) && this.renderPrintLabelButtonAFG() }
                      { isAP && this.renderImportSoButton() }
                      { (isVAK || isGFD || isLAP) && this.renderUploadPODMultiButton() }
                      { isVAK && (this.props.selectedCompany || {value: ''}).value != 6 && this.renderSplitSo() }
                      { isVAK && this.renderDealButton() }
                      { (isVAK && isMobile) && this.renderProcessedButton() }
                      { (isEzgo && isMobile) && this.renderSetToDoButton() }
                      { (isEzgo && isMobile) && this.renderSetToOpenButton() }
                      { (isEzgo && isMobile) && this.renderStoreSelectButton() }
                      { isDSQ && this.renderPrintLabelButtonDSQ()}
                      { false && this.renderAddTracking() }
                      { false && this.renderPrintLabelUSPride() }
                      { false && this.renderReprintLabelUSPride() }
                      { ((isABCFF) && isMobile) && this.abcffMsoTemplate()}

                      {/* { (isSV && this.context.router.routes[1].path === 'mobileSalesOrders') && this.dsqExcelTemplate() } */}
                      { (isDSQ && isSalesOrder) && this.dsqExcelTemplate() }
                      { (isDSQ && this.context.router.routes[1].path === 'outboundOrders') && this.dsqOutboundTemplate()}
                      { (isJTB && isSalesOrder) && this.jtbExcelTemplate() }
                      { (isWIZ && isSalesOrder) && this.wizExcelTemplate() }
                      { (isFJ && isSalesOrder) && this.fjExcelTemplate() }
                      { (isMAG && isSalesOrder) && this.magExcelTemplate() }
                      { isWIZ && this.bolList()}
                      { isWIZ && this.generateBOL()}

                      {(isWIZ) &&
                        (this.context.router.routes[1].path ===
                          "outboundOrders") && (
                          <Button
                            bsStyle="success"
                            type="submit"
                            onClick={() => {
                              // this.refs.msoCreateInputRef4.click();
                              this.openWIZPOD();
                            }}
                            disabled={this.state.salesOrders.selectedRows.length !== 1}
                          >
                            <em className="fa fa-list" />
                            <Translate value="pod" />
                          </Button>
                        )
                      }

                      { (isOCM || isEKC || isLMH || isBRO || isLAP || isAPD || isCCW || isCRW || isSC || isGFD || isSDR) && this.renderSendEmailButton() }
                      { (isLMH || isBRO) && this.renderSyncToMesButton()}
                      { ((isLAP || isUSPrideMulti || isAPD) && this.state.Status === "Backlog") && this.renderBacklogExport() }
                      { isOCM && this.renderResetLocationButton() }
                      { isABBLE && this.renderSOUploadButton() }
                      { ((isABBLE || isSKH || isUSPrideMulti) && this.context.router.routes[1].path === 'mobileSalesOrders' ) && this.renderTeapplixButton() }
                      { (isSV || isKM) && this.renderTeapplixButton() }
                      { (isABBLE || isSKH || isSV || isKM || isUSPrideMulti ) && this.renderTeapplixResyncButton() }
                      { isUSPrideMulti && this.renderMissingSKUsButton() }
                      { (isABBLE) && this.renderTeapplixSyncButton() }
                      { isSV && this.rollBackButton() }
                      { isAGD && this.renderStuff()}
                      {/* {isAGD && this.renderResyncShipstation()} */}
                      { isSKH && this.renderAcknowledgeOrdersButton() }
                      { isSKH && this.renderWalmartShipmentButton() }

                      { ((isSKH && isMobile) || (isABCFF && this.context.router.routes[1].path === 'outboundOrders')) && this.renderChangeShipMethodButton() }
                      {/* { isSV && this.renderPickerButton()} */}
                      { (isSKH || isAGD) && this.renderMissingSKUsButton()}
                      { (isSKH && isSalesOrder) && this.renderASNButton()}
                      { (isSKH && isSalesOrder) && this.renderUploadWalmartButtons()}
                      { (isSKH && isSalesOrder) && this.renderSendWalmartButtons()}
                      { (isSKH && isMobile) && this.renderABCFFSyncButton()}

                    </ButtonToolbar>
                  </div>

                  {(isLAP || isUSPrideMulti || isAPD) &&
                  <div className="table-filters-thirdrow" style={{ zIndex: 1, left: "177px" }}>
                    <ButtonToolbar style={{ position: 'relative', display: 'flex', flexDirection: 'row' }}>
                      {/* { ((isLAP || isUSPrideMulti || isAPD)) && this.renderSubmitBolImageButton() }
                      {  ((isLAP || isUSPrideMulti || isAPD)) && this.renderUploadPODButton()} */}

                    </ButtonToolbar>
                  </div>
                  }

                  {this.render3rdRowButtonsAbble()}

                  {/* {this.renderTesting()} */}
                  {
                    (isABC && this.context.router.routes[1].path !== 'salesOrders') &&
                    <Row style={{marginTop: '40px'}}>
                      <Col>
                        <label className="col-sm-3" style={{ width: '120px' }}><Translate value="so_num" /></label>
                        <label className="col-sm-3" style={{ width: '120px' }}><Translate value="company" /></label>
                        <label className="col-sm-3" style={{ width: '120px' }}>FBA</label>
                        <label className="col-sm-3" style={{ width: '120px' }}>BOL</label>
                        <label className="col-sm-3" style={{ width: '120px' }}>ISA</label>
                        <label className="col-sm-3" style={{ width: '120px' }}>Ship Status</label>
                        <label className="col-sm-3" style={{ width: '120px' }}>Container</label>
                      </Col>
                    </Row>
                  }
                  {
                    (isABC && this.context.router.routes[1].path !== 'salesOrders') &&
                    <Row>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="SONum" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="CompanyName" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="FBACode" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>

                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="CustomerBOLNo" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="IsaNo" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="ShippingStatus" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                      <Col className="col-sm-3" style={{ width: '120px' }} >
                        <Input name="ContainerNo" type="text" onChange={(e) => handleFilterChangePage(e.target)} />
                      </Col>
                    </Row>
                  }
                  {
                    (isABC && this.context.router.routes[1].path === 'salesOrders') &&
                    <div style={{height: "90px"}}></div>
                  }
                  {
                    (!isABC || this.context.router.routes[1].path === 'salesOrders') &&
                    <div
                      id="autosuggest-div"
                      className={(isTN || isAGD || isABC || isUSPrideMulti || isDSQ || isWIZ || isFJ || isJTB || isMAG || isABBLE || isOLG || isSV || isKM ) && "TNAutosuggest-div" || showExpressInvoice && "TNAutosuggest-div position_left"}
                    >
                      <Row style={{ height: "30px" }}>
                        <Col xs={10}>
                          <TypeRadios
                            InvoiceNoSearch
                            TrackingNoSearch={isAFG ? true : null}
                            CustomerPhoneSearch={isSDR ? true : null}
                            value={this.state.productSearchType}
                            handleOptionChange={this.handleOptionChange}
                            customerSearch={enableCustomerSearch}
                            ezgoFlag={isEzgo}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={6}>
                          <Row>
                            <Col xs={12}>
                              {(this.state.productSearchType === "invoiceNo" ||
                                this.state.productSearchType === "customer_id" ||
                                this.state.productSearchType === "customer_name" ||
                                this.state.productSearchType === "CustName" ||
                                this.state.productSearchType === "phonenumber") &&
                                this.renderInvoiceNoSearchInput()}
                              {this.state.productSearchType !== "invoiceNo" &&
                                this.state.productSearchType !== "customer_id" &&
                                this.state.productSearchType !== "customer_name" &&
                                this.state.productSearchType !== "trackingNo" &&
                                this.state.productSearchType !== "CustName" &&
                                this.state.productSearchType !== "phonenumber" &&
                                this.renderAutoSuggest()}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  }
                </div>
                {/* Sales Order Full Table */}
                {this.renderGGIButtons()}
                {this.renderOCMButtons()}
                {/* Non VAK | VAK: Non Ezgo's SO */}
                {(!isVAK || (isVAK && !isEzgo && !isMobile)) && this.renderTable()}
                {/* VAK: Ezgo's SO */}
                {(isVAK && isEzgo && !isMobile) && this.renderTableVAK()}
                {/* VAK MSO */}
                {(isVAK && isMobile) && this.renderMobileTableVAK(isEzgo)}
              </Panel>
            </Col>
          </Row>{" "}
          {/* End Sales Order Full Table  */}
          {/* Sale Order Details */}
          <Row>
            <Col xs={12}>
              { (!isABC && !isFJ && !isDSQ && !isWIZ && !isJTB && !isMAG && !isABCFF && !(isMobile && isVAK)) &&
                <h2>
                  <Translate value="sale_order_details" />
                </h2>
              }
              {
                (isDSQ || isWIZ || isJTB || isABCFF) &&
                <h2>
                <Translate value="order_details" />
                </h2>
              }
              {
                (!isABC && !isFJ && !isMAG && !(isMobile && isVAK)) &&
                <Panel className={(isSH || isAP) ? '' : 'details-table-collapse-fix'}>
                  {this.renderProductsTable()}
                </Panel>
              }
              { isFJ &&
                <h2>
                  <Translate value="order_details" />
                </h2>
              }
              { isFJ &&
                <Panel className="details-table-collapse-fix">
                  {/* {this.renderProductsTableFJ()} */}
                  {this.renderProductsTable()}
                </Panel>
              }
              { isMAG &&
                <h2>
                  <Translate value="container_info" /> ({ this.state.magSalesOrderDetail.SalesOrder_id ? this.state.magSalesOrderDetail.SONum : "None"})
                  {/* <div style={{marginLeft: '100px'}}>                   */}
                    <Button
                      bsStyle="success"
                      type="button"
                      style={{marginLeft: '50px'}}
                      disabled={!this.state.magSalesOrderDetail.SalesOrder_id}
                      onClick={(event) => {
                        this.saveMagStuff(event);
                      }}
                    >
                      <em className="fa fa-save" />
                      <Translate value="save_order_info" />
                    </Button>
                    {/* </div> */}
                </h2>
              }
              { isMAG &&
                <Panel className="details-table-collapse-fix">
                  {/* {this.renderProductsTableFJ()} */}
                  {this.renderMagContainer()}
                </Panel>
              }

              { isMAG &&
                <h2>
                  <Translate value="load_pickup_info" /> ({ this.state.magSalesOrderDetail.SalesOrder_id ? this.state.magSalesOrderDetail.SONum : "None"})
                </h2>
              }
              { isMAG &&
                // <Panel className="details-table-collapse-fix">
                <Panel>
                  {/* {this.renderProductsTableFJ()} */}
                  {this.renderMagLoad()}
                </Panel>
              }

              { isMAG &&
                <h2>
                  <Translate value="delivery_info" /> ({ this.state.magSalesOrderDetail.SalesOrder_id ? this.state.magSalesOrderDetail.SONum : "None"})
                </h2>
              }
              { isMAG &&
              // <Panel className="details-table-collapse-fix">
                <Panel>
                  {/* {this.renderProductsTableFJ()} */}
                  {this.renderMagDelivery()}
                </Panel>
              }
              { isMAG &&
                <h2>
                  <Translate value="empty_info" /> ({ this.state.magSalesOrderDetail.SalesOrder_id ? this.state.magSalesOrderDetail.SONum : "None"})
                </h2>
              }
              { isMAG &&
                // <Panel style={{marginBottom: '200px'}} className="details-table-collapse-fix">
                <Panel style={{marginBottom: '200px'}}>
                  {/* {this.renderProductsTableFJ()} */}
                  {this.renderMagEmpty()}
                </Panel>
              }
            </Col>
          </Row>{" "}
          {/* Sale Order Details */}
        </Grid>
        <LocationChange
          setModalVisibility={this.setLocationChangeModalVisibility}
          isVisible={this.state.isLocationChangeModalVisible}
          selectedRows={this.state.salesOrders.selectedRows}
          onSuccess={this.handleLocationChangeSuccess}
        />
        <InboundDateChange
          setModalVisibility={this.setInboundDateChangeModalVisibility}
          isVisible={this.state.isInboundDateChangeModalVisibile}
          selectedRows={this.state.salesOrders.selectedRows}
          onSuccess={this.handleLocationChangeSuccess}
        />
        <SkyLightStateless
          dialogStyles={isVAK && this.state.showMin ? minDialogStyle : createWeightDialogStyle}
          isVisible={this.state.changeWeightOpen}
          onCloseClicked={() => {
            this.closeChangeWeight();
          }}
          title={changeWeight}
        >
          <WeightChangeModalMulti
            salesOrderId={singleSalesOrderId}
            minOrMax={this.onMinOrMax}
            fetchShippingWeightTracking={this.props.fetchShippingWeightTracking}
            finalShippingWeight={this.state.finalShippingWeight}
            currentSalesOrder={this.state.salesOrders.selectedRows[0]}
            onSave={this.onChangeWeightSubmit}
            onPrint={this.onChangeWeightSubmitPrint}
            onSavePrint={this.onChangeWeightSubmitPrint}
            onChange={this.onShippingWeightChange}
            onPackingPrint={this.onPackingPrint}
            isMobile={isMobile}
            currentSalesOrderLine={this.state.salesOrderDetail.rows}
          />
        </SkyLightStateless>


        <SkyLightStateless
          dialogStyles={bolListDialogStyle}
          isVisible={this.state.multiplePackageVisibility}
          onCloseClicked={() => {
            this.setMultiplePackagelVisibility(false);
          }}
          title={"Print Multiple Packages"}
        >
          <MultiplePackageModal
          selectTeapplixShipping = {this.props.selectTeapplixShipping}
          singleSalesOrderId = {singleSalesOrderId}
          salesOrderPDF = {this.props.salesOrderPDF}
          setMultiplePackagelVisibility = {this.setMultiplePackagelVisibility}
          // this.props.selectTeapplixShipping('', salesOrderIdsString);
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={bolListDialogStyle}
          isVisible={this.state.bolListModalVisibility}
          onCloseClicked={() => {
            this.closebolListModal();
          }}
          title={"BOL List"}
        >
          <BOLListModal
            // salesOrderId={singleSalesOrderId}
            salesOrderNum={singleSalesOrderNum}
            closebolListModal={this.closebolListModal}
            printSalesOrderLabelBOL={this.props.printSalesOrderLabelBOL}
            testHAHA={this.props.printSalesOrderLabel}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={generateBOLStyle}
          isVisible={this.state.generateBOLModalVisibility}
          onCloseClicked={() => {
            this.closeGenerateBOLModal();
          }}
          title={"Generate BOL"}
        >
          <GenerateBOLModal
            salesOrderIdString={salesOrderIdString}
            salesOrderNumString={salesOrderNumString}
            closeGenerateBOLModal={this.closeGenerateBOLModal}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={dsqPrintDialogStyle}
          isVisible={this.state.dsqPrintVisibility}
          onCloseClicked={() => {
            this.closeDSQPrint();
          }}
          title={"Select Products"}
        >
          <DSQPrintModal
            // salesOrderId={singleSalesOrderId}
            // salesOrderNum={singleSalesOrderNum}
            printSalesOrderLabelDSQ={this.props.printSalesOrderLabelDSQ}
            singleSalesOrderId={singleSalesOrderId}
            closebolListModal={this.closeDSQPrint}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={changeTrackingDialogStyle}
          isVisible={this.state.changeTrackingOpen}
          onCloseClicked={() => {
            this.closeChangeTracking();
          }}
          title={"Change Tracking Number"}
        >
           {/* <Row className="centerStyle">
            <h4>
              Change
            </h4>
          </Row>
          <br /> */}
          <Row className="centerStyle">
            <div style={{width: '350px'}}>
              <Input type="text" value={this.state.newTrackingNum} onChange={this.onChangeTrackingNum} />
            </div>
          </Row>
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="success"
              onClick={this.changeTrackingConfirm}
              type="button"
            >
              <Translate value="confirm" />
            </Button>
            <Button
              bsStyle="danger"
              onClick={this.closeChangeTracking}
              type="button"
            >
              <Translate value="cancel" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={changeBOLDialogStyle}
          isVisible={this.state.trackingFormOpen}
          onCloseClicked={() => {
            this.closeTrackingForm();
          }}
          title={"Add Tracking Info"}
        >
          <Row>
            <Col sm={4}>
              <label><Translate value="tracking_num" /></label>
            </Col>
            <Col sm={4}>
              <label><Translate value="carrier" /></label>
            </Col>
            <Col sm={4}>
              <label><Translate value="ship_method" /></label>
            </Col>
          </Row>
          {
            isKM ?
            <Row>
              <Col sm={4}>
                <Input type="text" value={this.state.trackingformNum} onChange={this.onChangeFormNum} />
              </Col>
              <Col sm={4}>
                <Dropdown style={{ width: "100%" }}>
                  <Dropdown.Toggle
                    style={{
                      height: "25px",
                      width: "100%",
                      backgroundColor: "white",
                      border: "1px solid #555555",
                      color: "black",
                      fontWeight: "400",
                    }}
                  >
                    {this.state.trackingformCarrier && this.state.trackingformCarrier}
                    {!this.state.trackingformCarrier && "Select"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {kmCarrierOptions.map((el) => {
                      return (
                        <MenuItem onClick={() => this.onChangeFormCarrier(el)}>
                          {el.label}
                        </MenuItem>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col sm={4}>
                <Dropdown style={{ width: "100%" }}>
                  <Dropdown.Toggle
                    style={{
                      height: "25px",
                      width: "100%",
                      backgroundColor: "white",
                      border: "1px solid #555555",
                      color: "black",
                      fontWeight: "400",
                    }}
                  >
                    {this.state.trackingformMethod && this.state.trackingformMethod}
                    {!this.state.trackingformMethod && "Select"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {kmShipOptions.map((el) => {
                      return (
                        <MenuItem onClick={() => this.onChangeFormMethod(el)}>
                          {el.label}
                        </MenuItem>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
            :
            <Row>
              <Col sm={4}>
                <Input type="text" value={this.state.trackingformNum} onChange={this.onChangeFormNum} />
              </Col>
              <Col sm={4}>
                <Input type="text" value={this.state.trackingformCarrier} onChange={this.onChangeFormCarrier} />
              </Col>
              <Col sm={4}>
                <Input type="text" value={this.state.trackingformMethod} onChange={this.onChangeFormMethod} />
              </Col>
            </Row>
          }
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="success"
              onClick={this.confirmTrackingForm}
              type="button"
            >
              <Translate value="confirm" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={wizPODDialogStyle}
          isVisible={this.state.wizPODVisibility}
          onCloseClicked={() => {
            this.closeWIZPOD();
          }}
          title={"POD (" + singleSalesOrderNum + ")"}
        >
          <WIZPODModal
            // salesOrderId={singleSalesOrderId}
            // salesOrderNum={singleSalesOrderNum}
            // printSalesOrderLabelDSQ={this.props.printSalesOrderLabelDSQ}
            singleSalesOrderId={singleSalesOrderId}
            closeWIZPOD={this.closeWIZPOD}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createPickerDialogStyle}
          isVisible={this.state.PickerOpen}
          onCloseClicked={() => {
            this.closePicker();
          }}
          title={<Translate value="assign_picker" />}
        >
          <div className="centerStyle">
            <div  style={{width: "250px"}}>
            <Field name="Picker" component={Selection} options={userOptions} />
            </div>
            {/* <Dropdown>
              <Dropdown.Toggle
                style={{
                  width: "200px",
                  backgroundColor: "white",
                  border: "1px solid #555555",
                  color: "black",
                  fontWeight: "400",
                  marginTop: "10px",
                }}
              >
                {this.state.SelectedPicker && this.state.SelectedPicker}
                {!this.state.SelectedPicker && "Select"}
              </Dropdown.Toggle>
              <Dropdown.Menu className="super-colors">
                {userOptions.map((el) => {
                  return (
                    <MenuItem onClick={() => this.onPickerChange(el)}>
                      {el.label}
                    </MenuItem>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown> */}
            <div style={{ marginTop: "10px" }}>
              <Button
                bsStyle="success"
                type="submit"
                onClick={(event) => {
                  this.savePicker();
                }}
                disabled={SelectedPicker===''}
              >
                {/* <em className="fa fa-plus" /> */}
                <Translate value="assign" />
              </Button>
            </div>
          </div>
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={createWeightDialogStyle}
          isVisible={this.state.USPrideCreateOpen}
          onCloseClicked={() => {
            this.closeUSPrideCreate();
          }}
          title={<Translate value="create_with_excel" />}
        >
          <div className="centerStyle">
            {isABCFF ?
            <div>
              <Row className="centerStyle">
                <h4>
                  Select Customer:
                </h4>
              </Row>
              <Row className="centerStyle">
                <div style={{ width: "250px" }}>
                  <Field
                    name="excelCustomer"
                    placeholder={
                      <span style={{ fontStyle: "normal" }}>
                        Select
                      </span>
                    }
                    component={SelectionWithProps}
                    options={this.state.excelCustomerOptions}
                    onSelect={(value) => {
                      this.onUSPrideCustomerChange(value);
                    }}
                  />
                </div>
              </Row>
              <br />
              <Row className="centerStyle">
                <h4>
                  Select Market:
                </h4>
              </Row>
              <Row className="centerStyle">
                <div style={{ width: "250px" }}>
                  <Field
                    name="excelPlatform"
                    placeholder={
                      <span style={{ fontStyle: "normal" }}>
                        Select
                      </span>
                    }
                    component={SelectionWithProps}
                    options={USPridePlatformOptions}
                    onSelect={(value) => {
                      this.onUSPridePlatformChange(value);
                    }}
                  />
                </div>
              </Row>
            </div>
            :
            <Dropdown>
              <Dropdown.Toggle
                style={{
                  width: "154px",
                  backgroundColor: "white",
                  border: "1px solid #555555",
                  color: "black",
                  fontWeight: "400",
                  marginTop: "10px",
                }}
              >
                {this.state.USPridePlatform && this.state.USPridePlatform}
                {!this.state.USPridePlatform && "Select"}
              </Dropdown.Toggle>
              <Dropdown.Menu className="super-colors">
                {USPridePlatformOptions.map((el) => {
                  return (
                    <MenuItem onClick={() => this.onUSPridePlatformChange(el)}>
                      {el.label}
                    </MenuItem>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
            }
            <div style={{ marginTop: "10px" }}>
              <Button
                bsStyle="success"
                type="submit"
                onClick={(event) => {
                  this.refs.createSORef.click();
                }}
                disabled={
                  !checkPermission("add_sales_order")
                  || (USPridePlatform==='')
                }
              >
                <em className="fa fa-plus" />
                <Translate value="import_and_submit" />
              </Button>
              <input
                type='file'
                ref='createSORef'
                key={inputFieldKey}
                onClick={(e) => {
                  e.target.value = null;
                }}
                onChange={(e) => {
                  this.setState({ USPrideCreateOpen: false, USPrideCreateLoading: true});
                  const formData = new FormData();
                  const file = e.target.files[0];
                  formData.append('FILE', file);
                  generateSOWithExcelUSPride(formData, USPridePlatform, USPrideCustomer, this.props.selectedWarehouse, () => {
                    alert('success, reloading the page');
                    this.refreshSOList();
                    this.onUSPridePlatformChange('');
                    this.onUSPrideCustomerChange('');
                    this.setState({ USPrideCreateLoading: false});
                  }, () => {
                    this.setState({USPrideCreateLoading: false});
                  });
                }}
                style={{ display: 'none' }}
              />
            </div>
          </div>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createWeightDialogStyle}
          isVisible={this.state.paymentMethodModalVisibility}
          onCloseClicked={() => {
            this.closePaymentMethodModal();
          }}
          title={changePaymentMethod}
        >
          <PaymentMethodModal
            salesOrder={this.state.salesOrders.selectedRows}
            successSaved={this.handleSOPaymentMethodSaved}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={generateBOLStyle}
          isVisible={this.state.shipMethodModalVisibility}
          onCloseClicked={() => { this.closeChangeShipMethodModal(); }}
          title={changeShipMethod}
        >
          <ShipMethodModal
            salesOrder={this.state.salesOrders.selectedRows}
            successSaved={this.handleSOShipMethodSaved}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={DriverListModalStyle}
          isVisible={this.state.shipQtyModalVisibility}
          onCloseClicked={() => { this.closeChangeShipQtyModal(); }}
          title={changeShipQty}
        >
          <ShipQtyModal
            id={this.state.changeShipQtyId}
            successSaved={this.handleSOShipQtySaved}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={DriverListModalStyle}
          isVisible={this.state.editTrackingModalVisibility}
          onCloseClicked={() => { this.closeChangeTrackingModal(); }}
          title={changeTracking}
        >
          <EditTrackingModal
            id={this.state.changeTrackingId}
            successSaved={this.handleSOTrackingcSaved}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createTrackingDialogStyle}
          isVisible={this.state.displayTrackingOpen}
          onCloseClicked={() => {
            this.closeDisplayTracking();
          }}
          title={isAFG ? displayTrackingTitle : displayTrackingTitle2}
        >
          <SplitTrackingNumberModal
            salesOrderId={singleSalesOrderId}
            jmlPrintLabel={this.props.jmlPrintLabel}
            fetchJmlTracking={this.props.fetchJmlTracking}
            fetchShippingWeightTracking={this.props.fetchShippingWeightTracking}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={splitSoDialogStyle}
          isVisible={this.state.splitSoVisible}
          onCloseClicked={() => {
            this.closeSplitSo();
          }}
          title={splitSOTitle}
        >
          <SplitSOModal
            soDetail={this.state.salesOrderDetail}
            soId={this.state.salesOrders.selectedRows.length == 1 && this.state.salesOrders.selectedRows[0].SalesOrder_id}
            selectedCompany={this.props.selectedCompany}
            fetchActiveCustomers={this.props.fetchActiveCustomers}
            customers={this.props.customers}
            onConfirm={()=>{
              this.closeSplitSo(true)
            }}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.printTrackingConfirmOpen}
          onCloseClicked={this.closePrintTrackingConfirm}
          title={<Translate value="confirm_print_tracking" />}
        >
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_confirm_print_tracking" />
            </h4>
          </Row>
          <br />
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={this.closePrintTrackingConfirm}
              type="button"
            >
              <Translate value="no" />
            </Button>
            <Button
              bsStyle="success"
              onClick={this.printTrackingConfirm}
              type="button"
            >
              <Translate value="yes" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createPullSheetDialogStyle}
          isVisible={this.state.changePullSheetOpen}
          onCloseClicked={() => {
            this.closeChangePullSheet();
          }}
          title={changePullSheet}
        >
          <div>
            <Row>
              <Col sm={4}>
                <label>
                  <Translate value="order_amount" />
                </label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <Input type="number" onChange={this.onPullSheetChange} />
              </Col>
              <Col sm={3}>
                <ButtonToolbar>
                  <Button
                    bsStyle="primary"
                    onClick={() => {
                      this.onChangePullSheetSubmit();
                    }}
                  >
                    <Translate value="submit" />
                  </Button>
                </ButtonToolbar>
              </Col>
            </Row>
          </div>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.checkAuthorizeOpen}
          onCloseClicked={this.closeCheckAuthorize}
        >
          <ConfirmActionModal
            case="confirmPassword"
            closeC={this.checkAuthorize}
            checkPasswordFailure={this.props.checkPasswordFailure}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={voidNoteDialogStyle}
          isVisible={this.state.voidNoteModalVisibility}
          onCloseClicked={this.closeVoidNote}
          title={voidNoteTitle}
        >
          <Row className="centerStyle">
            <div style={{ width: "250px", marginTop: "10px" }}>
              <p style={{ marginBottom: "3px", fontWeight: "bold" }}>
                <Translate value="void_reason" />:
              </p>
              <Dropdown>
                <Dropdown.Toggle
                  style={{
                    width: "250px",
                    backgroundColor: "white",
                    border: "1px solid #555555",
                    color: "black",
                    fontWeight: "400",
                  }}
                >
                  {this.state.voidReason && this.state.voidReason}
                  {!this.state.voidReason && "Select"}
                </Dropdown.Toggle>
                <Dropdown.Menu className="super-colors">
                  {voidReasonSelection.map((el) => {
                    return (
                      <MenuItem onClick={() => this.onVoidReasonChange(el)}>
                        {el.label}
                      </MenuItem>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div
              style={{
                width: "350px",
                marginTop: "20px",
                marginBottom: "35px",
              }}
            >
              <p style={{ marginBottom: "3px", fontWeight: "bold" }}>
                <Translate value="void_note" />:
              </p>
              <Input
                type="textarea"
                rows={3}
                onChange={this.onVoidNoteChange}
              />
            </div>
          </Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button bsStyle="danger" onClick={this.closeVoidNote} type="button">
              <Translate value="cancel" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => {
                this.onConfirmVoidNote();
              }}
              type="button"
            >
              <Translate value="confirm_void" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={chowbusDialogStyle}
          isVisible={this.state.chowbusModalVisibility}
          onCloseClicked={this.closeChowbusModal}
          title={chowbusImportTitle}
        >
          <Row className="centerStyle" style={{ marginBottom: "20px" }}>
            <label>
              <Translate value="spreadsheet" />
            </label>
            <input
              style={{ border: "1px solid #aaa" }}
              type="file"
              name="file"
              onChange={this.onChangeChowbusImport}
            />
          </Row>

          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={this.closeChowbusModal}
              type="button"
            >
              <Translate value="cancel" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => {
                this.onConfirmChowbusImport();
              }}
              type="button"
            >
              <Translate value="import" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.confirmReshipOpen}
          onCloseClicked={() => {
            this.closeConfirmReship();
          }}
          title={reshipTitle}
        >
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_confirm_reship" />
            </h4>
          </Row>
          <br />
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={this.closeConfirmReship}
              type="button"
            >
              <Translate value="no" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => {
                this.onConfirmReship();
              }}
              type="button"
            >
              <Translate value="yes" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.showDriverImageOpen}
          onCloseClicked={() => {
            this.closeShowDriverImage();
          }}
          title={showImageTitle}
        >
          {this.renderDriverImage()}
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.showSignatureImageOpen}
          onCloseClicked={() => {
            this.closeSignatureImage();
          }}
          title={showImageTitle}
        >
          {this.renderSignatureImage()}
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={bolImageDialogue}
          isVisible={this.state.submitImageOpen}
          onCloseClicked={() => { this.closeSubmitImage(); }}
          title={submitImageTitle}
        >
          <BolImagesTable
            salesOrder_id={this.state.salesOrders.selectedRows.length === 1 &&
              this.state.salesOrders.selectedRows[0].SalesOrder_id}
            handleImageClosed={() => { this.closeSubmitImage(); }}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.printBolOpen}
          onCloseClicked={() => {
            this.closePrintBol();
          }}
          title={printBolTitle}
        >
          <Row className="centerStyle">{this.renderAddresses()}</Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="success"
              onClick={() => {
                this.props.printBolByFba(this.state.bolAddressFBA);
              }}
              type="button"
            >
              <Translate value="Print" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.confirmQuoteOpen}
          onCloseClicked={() => {
            this.closeConfirmQuote();
          }}
          title={quoteTitle}
        >
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_assign_customer" />
            </h4>
          </Row>
          <Row className="centerStyle">
            <div style={{ width: "350px" }}>
              <Field
                name="hmmCustomer"
                placeholder={
                  <span style={{ fontStyle: "normal" }}>
                    {this.state.quoteSelectedCustomerPlaceholder}
                  </span>
                }
                component={SelectionWithProps}
                options={this.state.quoteCustomerOptions}
                onSelect={(value) => {
                  this.onQuoteCustomerChange(value);
                }}
              />
            </div>
          </Row>
          {
            isABBLE || isKM && <div>
              <Row className="centerStyle">
                <h4>
                  <Translate value="warehouse" />:
                </h4>
              </Row>
              <Row className="centerStyle">
                <div style={{ width: "350px" }}>
                  <Field
                    name="hmmWarehouse"
                    placeholder={
                      <span style={{ fontStyle: "normal" }}>
                        {this.state.quoteSelectedWarehousePlaceholder}
                      </span>
                    }
                    component={SelectionWithProps}
                    options={this.state.quoteWarehouseOptions}
                    onSelect={(value) => {
                      this.onQuoteWarehouserChange(value);
                    }}
                  />
                </div>
              </Row>
            </div>
          }
          {(isSV || isSH || isAP || (isLAP || isUSPrideMulti || isAPD)) && <div>
            <Row style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <div style={{ width: "150px" }} className="centerStyle">
                <h4>Customer Number</h4>
                <Field
                  name="hmmCustomer"
                  placeholder={
                    <span style={{ fontStyle: "normal" }}>
                      customer number
                    </span>
                  }
                  component={SelectionWithProps}
                  options={this.state.quoteCustomerNoOptions}
                  onSelect={(value) => {
                    this.onQuoteCustomerChange(value);
                  }}
                />
              </div>
              <div style={{ width: "150px" }} className="centerStyle">
                <h4>Customer zipcode</h4>
                <Field
                  name="hmmCustomer"
                  placeholder={
                    <span style={{ fontStyle: "normal" }}>
                      customer zipcode
                    </span>
                  }
                  component={SelectionWithProps}
                  options={this.state.quoteCustomerZipOptions}
                  onSelect={(value) => {
                    this.onQuoteCustomerChange(value);
                  }}
                />
              </div>
              <div style={{ width: "150px" }} className="centerStyle">
                <h4>Customer phone</h4>
                <Field
                  name="hmmCustomer"
                  placeholder={
                    <span style={{ fontStyle: "normal" }}>
                      customer phone number
                    </span>
                  }
                  component={SelectionWithProps}
                  options={this.state.quoteCustomerPhoneOptions}
                  onSelect={(value) => {
                    this.onQuoteCustomerChange(value);
                  }}
                />
              </div>
            </Row>
          </div>}
          {
            !isABBLE && <div>
              <Row className="centerStyle">
                <h4>
                  <Translate value="shipping_address" />:
                </h4>
              </Row>
              <Row className="centerStyle">
                <div style={{ width: "350px" }}>
                  <Field
                    name="customerShipping"
                    placeholder={
                      <span style={{ fontStyle: "normal" }}>
                        {this.state.quoteSelectedShippingPH}
                      </span>
                    }
                    component={SelectionWithProps}
                    options={this.state.quoteShippingOptions}
                    onSelect={(value) => {
                      this.onQuoteShippingChange(value);
                    }}
                  />
                </div>
              </Row>
            </div>
          }
          <br />
          <br />
          <Row className="centerStyle">
            {/* <h4>
              <Translate value="msg_confirm_customer" />
            </h4> */}
          </Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={this.closeConfirmQuote}
              type="button"
            >
              <Translate value="no" />
            </Button>
            <Button
              bsStyle="success"
              disabled={!this.state.quoteSelectedCustomerId}
              onClick={() => {
                this.onConfirmQuote();
              }}
              type="button"
            >
              <Translate value="yes" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.confirmQuotePending}
          onCloseClicked={() => {
            this.setPendingConfirmModalVisibility();
          }}
          title={pendingTitle}
        >
          <Row className="centerStyle">
            <h4>
              <Translate value="pending_confirm" />
            </h4>
          </Row>
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_confirm_pending" />
            </h4>
          </Row>
          <br />
          <br />
          <br />
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={this.setPendingConfirmModalVisibility}
              type="button"
            >
              <Translate value="no" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => {
                const { salesOrders: {
                  selectedRows,
                } } = this.state;
                const id = selectedRows[0].SalesOrder_id;
                const success = () => {
                  this.refreshSOList();
                  this.setPendingConfirmModalVisibility();
                }
                this.props.setSOToPending(id, success);
              }}
              type="button"
            >
              <Translate value="yes" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.confirmOpenToQuote}
          onCloseClicked={() => {
            this.setQuoteConfirmModalVisibility();
          }}
          title={setQuoteTitle}
        >
          <Row className="centerStyle">
            <h4>
              <Translate value="quote_confirm" />
            </h4>
          </Row>
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_confirm_setso_quote" />
            </h4>
          </Row>
          <br />
          <br />
          <br />
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={this.setQuoteConfirmModalVisibility}
              type="button"
            >
              <Translate value="no" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => {
                const { salesOrders: {
                  selectedRows,
                } } = this.state;
                const id = selectedRows[0].SalesOrder_id;
                const success = () => {
                  this.refreshSOList();
                  this.setQuoteConfirmModalVisibility();
                }
                this.props.setSOToQuote(id, success);
              }}
              type="button"
            >
              <Translate value="yes" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.davisPOVisibility}
          onCloseClicked={() => {
            this.closeDavisPO();
          }}
          title={davisPOTitle}
        >
          <br />
          <br />
          <Row className="centerStyle">
            <h4>
              <Translate value="msg_po_to_so_dropship" />
            </h4>
          </Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={() => this.closeDavisPO()}
              type="button"
            >
              <Translate value="no" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => this.onConfirmDavisPO()}
              type="button"
            >
              <Translate value="yes" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.pridePrintVisibility}
          onCloseClicked={() => {
            this.closePridePrint();
          }}
          title={pridePrintTitle}
        >
          <br />
          <br />
          <Row className="centerStyle">
            <h4 style={{paddingLeft: '15px', paddingRight: '15px'}}>
              <Translate value="pride_msg_print_shipping" />
            </h4>
          </Row>
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="danger"
              onClick={() => this.closePridePrint()}
              type="button"
            >
              <Translate value="cancel" />
            </Button>
            <Button
              bsStyle="success"
              onClick={() => this.onConfirmPridePrint()}
              type="button"
            >
              <Translate value="continue" />
            </Button>
          </ButtonToolbar>
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={DriverListModalStyle}
          isVisible={this.state.driverListModalVisibility}
          onCloseClicked={this.setDriverListModalVisibility}
          title={"Assign MSOs to Driver"}
        >
          <DriverListModal
            assigningInboundDriver={this.state.assigningInboundDriver}
            assigningOutboundDriver={this.state.assigningOutboundDriver}
            selectedOrders={this.state.salesOrders.selectedRows || []}
            handleSuccess={this.handleAssignSOToDriverSuccess}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={DriverListModalStyle}
          isVisible={this.state.isaEditModalVisibility}
          onCloseClicked={this.setISAEditModalVisibility}
          title={"isa number update"}
        >
          <ISAEditModal
            selectedSalesOrder={this.state.salesOrders.selectedRows[0]}
            handleISANoUpdateSuccess={this.handleISANoUpdateSuccess}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={DriverListModalStyle}
          isVisible={this.state.ctnEditModalVisibility}
          onCloseClicked={this.setCTNEditModalVisibility}
          title={"ctn number update"}
        >
          <CTNEditModal
            selectedSalesOrder={this.state.salesOrders.selectedRows[0]}
            handleCTNNoUpdateSuccess={this.handleCTNNoUpdateSuccess}
          />
        </SkyLightStateless>
        <EmailContentModal
          visible={this.state.emailContentModalVisibility}
          subject={this.state.emailSubjectTemplate}
          content={this.state.emailContentTemplate}
          onConfirm={this.handleEmailContentConfirm}
          onClose={this.handleEmailContentClose}
          selectedRows={this.state.salesOrders ? this.state.salesOrders.selectedRows : []}
          source={"SO"}
        />
        <TeapplixResyncModal
          isVisible={this.state.isTeapplixResyncModalVisibile}
          setModalVisibility={this.setTeapplixResyncModalVisibility}
          resyncTeapplix={this.resyncTeapplix}
        />
        <StuffResyncModal
          isVisible={this.state.isStuffResyncModalVisibile}
          setModalVisibility={this.setStuffResyncModalVisibility}
          resyncTeapplix={this.resyncStuff}
          resyncType={this.state.resyncType}
        />
        <MissingSKUsModal
          isVisible={this.state.isMissingSKUsModalVisible}
          setModalVisibility={this.setMissingSKUsModalVisibility}
          salesOrders={this.state.salesOrders}
        />
        <MonitorNoteModal
          isVisible={this.state.isMonitorNoteModalVisible}
          setModalVisibility={this.setMonitorNoteModalVisibility}
          monitorRow={this.state.monitorRow}
          handleMonitorOrderSuccess={this.handleMonitorOrderSuccess}
        />
        <MonitorRemoveModal
          isVisible={this.state.isCancelMonitorModalVisible}
          setModalVisibility={this.setCancelMonitorModalVisibility}
          monitorRow={this.state.monitorRow}
          handleCancelMonitorOrderSuccess={this.handleMonitorOrderSuccess}
        />
        <MonitorListModal
          isVisible={this.state.isMonitorListModalVisible}
          setModalVisibility={this.setMonitorListModalVisibility}
          selectedWarehouse={this.props.selectedWarehouse}
        />
        <ShippingRateModal
          isVisible={this.state.isShipingRateVisible}
          setModalVisibility={this.setShippingRateVisibility}
          salesOrders={this.state.salesOrders}
          handleTeapplixPrintClick={this.handleTeapplixPrintClick}
        />
        <CreateExcelModal
          isVisible={this.state.createExcelModalVisible}
          setModalVisibility={this.setCreateExcelOCMModalVisibility}
          handleUploadSuccess={this.handleOCMCreateExcelSuccess}
        />
        <div id="sales-shipping-modal">
          <SkyLightStateless dialogStyles={createDialogShippingStyle} isVisible={this.state.showShippingOpen} onCloseClicked={this.closeShipping} title={<Translate value="sales_order_express_invoice" />}>
            <SalesShippingModal
              rows={this.state.isMergeSo ? this.state.mergeSOLines: this.state.currentSalesOrder && this.state.currentSalesOrder.Sales_Order_Lines}
              currentSalesOrder={this.state.isMergeSo ? this.state.mergeSODetails : this.state.currentSalesOrder}
              InvoiceNum={this.state.isMergeSo ? this.state.mergeSODetails && this.state.mergeSODetails.InvoiceNum:this.state.currentSalesOrder && this.state.currentSalesOrder.InvoiceNum}
              isMergeSo={this.state.isMergeSo}
              mergeSOIds={this.state.mergeSOIds}
              mergeSONums={this.state.mergeSONums}
              selectedCompany={this.props.selectedCompany}
            />
          </SkyLightStateless>
        </div>
        <SkyLightStateless
          dialogStyles={managePodDialogue}
          isVisible={this.state.managePodOpen}
          onCloseClicked={() => { this.closeManagePod(); }}
          title={<Translate value="upload_doc" />}
        >
          <div className="toolbar-row" style={{marginBottom: '10px'}}>
              <ButtonToolbar>
                {this.renderPodUpload()}
                {this.renderPodDelete()}
              </ButtonToolbar>
            </div>
            {this.renderPodTable()}
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={{...wizPODDialogStyle, width: 800, marginLeft: '-24%'}}
          isVisible={this.state.autoPrintModalVisibility}
          onCloseClicked={this.closeAutoPrintModal}
          title={<Translate value={"auto_print"} />}
        >
          <AutoPrintModal salesOrders={this.state.salesOrders} afterSave={this.handleAutoPrint}/>
        </SkyLightStateless>
        <SkyLightStateless
            dialogStyles={confirmDialogStyle}
            isVisible={this.state.storeModalVisibility}
            onCloseClicked={() => this.closeStoreModal()}
          >
            <div style={{padding: '10px 16px', fontSize: "14px"}}>
              {this.renderStoreTreeData()}
            </div>
            <Row className="centerStyle">
              <Button
                bsStyle="success"
                onClick={() => this.searchStoreModal()}
              >
                <Translate value="search" />
              </Button>
              <Button
                bsStyle="danger"
                style={{ marginLeft: '5px' }}
                onClick={() => this.closeStoreModal()}
              >
                <Translate value="cancel" />
              </Button>
            </Row>
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={syncToMESDialogStyle}
            isVisible={this.state.mesModalVisibility}
            onCloseClicked={() => this.closeMesModal()}
          >
            <div style={{padding: '10px 16px', fontSize: "14px", display: 'flex', justifyContent: "center"}}>
              <Translate value="confirm_sync_to_mes" />
            </div>
            <Row className="centerStyle">
              <Button
                bsStyle="success"
                onClick={() => this.confirmSyncToMES()}
              >
                <Translate value="confirm" />
              </Button>
              <Button
                bsStyle="danger"
                style={{ marginLeft: '5px' }}
                onClick={() => this.closeMesModal()}
              >
                <Translate value="cancel" />
              </Button>
            </Row>
          </SkyLightStateless>
          <DropshipModal
            visible={this.state.isDropshipOpen}
            isMerge={isAP}
            onClose={this.closeDropship}
            salesOrderId={this.state.salesOrderIds}
            handleCreatePOSuccess={() => {
              this.closeDropship();
              this.refreshSOList();
            }}
          />
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}
// class CellRenderer extends React.Component {
//   constructor() {
//     super();
//   }
//   getStyle = () => {
//     return {
//       position: 'absolute',
//       width: this.props.column.width,
//       height: this.props.height,
//       left: this.props.column.left,
//       border: '1px solid #eee',
//       ...(this.props.customStyle && this.props.customStyle(this.props) || {})
//     };
//   }
//   render() {
//     return React.createElement('div', { tabIndex: '-1', style: this.getStyle(), width: '100%', className: 'react-grid-Cell' })
//   }
// }
// CellRenderer.isSelected = (props) => {
//   let cellMetaData = props.cellMetaData,
//     rowIdx = props.rowIdx,
//     idx = props.idx;
//   if (cellMetaData == null) {
//     return false;
//   }
//   let selected = cellMetaData.selected;
//   return selected && selected.rowIdx === rowIdx && selected.idx === idx;
// };
// CellRenderer.isScrolling = (props) => {
//   return props.cellMetaData.isScrollingHorizontallyWithKeyboard;
// }
export default SalesOrder;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/salesOrders.jsx